// src/common/iso-countries.ts
var ISO_COUNTRIES = [
  { code: "AD", nameKo: "\uC548\uB3C4\uB77C", nameEn: "Andorra", flag: "\u{1F1E6}\u{1F1E9}" },
  { code: "AE", nameKo: "\uC544\uB78D\uC5D0\uBBF8\uB9AC\uD2B8", nameEn: "United Arab Emirates", flag: "\u{1F1E6}\u{1F1EA}" },
  { code: "AF", nameKo: "\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4", nameEn: "Afghanistan", flag: "\u{1F1E6}\u{1F1EB}" },
  { code: "AG", nameKo: "\uC564\uD2F0\uAC00 \uBC14\uBD80\uB2E4", nameEn: "Antigua and Barbuda", flag: "\u{1F1E6}\u{1F1EC}" },
  { code: "AI", nameKo: "\uC575\uADC8\uB77C", nameEn: "Anguilla", flag: "\u{1F1E6}\u{1F1EE}" },
  { code: "AL", nameKo: "\uC54C\uBC14\uB2C8\uC544", nameEn: "Albania", flag: "\u{1F1E6}\u{1F1F1}" },
  { code: "AM", nameKo: "\uC544\uB974\uBA54\uB2C8\uC544", nameEn: "Armenia", flag: "\u{1F1E6}\u{1F1F2}" },
  { code: "AO", nameKo: "\uC559\uACE8\uB77C", nameEn: "Angola", flag: "\u{1F1E6}\u{1F1F4}" },
  { code: "AQ", nameKo: "\uB0A8\uADF9", nameEn: "Antarctica", flag: "\u{1F1E6}\u{1F1F6}" },
  { code: "AR", nameKo: "\uC544\uB974\uD5E8\uD2F0\uB098", nameEn: "Argentina", flag: "\u{1F1E6}\u{1F1F7}" },
  { code: "AS", nameKo: "\uC544\uBA54\uB9AC\uCE78\uC0AC\uBAA8\uC544", nameEn: "American Samoa", flag: "\u{1F1E6}\u{1F1F8}" },
  { code: "AT", nameKo: "\uC624\uC2A4\uD2B8\uB9AC\uC544", nameEn: "Austria", flag: "\u{1F1E6}\u{1F1F9}" },
  { code: "AU", nameKo: "\uD638\uC8FC", nameEn: "Australia", flag: "\u{1F1E6}\u{1F1FA}" },
  { code: "AW", nameKo: "\uC544\uB8E8\uBC14", nameEn: "Aruba", flag: "\u{1F1E6}\u{1F1FC}" },
  { code: "AX", nameKo: "\uC62C\uB780\uB4DC \uC81C\uB3C4", nameEn: "\xC5land Islands", flag: "\u{1F1E6}\u{1F1FD}" },
  { code: "AZ", nameKo: "\uC544\uC81C\uB974\uBC14\uC774\uC794", nameEn: "Azerbaijan", flag: "\u{1F1E6}\u{1F1FF}" },
  { code: "BA", nameKo: "\uBCF4\uC2A4\uB2C8\uC544 \uD5E4\uB974\uCCB4\uACE0\uBE44\uB098", nameEn: "Bosnia and Herzegovina", flag: "\u{1F1E7}\u{1F1E6}" },
  { code: "BB", nameKo: "\uBC14\uBCA0\uC774\uB3C4\uC2A4", nameEn: "Barbados", flag: "\u{1F1E7}\u{1F1E7}" },
  { code: "BD", nameKo: "\uBC29\uAE00\uB77C\uB370\uC2DC", nameEn: "Bangladesh", flag: "\u{1F1E7}\u{1F1E9}" },
  { code: "BE", nameKo: "\uBCA8\uAE30\uC5D0", nameEn: "Belgium", flag: "\u{1F1E7}\u{1F1EA}" },
  { code: "BF", nameKo: "\uBD80\uB974\uD0A4\uB098\uD30C\uC18C", nameEn: "Burkina Faso", flag: "\u{1F1E7}\u{1F1EB}" },
  { code: "BG", nameKo: "\uBD88\uAC00\uB9AC\uC544", nameEn: "Bulgaria", flag: "\u{1F1E7}\u{1F1EC}" },
  { code: "BH", nameKo: "\uBC14\uB808\uC778", nameEn: "Bahrain", flag: "\u{1F1E7}\u{1F1ED}" },
  { code: "BI", nameKo: "\uBD80\uB8EC\uB514", nameEn: "Burundi", flag: "\u{1F1E7}\u{1F1EE}" },
  { code: "BJ", nameKo: "\uBCA0\uB0C9", nameEn: "Benin", flag: "\u{1F1E7}\u{1F1EF}" },
  { code: "BL", nameKo: "\uC0DD\uBC14\uB974\uD154\uB808\uBBF8", nameEn: "Saint Barth\xE9lemy", flag: "\u{1F1E7}\u{1F1F1}" },
  { code: "BM", nameKo: "\uBC84\uBBA4\uB2E4", nameEn: "Bermuda", flag: "\u{1F1E7}\u{1F1F2}" },
  { code: "BN", nameKo: "\uBE0C\uB8E8\uB098\uC774", nameEn: "Brunei", flag: "\u{1F1E7}\u{1F1F3}" },
  { code: "BO", nameKo: "\uBCFC\uB9AC\uBE44\uC544", nameEn: "Bolivia", flag: "\u{1F1E7}\u{1F1F4}" },
  { code: "BQ", nameKo: "\uCE74\uB9AC\uBE0C \uB124\uB35C\uB780\uB4DC", nameEn: "Caribbean Netherlands", flag: "\u{1F1E7}\u{1F1F6}" },
  { code: "BR", nameKo: "\uBE0C\uB77C\uC9C8", nameEn: "Brazil", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "BS", nameKo: "\uBC14\uD558\uB9C8", nameEn: "Bahamas", flag: "\u{1F1E7}\u{1F1F8}" },
  { code: "BT", nameKo: "\uBD80\uD0C4", nameEn: "Bhutan", flag: "\u{1F1E7}\u{1F1F9}" },
  { code: "BV", nameKo: "\uBD80\uBCA0\uC12C", nameEn: "Bouvet Island", flag: "\u{1F1E7}\u{1F1FB}" },
  { code: "BW", nameKo: "\uBCF4\uCE20\uC640\uB098", nameEn: "Botswana", flag: "\u{1F1E7}\u{1F1FC}" },
  { code: "BY", nameKo: "\uBCA8\uB77C\uB8E8\uC2A4", nameEn: "Belarus", flag: "\u{1F1E7}\u{1F1FE}" },
  { code: "BZ", nameKo: "\uBCA8\uB9AC\uC988", nameEn: "Belize", flag: "\u{1F1E7}\u{1F1FF}" },
  { code: "CA", nameKo: "\uCE90\uB098\uB2E4", nameEn: "Canada", flag: "\u{1F1E8}\u{1F1E6}" },
  { code: "CC", nameKo: "\uCF54\uCF54\uC2A4 \uC81C\uB3C4", nameEn: "Cocos (Keeling) Islands", flag: "\u{1F1E8}\u{1F1E8}" },
  { code: "CD", nameKo: "\uCF69\uACE0\uBBFC\uC8FC\uACF5\uD654\uAD6D", nameEn: "Congo (DRC)", flag: "\u{1F1E8}\u{1F1E9}" },
  { code: "CF", nameKo: "\uC911\uC559\uC544\uD504\uB9AC\uCE74\uACF5\uD654\uAD6D", nameEn: "Central African Republic", flag: "\u{1F1E8}\u{1F1EB}" },
  { code: "CG", nameKo: "\uCF69\uACE0\uACF5\uD654\uAD6D", nameEn: "Congo (Republic)", flag: "\u{1F1E8}\u{1F1EC}" },
  { code: "CH", nameKo: "\uC2A4\uC704\uC2A4", nameEn: "Switzerland", flag: "\u{1F1E8}\u{1F1ED}" },
  { code: "CI", nameKo: "\uCF54\uD2B8\uB514\uBD80\uC544\uB974", nameEn: "C\xF4te d'Ivoire", flag: "\u{1F1E8}\u{1F1EE}" },
  { code: "CK", nameKo: "\uCFE1 \uC81C\uB3C4", nameEn: "Cook Islands", flag: "\u{1F1E8}\u{1F1F0}" },
  { code: "CL", nameKo: "\uCE60\uB808", nameEn: "Chile", flag: "\u{1F1E8}\u{1F1F1}" },
  { code: "CM", nameKo: "\uCE74\uBA54\uB8EC", nameEn: "Cameroon", flag: "\u{1F1E8}\u{1F1F2}" },
  { code: "CN", nameKo: "\uC911\uAD6D", nameEn: "China", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "CO", nameKo: "\uCF5C\uB86C\uBE44\uC544", nameEn: "Colombia", flag: "\u{1F1E8}\u{1F1F4}" },
  { code: "CR", nameKo: "\uCF54\uC2A4\uD0C0\uB9AC\uCE74", nameEn: "Costa Rica", flag: "\u{1F1E8}\u{1F1F7}" },
  { code: "CU", nameKo: "\uCFE0\uBC14", nameEn: "Cuba", flag: "\u{1F1E8}\u{1F1FA}" },
  { code: "CV", nameKo: "\uCE74\uBCF4\uBCA0\uB974\uB370", nameEn: "Cabo Verde", flag: "\u{1F1E8}\u{1F1FB}" },
  { code: "CW", nameKo: "\uD034\uB77C\uC18C", nameEn: "Cura\xE7ao", flag: "\u{1F1E8}\u{1F1FC}" },
  { code: "CX", nameKo: "\uD06C\uB9AC\uC2A4\uB9C8\uC2A4\uC12C", nameEn: "Christmas Island", flag: "\u{1F1E8}\u{1F1FD}" },
  { code: "CY", nameKo: "\uD0A4\uD504\uB85C\uC2A4", nameEn: "Cyprus", flag: "\u{1F1E8}\u{1F1FE}" },
  { code: "CZ", nameKo: "\uCCB4\uCF54", nameEn: "Czechia", flag: "\u{1F1E8}\u{1F1FF}" },
  { code: "DE", nameKo: "\uB3C5\uC77C", nameEn: "Germany", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "DJ", nameKo: "\uC9C0\uBD80\uD2F0", nameEn: "Djibouti", flag: "\u{1F1E9}\u{1F1EF}" },
  { code: "DK", nameKo: "\uB374\uB9C8\uD06C", nameEn: "Denmark", flag: "\u{1F1E9}\u{1F1F0}" },
  { code: "DM", nameKo: "\uB3C4\uBBF8\uB2C8\uCE74", nameEn: "Dominica", flag: "\u{1F1E9}\u{1F1F2}" },
  { code: "DO", nameKo: "\uB3C4\uBBF8\uB2C8\uCE74\uACF5\uD654\uAD6D", nameEn: "Dominican Republic", flag: "\u{1F1E9}\u{1F1F4}" },
  { code: "DZ", nameKo: "\uC54C\uC81C\uB9AC", nameEn: "Algeria", flag: "\u{1F1E9}\u{1F1FF}" },
  { code: "EC", nameKo: "\uC5D0\uCF70\uB3C4\uB974", nameEn: "Ecuador", flag: "\u{1F1EA}\u{1F1E8}" },
  { code: "EE", nameKo: "\uC5D0\uC2A4\uD1A0\uB2C8\uC544", nameEn: "Estonia", flag: "\u{1F1EA}\u{1F1EA}" },
  { code: "EG", nameKo: "\uC774\uC9D1\uD2B8", nameEn: "Egypt", flag: "\u{1F1EA}\u{1F1EC}" },
  { code: "EH", nameKo: "\uC11C\uC0AC\uD558\uB77C", nameEn: "Western Sahara", flag: "\u{1F1EA}\u{1F1ED}" },
  { code: "ER", nameKo: "\uC5D0\uB9AC\uD2B8\uB808\uC544", nameEn: "Eritrea", flag: "\u{1F1EA}\u{1F1F7}" },
  { code: "ES", nameKo: "\uC2A4\uD398\uC778", nameEn: "Spain", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "ET", nameKo: "\uC5D0\uD2F0\uC624\uD53C\uC544", nameEn: "Ethiopia", flag: "\u{1F1EA}\u{1F1F9}" },
  { code: "FI", nameKo: "\uD540\uB780\uB4DC", nameEn: "Finland", flag: "\u{1F1EB}\u{1F1EE}" },
  { code: "FJ", nameKo: "\uD53C\uC9C0", nameEn: "Fiji", flag: "\u{1F1EB}\u{1F1EF}" },
  { code: "FK", nameKo: "\uD3EC\uD074\uB79C\uB4DC \uC81C\uB3C4", nameEn: "Falkland Islands", flag: "\u{1F1EB}\u{1F1F0}" },
  { code: "FM", nameKo: "\uBBF8\uD06C\uB85C\uB124\uC2DC\uC544 \uC5F0\uBC29", nameEn: "Micronesia", flag: "\u{1F1EB}\u{1F1F2}" },
  { code: "FO", nameKo: "\uD398\uB85C \uC81C\uB3C4", nameEn: "Faroe Islands", flag: "\u{1F1EB}\u{1F1F4}" },
  { code: "FR", nameKo: "\uD504\uB791\uC2A4", nameEn: "France", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "GA", nameKo: "\uAC00\uBD09", nameEn: "Gabon", flag: "\u{1F1EC}\u{1F1E6}" },
  { code: "GB", nameKo: "\uC601\uAD6D", nameEn: "United Kingdom", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "GD", nameKo: "\uADF8\uB808\uB098\uB2E4", nameEn: "Grenada", flag: "\u{1F1EC}\u{1F1E9}" },
  { code: "GE", nameKo: "\uC870\uC9C0\uC544", nameEn: "Georgia", flag: "\u{1F1EC}\u{1F1EA}" },
  { code: "GF", nameKo: "\uD504\uB791\uC2A4\uB839 \uAE30\uC544\uB098", nameEn: "French Guiana", flag: "\u{1F1EC}\u{1F1EB}" },
  { code: "GG", nameKo: "\uAC74\uC9C0", nameEn: "Guernsey", flag: "\u{1F1EC}\u{1F1EC}" },
  { code: "GH", nameKo: "\uAC00\uB098", nameEn: "Ghana", flag: "\u{1F1EC}\u{1F1ED}" },
  { code: "GI", nameKo: "\uC9C0\uBE0C\uB864\uD130", nameEn: "Gibraltar", flag: "\u{1F1EC}\u{1F1EE}" },
  { code: "GL", nameKo: "\uADF8\uB9B0\uB780\uB4DC", nameEn: "Greenland", flag: "\u{1F1EC}\u{1F1F1}" },
  { code: "GM", nameKo: "\uAC10\uBE44\uC544", nameEn: "Gambia", flag: "\u{1F1EC}\u{1F1F2}" },
  { code: "GN", nameKo: "\uAE30\uB2C8", nameEn: "Guinea", flag: "\u{1F1EC}\u{1F1F3}" },
  { code: "GP", nameKo: "\uACFC\uB4E4\uB8E8\uD504", nameEn: "Guadeloupe", flag: "\u{1F1EC}\u{1F1F5}" },
  { code: "GQ", nameKo: "\uC801\uB3C4\uAE30\uB2C8", nameEn: "Equatorial Guinea", flag: "\u{1F1EC}\u{1F1F6}" },
  { code: "GR", nameKo: "\uADF8\uB9AC\uC2A4", nameEn: "Greece", flag: "\u{1F1EC}\u{1F1F7}" },
  { code: "GS", nameKo: "\uC0AC\uC6B0\uC2A4\uC870\uC9C0\uC544 \uC0AC\uC6B0\uC2A4\uC0CC\uB4DC\uC704\uCE58 \uC81C\uB3C4", nameEn: "South Georgia", flag: "\u{1F1EC}\u{1F1F8}" },
  { code: "GT", nameKo: "\uACFC\uD14C\uB9D0\uB77C", nameEn: "Guatemala", flag: "\u{1F1EC}\u{1F1F9}" },
  { code: "GU", nameKo: "\uAD0C", nameEn: "Guam", flag: "\u{1F1EC}\u{1F1FA}" },
  { code: "GW", nameKo: "\uAE30\uB2C8\uBE44\uC0AC\uC6B0", nameEn: "Guinea-Bissau", flag: "\u{1F1EC}\u{1F1FC}" },
  { code: "GY", nameKo: "\uAC00\uC774\uC544\uB098", nameEn: "Guyana", flag: "\u{1F1EC}\u{1F1FE}" },
  { code: "HK", nameKo: "\uD64D\uCF69", nameEn: "Hong Kong", flag: "\u{1F1ED}\u{1F1F0}" },
  { code: "HM", nameKo: "\uD5C8\uB4DC \uB9E5\uB3C4\uB110\uB4DC \uC81C\uB3C4", nameEn: "Heard and McDonald Islands", flag: "\u{1F1ED}\u{1F1F2}" },
  { code: "HN", nameKo: "\uC628\uB450\uB77C\uC2A4", nameEn: "Honduras", flag: "\u{1F1ED}\u{1F1F3}" },
  { code: "HR", nameKo: "\uD06C\uB85C\uC544\uD2F0\uC544", nameEn: "Croatia", flag: "\u{1F1ED}\u{1F1F7}" },
  { code: "HT", nameKo: "\uC544\uC774\uD2F0", nameEn: "Haiti", flag: "\u{1F1ED}\u{1F1F9}" },
  { code: "HU", nameKo: "\uD5DD\uAC00\uB9AC", nameEn: "Hungary", flag: "\u{1F1ED}\u{1F1FA}" },
  { code: "ID", nameKo: "\uC778\uB3C4\uB124\uC2DC\uC544", nameEn: "Indonesia", flag: "\u{1F1EE}\u{1F1E9}" },
  { code: "IE", nameKo: "\uC544\uC77C\uB79C\uB4DC", nameEn: "Ireland", flag: "\u{1F1EE}\u{1F1EA}" },
  { code: "IL", nameKo: "\uC774\uC2A4\uB77C\uC5D8", nameEn: "Israel", flag: "\u{1F1EE}\u{1F1F1}" },
  { code: "IM", nameKo: "\uB9E8\uC12C", nameEn: "Isle of Man", flag: "\u{1F1EE}\u{1F1F2}" },
  { code: "IN", nameKo: "\uC778\uB3C4", nameEn: "India", flag: "\u{1F1EE}\u{1F1F3}" },
  {
    code: "IO",
    nameKo: "\uC601\uAD6D\uB839 \uC778\uB3C4\uC591 \uC9C0\uC5ED",
    nameEn: "British Indian Ocean Territory",
    flag: "\u{1F1EE}\u{1F1F4}"
  },
  { code: "IQ", nameKo: "\uC774\uB77C\uD06C", nameEn: "Iraq", flag: "\u{1F1EE}\u{1F1F6}" },
  { code: "IR", nameKo: "\uC774\uB780", nameEn: "Iran", flag: "\u{1F1EE}\u{1F1F7}" },
  { code: "IS", nameKo: "\uC544\uC774\uC2AC\uB780\uB4DC", nameEn: "Iceland", flag: "\u{1F1EE}\u{1F1F8}" },
  { code: "IT", nameKo: "\uC774\uD0C8\uB9AC\uC544", nameEn: "Italy", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "JE", nameKo: "\uC800\uC9C0", nameEn: "Jersey", flag: "\u{1F1EF}\u{1F1EA}" },
  { code: "JM", nameKo: "\uC790\uBA54\uC774\uCE74", nameEn: "Jamaica", flag: "\u{1F1EF}\u{1F1F2}" },
  { code: "JO", nameKo: "\uC694\uB974\uB2E8", nameEn: "Jordan", flag: "\u{1F1EF}\u{1F1F4}" },
  { code: "JP", nameKo: "\uC77C\uBCF8", nameEn: "Japan", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "KE", nameKo: "\uCF00\uB0D0", nameEn: "Kenya", flag: "\u{1F1F0}\u{1F1EA}" },
  { code: "KG", nameKo: "\uD0A4\uB974\uAE30\uC2A4\uC2A4\uD0C4", nameEn: "Kyrgyzstan", flag: "\u{1F1F0}\u{1F1EC}" },
  { code: "KH", nameKo: "\uCE84\uBCF4\uB514\uC544", nameEn: "Cambodia", flag: "\u{1F1F0}\u{1F1ED}" },
  { code: "KI", nameKo: "\uD0A4\uB9AC\uBC14\uC2DC", nameEn: "Kiribati", flag: "\u{1F1F0}\u{1F1EE}" },
  { code: "KM", nameKo: "\uCF54\uBAA8\uB85C", nameEn: "Comoros", flag: "\u{1F1F0}\u{1F1F2}" },
  { code: "KN", nameKo: "\uC138\uC778\uD2B8\uD0A4\uCE20 \uB124\uBE44\uC2A4", nameEn: "Saint Kitts and Nevis", flag: "\u{1F1F0}\u{1F1F3}" },
  { code: "KP", nameKo: "\uBD81\uD55C", nameEn: "North Korea", flag: "\u{1F1F0}\u{1F1F5}" },
  { code: "KR", nameKo: "\uB300\uD55C\uBBFC\uAD6D", nameEn: "South Korea", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "KW", nameKo: "\uCFE0\uC6E8\uC774\uD2B8", nameEn: "Kuwait", flag: "\u{1F1F0}\u{1F1FC}" },
  { code: "KY", nameKo: "\uCF00\uC774\uB9E8 \uC81C\uB3C4", nameEn: "Cayman Islands", flag: "\u{1F1F0}\u{1F1FE}" },
  { code: "KZ", nameKo: "\uCE74\uC790\uD750\uC2A4\uD0C4", nameEn: "Kazakhstan", flag: "\u{1F1F0}\u{1F1FF}" },
  { code: "LA", nameKo: "\uB77C\uC624\uC2A4", nameEn: "Laos", flag: "\u{1F1F1}\u{1F1E6}" },
  { code: "LB", nameKo: "\uB808\uBC14\uB17C", nameEn: "Lebanon", flag: "\u{1F1F1}\u{1F1E7}" },
  { code: "LC", nameKo: "\uC138\uC778\uD2B8\uB8E8\uC2DC\uC544", nameEn: "Saint Lucia", flag: "\u{1F1F1}\u{1F1E8}" },
  { code: "LI", nameKo: "\uB9AC\uD788\uD150\uC288\uD0C0\uC778", nameEn: "Liechtenstein", flag: "\u{1F1F1}\u{1F1EE}" },
  { code: "LK", nameKo: "\uC2A4\uB9AC\uB791\uCE74", nameEn: "Sri Lanka", flag: "\u{1F1F1}\u{1F1F0}" },
  { code: "LR", nameKo: "\uB77C\uC774\uBCA0\uB9AC\uC544", nameEn: "Liberia", flag: "\u{1F1F1}\u{1F1F7}" },
  { code: "LS", nameKo: "\uB808\uC18C\uD1A0", nameEn: "Lesotho", flag: "\u{1F1F1}\u{1F1F8}" },
  { code: "LT", nameKo: "\uB9AC\uD22C\uC544\uB2C8\uC544", nameEn: "Lithuania", flag: "\u{1F1F1}\u{1F1F9}" },
  { code: "LU", nameKo: "\uB8E9\uC148\uBD80\uB974\uD06C", nameEn: "Luxembourg", flag: "\u{1F1F1}\u{1F1FA}" },
  { code: "LV", nameKo: "\uB77C\uD2B8\uBE44\uC544", nameEn: "Latvia", flag: "\u{1F1F1}\u{1F1FB}" },
  { code: "LY", nameKo: "\uB9AC\uBE44\uC544", nameEn: "Libya", flag: "\u{1F1F1}\u{1F1FE}" },
  { code: "MA", nameKo: "\uBAA8\uB85C\uCF54", nameEn: "Morocco", flag: "\u{1F1F2}\u{1F1E6}" },
  { code: "MC", nameKo: "\uBAA8\uB098\uCF54", nameEn: "Monaco", flag: "\u{1F1F2}\u{1F1E8}" },
  { code: "MD", nameKo: "\uBAB0\uB3C4\uBC14", nameEn: "Moldova", flag: "\u{1F1F2}\u{1F1E9}" },
  { code: "ME", nameKo: "\uBAAC\uD14C\uB124\uADF8\uB85C", nameEn: "Montenegro", flag: "\u{1F1F2}\u{1F1EA}" },
  { code: "MF", nameKo: "\uC0DD\uB9C8\uB974\uD0F1", nameEn: "Saint Martin (French)", flag: "\u{1F1F2}\u{1F1EB}" },
  { code: "MG", nameKo: "\uB9C8\uB2E4\uAC00\uC2A4\uCE74\uB974", nameEn: "Madagascar", flag: "\u{1F1F2}\u{1F1EC}" },
  { code: "MH", nameKo: "\uB9C8\uC15C \uC81C\uB3C4", nameEn: "Marshall Islands", flag: "\u{1F1F2}\u{1F1ED}" },
  { code: "MK", nameKo: "\uBD81\uB9C8\uCF00\uB3C4\uB2C8\uC544", nameEn: "North Macedonia", flag: "\u{1F1F2}\u{1F1F0}" },
  { code: "ML", nameKo: "\uB9D0\uB9AC", nameEn: "Mali", flag: "\u{1F1F2}\u{1F1F1}" },
  { code: "MM", nameKo: "\uBBF8\uC580\uB9C8", nameEn: "Myanmar", flag: "\u{1F1F2}\u{1F1F2}" },
  { code: "MN", nameKo: "\uBABD\uACE8", nameEn: "Mongolia", flag: "\u{1F1F2}\u{1F1F3}" },
  { code: "MO", nameKo: "\uB9C8\uCE74\uC624", nameEn: "Macao", flag: "\u{1F1F2}\u{1F1F4}" },
  { code: "MP", nameKo: "\uBD81\uB9C8\uB9AC\uC544\uB098 \uC81C\uB3C4", nameEn: "Northern Mariana Islands", flag: "\u{1F1F2}\u{1F1F5}" },
  { code: "MQ", nameKo: "\uB9C8\uB974\uD2F0\uB2C8\uD06C", nameEn: "Martinique", flag: "\u{1F1F2}\u{1F1F6}" },
  { code: "MR", nameKo: "\uBAA8\uB9AC\uD0C0\uB2C8", nameEn: "Mauritania", flag: "\u{1F1F2}\u{1F1F7}" },
  { code: "MS", nameKo: "\uBAAC\uD2B8\uC138\uB7AB", nameEn: "Montserrat", flag: "\u{1F1F2}\u{1F1F8}" },
  { code: "MT", nameKo: "\uBAB0\uD0C0", nameEn: "Malta", flag: "\u{1F1F2}\u{1F1F9}" },
  { code: "MU", nameKo: "\uBAA8\uB9AC\uC154\uC2A4", nameEn: "Mauritius", flag: "\u{1F1F2}\u{1F1FA}" },
  { code: "MV", nameKo: "\uBAB0\uB514\uBE0C", nameEn: "Maldives", flag: "\u{1F1F2}\u{1F1FB}" },
  { code: "MW", nameKo: "\uB9D0\uB77C\uC704", nameEn: "Malawi", flag: "\u{1F1F2}\u{1F1FC}" },
  { code: "MX", nameKo: "\uBA55\uC2DC\uCF54", nameEn: "Mexico", flag: "\u{1F1F2}\u{1F1FD}" },
  { code: "MY", nameKo: "\uB9D0\uB808\uC774\uC2DC\uC544", nameEn: "Malaysia", flag: "\u{1F1F2}\u{1F1FE}" },
  { code: "MZ", nameKo: "\uBAA8\uC7A0\uBE44\uD06C", nameEn: "Mozambique", flag: "\u{1F1F2}\u{1F1FF}" },
  { code: "NA", nameKo: "\uB098\uBBF8\uBE44\uC544", nameEn: "Namibia", flag: "\u{1F1F3}\u{1F1E6}" },
  { code: "NC", nameKo: "\uB274\uCE7C\uB808\uB3C4\uB2C8\uC544", nameEn: "New Caledonia", flag: "\u{1F1F3}\u{1F1E8}" },
  { code: "NE", nameKo: "\uB2C8\uC81C\uB974", nameEn: "Niger", flag: "\u{1F1F3}\u{1F1EA}" },
  { code: "NF", nameKo: "\uB178\uD37D\uC12C", nameEn: "Norfolk Island", flag: "\u{1F1F3}\u{1F1EB}" },
  { code: "NG", nameKo: "\uB098\uC774\uC9C0\uB9AC\uC544", nameEn: "Nigeria", flag: "\u{1F1F3}\u{1F1EC}" },
  { code: "NI", nameKo: "\uB2C8\uCE74\uB77C\uACFC", nameEn: "Nicaragua", flag: "\u{1F1F3}\u{1F1EE}" },
  { code: "NL", nameKo: "\uB124\uB35C\uB780\uB4DC", nameEn: "Netherlands", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "NO", nameKo: "\uB178\uB974\uC6E8\uC774", nameEn: "Norway", flag: "\u{1F1F3}\u{1F1F4}" },
  { code: "NP", nameKo: "\uB124\uD314", nameEn: "Nepal", flag: "\u{1F1F3}\u{1F1F5}" },
  { code: "NR", nameKo: "\uB098\uC6B0\uB8E8", nameEn: "Nauru", flag: "\u{1F1F3}\u{1F1F7}" },
  { code: "NU", nameKo: "\uB2C8\uC6B0\uC5D0", nameEn: "Niue", flag: "\u{1F1F3}\u{1F1FA}" },
  { code: "NZ", nameKo: "\uB274\uC9C8\uB79C\uB4DC", nameEn: "New Zealand", flag: "\u{1F1F3}\u{1F1FF}" },
  { code: "OM", nameKo: "\uC624\uB9CC", nameEn: "Oman", flag: "\u{1F1F4}\u{1F1F2}" },
  { code: "PA", nameKo: "\uD30C\uB098\uB9C8", nameEn: "Panama", flag: "\u{1F1F5}\u{1F1E6}" },
  { code: "PE", nameKo: "\uD398\uB8E8", nameEn: "Peru", flag: "\u{1F1F5}\u{1F1EA}" },
  { code: "PF", nameKo: "\uD504\uB791\uC2A4\uB839 \uD3F4\uB9AC\uB124\uC2DC\uC544", nameEn: "French Polynesia", flag: "\u{1F1F5}\u{1F1EB}" },
  { code: "PG", nameKo: "\uD30C\uD478\uC544\uB274\uAE30\uB2C8", nameEn: "Papua New Guinea", flag: "\u{1F1F5}\u{1F1EC}" },
  { code: "PH", nameKo: "\uD544\uB9AC\uD540", nameEn: "Philippines", flag: "\u{1F1F5}\u{1F1ED}" },
  { code: "PK", nameKo: "\uD30C\uD0A4\uC2A4\uD0C4", nameEn: "Pakistan", flag: "\u{1F1F5}\u{1F1F0}" },
  { code: "PL", nameKo: "\uD3F4\uB780\uB4DC", nameEn: "Poland", flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "PM", nameKo: "\uC0DD\uD53C\uC5D0\uB974 \uBBF8\uD074\uB871", nameEn: "Saint Pierre and Miquelon", flag: "\u{1F1F5}\u{1F1F2}" },
  { code: "PN", nameKo: "\uD54F\uCF00\uC5B8 \uC81C\uB3C4", nameEn: "Pitcairn Islands", flag: "\u{1F1F5}\u{1F1F3}" },
  { code: "PR", nameKo: "\uD478\uC5D0\uB974\uD1A0\uB9AC\uCF54", nameEn: "Puerto Rico", flag: "\u{1F1F5}\u{1F1F7}" },
  { code: "PS", nameKo: "\uD314\uB808\uC2A4\uD0C0\uC778", nameEn: "Palestine", flag: "\u{1F1F5}\u{1F1F8}" },
  { code: "PT", nameKo: "\uD3EC\uB974\uD22C\uAC08", nameEn: "Portugal", flag: "\u{1F1F5}\u{1F1F9}" },
  { code: "PW", nameKo: "\uD314\uB77C\uC6B0", nameEn: "Palau", flag: "\u{1F1F5}\u{1F1FC}" },
  { code: "PY", nameKo: "\uD30C\uB77C\uACFC\uC774", nameEn: "Paraguay", flag: "\u{1F1F5}\u{1F1FE}" },
  { code: "QA", nameKo: "\uCE74\uD0C0\uB974", nameEn: "Qatar", flag: "\u{1F1F6}\u{1F1E6}" },
  { code: "RE", nameKo: "\uB808\uC704\uB2C8\uC639", nameEn: "R\xE9union", flag: "\u{1F1F7}\u{1F1EA}" },
  { code: "RO", nameKo: "\uB8E8\uB9C8\uB2C8\uC544", nameEn: "Romania", flag: "\u{1F1F7}\u{1F1F4}" },
  { code: "RS", nameKo: "\uC138\uB974\uBE44\uC544", nameEn: "Serbia", flag: "\u{1F1F7}\u{1F1F8}" },
  { code: "RU", nameKo: "\uB7EC\uC2DC\uC544", nameEn: "Russia", flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "RW", nameKo: "\uB974\uC644\uB2E4", nameEn: "Rwanda", flag: "\u{1F1F7}\u{1F1FC}" },
  { code: "SA", nameKo: "\uC0AC\uC6B0\uB514\uC544\uB77C\uBE44\uC544", nameEn: "Saudi Arabia", flag: "\u{1F1F8}\u{1F1E6}" },
  { code: "SB", nameKo: "\uC194\uB85C\uBAAC \uC81C\uB3C4", nameEn: "Solomon Islands", flag: "\u{1F1F8}\u{1F1E7}" },
  { code: "SC", nameKo: "\uC138\uC774\uC178", nameEn: "Seychelles", flag: "\u{1F1F8}\u{1F1E8}" },
  { code: "SD", nameKo: "\uC218\uB2E8", nameEn: "Sudan", flag: "\u{1F1F8}\u{1F1E9}" },
  { code: "SE", nameKo: "\uC2A4\uC6E8\uB374", nameEn: "Sweden", flag: "\u{1F1F8}\u{1F1EA}" },
  { code: "SG", nameKo: "\uC2F1\uAC00\uD3EC\uB974", nameEn: "Singapore", flag: "\u{1F1F8}\u{1F1EC}" },
  { code: "SH", nameKo: "\uC138\uC778\uD2B8\uD5EC\uB808\uB098", nameEn: "Saint Helena", flag: "\u{1F1F8}\u{1F1ED}" },
  { code: "SI", nameKo: "\uC2AC\uB85C\uBCA0\uB2C8\uC544", nameEn: "Slovenia", flag: "\u{1F1F8}\u{1F1EE}" },
  { code: "SJ", nameKo: "\uC2A4\uBC1C\uBC14\uB974 \uC580\uB9C8\uC60C", nameEn: "Svalbard and Jan Mayen", flag: "\u{1F1F8}\u{1F1EF}" },
  { code: "SK", nameKo: "\uC2AC\uB85C\uBC14\uD0A4\uC544", nameEn: "Slovakia", flag: "\u{1F1F8}\u{1F1F0}" },
  { code: "SL", nameKo: "\uC2DC\uC5D0\uB77C\uB9AC\uC628", nameEn: "Sierra Leone", flag: "\u{1F1F8}\u{1F1F1}" },
  { code: "SM", nameKo: "\uC0B0\uB9C8\uB9AC\uB178", nameEn: "San Marino", flag: "\u{1F1F8}\u{1F1F2}" },
  { code: "SN", nameKo: "\uC138\uB124\uAC08", nameEn: "Senegal", flag: "\u{1F1F8}\u{1F1F3}" },
  { code: "SO", nameKo: "\uC18C\uB9D0\uB9AC\uC544", nameEn: "Somalia", flag: "\u{1F1F8}\u{1F1F4}" },
  { code: "SR", nameKo: "\uC218\uB9AC\uB0A8", nameEn: "Suriname", flag: "\u{1F1F8}\u{1F1F7}" },
  { code: "SS", nameKo: "\uB0A8\uC218\uB2E8", nameEn: "South Sudan", flag: "\u{1F1F8}\u{1F1F8}" },
  { code: "ST", nameKo: "\uC0C1\uD22C\uBA54 \uD504\uB9B0\uC2DC\uD398", nameEn: "Sao Tome and Principe", flag: "\u{1F1F8}\u{1F1F9}" },
  { code: "SV", nameKo: "\uC5D8\uC0B4\uBC14\uB3C4\uB974", nameEn: "El Salvador", flag: "\u{1F1F8}\u{1F1FB}" },
  { code: "SX", nameKo: "\uC2E0\uD2B8\uB9C8\uB974\uD134", nameEn: "Sint Maarten", flag: "\u{1F1F8}\u{1F1FD}" },
  { code: "SY", nameKo: "\uC2DC\uB9AC\uC544", nameEn: "Syria", flag: "\u{1F1F8}\u{1F1FE}" },
  { code: "SZ", nameKo: "\uC5D0\uC2A4\uC640\uD2F0\uB2C8", nameEn: "Eswatini", flag: "\u{1F1F8}\u{1F1FF}" },
  { code: "TC", nameKo: "\uD130\uD06C\uC2A4 \uCF00\uC774\uCEE4\uC2A4 \uC81C\uB3C4", nameEn: "Turks and Caicos", flag: "\u{1F1F9}\u{1F1E8}" },
  { code: "TD", nameKo: "\uCC28\uB4DC", nameEn: "Chad", flag: "\u{1F1F9}\u{1F1E9}" },
  {
    code: "TF",
    nameKo: "\uD504\uB791\uC2A4\uB839 \uB0A8\uBC29 \uBC0F \uB0A8\uADF9",
    nameEn: "French Southern Territories",
    flag: "\u{1F1F9}\u{1F1EB}"
  },
  { code: "TG", nameKo: "\uD1A0\uACE0", nameEn: "Togo", flag: "\u{1F1F9}\u{1F1EC}" },
  { code: "TH", nameKo: "\uD0DC\uAD6D", nameEn: "Thailand", flag: "\u{1F1F9}\u{1F1ED}" },
  { code: "TJ", nameKo: "\uD0C0\uC9C0\uD0A4\uC2A4\uD0C4", nameEn: "Tajikistan", flag: "\u{1F1F9}\u{1F1EF}" },
  { code: "TK", nameKo: "\uD1A0\uCF08\uB77C\uC6B0", nameEn: "Tokelau", flag: "\u{1F1F9}\u{1F1F0}" },
  { code: "TL", nameKo: "\uB3D9\uD2F0\uBAA8\uB974", nameEn: "Timor-Leste", flag: "\u{1F1F9}\u{1F1F1}" },
  { code: "TM", nameKo: "\uD22C\uB974\uD06C\uBA54\uB2C8\uC2A4\uD0C4", nameEn: "Turkmenistan", flag: "\u{1F1F9}\u{1F1F2}" },
  { code: "TN", nameKo: "\uD280\uB2C8\uC9C0", nameEn: "Tunisia", flag: "\u{1F1F9}\u{1F1F3}" },
  { code: "TO", nameKo: "\uD1B5\uAC00", nameEn: "Tonga", flag: "\u{1F1F9}\u{1F1F4}" },
  { code: "TR", nameKo: "\uD280\uB974\uD0A4\uC608", nameEn: "T\xFCrkiye", flag: "\u{1F1F9}\u{1F1F7}" },
  { code: "TT", nameKo: "\uD2B8\uB9AC\uB2C8\uB2E4\uB4DC \uD1A0\uBC14\uACE0", nameEn: "Trinidad and Tobago", flag: "\u{1F1F9}\u{1F1F9}" },
  { code: "TV", nameKo: "\uD22C\uBC1C\uB8E8", nameEn: "Tuvalu", flag: "\u{1F1F9}\u{1F1FB}" },
  { code: "TW", nameKo: "\uB300\uB9CC", nameEn: "Taiwan", flag: "\u{1F1F9}\u{1F1FC}" },
  { code: "TZ", nameKo: "\uD0C4\uC790\uB2C8\uC544", nameEn: "Tanzania", flag: "\u{1F1F9}\u{1F1FF}" },
  { code: "UA", nameKo: "\uC6B0\uD06C\uB77C\uC774\uB098", nameEn: "Ukraine", flag: "\u{1F1FA}\u{1F1E6}" },
  { code: "UG", nameKo: "\uC6B0\uAC04\uB2E4", nameEn: "Uganda", flag: "\u{1F1FA}\u{1F1EC}" },
  {
    code: "UM",
    nameKo: "\uBBF8\uAD6D\uB839 \uAD70\uC18C \uC81C\uB3C4",
    nameEn: "United States Minor Outlying Islands",
    flag: "\u{1F1FA}\u{1F1F2}"
  },
  { code: "US", nameKo: "\uBBF8\uAD6D", nameEn: "United States", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "UY", nameKo: "\uC6B0\uB8E8\uACFC\uC774", nameEn: "Uruguay", flag: "\u{1F1FA}\u{1F1FE}" },
  { code: "UZ", nameKo: "\uC6B0\uC988\uBCA0\uD0A4\uC2A4\uD0C4", nameEn: "Uzbekistan", flag: "\u{1F1FA}\u{1F1FF}" },
  { code: "VA", nameKo: "\uBC14\uD2F0\uCE78", nameEn: "Vatican City", flag: "\u{1F1FB}\u{1F1E6}" },
  {
    code: "VC",
    nameKo: "\uC138\uC778\uD2B8\uBE48\uC13C\uD2B8 \uADF8\uB808\uB098\uB518",
    nameEn: "Saint Vincent and the Grenadines",
    flag: "\u{1F1FB}\u{1F1E8}"
  },
  { code: "VE", nameKo: "\uBCA0\uB124\uC218\uC5D8\uB77C", nameEn: "Venezuela", flag: "\u{1F1FB}\u{1F1EA}" },
  { code: "VG", nameKo: "\uC601\uAD6D\uB839 \uBC84\uC9C4\uC544\uC77C\uB79C\uB4DC", nameEn: "British Virgin Islands", flag: "\u{1F1FB}\u{1F1EC}" },
  { code: "VI", nameKo: "\uBBF8\uAD6D\uB839 \uBC84\uC9C4\uC544\uC77C\uB79C\uB4DC", nameEn: "U.S. Virgin Islands", flag: "\u{1F1FB}\u{1F1EE}" },
  { code: "VN", nameKo: "\uBCA0\uD2B8\uB0A8", nameEn: "Vietnam", flag: "\u{1F1FB}\u{1F1F3}" },
  { code: "VU", nameKo: "\uBC14\uB204\uC544\uD22C", nameEn: "Vanuatu", flag: "\u{1F1FB}\u{1F1FA}" },
  { code: "WF", nameKo: "\uC648\uB9AC\uC2A4 \uD478\uD22C\uB098", nameEn: "Wallis and Futuna", flag: "\u{1F1FC}\u{1F1EB}" },
  { code: "WS", nameKo: "\uC0AC\uBAA8\uC544", nameEn: "Samoa", flag: "\u{1F1FC}\u{1F1F8}" },
  { code: "YE", nameKo: "\uC608\uBA58", nameEn: "Yemen", flag: "\u{1F1FE}\u{1F1EA}" },
  { code: "YT", nameKo: "\uB9C8\uC694\uD2B8", nameEn: "Mayotte", flag: "\u{1F1FE}\u{1F1F9}" },
  { code: "ZA", nameKo: "\uB0A8\uC544\uD504\uB9AC\uCE74\uACF5\uD654\uAD6D", nameEn: "South Africa", flag: "\u{1F1FF}\u{1F1E6}" },
  { code: "ZM", nameKo: "\uC7A0\uBE44\uC544", nameEn: "Zambia", flag: "\u{1F1FF}\u{1F1F2}" },
  { code: "ZW", nameKo: "\uC9D0\uBC14\uBE0C\uC6E8", nameEn: "Zimbabwe", flag: "\u{1F1FF}\u{1F1FC}" }
];
var ISO_COUNTRY_BY_CODE = new Map(
  ISO_COUNTRIES.map((c) => [c.code, c])
);
function isValidIsoCountry(code) {
  return ISO_COUNTRY_BY_CODE.has(code);
}
function getIsoCountryNameKo(code) {
  return ISO_COUNTRY_BY_CODE.get(code)?.nameKo ?? code;
}
function formatIsoCountryDisplay(code) {
  const c = ISO_COUNTRY_BY_CODE.get(code);
  return c ? `${c.flag} ${c.nameKo}` : code;
}

// src/common/validation.ts
import { z } from "zod";
var USERNAME_MIN_LENGTH = 3;
var USERNAME_MAX_LENGTH = 20;
var USERNAME_PATTERN = /^[a-zA-Z0-9_]+$/;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
var LEGAL_NAME_MIN_LENGTH = 2;
var LEGAL_NAME_MAX_LENGTH = 50;
var CREVASSE_EMAIL_DOMAIN = "@crevasse.ai";
var MESSAGE_CONTENT_MAX_LENGTH = 5e3;
var PROOF_DESCRIPTION_MAX_LENGTH = 5e3;
var POINTS_MIN = 0;
var REWARD_POINTS_MIN = 0;
var CHECKPOINT_ORDER_MIN = 0;
var UsernameSchema = z.string().min(USERNAME_MIN_LENGTH, `\uC0AC\uC6A9\uC790\uBA85\uC740 \uCD5C\uC18C ${USERNAME_MIN_LENGTH}\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`).max(USERNAME_MAX_LENGTH, `\uC0AC\uC6A9\uC790\uBA85\uC740 \uCD5C\uB300 ${USERNAME_MAX_LENGTH}\uC790\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4`).regex(USERNAME_PATTERN, "\uC0AC\uC6A9\uC790\uBA85\uC740 \uC601\uBB38, \uC22B\uC790, \uBC11\uC904(_)\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4");
var PasswordSchema = z.string().min(PASSWORD_MIN_LENGTH, `\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uC18C ${PASSWORD_MIN_LENGTH}\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`).regex(
  PASSWORD_PATTERN,
  "\uBE44\uBC00\uBC88\uD638\uB294 \uB300\uBB38\uC790, \uC18C\uBB38\uC790, \uC22B\uC790, \uD2B9\uC218\uBB38\uC790(@$!%*?&)\uB97C \uAC01\uAC01 1\uAC1C \uC774\uC0C1 \uD3EC\uD568\uD574\uC57C \uD569\uB2C8\uB2E4"
);
var LegalNameSchema = z.string().min(LEGAL_NAME_MIN_LENGTH, `\uC774\uB984\uC740 \uCD5C\uC18C ${LEGAL_NAME_MIN_LENGTH}\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`).max(LEGAL_NAME_MAX_LENGTH, `\uC774\uB984\uC740 \uCD5C\uB300 ${LEGAL_NAME_MAX_LENGTH}\uC790\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4`);
var EmailSchema = z.email("\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4");
var CrevasseEmailSchema = EmailSchema.refine(
  (email) => email.endsWith(CREVASSE_EMAIL_DOMAIN),
  { message: `${CREVASSE_EMAIL_DOMAIN} \uC774\uBA54\uC77C\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4` }
);
var MessageContentSchema = z.string().max(
  MESSAGE_CONTENT_MAX_LENGTH,
  `\uBA54\uC2DC\uC9C0\uB294 \uCD5C\uB300 ${MESSAGE_CONTENT_MAX_LENGTH}\uC790\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4`
);
var PointsSchema = z.number().int("\uC815\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4").min(POINTS_MIN, `\uD3EC\uC778\uD2B8\uB294 ${POINTS_MIN} \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`);
var RewardPointsSchema = z.number().int("\uC815\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4").min(REWARD_POINTS_MIN, `\uBCF4\uC0C1 \uD3EC\uC778\uD2B8\uB294 ${REWARD_POINTS_MIN} \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`);
var CheckpointOrderSchema = z.number().int("\uC815\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4").min(CHECKPOINT_ORDER_MIN, `\uCCB4\uD06C\uD3EC\uC778\uD2B8 \uC21C\uC11C\uB294 ${CHECKPOINT_ORDER_MIN} \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`);
var IsoCountryCodeSchema = z.string().regex(/^[A-Z]{2}$/, "ISO 3166-1 alpha-2 \uD615\uC2DD\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4 (\uC608: KR, US)").refine(isValidIsoCountry, { message: "\uC54C \uC218 \uC5C6\uB294 \uAD6D\uAC00 \uCF54\uB4DC\uC785\uB2C8\uB2E4" });
var IsoCountryCodeArraySchema = z.array(IsoCountryCodeSchema);
var DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
function isValidDateOnly(value) {
  if (!DATE_ONLY_PATTERN.test(value)) {
    return false;
  }
  const [yearPart, monthPart, dayPart] = value.split("-");
  const year = Number(yearPart);
  const month = Number(monthPart);
  const day = Number(dayPart);
  const utcDate2 = new Date(Date.UTC(year, month - 1, day));
  return utcDate2.getUTCFullYear() === year && utcDate2.getUTCMonth() === month - 1 && utcDate2.getUTCDate() === day;
}
var ISO8601_PATTERN = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
var Iso8601Schema = z.string().regex(ISO8601_PATTERN, "ISO 8601 \uD615\uC2DD\uC758 \uB0A0\uC9DC \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4");

// src/common/assert.ts
function assertStatus(entityName, entityId, currentValue, expected, verb, fieldName = "status") {
  if (!expected.includes(currentValue)) {
    throw new Error(
      `Cannot ${verb} ${entityName} ${entityId}: ${fieldName} is ${currentValue}, expected ${expected.join(" or ")}`
    );
  }
}

// src/common/kst.ts
import {
  format,
  startOfDay,
  startOfWeek,
  startOfMonth,
  addDays,
  isWeekend,
  eachDayOfInterval
} from "date-fns";
import { TZDate } from "@date-fns/tz";
var KST = "Asia/Seoul";
function kstDate(date2) {
  if (date2 === void 0) return new TZDate(/* @__PURE__ */ new Date(), KST);
  if (typeof date2 === "string") return new TZDate(new Date(date2), KST);
  return new TZDate(date2, KST);
}
function toKstParts(date2) {
  const kst = kstDate(date2);
  return {
    year: kst.getFullYear(),
    month: kst.getMonth() + 1,
    day: kst.getDate(),
    hour: kst.getHours(),
    minute: kst.getMinutes(),
    second: kst.getSeconds()
  };
}
function toKstDateString(date2 = /* @__PURE__ */ new Date()) {
  return format(kstDate(date2), "yyyy-MM-dd");
}
function getKstDateString(value) {
  if (value === null || value === void 0 || value === "") return "";
  const date2 = typeof value === "string" ? new Date(value) : value;
  return Number.isNaN(date2.getTime()) ? "" : toKstDateString(date2);
}
function getKstMonthDay(value) {
  return getKstDateString(value).slice(5);
}
function getKstDateAfterDays(days, now = /* @__PURE__ */ new Date()) {
  return toKstDateString(new Date(now.getTime() + days * 864e5));
}
function toKstTimeMinutes(date2) {
  const kst = kstDate(date2);
  return kst.getHours() * 60 + kst.getMinutes();
}
function getKstDayRange(now = /* @__PURE__ */ new Date()) {
  const kst = kstDate(now);
  const todayStart = startOfDay(kst);
  const tomorrowStart = addDays(todayStart, 1);
  return {
    todayStart: new Date(todayStart.getTime()),
    tomorrowStart: new Date(tomorrowStart.getTime())
  };
}
var WORK_DAY_CUTOFF_HOUR = 5;
function toKstWorkDateString(date2 = /* @__PURE__ */ new Date(), cutoffHour = WORK_DAY_CUTOFF_HOUR) {
  return toKstDateString(new Date(date2.getTime() - cutoffHour * 36e5));
}
function getKstWorkDayRange(now = /* @__PURE__ */ new Date(), cutoffHour = WORK_DAY_CUTOFF_HOUR) {
  const workDate = toKstWorkDateString(now, cutoffHour);
  const hh = String(cutoffHour).padStart(2, "0");
  const workDayStart = /* @__PURE__ */ new Date(`${workDate}T${hh}:00:00+09:00`);
  const nextWorkDayStart = new Date(workDayStart.getTime() + 24 * 36e5);
  return { workDayStart, nextWorkDayStart };
}
function getKstWorkDayLastInstant(date2, cutoffHour = WORK_DAY_CUTOFF_HOUR) {
  return new Date(getKstWorkDayRange(date2, cutoffHour).nextWorkDayStart.getTime() - 1);
}
function kstStartOfDay(date2) {
  const kst = kstDate(date2 ?? /* @__PURE__ */ new Date());
  const start = startOfDay(kst);
  return new Date(start.getTime());
}
function getKstWeekStart(now = /* @__PURE__ */ new Date()) {
  const start = startOfWeek(kstDate(now), { weekStartsOn: 1 });
  return new Date(start.getTime());
}
function getKstMonthStart(now = /* @__PURE__ */ new Date()) {
  const start = startOfMonth(kstDate(now));
  return new Date(start.getTime());
}
var KST_MONTH_OFFSET_MS = 9 * 60 * 60 * 1e3;
function getKstMonthRange(year, month) {
  return {
    start: new Date(Date.UTC(year, month - 1, 1) - KST_MONTH_OFFSET_MS),
    end: new Date(Date.UTC(year, month, 1) - KST_MONTH_OFFSET_MS)
  };
}
function getKstPeriod(date2 = /* @__PURE__ */ new Date()) {
  return format(kstDate(date2), "yyyy-MM");
}
function previousKstPeriod(period) {
  const [yearStr, monthStr] = period.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const prev = new Date(Date.UTC(year, month - 2, 1));
  return `${prev.getUTCFullYear()}-${String(prev.getUTCMonth() + 1).padStart(2, "0")}`;
}
function nextKstPeriod(period) {
  const [yearStr, monthStr] = period.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const next = new Date(Date.UTC(year, month, 1));
  return `${next.getUTCFullYear()}-${String(next.getUTCMonth() + 1).padStart(2, "0")}`;
}
function formatKstDateTime(date2) {
  return format(kstDate(date2), "yyyy-MM-dd HH:mm");
}
function formatKstTime(date2) {
  return format(kstDate(date2), "HH:mm");
}
function countWeekdays(start, end) {
  const kstStart = startOfDay(kstDate(start));
  const kstEnd = startOfDay(kstDate(end));
  const days = eachDayOfInterval({ start: kstStart, end: kstEnd });
  return days.filter((d) => !isWeekend(d)).length;
}
function formatDuration(ms) {
  if (!Number.isFinite(ms) || ms < 0) return "0h 0m";
  const totalMinutes = Math.floor(ms / 6e4);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}

// src/common/utc-date.ts
function toUtcDateString(date2) {
  return date2.toISOString().slice(0, 10);
}

// src/common/error-codes.ts
var COMMON_ERROR_CODES = {
  BAD_REQUEST: "AEG-COMMON-400-000",
  UNAUTHORIZED: "AEG-COMMON-401-000",
  FORBIDDEN: "AEG-COMMON-403-000",
  NOT_FOUND: "AEG-COMMON-404-000",
  CONFLICT: "AEG-COMMON-409-000",
  PAYLOAD_TOO_LARGE: "AEG-COMMON-413-000",
  UNPROCESSABLE_ENTITY: "AEG-COMMON-422-000",
  TOO_MANY_REQUESTS: "AEG-COMMON-429-000",
  INTERNAL_SERVER_ERROR: "AEG-COMMON-500-000"
};
var AUTH_ERROR_CODES = {
  // 400 — Bad Request
  PASSKEY_REG_CHALLENGE_NOT_FOUND: "AEG-AUTH-400-001",
  PASSKEY_REG_CHALLENGE_EXPIRED: "AEG-AUTH-400-002",
  PASSKEY_REG_VERIFICATION_FAILED: "AEG-AUTH-400-003",
  PASSKEY_NO_CREDENTIALS: "AEG-AUTH-400-004",
  PASSKEY_AUTH_CHALLENGE_NOT_FOUND: "AEG-AUTH-400-005",
  PASSKEY_AUTH_CHALLENGE_EXPIRED: "AEG-AUTH-400-006",
  PASSKEY_AUTH_VERIFICATION_FAILED: "AEG-AUTH-400-007",
  // 401 — Unauthorized
  INVALID_CREDENTIALS: "AEG-AUTH-401-001",
  ACCOUNT_DISABLED: "AEG-AUTH-401-002",
  // 입사예정(PENDING_ONBOARD) — 계정은 있으나 입사일 전이라 아직 열리지 않았다.
  // ACCOUNT_DISABLED 와 나누는 이유: 비활성 계정은 복구 요청 대상이지만 이쪽은 기다리면 열린다.
  ACCOUNT_NOT_YET_ACTIVE: "AEG-AUTH-401-005",
  // 가입 확인을 마치고 팀 배정을 기다리는 계정(PENDING_SIGNUP) — 자격 증명이 맞을 때만 나간다.
  // 미확인 가입 행은 비밀번호가 없어 없는 주소와 같은 INVALID_CREDENTIALS 를 받으므로 전용 코드가 없다
  // (87bac89b 반려 사유별 수정 3). 401-006 은 그 옛 코드 자리라 다시 쓰지 않는다.
  ACCOUNT_AWAITING_TEAM: "AEG-AUTH-401-007",
  INVALID_OTP: "AEG-AUTH-401-003",
  USER_NOT_FOUND: "AEG-AUTH-401-004",
  REFRESH_TOKEN_INVALID: "AEG-AUTH-401-010",
  REFRESH_TOKEN_REVOKED: "AEG-AUTH-401-011",
  REFRESH_TOKEN_EXPIRED: "AEG-AUTH-401-012",
  REFRESH_TOKEN_MISMATCH: "AEG-AUTH-401-013",
  RESET_TOKEN_INVALID: "AEG-AUTH-401-020",
  PASSKEY_OWNER_MISMATCH: "AEG-AUTH-403-001",
  // 404 — Not Found
  PASSKEY_NOT_FOUND: "AEG-AUTH-404-001",
  PASSKEY_USER_NOT_FOUND: "AEG-AUTH-404-002",
  OTP_USER_NOT_FOUND: "AEG-AUTH-404-003",
  ADMIN_RESET_USER_NOT_FOUND: "AEG-AUTH-404-004",
  // 409 — Conflict
  EMAIL_ALREADY_EXISTS: "AEG-AUTH-409-001"
};
var QUEST_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-QUEST-404-001",
  ACCEPTANCE_NOT_FOUND: "AEG-QUEST-404-002",
  // 400
  NOT_EDITABLE_STATUS: "AEG-QUEST-400-001",
  CREATE_FAILED: "AEG-QUEST-400-002",
  SUBMIT_APPROVAL_FAILED: "AEG-QUEST-400-003",
  APPROVAL_FAILED: "AEG-QUEST-400-004",
  REJECT_FAILED: "AEG-QUEST-400-005",
  COMPLETE_FAILED: "AEG-QUEST-400-006",
  FAIL_FAILED: "AEG-QUEST-400-007",
  ARCHIVE_FAILED: "AEG-QUEST-400-008",
  DELETE_FAILED: "AEG-QUEST-400-009",
  ACCEPT_FAILED: "AEG-QUEST-400-010",
  DROP_FAILED: "AEG-QUEST-400-011",
  OUTBREAK_FAILED: "AEG-QUEST-400-012",
  DEADLINE_IN_PAST: "AEG-QUEST-400-013",
  // 014(CREATOR_CANNOT_ACCEPT) 는 생성자 수락 허용으로 제거 — 번호는 재사용하지 않는다.
  REVOKE_OUTBREAK_FAILED: "AEG-QUEST-400-015",
  REWARD_LOCKED_ZERO_BUDGET: "AEG-QUEST-400-016",
  /** 미정산(COMPLETED·FORFEITED 외) 체크포인트가 남은 퀘스트의 완료 시도 차단 */
  CHECKPOINTS_NOT_SETTLED: "AEG-QUEST-400-017",
  /** H3 CP5 — 아직 만료되지 않은(FAILED 도, FAILED acceptance 도 없는) 퀘스트의 종결 시도 */
  EXPIRY_CLOSE_NOT_EXPIRED: "AEG-QUEST-400-018",
  /** H3 CP5 — 이미 종결 이벤트가 있는 만료 퀘스트의 재종결 시도 */
  EXPIRY_CLOSE_ALREADY_CLOSED: "AEG-QUEST-400-019",
  /** H3 CP5 — 사유(reason) 없는 종결 시도 */
  EXPIRY_CLOSE_REASON_REQUIRED: "AEG-QUEST-400-020",
  /** 붙이려는 사내 제품이 존재하지 않음 */
  PRODUCT_NOT_FOUND: "AEG-QUEST-400-021",
  /** 제품의 팀 ≠ 퀘스트의 팀 (팀 미배정 제품 포함) */
  PRODUCT_TEAM_MISMATCH: "AEG-QUEST-400-022",
  /** 팀 퀘스트가 아닌데 제품이 붙어 있음 — 맞출 팀 자체가 없다 */
  PRODUCT_SCOPE_NOT_TEAM: "AEG-QUEST-400-023",
  /** 제품과 시나리오 동시 부착 — 두 축은 배타 */
  PRODUCT_SCENARIO_EXCLUSIVE: "AEG-QUEST-400-024",
  /** 일반 퀘스트 관리 철회 실패 */
  WITHDRAW_FAILED: "AEG-QUEST-400-025",
  /** 일반 퀘스트 관리 철회에 사유가 없음 */
  WITHDRAW_REASON_REQUIRED: "AEG-QUEST-400-026",
  /** 포인트가 지급된 퀘스트의 삭제 시도 — 포인트 이력이 퀘스트를 삭제 금지로 참조한다 */
  DELETE_POINTS_PAID: "AEG-QUEST-400-027",
  /** 검토 대기(SUBMITTED) 증빙이 남은 퀘스트의 완료 시도 — 승인·반려가 먼저다 */
  PROOFS_PENDING_REVIEW: "AEG-QUEST-400-028",
  /** 퀘스트 팀 단가표(없는 등급은 회사 범위) 밖 금액 — 퀘스트 540e5d83 */
  REWARD_OUT_OF_PRICING_RANGE: "AEG-QUEST-400-029",
  /** 금액이 있는데 등급이 없어 범위를 판정할 수 없음 — 퀘스트 540e5d83 */
  REWARD_REQUIRES_DIFFICULTY: "AEG-QUEST-400-030",
  /** 유단가 생성·단가/등급 변경에 우선순위 3문 근거가 없음 — LAB-133 */
  PRICING_GROUND_REQUIRED: "AEG-QUEST-400-031",
  /** 기준값을 벗어난 금액(밴드 끝값 포함)에 사유 코드가 없음 — LAB-133 */
  PRICING_REASON_REQUIRED: "AEG-QUEST-400-032",
  /** 착수(수락·증빙·태스크) 뒤 유단가 퀘스트의 단가 인상 — 단가 정책 §3 */
  REWARD_RAISE_LOCKED_AFTER_ENGAGEMENT: "AEG-QUEST-400-033",
  CHECKPOINT_REWARD_MISMATCH: "AEG-QUEST-400-034",
  // 403
  OPERATOR_NOT_OWNER: "AEG-QUEST-403-001",
  DROP_NOT_OWNER: "AEG-QUEST-403-002",
  /** GLOBAL(월드) 퀘스트 승인은 대표(ADMIN∧EXECUTIVE)만 — 비-EXECUTIVE ADMIN 차단 */
  GLOBAL_APPROVE_NOT_CEO: "AEG-QUEST-403-003",
  /** GLOBAL 퀘스트 제안 자격 미달 — quest:create ∧ quest:update 필요 */
  GLOBAL_PROPOSE_FORBIDDEN: "AEG-QUEST-403-004",
  /**
   * GLOBAL(월드) 퀘스트 반려도 대표(ADMIN∧EXECUTIVE)만 — 승인과 같은 축.
   * 라우트 권한이 승인과 공유(quest:approve)라 게이트가 없으면 비-EXECUTIVE ADMIN 이
   * 승인은 못 하면서 반려는 성공했다. 반려는 제안을 되돌리는 종결 행위라 무게가 같다.
   */
  GLOBAL_REJECT_NOT_CEO: "AEG-QUEST-403-005",
  /** 일반 퀘스트 관리 철회 권한 없음 */
  WITHDRAW_FORBIDDEN: "AEG-QUEST-403-006",
  /** 팀장 답 기다림 모아 보기 — 호출자가 어느 업무 팀의 LEADER 도 아님 */
  AWAITING_REPLY_NOT_LEADER: "AEG-QUEST-403-007"
};
var BUDGET_LEDGER_ERROR_CODES = {
  // 400
  /** 마감된 급여기간 원장에 대한 쓰기 — 소진·확정·손실제거·삭제·행생성·퀘스트 FK 부착/재바인딩 전부 (docs/design/budget-ledger-period-close.md §6·§10) */
  PERIOD_CLOSED: "AEG-BUDGET-LEDGER-400-001",
  /** 늦은 승인 이월 — 옮겨갈 다음 열린 원장의 잔액이 이번 소진액에 못 미친다 (설계 §7 재검사, CP1 결정 D2) */
  CARRYOVER_OVERCOMMIT: "AEG-BUDGET-LEDGER-400-002",
  /**
   * 마감 조건 미충족 — 기간이 아직 안 끝났거나, 배당 풀>0 인 미확정 팀이 남았거나,
   * 확정분 중 미지급이 남았거나, 그 기간 원장이 아예 없다 (같은 문서 §5).
   */
  NOT_CLOSABLE: "AEG-BUDGET-LEDGER-400-003",
  // 409
  /** 늦은 승인 이월 — 같은 풀에 열린 다음 원장이 없어 승인을 보류한다 (증빙 무접촉, CP1 결정 D4) */
  NEXT_LEDGER_MISSING: "AEG-BUDGET-LEDGER-409-001"
};
var CHECKPOINT_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-CHECKPOINT-404-001",
  // 400
  CREATE_FAILED: "AEG-CHECKPOINT-400-001",
  ASSIGN_FAILED: "AEG-CHECKPOINT-400-002",
  COMPLETE_FAILED: "AEG-CHECKPOINT-400-003",
  RELEASE_FAILED: "AEG-CHECKPOINT-400-004",
  UPDATE_FAILED: "AEG-CHECKPOINT-400-005",
  NOT_EDITABLE_QUEST_STATUS: "AEG-CHECKPOINT-400-006",
  NOT_DELETABLE_QUEST_STATUS: "AEG-CHECKPOINT-400-007",
  HAS_PROOF: "AEG-CHECKPOINT-400-008",
  NOT_REORDERABLE_QUEST_STATUS: "AEG-CHECKPOINT-400-009",
  REORDER_ID_MISMATCH: "AEG-CHECKPOINT-400-010",
  REORDER_ID_NOT_IN_QUEST: "AEG-CHECKPOINT-400-011",
  REWARD_BUDGET_EXCEEDED: "AEG-CHECKPOINT-400-012",
  HAS_COMPLETED_TASK: "AEG-CHECKPOINT-400-013",
  HAS_TASK_TYPE_LOCKED: "AEG-CHECKPOINT-400-014",
  INSUFFICIENT_TASK_VALUE: "AEG-CHECKPOINT-400-015",
  /** 선행 CP 미완료로 아직 잠긴(chained) CP 를 승인하려 함 */
  CHAIN_LOCKED: "AEG-CHECKPOINT-400-016"
};
var QUEST_TASK_ERROR_CODES = {
  // 400
  /** Premise 10: 정성(completion) CP에 비-LEADER 다른 팀원의 active task 이미 존재 — 1명 단일 시상 enforce */
  COMPLETION_CP_LOCKED: "AEG-QUEST-TASK-400-001",
  /** 체크아웃 시 실제 수치가 계획과 다른데 사유(varianceReason)가 없음 */
  VARIANCE_REASON_REQUIRED: "AEG-QUEST-TASK-400-002",
  /** 종결(COMPLETED/LOCKED/FORFEITED) 체크포인트에는 태스크 생성 불가 */
  CP_NOT_OPEN: "AEG-QUEST-TASK-400-003",
  /**
   * 이미 정산이 끝난(분배 완료·몰수) 스코프의 방치 태스크에 소급 CHECKOUT("어제 완료했음")을 시도.
   * 실적이 분배 스냅샷 뒤에 얹혀 이중 계상되므로 막는다. '정리'(SWEPT)는 실적 0이라 계속 허용.
   */
  SETTLEMENT_TERMINAL: "AEG-QUEST-TASK-400-004",
  /** 지난 업무일에 착수한 태스크만 배너에서 해소할 수 있음(오늘 착수분은 일반 체크아웃 경로) */
  NOT_STALE_TASK: "AEG-QUEST-TASK-400-005",
  /** 누적 완료 건수(cumulativeValue)가 같은 CP 에 지금까지 적립된 본인 값보다 작음 — 음수 차액은 저장하지 않는다 */
  CUMULATIVE_BELOW_PRIOR: "AEG-QUEST-TASK-400-006",
  // 409
  /** 피드백이 1건이라도 달린 태스크는 삭제 불가 — 피드백은 영구 기록 */
  TASK_HAS_FEEDBACK: "AEG-QUEST-TASK-409-001",
  /** 자동채움 보정 태스크(시스템 생성)는 삭제 불가 — 게이지·funnel 정합 보존 */
  SYSTEM_TASK_IMMUTABLE: "AEG-QUEST-TASK-409-002"
};
var PROOF_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-PROOF-404-001",
  QUEST_NOT_FOUND: "AEG-PROOF-404-002",
  CHECKPOINT_NOT_FOUND: "AEG-PROOF-404-003",
  // 400
  MISSING_CHECKPOINT_OR_QUEST_ID: "AEG-PROOF-400-001",
  DUPLICATE_QUEST_PROOF: "AEG-PROOF-400-002",
  ALREADY_PROCESSED: "AEG-PROOF-400-003",
  CREATE_FAILED: "AEG-PROOF-400-004",
  SUBMIT_FAILED: "AEG-PROOF-400-005",
  APPROVE_FAILED: "AEG-PROOF-400-006",
  REJECT_FAILED: "AEG-PROOF-400-007",
  RESUBMIT_FAILED: "AEG-PROOF-400-008",
  UPDATE_FAILED: "AEG-PROOF-400-009",
  QUEST_NOT_ACTIVE: "AEG-PROOF-400-010",
  INSUFFICIENT_TASK_VALUE: "AEG-PROOF-400-011",
  /** ADCODE quest-level 증빙은 파일/링크 첨부 1개 이상 필수 (요청자 수락/반려 판단 근거) */
  MISSING_ATTACHMENT: "AEG-PROOF-400-012",
  /** ADCODE quest-level 증빙은 설명(description) 비어 있으면 거부 */
  EMPTY_DESCRIPTION: "AEG-PROOF-400-013",
  /** ADCODE 증빙 반려 시 사유(comment)는 필수 — 사유 없으면 피드백이 안 됨(plan 2026-06-23) */
  REJECT_REASON_REQUIRED: "AEG-PROOF-400-014",
  /** 수락(QuestAcceptance ACCEPTED)하지 않은 퀘스트에는 증빙을 제출할 수 없다 */
  QUEST_NOT_ACCEPTED: "AEG-PROOF-400-015",
  /** 체크포인트 없는 퀘스트(경쟁형)에 다른 수락자의 증빙이 검토 중이면 제출할 수 없다 */
  QUEST_PROOF_UNDER_REVIEW: "AEG-PROOF-400-016",
  /** 정성 CP 증빙은 그 CP 에 제출자 태스크가 있어야 낼 수 있다(검토 요청 버튼과 같은 조건) */
  QUALITATIVE_PROOF_NEEDS_TASK: "AEG-PROOF-400-017",
  /** 설명도 첨부도 없는 증빙은 제출할 수 없다(웹 hasProofContent 와 같은 조건) */
  EMPTY_PROOF: "AEG-PROOF-400-018",
  /** 체크포인트 없는 퀘스트의 자동 증빙 제출 — 그 퀘스트에 체크인한 내 태스크가 없다 */
  QUEST_PROOF_NEEDS_TASK: "AEG-PROOF-400-019",
  /** 자동 증빙 제출은 체크포인트 없는 퀘스트에서만 — 체크포인트 퀘스트의 퀘스트 단위 증빙은 예산 전체를 잠근다 */
  AUTO_SUBMIT_CHECKPOINT_QUEST: "AEG-PROOF-400-020",
  // 403
  SUBMIT_FORBIDDEN: "AEG-PROOF-403-001",
  REVIEW_FORBIDDEN: "AEG-PROOF-403-002",
  RESUBMIT_FORBIDDEN: "AEG-PROOF-403-003",
  UPDATE_FORBIDDEN: "AEG-PROOF-403-004",
  // 409
  /** 검수 화면이 본 증빙 버전과 지금 버전이 다르다 — 최신 내용을 다시 확인한 뒤 승인한다(퀘스트 02c530dd) */
  STALE_REVIEW: "AEG-PROOF-409-001"
};
var TEAM_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-TEAM-404-001",
  // 400
  CREATE_DEPARTMENT_FAILED: "AEG-TEAM-400-001",
  CREATE_TASKFORCE_FAILED: "AEG-TEAM-400-002",
  ARCHIVE_FAILED: "AEG-TEAM-400-003",
  RESTORE_FAILED: "AEG-TEAM-400-004",
  ADD_MEMBER_FAILED: "AEG-TEAM-400-005",
  REMOVE_MEMBER_FAILED: "AEG-TEAM-400-006",
  TRANSFER_LEADERSHIP_FAILED: "AEG-TEAM-400-007",
  UPDATE_CAPABILITIES_FAILED: "AEG-TEAM-400-008",
  CREATE_CLUB_FAILED: "AEG-TEAM-400-009",
  JOIN_CLUB_FAILED: "AEG-TEAM-400-010",
  // 403 — 구성원 추가·제거·리더 이전은 ADMIN ∪ HR_MANAGEMENT ∪ 그 팀의 현 LEADER 만(감사 C17).
  FORBIDDEN_MEMBERSHIP: "AEG-TEAM-403-001",
  // 403 — 보관·복원은 ADMIN ∪ HR_MANAGEMENT ∪ 그 팀의 LEADER 만(퀘스트 480145fb). 보관이 구성원 행을 지운다.
  FORBIDDEN_ARCHIVE: "AEG-TEAM-403-002",
  // 403 — 태스크포스 생성은 ADMIN 이나 부서(DEPARTMENT) 팀의 팀장만(LAB-11). 동아리장·태스크포스 팀장·팀원은 못 만든다.
  FORBIDDEN_TASK_FORCE_CREATE: "AEG-TEAM-403-003",
  // 409 — 메일 소유 확인을 마치지 않은 가입 계정은 팀에 넣지 않는다(87bac89b 반려 사유별 수정 4).
  // 배정만 받고 확인하지 않은 계정이 생기지 않게 하는 문이다. 판정은 상태 기준이다.
  SIGNUP_NOT_VERIFIED: "AEG-TEAM-409-001"
};
var CLUB_ERROR_CODES = {
  // 404
  POLL_NOT_FOUND: "AEG-CLUB-404-001",
  FEED_NOT_FOUND: "AEG-CLUB-404-002",
  // 403
  NOT_LEADER: "AEG-CLUB-403-001",
  NOT_MEMBER: "AEG-CLUB-403-002",
  LEADER_MUST_TRANSFER: "AEG-CLUB-403-003",
  // 400
  CREATE_POLL_FAILED: "AEG-CLUB-400-001",
  CONFIRM_POLL_FAILED: "AEG-CLUB-400-002",
  CREATE_FEED_FAILED: "AEG-CLUB-400-003",
  POLL_CLOSED: "AEG-CLUB-400-004"
};
var SCENARIO_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-SCENARIO-404-001",
  // 400
  CREATE_FAILED: "AEG-SCENARIO-400-001",
  ACTIVATE_FAILED: "AEG-SCENARIO-400-002",
  COMPLETE_FAILED: "AEG-SCENARIO-400-003",
  DELETE_FAILED: "AEG-SCENARIO-400-004",
  UPDATE_FAILED: "AEG-SCENARIO-400-005",
  FAIL_FAILED: "AEG-SCENARIO-400-006",
  ARCHIVE_FAILED: "AEG-SCENARIO-400-007",
  // plan 2c8bbc6c: 보상 걸린 진행중(ACTIVE) 퀘스트가 있어 아카이브 차단. FE 는 커스텀 message 를
  // 그대로 토스트해야 하므로 getApiErrorMessage 의 ERROR_CODE_MESSAGE_MAP 에는 넣지 않는다.
  ARCHIVE_BLOCKED_ACTIVE_REWARD: "AEG-SCENARIO-400-008",
  // D1 — 진행 책임자로 참여팀 밖 유저를 지정 시도. FK 는 실재만 보장하므로 서비스가 소속을 검증한다.
  INVALID_PROGRESS_OWNER: "AEG-SCENARIO-400-009",
  // 34f36037 — 로스터 행이 선 뒤 계약 조건·캠페인 난이도 수정 시도. UPDATE_FAILED 를 재사용하지
  // 않는 이유: 화면이 "왜 막혔나"를 구분해 안내할 수 없다.
  CONTRACT_TERMS_LOCKED: "AEG-SCENARIO-400-010",
  // 409
  // cb097c4f — 조회수 실적이 있는 캠페인의 목표 조회수를 사유 없이 바꾸려 함. 편집 창이 이 코드를
  // 보고 사유 칸을 연다. ERROR_CODE_MESSAGE_MAP 에는 넣지 않는다 — 서버 문구를 그대로 보인다.
  TARGET_VIEWS_CHANGE_REASON_REQUIRED: "AEG-SCENARIO-409-001"
};
var ATTENDANCE_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-ATT-404-001",
  CORRECTION_NOT_FOUND: "AEG-ATT-404-002",
  OFF_DAY_REQUEST_NOT_FOUND: "AEG-ATT-404-003",
  TIME_CLASSIFICATION_NOT_FOUND: "AEG-ATT-404-004",
  // 409
  ALREADY_CLOCKED_IN: "AEG-ATT-409-001",
  DUPLICATE_CORRECTION: "AEG-ATT-409-002",
  DUPLICATE_OFF_DAY_REQUEST: "AEG-ATT-409-003",
  CORRECTION_STALE: "AEG-ATT-409-004",
  CORRECTION_CHANGED_SINCE_VIEWED: "AEG-ATT-409-008",
  // 400 – clock in/out
  CLOCK_IN_FAILED: "AEG-ATT-400-001",
  ALREADY_CLOCKED_OUT: "AEG-ATT-400-002",
  INVALID_CLOCK_OUT_TIME: "AEG-ATT-400-003",
  FUTURE_CLOCK_OUT: "AEG-ATT-400-004",
  CLOCK_OUT_BEFORE_CLOCK_IN: "AEG-ATT-400-005",
  FUTURE_RECORD: "AEG-ATT-400-006",
  END_BEFORE_START: "AEG-ATT-400-007",
  // 400 – break
  BREAK_START_FAILED: "AEG-ATT-400-008",
  BREAK_END_FAILED: "AEG-ATT-400-009",
  // 400 – correction
  INVALID_CORRECTION_DATE: "AEG-ATT-400-010",
  CORRECTION_EXPIRED: "AEG-ATT-400-011",
  CORRECTION_ALREADY_PROCESSED: "AEG-ATT-400-012",
  CORRECTION_CLOCK_IN_AFTER_OUT: "AEG-ATT-400-013",
  CORRECTION_CLOCK_OUT_BEFORE_IN: "AEG-ATT-400-014",
  UNSUPPORTED_CORRECTION_FIELD: "AEG-ATT-400-015",
  CORRECTION_OUT_OF_SEGMENT_RANGE: "AEG-ATT-400-016",
  CORRECTION_FAILED: "AEG-ATT-400-017",
  CORRECTION_DATE_CHANGE: "AEG-ATT-400-023",
  CORRECTION_SPAN_TOO_LONG: "AEG-ATT-400-027",
  RESUBMIT_NO_PENDING_CORRECTION: "AEG-ATT-400-028",
  // 400 – misc
  WORK_DURATION_CALC_FAILED: "AEG-ATT-400-018",
  OFF_DAY_ALREADY_PROCESSED: "AEG-ATT-400-019",
  CLASSIFICATION_INVALID_STATUS: "AEG-ATT-400-020",
  CLOCK_OUT_FAILED: "AEG-ATT-400-021",
  // 403
  FORBIDDEN_OTHER_USER_CLOCK: "AEG-ATT-403-001",
  FORBIDDEN_OTHER_USER_BREAK: "AEG-ATT-403-002",
  FORBIDDEN_CORRECTION_SELF_ONLY: "AEG-ATT-403-003",
  FORBIDDEN_CORRECTION_LIST: "AEG-ATT-403-004",
  FORBIDDEN_ADMIN_ACCESS: "AEG-ATT-403-005",
  FORBIDDEN_RECORD_ACCESS: "AEG-ATT-403-006",
  FORBIDDEN_USER_ACCESS: "AEG-ATT-403-007",
  FORBIDDEN_SELF_REVIEW: "AEG-ATT-403-008",
  FORBIDDEN_CROSS_TEAM_REVIEW: "AEG-ATT-403-009",
  // 409 – overlap
  OVERLAPPING_ATTENDANCE: "AEG-ATT-409-005",
  // Segment correction
  SEGMENT_CORRECTION_NOT_FOUND: "AEG-ATT-404-005",
  SEGMENT_CORRECTION_DUPLICATE: "AEG-ATT-409-006",
  SEGMENT_CORRECTION_STALE: "AEG-ATT-409-007",
  SEGMENT_CORRECTION_ALREADY_PROCESSED: "AEG-ATT-400-024",
  SEGMENT_CORRECTION_FAILED: "AEG-ATT-400-025",
  SEGMENT_CORRECTION_INVALID_TYPE: "AEG-ATT-400-026",
  SEGMENT_NOT_FOUND: "AEG-ATT-404-006"
};
var LEAVE_ERROR_CODES = {
  // 404
  USER_NOT_FOUND: "AEG-LEAVE-404-001",
  REQUEST_NOT_FOUND: "AEG-LEAVE-404-002",
  APPROVER_NOT_FOUND: "AEG-LEAVE-404-003",
  REFERRER_NOT_FOUND: "AEG-LEAVE-404-004",
  APPROVAL_NOT_FOUND: "AEG-LEAVE-404-005",
  // 400 – balance
  BALANCE_NEGATIVE: "AEG-LEAVE-400-001",
  INSUFFICIENT_BALANCE: "AEG-LEAVE-400-002",
  // 400 – half-day validation
  HALF_DAY_SINGLE_ONLY: "AEG-LEAVE-400-003",
  HALF_DAY_HALF_ONLY: "AEG-LEAVE-400-004",
  HALF_DAY_NO_WEEKEND: "AEG-LEAVE-400-005",
  // 400 – request validation
  INVALID_DAYS: "AEG-LEAVE-400-006",
  SELF_APPROVER: "AEG-LEAVE-400-007",
  OVERLAP_EXISTS: "AEG-LEAVE-400-008",
  // 400 – approve / reject / cancel
  APPROVE_NOT_PENDING: "AEG-LEAVE-400-009",
  REJECT_NOT_PENDING: "AEG-LEAVE-400-010",
  CANCEL_NOT_OWNER: "AEG-LEAVE-400-011",
  CANCEL_INVALID_STATUS: "AEG-LEAVE-400-012",
  START_DATE_PAST: "AEG-LEAVE-400-015",
  CANCEL_ALREADY_STARTED: "AEG-LEAVE-400-016",
  // 400 – rollover
  ROLLOVER_NO_PREVIOUS_BALANCE: "AEG-LEAVE-400-013",
  ROLLOVER_ALREADY_APPLIED: "AEG-LEAVE-400-014",
  // 400 – admin cancel
  ADMIN_CANCEL_INVALID_STATUS: "AEG-LEAVE-400-017",
  // 400 – proof
  PROOF_NOT_REQUIRED: "AEG-LEAVE-400-018",
  PROOF_ALREADY_SUBMITTED: "AEG-LEAVE-400-019",
  PROOF_NO_ATTACHMENT: "AEG-LEAVE-400-020",
  // 400 – proxy
  PROXY_SICK_ONLY: "AEG-LEAVE-400-021",
  // 400 – sick auto-approve
  APPROVER_REQUIRED: "AEG-LEAVE-400-022",
  // 400 – proof review (v2)
  PROOF_REVIEW_NOT_SUBMITTED: "AEG-LEAVE-400-023",
  PROOF_RESUBMIT_NOT_REVIEWABLE: "AEG-LEAVE-400-024",
  PROOF_RESUBMIT_REASON_REQUIRED: "AEG-LEAVE-400-025",
  // 400 – 휴가 승인 권한(leave:approve)이 없는 사람을 결재자로 지정
  APPROVER_NOT_ELIGIBLE: "AEG-LEAVE-400-026",
  // 403
  ATTACHMENT_NOT_OWNED: "AEG-LEAVE-403-001",
  NOT_ASSIGNED_APPROVER: "AEG-LEAVE-403-002",
  ATTACHMENT_ACCESS_DENIED: "AEG-LEAVE-403-003",
  ADMIN_ACCESS_DENIED: "AEG-LEAVE-403-004",
  REQUEST_ACCESS_DENIED: "AEG-LEAVE-403-005",
  APPROVAL_NOT_OWNER: "AEG-LEAVE-403-006",
  ADMIN_CANCEL_NO_PERMISSION: "AEG-LEAVE-403-007",
  PROOF_ACCESS_DENIED: "AEG-LEAVE-403-008",
  // 403 – proof review (v2)
  PROOF_REVIEW_FORBIDDEN: "AEG-LEAVE-403-009",
  // 403 – HR 대리 승인 대기 목록은 HR_MANAGEMENT 보유자만
  PROXY_QUEUE_FORBIDDEN: "AEG-LEAVE-403-010"
};
var WORKLOG_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-WORKLOG-404-001",
  // 409
  DUPLICATE_DATE: "AEG-WORKLOG-409-001",
  // 400
  CREATE_FAILED: "AEG-WORKLOG-400-001",
  UPDATE_FAILED: "AEG-WORKLOG-400-002",
  SUBMIT_FAILED: "AEG-WORKLOG-400-003",
  /** 요약 재생성은 제출(SUBMITTED)된 일지에만 허용된다. */
  SUMMARY_NOT_SUBMITTED: "AEG-WORKLOG-400-004",
  /** 본문이 비어 있어 요약할 내용이 없다. */
  SUMMARY_EMPTY_CONTENT: "AEG-WORKLOG-400-005",
  /**
   * 지난 업무일의 일지는 마감하지 않는다 — 마감이 오늘 태스크를 그 일지로 옮긴다
   * (`handleSubmitWorkLog` 가 `findToday` 로 붙인다).
   */
  SUBMIT_PAST_DATE: "AEG-WORKLOG-400-006",
  // 403
  UPDATE_FORBIDDEN: "AEG-WORKLOG-403-001",
  SUBMIT_FORBIDDEN: "AEG-WORKLOG-403-002",
  READ_FORBIDDEN: "AEG-WORKLOG-403-003",
  /** 본인 또는 본인 팀원의 일지가 아니다(읽기 게이트와 같은 축). */
  SUMMARY_FORBIDDEN: "AEG-WORKLOG-403-004",
  /** 이미 진행 중인 요약 run 이 있다(원자 클레임 실패). */
  SUMMARY_IN_PROGRESS: "AEG-WORKLOG-409-002",
  /** OpenClaw 미연결 등으로 요약 요청 자체를 보내지 못했다. */
  SUMMARY_UNAVAILABLE: "AEG-WORKLOG-503-001"
};
var POINT_ERROR_CODES = {
  // 400
  AMOUNT_NOT_POSITIVE: "AEG-POINT-400-001",
  AMOUNT_ZERO: "AEG-POINT-400-002",
  ADJUST_NEGATIVE_BALANCE: "AEG-POINT-400-003",
  // 수동 지급(GRANT) 예산 가드 — 소진 풀은 수령자 소속팀 TEAM 원장으로 확정,
  // 귀속 축이 없으면 fail-closed (docs/plans/point-grant-budget-guard/cp1-decision-2026-08-12.md)
  GRANT_NO_TEAM_MEMBERSHIP: "AEG-POINT-400-004",
  GRANT_BUDGET_LEDGER_MISSING: "AEG-POINT-400-005",
  // 양수 조정 용도 레인 — 자유형 양수 적립이 예산 가드 우회 통로였다.
  // (docs/plans/point-adjust-guard/cp1-decision-2026-08-18.md)
  /** 정정 대상 참조도 사유 카테고리도 없다 */
  ADJUST_LANE_REQUIRED: "AEG-POINT-400-006",
  /** 둘 다 주어져 어느 용도로 기록할지 정해지지 않는다 */
  ADJUST_LANE_AMBIGUOUS: "AEG-POINT-400-007",
  /** 음수 조정에 레인 필드가 붙었다 — 레인은 양수 전용 축이다 */
  ADJUST_LANE_NOT_APPLICABLE: "AEG-POINT-400-008",
  ADJUST_TARGET_NOT_FOUND: "AEG-POINT-400-009",
  /** 대상이 음수 행이 아니다 — 양수 행 참조는 타인의 대형 적립을 복사하는 경로가 된다 */
  ADJUST_TARGET_NOT_REVERSIBLE: "AEG-POINT-400-010",
  /** 대상이 다른 사용자의 행이다 — 세탁 이전 차단 */
  ADJUST_TARGET_USER_MISMATCH: "AEG-POINT-400-011",
  /** 대상별 누적 복원액이 대상 금액을 넘는다 — 같은 대상 반복 참조 차단 */
  ADJUST_RESTORE_EXCEEDS_TARGET: "AEG-POINT-400-012",
  // 급여기간 배당 지급 — 확정본에서만 읽는다
  // (docs/plans/payperiod-dividend-freeze/cp1-decision-2026-08-20.md §4)
  /** 확정된 몫이 아니다 — 확정 전이거나 이미 지워진 기간이다 */
  DIVIDEND_SHARE_NOT_FOUND: "AEG-POINT-400-013",
  /** 이미 지급된 몫이다 — 같은 실적으로 두 번 받는 경로 차단 */
  DIVIDEND_SHARE_ALREADY_PAID: "AEG-POINT-400-014",
  /** 확정액이 0 이라 지급할 게 없다 — 명단에는 남지만 지급 대상은 아니다 */
  DIVIDEND_SHARE_NOT_PAYABLE: "AEG-POINT-400-015"
};
var USER_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-USER-404-001",
  // 400
  ALREADY_DEACTIVATED: "AEG-USER-400-001",
  NOT_DEACTIVATED: "AEG-USER-400-002",
  SELF_ADMIN_REVOKE: "AEG-USER-400-003",
  LAST_ADMIN_REVOKE: "AEG-USER-400-004",
  HIRE_DATE_IN_FUTURE: "AEG-USER-400-005",
  SELF_DELETE: "AEG-USER-400-006",
  // 403 — 고용 생애주기(퇴사·복직·퇴직일 확정)는 ADMIN ∪ HR_MANAGEMENT 만.
  // attendance:manage 가 teamRole LEADER 에도 부여되므로 데코레이터만으로는 안 막힌다.
  FORBIDDEN_LIFECYCLE: "AEG-USER-403-001",
  // 403 — 본인 직급은 다른 인사 담당이 바꾼다 · EXECUTIVE 를 주거나 바꾸는 것은 대표만(감사 C20·C21).
  SELF_LEVEL_CHANGE: "AEG-USER-403-002",
  EXECUTIVE_LEVEL_CEO_ONLY: "AEG-USER-403-003",
  SELF_EMAIL_CHANGE: "AEG-USER-403-004",
  EMAIL_CHANGE_FORBIDDEN: "AEG-USER-403-005",
  // 409
  EMAIL_TAKEN: "AEG-USER-409-001",
  // 422 — 활동 기록(퀘스트·근태 등) 보유 계정은 hard delete 불가, 퇴사 처리로 유도
  HAS_ACTIVITY: "AEG-USER-422-001"
};
var RANK_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-RANK-404-001",
  // 400
  INVALID_POINTS: "AEG-RANK-400-001"
};
var CHAT_ERROR_CODES = {
  // 404
  CHANNEL_NOT_FOUND: "AEG-CHAT-404-001",
  MESSAGE_NOT_FOUND: "AEG-CHAT-404-002",
  PARENT_MESSAGE_NOT_FOUND: "AEG-CHAT-404-003",
  CHANNEL_GROUP_NOT_FOUND: "AEG-CHAT-404-004",
  // 403
  CANNOT_JOIN_DM: "AEG-CHAT-403-001",
  CHANNEL_OWNER_ONLY_UPDATE: "AEG-CHAT-403-002",
  CHANNEL_OWNER_ONLY_DELETE: "AEG-CHAT-403-003",
  CHANNEL_OWNER_ONLY_MOVE: "AEG-CHAT-403-004",
  NOT_CHANNEL_MEMBER: "AEG-CHAT-403-005",
  NOT_CHANNEL_OWNER: "AEG-CHAT-403-006",
  NOT_MESSAGE_AUTHOR: "AEG-CHAT-403-007",
  // 400
  CANNOT_LEAVE_GENERAL: "AEG-CHAT-400-001",
  CANNOT_DELETE_GENERAL: "AEG-CHAT-400-002",
  INVALID_URL_PROTOCOL: "AEG-CHAT-400-003",
  BLOCKED_URL: "AEG-CHAT-400-004",
  INVALID_URL: "AEG-CHAT-400-005",
  OWNER_CANNOT_LEAVE: "AEG-CHAT-400-006",
  INVITE_PUBLIC_CHANNEL: "AEG-CHAT-400-007",
  CANNOT_KICK_OWNER: "AEG-CHAT-400-008",
  ALREADY_MEMBER: "AEG-CHAT-400-009",
  TARGET_NOT_MEMBER: "AEG-CHAT-400-010",
  INVALID_SEARCH_QUERY: "AEG-CHAT-400-011",
  INVALID_CHANNEL_NAME: "AEG-CHAT-400-012",
  MESSAGE_NOT_EDITABLE: "AEG-CHAT-400-013",
  CHANNEL_ARCHIVED: "AEG-CHAT-400-014",
  USER_NOT_FOUND: "AEG-CHAT-404-005"
};
var ASSISTANT_ERROR_CODES = {
  // 404
  CONVERSATION_NOT_FOUND: "AEG-ASSISTANT-404-001",
  // 403
  NOT_CONVERSATION_OWNER: "AEG-ASSISTANT-403-001",
  // 409 — graph-send 단일-활성 제약: 같은 대화의 graph-send 가 이미 in-flight
  GRAPH_SEND_IN_FLIGHT: "AEG-ASSISTANT-409-001",
  // 400 — 등록된 OPENCLAW 에이전트가 아닌 agentSlug
  UNKNOWN_AGENT: "AEG-ASSISTANT-400-001"
};
var SETTINGS_ERROR_CODES = {
  // 404
  HOLIDAY_NOT_FOUND: "AEG-SETTINGS-404-001",
  // 400
  API_KEY_MISSING: "AEG-SETTINGS-400-001"
};
var UPLOAD_ERROR_CODES = {
  // 400
  INVALID_PATH: "AEG-UPLOAD-400-001",
  FOREIGN_PATH: "AEG-UPLOAD-400-002",
  // 409
  REFERENCED_PATH: "AEG-UPLOAD-409-001",
  // 500
  UPLOAD_URL_FAILED: "AEG-UPLOAD-500-001",
  DOWNLOAD_URL_FAILED: "AEG-UPLOAD-500-002",
  DELETE_FAILED: "AEG-UPLOAD-500-003"
};
var AGENT_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-AGENT-404-001",
  // 409
  NAME_ALREADY_EXISTS: "AEG-AGENT-409-001"
};
var QUEST_TEMPLATE_ERROR_CODES = {
  // 404
  NOT_FOUND: "AEG-QUEST-TEMPLATE-404-001",
  // 400
  CREATE_FAILED: "AEG-QUEST-TEMPLATE-400-001",
  UPDATE_FAILED: "AEG-QUEST-TEMPLATE-400-002",
  DELETE_FAILED: "AEG-QUEST-TEMPLATE-400-003",
  INVALID_REWARD_RATIO: "AEG-QUEST-TEMPLATE-400-004",
  INSTANTIATE_FAILED: "AEG-QUEST-TEMPLATE-400-005"
};
var PROPOSAL_ERROR_CODES = {
  // 400 — 채택 대상 퀘스트가 없거나 제안과 팀이 다름
  ADOPTED_QUEST_INVALID: "AEG-PROPOSAL-400-001",
  // 400 — title/description 길이 초과
  LENGTH_EXCEEDED: "AEG-PROPOSAL-400-002",
  // 403 — 소속되지 않은 팀에 제안 생성
  NOT_TEAM_MEMBER: "AEG-PROPOSAL-403-001",
  // 409 — 이미 처리된(OPEN 아닌) 제안 재처리. 두 팀장 동시 처리 시 둘째가 받는 코드.
  ALREADY_RESOLVED: "AEG-PROPOSAL-409-001"
};

// src/common/brand.ts
var Brand = {
  name: "AXIOM",
  apiTitle: "AXIOM API",
  apiDescription: "AXIOM Backend API Documentation",
  emailFrom: "AXIOM",
  emailSubjectPrefix: "[AXIOM]",
  botUserAgent: "AXIOM-Bot/1.0"
};

// src/common/pagination.ts
var DEFAULT_PAGE_LIMIT = 20;
function buildCursorResponse(items, limit) {
  const hasMore = items.length > limit;
  const data = hasMore ? items.slice(0, limit) : items;
  const nextCursor = hasMore && data.length > 0 ? data[data.length - 1].id : null;
  return { data, hasMore, nextCursor };
}
var UNPAGINATED_LIST_CAP = 500;
var MAX_CURSOR_PAGES = 100;
async function fetchAllCursorPages(fetchPage) {
  const all = [];
  let cursor;
  for (let page = 0; page < MAX_CURSOR_PAGES; page++) {
    const res = await fetchPage(cursor);
    if (Array.isArray(res)) return res;
    all.push(...res.data);
    if (!res.hasMore || res.nextCursor === null) return all;
    if (res.nextCursor === cursor) {
      throw new Error("fetchAllCursorPages: nextCursor did not advance");
    }
    cursor = res.nextCursor;
  }
  throw new Error(`fetchAllCursorPages: exceeded ${MAX_CURSOR_PAGES} pages`);
}

// src/common/feature-flag.ts
var DEFAULT_FEATURE_FLAGS = {
  // 리더보드 V1(PR #693) 출시 단계 진입 (2026-06-11): 'teaser' = 일반 사용자는 placeholder([DECRYPTING...]),
  // BETA_TESTER 캐퍼빌리티 팀만 실제 리더보드 노출. 전체 'live' flip 은 베타 검증 후 별 PR.
  leaderboard: "teaser",
  gamification: "hidden",
  // 오늘 일지 정식 출시 (2026-10-07): 베타(teaser)를 거쳐 전체 사용자 live.
  today: "live",
  // streak 키는 스트릭 철회(2026-07-30)와 함께 삭제됐다 — 'hidden' 은 되돌릴 수 있는
  // 스위치라 override 한 줄이면 철회한 화면이 되살아난다. 되돌릴 스위치는 없다.
  scenarios: "teaser",
  "advertiser-console": "teaser",
  // 캠페인 성과급은 dev·베타 팀을 포함해 숨긴다(이강주 2026-11-02).
  "campaign-bonus": "hidden",
  // 대표 콘솔 정식 출시 (2026-10-01): 주인(EXECUTIVE ∧ ADMIN)은 view-access 창 게이트가 가른다.
  // teaser 는 BETA_TESTER 팀 소속을 한 번 더 요구해 팀이 없는 대표가 창을 못 열었다.
  "ceo-console": "live",
  // 라운지 정식 출시 (2026-06-12): 베타(teaser, 2026-06-09~) 검증 완료 — 전체 사용자에게 live.
  lounge: "live",
  // 팀 운영 통합(C-Full) 정식 출시 (2026-06-12): 베타(teaser, 2026-06-11~) 거쳐 전체 사용자 live.
  // '팀 근무' 창 제거와 함께 flip — 승인 표면은 통합 컨테이너(TeamOpsUnifiedContainer)로 단일화.
  "team-ops": "live",
  // 운영 master에서 worklog 작성 흐름이 안정화되기 전까지 미제출 알림 차단.
  // backend WorklogClockOutListener가 isFeatureActive('work-log')로 게이트.
  // 작성 흐름이 안정되면 'live'로 전환(또는 backend env FEATURE_FLAGS=work-log=live override).
  "work-log": "hidden",
  // 도깨비 노드 그래프 척추(fromMessageId+pinnedMessageIds send 경로). 기본 OFF.
  // ON 시 GraphComposer 가 selectedId=fromMessageId, pinnedIds=pinnedMessageIds 로 실 send.
  // OFF 면 기존 lastUserMsg(선형) send 경로 그대로. backend send-composition 결선 후 'live' 승급.
  assistantGraphContext: "hidden",
  // 사내 위키(퀘스트 922198e1). 사용법 문서를 채워 전원에게 연다(2026-10-06, 설계 docs/design/axiom-wiki.md ③).
  wiki: "live",
  // 시나리오 메일 면의 섭외 발송(후보 선택 → 작성기 → 대량 발송). 운영은 숨기고 dev 에서만 보인다
  // (2026-09-29). 회신 큐·발송 이력·행 스레드(shared inbox)는 운영 중이라 이 플래그 밖이다.
  // backend 도 이 값으로 발송 진입점을 거절한다 — dev 서버는 env FEATURE_FLAGS=outreach-send=live 가 필요하다.
  "outreach-send": "hidden"
};
var DEV_VISIBLE_HIDDEN_FLAGS = /* @__PURE__ */ new Set(["outreach-send"]);
var featureFlags = { ...DEFAULT_FEATURE_FLAGS };
function resetFeatureFlags() {
  for (const key of Object.keys(featureFlags)) {
    delete featureFlags[key];
  }
  Object.assign(featureFlags, DEFAULT_FEATURE_FLAGS);
}
function parseFlagValue(raw) {
  if (raw === "teaser") return "teaser";
  if (raw === "hidden" || raw === "false") return "hidden";
  return "live";
}
function applyFeatureFlagOverrides(envValue, options = {}) {
  if (envValue === void 0) return;
  const devVisible = options.devVisible ?? true;
  if (envValue === "" || envValue === "all") {
    for (const key of Object.keys(featureFlags)) {
      if (DEFAULT_FEATURE_FLAGS[key] === "hidden" && !(devVisible && DEV_VISIBLE_HIDDEN_FLAGS.has(key))) {
        continue;
      }
      featureFlags[key] = "live";
    }
    return;
  }
  for (const pair of envValue.split(",")) {
    const [key, val] = pair.split("=").map((s) => s.trim());
    if (!key) continue;
    featureFlags[key] = parseFlagValue(val);
  }
}
function getViewState(viewId, teamCapabilities) {
  const value = featureFlags[viewId];
  if (value === void 0) return "live";
  if (value === "teaser" && teamCapabilities?.includes("BETA_TESTER")) return "live";
  return value;
}
var NOTIFICATION_FEATURE_MAP = {
  RANK_CHANGED: "leaderboard",
  OUTBREAK_TRIGGERED: "gamification",
  OUTBREAK_REVOKED: "gamification"
  // ⚠️ OPEN_CALL_REVOKED 를 여기 넣지 말 것. 이름이 형제라 'gamification' 에 매핑하기 쉬운데
  // 그 플래그는 기본 hidden 이라 수락자 통지가 INSERT 전에 통째로 버려진다(예외·로그 없음).
  // 아웃브레이크는 게이미피케이션 연출이지만 공개모집 철회는 운영 알림이다 — 게이트를 두지 않는다.
};
function isFeatureActive(featureName) {
  return getViewState(featureName) === "live";
}
function isNotificationAllowed(type) {
  const feature = NOTIFICATION_FEATURE_MAP[type];
  if (!feature) return true;
  return isFeatureActive(feature);
}

// src/common/hangul.ts
var HANGUL_BASE = 44032;
var JUNG_COUNT = 21;
var JONG_COUNT = 28;
var CHOSEONG_LIST = [
  "\u3131",
  "\u3132",
  "\u3134",
  "\u3137",
  "\u3138",
  "\u3139",
  "\u3141",
  "\u3142",
  "\u3143",
  "\u3145",
  "\u3146",
  "\u3147",
  "\u3148",
  "\u3149",
  "\u314A",
  "\u314B",
  "\u314C",
  "\u314D",
  "\u314E"
];
function getChoseong(char) {
  const code = char.charCodeAt(0);
  if (code < HANGUL_BASE || code > 55203) return -1;
  return Math.floor((code - HANGUL_BASE) / (JUNG_COUNT * JONG_COUNT));
}
function isChoseong(char) {
  const code = char.charCodeAt(0);
  return code >= 12593 && code <= 12622;
}
function matchHangul(query, target) {
  if (!query) return true;
  const q = query.trim().toLowerCase();
  const t = target.toLowerCase();
  if (t.includes(q)) return true;
  if ([...q].every(isChoseong)) {
    const targetChars = [...t];
    for (let i = 0; i <= targetChars.length - q.length; i++) {
      let matched = true;
      for (let j = 0; j < q.length; j++) {
        const targetChar = targetChars[i + j];
        const targetChoIdx = getChoseong(targetChar);
        const queryChoIdx = CHOSEONG_LIST.indexOf(q[j]);
        if (targetChoIdx === -1 || queryChoIdx === -1 || targetChoIdx !== queryChoIdx) {
          matched = false;
          break;
        }
      }
      if (matched) return true;
    }
  }
  return false;
}

// src/domain/quest/values.ts
var QuestStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  /** CP-less quest 분배 후 task 추가/proof 제출 차단 (v0.5 1A' 결정). multi-proof 함정 차단. */
  LOCKED: "LOCKED",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  /** 관리자가 발행 중인 퀘스트를 사유와 함께 철회한 종결 상태. */
  WITHDRAWN: "WITHDRAWN",
  ARCHIVED: "ARCHIVED"
};
var QuestApprovalStatus = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var QuestScope = {
  TEAM: "TEAM",
  GLOBAL: "GLOBAL",
  SYSTEM: "SYSTEM"
};
var QuestTargetType = {
  USER: "USER",
  TEAM: "TEAM"
};
var QuestAcceptanceStatus = {
  ACCEPTED: "ACCEPTED",
  DROPPED: "DROPPED",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};

// src/domain/quest/quest.ts
function createQuest(params) {
  if (params.rewardPoints < 0) {
    throw new Error(`rewardPoints cannot be negative, got ${params.rewardPoints}`);
  }
  if (params.scope === QuestScope.TEAM && !params.teamId) {
    throw new Error("teamId is required when scope is TEAM");
  }
  if (params.scope === QuestScope.GLOBAL && params.teamId) {
    throw new Error("teamId must be null when scope is GLOBAL");
  }
  if (params.scope === QuestScope.SYSTEM && params.teamId) {
    throw new Error("teamId must be null when scope is SYSTEM");
  }
  if (params.scope === QuestScope.SYSTEM && params.scenarioId) {
    throw new Error("scenarioId is not allowed when scope is SYSTEM");
  }
  if (params.scenarioId && params.scope !== QuestScope.TEAM) {
    throw new Error("scope must be TEAM when scenarioId is provided");
  }
  if (params.deadline && new Date(params.deadline) < new Date(params.now)) {
    throw new Error(
      `deadline cannot be in the past: deadline=${params.deadline}, now=${params.now}`
    );
  }
  const skipApproval = params.skipApproval ?? params.rewardPoints === 0;
  return {
    id: params.id,
    title: params.title,
    description: params.description,
    scope: params.scope,
    targetType: params.targetType,
    teamId: params.teamId,
    status: skipApproval ? QuestStatus.ACTIVE : QuestStatus.DRAFT,
    creatorId: params.creatorId,
    rewardPoints: params.rewardPoints,
    deadline: params.deadline,
    scenarioId: params.scenarioId ?? null,
    productId: params.productId ?? null,
    requesterId: params.requesterId ?? null,
    requesterScenarioId: params.requesterScenarioId ?? null,
    origin: params.origin ?? null,
    requesterSheetUrl: params.requesterSheetUrl ?? null,
    templateId: params.templateId ?? null,
    approvalStatus: skipApproval ? QuestApprovalStatus.APPROVED : QuestApprovalStatus.DRAFT,
    approvedBy: null,
    approvedAt: null,
    rejectionReason: null,
    difficulty: params.difficulty ?? null,
    createdAt: params.now,
    updatedAt: params.now
  };
}
function submitForApproval(quest, now) {
  if (quest.approvalStatus !== QuestApprovalStatus.DRAFT && quest.approvalStatus !== QuestApprovalStatus.REJECTED) {
    throw new Error(
      `Cannot submit quest ${quest.id}: approvalStatus is ${quest.approvalStatus}, expected DRAFT or REJECTED`
    );
  }
  return {
    ...quest,
    approvalStatus: QuestApprovalStatus.PENDING_APPROVAL,
    updatedAt: now
  };
}
function approveQuest(quest, approverId, now, difficulty, rewardPoints) {
  if (quest.approvalStatus !== QuestApprovalStatus.PENDING_APPROVAL) {
    throw new Error(
      `Cannot approve quest ${quest.id}: approvalStatus is ${quest.approvalStatus}, expected PENDING_APPROVAL`
    );
  }
  return {
    ...quest,
    status: QuestStatus.ACTIVE,
    approvalStatus: QuestApprovalStatus.APPROVED,
    approvedBy: approverId,
    approvedAt: now,
    ...difficulty !== void 0 && { difficulty },
    ...rewardPoints !== void 0 && { rewardPoints },
    updatedAt: now
  };
}
function rejectQuest(quest, approverId, reason, now) {
  if (quest.approvalStatus !== QuestApprovalStatus.PENDING_APPROVAL) {
    throw new Error(
      `Cannot reject quest ${quest.id}: approvalStatus is ${quest.approvalStatus}, expected PENDING_APPROVAL`
    );
  }
  return {
    ...quest,
    approvalStatus: QuestApprovalStatus.REJECTED,
    approvedBy: approverId,
    rejectionReason: reason,
    updatedAt: now
  };
}
function completeQuest(quest, now) {
  assertStatus(
    "quest",
    quest.id,
    quest.status,
    [QuestStatus.ACTIVE, QuestStatus.LOCKED],
    "complete"
  );
  return { ...quest, status: QuestStatus.COMPLETED, updatedAt: now };
}
function failQuest(quest, now) {
  assertStatus("quest", quest.id, quest.status, [QuestStatus.ACTIVE], "fail");
  return { ...quest, status: QuestStatus.FAILED, updatedAt: now };
}
function withdrawQuest(quest, withdrawnByUserId, reason, now) {
  if (quest.worldQuestKind != null) {
    throw new Error(
      `Cannot withdraw world quest ${quest.id}: use revokeWorldQuest to preserve its sealed provenance`
    );
  }
  if (quest.origin === "ADCODE_REQUEST") {
    throw new Error(`Cannot withdraw ADCODE_REQUEST quest ${quest.id}`);
  }
  assertStatus("quest", quest.id, quest.status, [QuestStatus.ACTIVE], "withdraw");
  const normalizedWithdrawnByUserId = withdrawnByUserId.trim();
  const normalizedReason = reason.trim();
  if (!normalizedWithdrawnByUserId) {
    throw new Error("withdrawnByUserId is required");
  }
  if (!normalizedReason) {
    throw new Error("withdrawal reason is required");
  }
  return {
    ...quest,
    status: QuestStatus.WITHDRAWN,
    withdrawnAt: now,
    withdrawnBy: normalizedWithdrawnByUserId,
    withdrawalReason: normalizedReason,
    updatedAt: now
  };
}
function archiveQuest(quest, now) {
  const canArchive = quest.status === QuestStatus.COMPLETED || quest.status === QuestStatus.FAILED || quest.status === QuestStatus.WITHDRAWN;
  if (!canArchive) {
    throw new Error(
      `Cannot archive quest ${quest.id}: status is ${quest.status}, approvalStatus is ${quest.approvalStatus}. Expected status COMPLETED|FAILED|WITHDRAWN`
    );
  }
  return { ...quest, status: QuestStatus.ARCHIVED, updatedAt: now };
}
function deleteQuest(quest, options) {
  if (quest.status === QuestStatus.COMPLETED || quest.status === QuestStatus.FAILED || quest.status === QuestStatus.WITHDRAWN || quest.status === QuestStatus.ARCHIVED) {
    throw new Error(`Cannot delete quest ${quest.id}: status ${quest.status} is terminal`);
  }
  if (isSealedWorldQuestKind(quest.worldQuestKind) && !options?.force) {
    throw new Error(
      `Cannot delete ${quest.worldQuestKind} quest ${quest.id}: status is ${quest.status}. Use revokeWorldQuest (sealed-archive) instead \u2014 provenance row must be preserved`
    );
  }
}
var SEALED_WORLD_QUEST_KIND = {
  OUTBREAK: true,
  OPEN_CALL: true
};
function isSealedWorldQuestKind(kind) {
  return SEALED_WORLD_QUEST_KIND[kind] === true;
}
function revokeWorldQuest(quest, now, params) {
  if (!isSealedWorldQuestKind(quest.worldQuestKind)) {
    throw new Error(
      `Cannot revoke quest ${quest.id}: worldQuestKind is ${quest.worldQuestKind ?? "null"}, expected OUTBREAK|OPEN_CALL`
    );
  }
  if (quest.status === QuestStatus.ARCHIVED) {
    throw new Error(`Cannot revoke quest ${quest.id}: already ARCHIVED`);
  }
  return {
    ...quest,
    status: QuestStatus.ARCHIVED,
    revokedAt: now,
    revokedBy: params.revokedByUserId,
    revokeReason: params.reason,
    updatedAt: now
  };
}
function validateCheckpointRewardTotal(checkpointRewards, questRewardPoints) {
  const total = checkpointRewards.reduce((sum, r) => sum + r, 0);
  if (total > questRewardPoints) {
    throw new Error(
      `Checkpoint reward total (${total}) exceeds quest rewardPoints (${questRewardPoints})`
    );
  }
}
function validateCheckpointRewardBalanced(checkpointRewards, questRewardPoints) {
  if (checkpointRewards.length === 0) {
    return;
  }
  const total = checkpointRewards.reduce((sum, r) => sum + r, 0);
  if (total !== questRewardPoints) {
    throw new Error(
      `Checkpoint reward total (${total}) must equal quest rewardPoints (${questRewardPoints})`
    );
  }
}
function triggerOutbreak(quest, now, params) {
  assertStatus("quest", quest.id, quest.status, [QuestStatus.ACTIVE], "trigger outbreak on");
  if (quest.scope !== QuestScope.TEAM) {
    throw new Error(
      `Cannot trigger outbreak on quest ${quest.id}: scope is already ${quest.scope}`
    );
  }
  if (quest.origin === "ADCODE_REQUEST") {
    throw new Error(
      `Cannot trigger outbreak on quest ${quest.id}: ADCODE-origin quests cannot be promoted to world quests`
    );
  }
  if (quest.origin === "VA_REQUEST") {
    throw new Error(
      `Cannot trigger outbreak on quest ${quest.id}: VA-origin quests cannot be promoted to world quests`
    );
  }
  if (quest.origin === "ONBOARDING") {
    throw new Error(
      `Cannot trigger outbreak on quest ${quest.id}: ONBOARDING-origin quests cannot be promoted to world quests`
    );
  }
  const originTeamId = quest.teamId;
  return {
    ...quest,
    worldQuestKind: "OUTBREAK",
    promotedAt: now,
    promotedBy: params.triggeredByUserId,
    originTeamId,
    originTeamName: params.originTeamName,
    scope: QuestScope.GLOBAL,
    teamId: null,
    // 불변식 회복 — GLOBAL 퀘스트는 시나리오에 소속되지 않는다(확산 전 stale scenarioId 정리).
    scenarioId: null,
    updatedAt: now
  };
}
function computeWorldQuestLane(q) {
  if (q.worldQuestKind === "OUTBREAK" && q.status === QuestStatus.ACTIVE && q.outbreakMitigatedAt == null) {
    return "amber";
  }
  return "violet";
}
function isQuestExpired(quest, now) {
  if (quest.status !== QuestStatus.ACTIVE) {
    return false;
  }
  if (quest.deadline == null) {
    return false;
  }
  return new Date(quest.deadline) < new Date(now);
}
function classifyExpiredAttribution(acceptances) {
  return acceptances.some((a) => a.status === QuestAcceptanceStatus.ACCEPTED) ? "INDIVIDUAL" : "TEAM";
}
function isQuestAcceptanceBlockedByCheckpoints(params) {
  return !params.hasNoCheckpoints && !params.hasOpenCheckpoints;
}
function getQuestAcceptanceBlockedReason(params) {
  if (isQuestAcceptanceBlockedByCheckpoints(params)) {
    return "\uD604\uC7AC \uC218\uB77D\uD560 \uC218 \uC788\uB294 \uCCB4\uD06C\uD3EC\uC778\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.";
  }
  if (params.hasNoCheckpoints && params.questProofs?.some(
    (proof) => proof.checkpointId === null && (proof.status === "SUBMITTED" || proof.status === "COMPLETED")
  )) {
    return "\uC774\uBBF8 \uC99D\uBE59\uC774 \uC81C\uCD9C\uB418\uC5B4 \uD018\uC2A4\uD2B8\uB97C \uC218\uB77D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.";
  }
  return null;
}
function acceptQuest(params) {
  assertStatus("quest", params.questId, params.questStatus, [QuestStatus.ACTIVE], "accept");
  const blockedReason = getQuestAcceptanceBlockedReason(params);
  if (blockedReason !== null) {
    throw new Error(blockedReason);
  }
  if (params.existingAcceptance) {
    if (params.existingAcceptance.status === QuestAcceptanceStatus.DROPPED) {
      return {
        ...params.existingAcceptance,
        status: QuestAcceptanceStatus.ACCEPTED,
        acceptedTeamId: params.acceptedTeamId ?? null,
        acceptedTeamName: params.acceptedTeamName ?? null,
        updatedAt: params.now
      };
    }
    throw new Error(`User ${params.userId} already has acceptance for quest ${params.questId}`);
  }
  return {
    id: params.id,
    userId: params.userId,
    questId: params.questId,
    status: QuestAcceptanceStatus.ACCEPTED,
    acceptedTeamId: params.acceptedTeamId ?? null,
    acceptedTeamName: params.acceptedTeamName ?? null,
    createdAt: params.now,
    updatedAt: params.now
  };
}
function dropAcceptance(acceptance, now) {
  assertStatus(
    "acceptance",
    acceptance.id,
    acceptance.status,
    [QuestAcceptanceStatus.ACCEPTED],
    "drop"
  );
  return { ...acceptance, status: QuestAcceptanceStatus.DROPPED, updatedAt: now };
}
function completeAcceptances(acceptances, now) {
  return acceptances.filter((a) => a.status === QuestAcceptanceStatus.ACCEPTED).map((a) => ({ ...a, status: QuestAcceptanceStatus.COMPLETED, updatedAt: now }));
}
function failAcceptances(acceptances, now) {
  return acceptances.filter((a) => a.status === QuestAcceptanceStatus.ACCEPTED).map((a) => ({ ...a, status: QuestAcceptanceStatus.FAILED, updatedAt: now }));
}
function withdrawAcceptances(acceptances, now) {
  return acceptances.filter((acceptance) => acceptance.status === QuestAcceptanceStatus.ACCEPTED).map((acceptance) => ({
    ...acceptance,
    status: QuestAcceptanceStatus.DROPPED,
    updatedAt: now
  }));
}
function getActiveParticipantCount(acceptances) {
  return acceptances.filter((a) => a.status === QuestAcceptanceStatus.ACCEPTED).length;
}

// src/domain/quest/progress.ts
function computeQuestProgress(input) {
  const { status, checkpoints } = input;
  if (checkpoints === void 0) return null;
  if (checkpoints.length === 0) {
    return status === QuestStatus.LOCKED ? 1 : null;
  }
  const completed = checkpoints.filter((c) => c.status === "COMPLETED").length;
  return completed / checkpoints.length;
}

// src/domain/quest/onboarding-quest.ts
var ONBOARDING_QUEST_ORIGIN = "ONBOARDING";
function isOnboardingQuestHiddenFor(quest, viewerId) {
  if (quest.origin !== ONBOARDING_QUEST_ORIGIN) return false;
  return !viewerId || quest.requesterId !== viewerId;
}
function onboardingQuestVisibilityWhere(viewerId) {
  const arms = [
    { origin: null },
    { origin: { not: ONBOARDING_QUEST_ORIGIN } }
  ];
  if (viewerId) arms.push({ requesterId: viewerId });
  return { OR: arms };
}

// src/domain/quest/unpriced-quest.ts
var PRICE_CHANGED_FIELD = "rewardPoints";
function unpricedQuestWhere() {
  return {
    rewardPoints: 0,
    approvalEvents: {
      none: {
        changedField: PRICE_CHANGED_FIELD,
        AND: [{ oldValue: { not: null } }, { oldValue: { not: "0" } }]
      }
    }
  };
}

// src/domain/quest/scenario-seed-quest.ts
var SCENARIO_SEED_QUEST_ORIGIN = "SCENARIO_SEED";
function isScenarioSeedQuest(quest) {
  return quest.origin === SCENARIO_SEED_QUEST_ORIGIN;
}

// src/domain/quest/thread.ts
function assertThreadBody(body, label) {
  if (!body.trim()) {
    throw new Error(`${label} cannot be empty`);
  }
}

// src/domain/quest/adcode-comment.ts
var ADCODE_REQUEST_COMMENT_MAX_LENGTH = 2e3;
function hasAdcodeCommentThread(input) {
  return (input.comments?.length ?? 0) > 0 || (input.events?.some((e) => e.kind === "rejected") ?? false);
}
function canCommentOnAdcodeRequest(ctx) {
  return ctx.isAdcodeCapable || ctx.isScenarioParticipant || ctx.isPrivileged;
}

// src/domain/quest/adcode-review.ts
function canReviewAdcodeProof(reviewer, target) {
  if (reviewer.isLeader) return true;
  if (!reviewer.userId) return false;
  return target.requesterId === reviewer.userId || target.progressOwnerId === reviewer.userId || target.subOwnerIds.includes(reviewer.userId);
}

// src/domain/quest/proof-reminder.ts
var PROOF_REMINDER_SUBMITTED_STATUSES = ["SUBMITTED", "COMPLETED"];
function selectProofReminderTargets(input) {
  const submitted = new Set(
    input.proofs.filter((p) => PROOF_REMINDER_SUBMITTED_STATUSES.includes(p.status)).map((p) => p.userId)
  );
  const usersById = new Map(input.users.map((u) => [u.id, u]));
  const targets = [];
  const seen = /* @__PURE__ */ new Set();
  for (const acceptance of input.acceptances) {
    if (acceptance.status !== "ACCEPTED") continue;
    if (submitted.has(acceptance.userId)) continue;
    if (seen.has(acceptance.userId)) continue;
    const user = usersById.get(acceptance.userId);
    if (!user) continue;
    if (user.deletedAt) continue;
    if (user.isAutomatedAgent) continue;
    seen.add(acceptance.userId);
    targets.push({ userId: user.id, username: user.username });
  }
  return targets;
}

// src/domain/quest/quest-chain.ts
var SETTLED = /* @__PURE__ */ new Set(["COMPLETED", "FAILED", "WITHDRAWN", "ARCHIVED"]);
var CLEARED = /* @__PURE__ */ new Set(["COMPLETED", "LOCKED"]);
function isQuestChainCleared(quest) {
  return CLEARED.has(quest.status) || quest.status === "ARCHIVED" && quest.completedAt != null;
}
function groupPrerequisites(prerequisites) {
  const groups = [];
  const keyed = /* @__PURE__ */ new Map();
  for (const prerequisite of prerequisites) {
    if (prerequisite.groupKey == null) {
      groups.push([prerequisite]);
      continue;
    }
    const existing = keyed.get(prerequisite.groupKey);
    if (existing) existing.push(prerequisite);
    else {
      const group = [prerequisite];
      keyed.set(prerequisite.groupKey, group);
      groups.push(group);
    }
  }
  return groups;
}
function countPendingGroups(prerequisites, summaries = []) {
  const satisfied = new Set(
    summaries.filter((group) => group.groupSatisfied === true).map((group) => group.groupKey)
  );
  return groupPrerequisites(prerequisites).filter(
    (group) => !(group[0].groupKey != null && satisfied.has(group[0].groupKey)) && !group.some(
      (prerequisite) => prerequisite.cleared ?? isQuestChainCleared({
        status: prerequisite.status,
        completedAt: prerequisite.completedAt
      })
    )
  ).length;
}
function isUnblockedBy(prerequisites, clearedId) {
  const cleared = prerequisites.find((prerequisite) => prerequisite.id === clearedId);
  if (!cleared || !isQuestChainCleared({ status: cleared.status, completedAt: cleared.completedAt }))
    return false;
  const beforeClear = prerequisites.map(
    (prerequisite) => prerequisite.id === clearedId ? { ...prerequisite, status: "ACTIVE" } : prerequisite
  );
  return countPendingGroups(beforeClear) > 0 && countPendingGroups(prerequisites) === 0;
}
function describeQuestChain(questId, nodes) {
  const byId = new Map(nodes.map((n) => [n.id, n]));
  const self = byId.get(questId);
  if (!self) return null;
  if (self.prerequisiteGroups?.some((group) => group.groupSatisfied === null)) {
    return { label: "\uD655\uC778\uD560 \uC218 \uC5C6\uB294 \uC120\uD589\uC774 \uC788\uC2B5\uB2C8\uB2E4", pending: true, unknown: true };
  }
  const edges = new Map(
    (self.prerequisiteEdges ?? self.dependsOnQuests ?? []).map((edge) => [edge.id, edge])
  );
  const prerequisites = (self.dependsOn ?? []).flatMap((id) => {
    const prerequisite = byId.get(id);
    const edge = edges.get(id);
    return prerequisite ? [
      {
        ...prerequisite,
        groupKey: edge?.groupKey
      }
    ] : [];
  });
  const liveDependents = nodes.filter(
    (n) => (n.dependsOn ?? []).includes(questId) && !SETTLED.has(n.status)
  );
  if (prerequisites.length === 0 && liveDependents.length === 0) return null;
  const left = countPendingGroups(prerequisites, self.prerequisiteGroups);
  const pending = left > 0;
  const chain = linearChainOf(questId, byId, nodes);
  if (chain) {
    return { label: `\uC5F0\uACC4 ${chain.indexOf(questId) + 1}/${chain.length}`, pending };
  }
  if (prerequisites.length > 0) {
    const groups = groupPrerequisites(prerequisites);
    const total = groups.length;
    const unit = prerequisites.some((prerequisite) => prerequisite.groupKey != null) ? "\uBB36\uC74C" : "\uAC74";
    return {
      label: left > 0 ? `\uC120\uD589 ${total}${unit} \uC911 ${left}${unit} \uB0A8\uC74C` : `\uC120\uD589 ${total}${unit} \uBAA8\uB450 \uC644\uB8CC`,
      pending
    };
  }
  return { label: `\uD6C4\uD589 ${liveDependents.length}\uAC74`, pending };
}
function linearChainOf(questId, byId, nodes) {
  const prereqsOf = (id) => (byId.get(id)?.dependsOn ?? []).filter((p) => byId.has(p));
  const dependentsOf = (id) => nodes.filter((n) => (n.dependsOn ?? []).includes(id)).map((n) => n.id);
  const component = /* @__PURE__ */ new Set();
  const queue = [questId];
  while (queue.length > 0) {
    const cur2 = queue.pop();
    if (component.has(cur2)) continue;
    component.add(cur2);
    queue.push(...prereqsOf(cur2), ...dependentsOf(cur2));
  }
  for (const id of component) {
    if (prereqsOf(id).length > 1 || dependentsOf(id).length > 1) return null;
  }
  const root = [...component].find((id) => prereqsOf(id).length === 0);
  if (!root) return null;
  const chain = [];
  let cur = root;
  while (cur && !chain.includes(cur)) {
    chain.push(cur);
    cur = dependentsOf(cur)[0];
  }
  return chain.length === component.size ? chain : null;
}

// src/domain/quest/difficulty-guide.ts
var QUEST_DIFFICULTY_GUIDE = [
  {
    value: "COMMON",
    label: "\uAC04\uB2E8",
    criteria: "\uD558\uB294 \uBC95\uC774 \uB2E4 \uC815\uD574\uC838 \uC788\uB2E4",
    example: "\uC815\uD574\uC9C4 \uC591\uC2DD\uC5D0 \uCEA0\uD398\uC778 \uB9AC\uD3EC\uD2B8\uB97C \uCC44\uC6CC \uC62C\uB9B0\uB2E4"
  },
  {
    value: "UNCOMMON",
    label: "\uBCF4\uD1B5",
    criteria: "\uB300\uBD80\uBD84 \uC815\uD574\uC838 \uC788\uACE0 \uC77C\uBD80\uB9CC \uC9C1\uC811 \uC815\uD55C\uB2E4",
    example: "\uD574\uBCF8 \uBE0C\uB79C\uB4DC \uC2DC\uB529\uC744 \uB3CC\uB9AC\uBA70 \uB300\uC0C1\uB9CC \uC0C8\uB85C \uACE0\uB978\uB2E4"
  },
  {
    value: "RARE",
    label: "\uB3C4\uC804",
    criteria: "\uC808\uBC18\uCBE4 \uC815\uD574\uC838 \uC788\uC5B4 \uBC29\uBC95\uBD80\uD130 \uCC3E\uB294\uB2E4",
    example: "\uD06C\uB9AC\uC5D0\uC774\uD130 \uD68C\uC2E0\uC728\uC774 \uB5A8\uC5B4\uC9C4 \uC6D0\uC778\uC744 \uCC3E\uC544 \uAC1C\uC120\uD55C\uB2E4"
  },
  {
    value: "EPIC",
    label: "\uACE0\uB09C\uB3C4",
    criteria: "\uAC70\uC758 \uC815\uD574\uC9C4 \uAC8C \uC5C6\uC5B4 \uC124\uACC4\uBD80\uD130 \uD55C\uB2E4",
    example: "\uC0C8 \uCE74\uD14C\uACE0\uB9AC \uAD11\uACE0\uC8FC\uC6A9 \uC2DC\uB529 \uD750\uB984\uC744 \uC124\uACC4\uD55C\uB2E4"
  },
  {
    value: "LEGENDARY",
    label: "\uD2B9\uBCC4",
    criteria: "\uC815\uD574\uC9C4 \uAC8C \uC5C6\uC5B4 \uB418\uB294\uC9C0\uBD80\uD130 \uD655\uC778\uD55C\uB2E4",
    example: "\uD574\uBCF8 \uC801 \uC5C6\uB294 \uAE00\uB85C\uBC8C \uB9C8\uCF13\uC744 \uC5F4\uC5B4 \uBC29\uC2DD\uBD80\uD130 \uC7A1\uB294\uB2E4"
  }
];
var QUEST_DIFFICULTY_CRITERIA_TEXT = `\uD310\uC815 \uCD95\uC740 "\uD558\uB294 \uBC95\uC774 \uC5BC\uB9C8\uB098 \uC815\uD574\uC838 \uC788\uB098" \uD558\uB098\uB2E4. ${QUEST_DIFFICULTY_GUIDE.map(
  (level) => `${level.value}(${level.label}) ${level.criteria} \u2014 \uC608: ${level.example}`
).join(" \xB7 ")}`;

// src/domain/quest/difficulty-weight.ts
var QUEST_WEIGHT_FORMULA_VERSION = "v1";
var QUEST_WEIGHT_ALPHA_DEFAULT = 0.9;
var BAND_MEDIAN = {
  COMMON: 1500,
  UNCOMMON: 4e3,
  RARE: 7500,
  EPIC: 2e4,
  LEGENDARY: 4e4
};
function questDifficultyWeight(difficulty, alpha = QUEST_WEIGHT_ALPHA_DEFAULT) {
  const resolved = difficulty ?? "COMMON";
  const median = BAND_MEDIAN[resolved] ?? BAND_MEDIAN.COMMON;
  return Math.pow(median / BAND_MEDIAN.COMMON, alpha);
}
function gateWeightSnapshot(difficulty, alpha = QUEST_WEIGHT_ALPHA_DEFAULT) {
  if (difficulty == null) {
    return { questWeight: null, weightAlpha: null, weightFormulaVersion: null };
  }
  return {
    questWeight: questDifficultyWeight(difficulty, alpha),
    weightAlpha: alpha,
    weightFormulaVersion: QUEST_WEIGHT_FORMULA_VERSION
  };
}
function gateWeightShares(checkpointPoints) {
  const n = checkpointPoints.length;
  if (n === 0) return [];
  const allPriced = checkpointPoints.every((p) => p > 0);
  if (!allPriced) return checkpointPoints.map(() => 1 / n);
  const sum = checkpointPoints.reduce((a, b) => a + b, 0);
  return checkpointPoints.map((p) => p / sum);
}
function gateWeight(params) {
  const questWeight = params.frozenQuestWeight ?? questDifficultyWeight(params.difficulty);
  return questWeight * params.share;
}

// src/domain/quest/gate-ownership.ts
function resolveProofGateOwners(rows) {
  const candidatesByGate = /* @__PURE__ */ new Map();
  for (const r of rows) {
    let candidates = candidatesByGate.get(r.checkpointId);
    if (!candidates) {
      candidates = /* @__PURE__ */ new Map();
      candidatesByGate.set(r.checkpointId, candidates);
    }
    candidates.set(r.userId, (candidates.get(r.userId) ?? 0) + r.pointsAwarded);
  }
  const owners = /* @__PURE__ */ new Map();
  for (const [gateId, candidates] of candidatesByGate) {
    const owner = [...candidates.entries()].sort(
      ([aId, a], [bId, b]) => b - a || aId.localeCompare(bId)
    )[0]?.[0];
    if (owner != null) owners.set(gateId, owner);
  }
  return owners;
}
function resolveQualitativeGateOwners(rows) {
  const candidatesByGate = /* @__PURE__ */ new Map();
  for (const r of rows) {
    let candidates = candidatesByGate.get(r.checkpointId);
    if (!candidates) {
      candidates = /* @__PURE__ */ new Map();
      candidatesByGate.set(r.checkpointId, candidates);
    }
    const cur = candidates.get(r.assigneeId) ?? {
      value: 0,
      tasks: 0,
      firstAt: Number.POSITIVE_INFINITY
    };
    cur.value += r.value;
    cur.tasks += 1;
    cur.firstAt = Math.min(cur.firstAt, r.createdAtMs);
    candidates.set(r.assigneeId, cur);
  }
  const owners = /* @__PURE__ */ new Map();
  for (const [gateId, candidates] of candidatesByGate) {
    const owner = [...candidates.entries()].sort(
      ([aId, a], [bId, b]) => b.value - a.value || b.tasks - a.tasks || a.firstAt - b.firstAt || aId.localeCompare(bId)
    )[0]?.[0];
    if (owner != null) owners.set(gateId, owner);
  }
  return owners;
}

// src/domain/quest/product-attachment.ts
var QuestProductAttachmentViolation = {
  /** 붙이려는 제품이 존재하지 않는다. */
  PRODUCT_NOT_FOUND: "PRODUCT_NOT_FOUND",
  /** 제품의 팀 ≠ 퀘스트의 팀. 팀 미배정 제품(teamId null)도 여기로 온다. */
  TEAM_MISMATCH: "TEAM_MISMATCH",
  /** 팀 퀘스트가 아닌데 제품이 붙었다 — 맞출 팀 자체가 없다. */
  SCOPE_NOT_TEAM: "SCOPE_NOT_TEAM",
  /** 제품과 시나리오가 동시에 붙었다 — 두 축은 배타다. */
  SCENARIO_EXCLUSIVE: "SCENARIO_EXCLUSIVE"
};
function checkQuestProductAttachment(input) {
  if (input.productId === null) return null;
  if (input.scenarioId) {
    return QuestProductAttachmentViolation.SCENARIO_EXCLUSIVE;
  }
  if (input.scope !== QuestScope.TEAM) {
    return QuestProductAttachmentViolation.SCOPE_NOT_TEAM;
  }
  if (input.product === null) {
    return QuestProductAttachmentViolation.PRODUCT_NOT_FOUND;
  }
  if (input.product.teamId !== input.teamId) {
    return QuestProductAttachmentViolation.TEAM_MISMATCH;
  }
  return null;
}

// src/domain/quest/transitions.ts
var QUEST_STATES = [
  "DRAFT/DRAFT",
  "DRAFT/PENDING_APPROVAL",
  "DRAFT/REJECTED",
  "ACTIVE/APPROVED",
  "LOCKED/APPROVED",
  "COMPLETED/APPROVED",
  "FAILED/APPROVED",
  "WITHDRAWN/APPROVED",
  "ARCHIVED/APPROVED",
  "ARCHIVED/REJECTED"
];
var QUEST_TRANSITIONS = {
  "DRAFT/DRAFT": ["DRAFT/PENDING_APPROVAL"],
  "DRAFT/PENDING_APPROVAL": ["ACTIVE/APPROVED", "DRAFT/REJECTED"],
  "DRAFT/REJECTED": ["DRAFT/PENDING_APPROVAL"],
  "ACTIVE/APPROVED": [
    "LOCKED/APPROVED",
    "COMPLETED/APPROVED",
    "FAILED/APPROVED",
    "WITHDRAWN/APPROVED",
    "ARCHIVED/APPROVED",
    "DRAFT/DRAFT"
  ],
  "LOCKED/APPROVED": ["COMPLETED/APPROVED", "ARCHIVED/APPROVED", "DRAFT/DRAFT"],
  "COMPLETED/APPROVED": ["ARCHIVED/APPROVED", "DRAFT/DRAFT"],
  "FAILED/APPROVED": ["ARCHIVED/APPROVED", "DRAFT/DRAFT"],
  "WITHDRAWN/APPROVED": ["ARCHIVED/APPROVED"],
  "ARCHIVED/APPROVED": [],
  "ARCHIVED/REJECTED": []
};
function questStateOf(quest) {
  return `${quest.status}/${quest.approvalStatus}`;
}
function splitQuestState(state) {
  const [status, approvalStatus] = state.split("/");
  return { status, approvalStatus };
}
function isReachableQuestState(state) {
  return QUEST_STATES.includes(state);
}
function canTransitionQuest(from, to) {
  if (from === to) return false;
  if (!isReachableQuestState(from) || !isReachableQuestState(to)) return false;
  return QUEST_TRANSITIONS[from].includes(to);
}
function questTransitionSourcesTo(to) {
  return QUEST_STATES.filter((from) => canTransitionQuest(from, to));
}

// src/domain/quest/distribution.ts
var DISTRIBUTION_KINDS = [
  "auto",
  "override",
  "fallback_proof_single",
  "qualitative_single",
  "no_op"
];
var NO_OP = {
  kind: "no_op",
  recipients: [],
  totalDistributed: 0
};
function computeDistribution(input) {
  if (input.rewardPoints <= 0) return NO_OP;
  if (input.override) {
    return applyOverride(input.override, input.rewardPoints);
  }
  const validTasks = input.tasks.filter(
    (t) => typeof t.value === "number" && t.value > 0
  );
  if (validTasks.length === 0) {
    if (!input.fallbackUserId) return NO_OP;
    return {
      kind: "fallback_proof_single",
      recipients: [{ userId: input.fallbackUserId, amount: input.rewardPoints }],
      totalDistributed: input.rewardPoints
    };
  }
  const totalValue = validTasks.reduce((sum2, t) => sum2 + t.value, 0);
  const perTask = validTasks.map((t) => ({
    userId: t.assigneeId,
    amount: Math.floor(t.value / totalValue * input.rewardPoints)
  }));
  const sum = perTask.reduce((s, d) => s + d.amount, 0);
  const remainder = input.rewardPoints - sum;
  if (remainder > 0 && perTask[0]) {
    perTask[0].amount += remainder;
  }
  const userTotals = /* @__PURE__ */ new Map();
  for (const d of perTask) {
    userTotals.set(d.userId, (userTotals.get(d.userId) ?? 0) + d.amount);
  }
  const recipients = Array.from(userTotals, ([userId, amount]) => ({
    userId,
    amount
  })).filter((r) => r.amount > 0);
  const totalDistributed = recipients.reduce((s, r) => s + r.amount, 0);
  return { kind: "auto", recipients, totalDistributed };
}
function applyOverride(override, rewardPoints) {
  const entries = Object.entries(override);
  if (entries.length === 0) return NO_OP;
  const sumPct = entries.reduce((s, [, pct]) => s + pct, 0);
  if (sumPct <= 0) return NO_OP;
  const perUser = entries.map(([userId, pct]) => ({
    userId,
    amount: Math.floor(pct / sumPct * rewardPoints)
  }));
  const sum = perUser.reduce((s, d) => s + d.amount, 0);
  const remainder = rewardPoints - sum;
  if (remainder > 0 && perUser[0]) {
    perUser[0].amount += remainder;
  }
  const recipients = perUser.filter((r) => r.amount > 0);
  const totalDistributed = recipients.reduce((s, r) => s + r.amount, 0);
  return { kind: "override", recipients, totalDistributed };
}

// src/domain/quest/index.ts
var QuestDifficulty = {
  COMMON: "COMMON",
  UNCOMMON: "UNCOMMON",
  RARE: "RARE",
  EPIC: "EPIC",
  LEGENDARY: "LEGENDARY"
};

// src/domain/advertiser/advertiser.ts
function normalizeAdvertiserName(name) {
  return name.trim().toLowerCase();
}
function createAdvertiser(params) {
  if (!params.name.trim()) {
    throw new Error("Advertiser name cannot be empty");
  }
  const normalized = normalizeAdvertiserName(params.name);
  if (!normalized) {
    throw new Error("Advertiser name normalized is empty after trim");
  }
  return {
    id: params.id,
    name: params.name,
    nameNormalized: normalized,
    displayName: params.displayName ?? null,
    note: params.note ?? null,
    country: params.country ?? null,
    firstMeetingAt: params.firstMeetingAt ?? null,
    mergedIntoAdvertiserId: null,
    reviewFlaggedAt: null,
    reviewFlagNote: null,
    isActive: true,
    isSystem: params.isSystem ?? false,
    contractPartyKind: "UNKNOWN",
    createdAt: params.now,
    updatedAt: params.now
  };
}
function updateAdvertiser(advertiser, updates, now) {
  if (advertiser.isSystem) {
    throw new Error("Cannot update system advertiser");
  }
  return {
    ...advertiser,
    displayName: updates.displayName !== void 0 ? updates.displayName : advertiser.displayName,
    note: updates.note !== void 0 ? updates.note : advertiser.note,
    updatedAt: now
  };
}
function setAdvertiserActive(advertiser, isActive, now) {
  if (advertiser.isSystem) {
    throw new Error("Cannot toggle active state on system advertiser");
  }
  return {
    ...advertiser,
    isActive,
    updatedAt: now
  };
}
function assertAdvertiserUsable(advertiser) {
  if (advertiser.isSystem) {
    throw new Error(`Cannot use system advertiser: ${advertiser.name}`);
  }
  if (!advertiser.isActive) {
    throw new Error(`Cannot use inactive advertiser: ${advertiser.name}`);
  }
  if (advertiser.mergedIntoAdvertiserId !== null) {
    throw new Error(
      `Cannot use merged advertiser: ${advertiser.name} (merged into ${advertiser.mergedIntoAdvertiserId})`
    );
  }
}

// src/domain/advertiser/index.ts
var CONTRACT_PARTY_KINDS = ["BRAND", "AGENCY", "DISTRIBUTOR", "UNKNOWN"];

// src/domain/attendance/values.ts
var AttendanceStatus = {
  CLOCKED_IN: "CLOCKED_IN",
  ON_BREAK: "ON_BREAK",
  CLOCKED_OUT: "CLOCKED_OUT",
  ABSENT: "ABSENT"
};
var SegmentType = {
  WORK: "WORK",
  BREAK: "BREAK",
  // 동아리 활동 시간 — 근무시간 집계/분류에서 제외(type===WORK 필터가 자동 배제).
  // 출처 식별은 sourceType='CLUB_FEED'. 일반 근무·연장·야간 판정에 섞이지 않는다.
  CLUB: "CLUB"
};
var ScheduleType = {
  WORKDAY: "WORKDAY",
  OFF_DAY: "OFF_DAY",
  HOLIDAY: "HOLIDAY"
};

// src/domain/attendance/attendance.ts
function detectMissedClockOut(existingActiveAttendance, now) {
  if (!existingActiveAttendance) return null;
  if (existingActiveAttendance.clockOutAt) return null;
  const clockInDate = new Date(existingActiveAttendance.clockInAt);
  const nowDate = new Date(now);
  const nowKst = toKstParts(nowDate);
  const clockInKst = toKstParts(clockInDate);
  const clockInEpochDay = Math.floor(
    Date.UTC(clockInKst.year, clockInKst.month - 1, clockInKst.day) / 864e5
  );
  const nowEpochDay = Math.floor(Date.UTC(nowKst.year, nowKst.month - 1, nowKst.day) / 864e5);
  const dayDiff = nowEpochDay - clockInEpochDay;
  if (nowKst.hour >= 0 && nowKst.hour < 6 && dayDiff <= 1) {
    return null;
  }
  if (dayDiff > 0) {
    return existingActiveAttendance;
  }
  return null;
}
function forceCloseAttendance(attendance, clockOutTime, reason) {
  if (attendance.status === AttendanceStatus.CLOCKED_OUT) return attendance;
  const clockOutMs = new Date(clockOutTime).getTime();
  const updatedSegments = attendance.segments.flatMap((seg) => {
    const startMs = new Date(seg.startAt).getTime();
    if (startMs > clockOutMs) return [];
    if (!seg.endAt) {
      if (seg.type === SegmentType.BREAK) {
        return [closeSegment(seg, seg.startAt)];
      }
      return [closeSegment(seg, clockOutTime)];
    }
    const endMs = new Date(seg.endAt).getTime();
    if (endMs > clockOutMs) {
      return [closeSegment(seg, clockOutTime)];
    }
    return [seg];
  });
  return {
    ...attendance,
    clockOutAt: clockOutTime,
    status: AttendanceStatus.CLOCKED_OUT,
    note: reason,
    segments: updatedSegments,
    updatedAt: clockOutTime
  };
}
function closeMissedAttendance(attendance, clockOutTime) {
  return forceCloseAttendance(attendance, clockOutTime, "\uD1F4\uADFC \uB204\uB77D \u2014 \uC218\uB3D9 \uB9C8\uAC10");
}
function exceedsDailyMax(attendance, maxHours, now) {
  const totalMs = attendance.segments.filter((s) => s.type === SegmentType.WORK).reduce((sum, s) => {
    if (s.duration !== null) return sum + s.duration;
    if (s.endAt) return sum + (new Date(s.endAt).getTime() - new Date(s.startAt).getTime());
    return sum + (new Date(now).getTime() - new Date(s.startAt).getTime());
  }, 0);
  return totalMs > maxHours * 36e5;
}
function validateMissedClockOutTime(clockInAt, clockOutTime, now) {
  const clockInMs = new Date(clockInAt).getTime();
  const clockOutMs = new Date(clockOutTime).getTime();
  const nowMs = new Date(now).getTime();
  if (clockOutMs <= clockInMs) {
    return "\uD1F4\uADFC \uC2DC\uAC01\uC740 \uCD9C\uADFC \uC2DC\uAC01 \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4";
  }
  if (clockOutMs > nowMs) {
    return "\uD1F4\uADFC \uC2DC\uAC01\uC740 \uD604\uC7AC \uC2DC\uAC01 \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4";
  }
  return null;
}
function validateMissedClockInTime(clockInTime, clockOutTime, now) {
  const clockInMs = new Date(clockInTime).getTime();
  const clockOutMs = new Date(clockOutTime).getTime();
  const nowMs = new Date(now).getTime();
  if (clockInMs > nowMs) {
    return "\uCD9C\uADFC \uC2DC\uAC01\uC740 \uD604\uC7AC \uC2DC\uAC01 \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4";
  }
  if (clockOutMs <= clockInMs) {
    return "\uD1F4\uADFC \uC2DC\uAC01\uC740 \uCD9C\uADFC \uC2DC\uAC01 \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4";
  }
  if (clockOutMs > nowMs) {
    return "\uD1F4\uADFC \uC2DC\uAC01\uC740 \uD604\uC7AC \uC2DC\uAC01 \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4";
  }
  return null;
}
function closeSegment(segment, now) {
  const endMs = new Date(now).getTime();
  const startMs = new Date(segment.startAt).getTime();
  const safeEnd = endMs >= startMs ? now : segment.startAt;
  const duration = endMs >= startMs ? endMs - startMs : 0;
  return {
    ...segment,
    endAt: safeEnd,
    duration
  };
}
function createSegment(id, attendanceId, type, startAt) {
  return {
    id,
    attendanceId,
    type,
    startAt,
    endAt: null,
    duration: null
  };
}
function closeAllOpenSegments(segments, endTime) {
  return segments.map((seg) => seg.endAt === null ? closeSegment(seg, endTime) : seg);
}
function validateTimeOrder(clockInAt, clockOutAt) {
  if (new Date(clockInAt).getTime() >= new Date(clockOutAt).getTime()) {
    throw new Error("\uCD9C\uADFC \uC2DC\uAC04\uC740 \uD1F4\uADFC \uC2DC\uAC04\uBCF4\uB2E4 \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4");
  }
}
function assertHasWorkSegment(segments) {
  if (!segments.some((seg) => seg.type === SegmentType.WORK)) {
    throw new Error("\uC815\uC815 \uC2DC\uAC04\uC774 \uADFC\uBB34 \uAD6C\uAC04 \uBC94\uC704\uB97C \uBC97\uC5B4\uB0A9\uB2C8\uB2E4");
  }
}
function syncSegmentBoundaries(segments, field, newTime) {
  const workSegments = segments.map((seg, idx) => ({ seg, idx })).filter(({ seg }) => seg.type === SegmentType.WORK);
  if (workSegments.length === 0) return segments;
  const msOf = (t) => new Date(t).getTime();
  const newMs = msOf(newTime);
  if (field === "clockInAt") {
    const earliestStart = Math.min(...segments.map((seg) => msOf(seg.startAt)));
    if (newMs <= earliestStart) {
      const { seg: first, idx } = workSegments[0];
      const result = [...segments];
      result[idx] = {
        ...first,
        startAt: newTime,
        duration: first.endAt ? msOf(first.endAt) - newMs : first.duration
      };
      return result;
    }
    const trimmed2 = segments.flatMap((seg) => {
      const endMs = seg.endAt ? msOf(seg.endAt) : null;
      if (endMs !== null && endMs <= newMs) return [];
      if (msOf(seg.startAt) >= newMs) return [seg];
      return [
        {
          ...seg,
          startAt: newTime,
          duration: endMs === null ? seg.duration : endMs - newMs
        }
      ];
    });
    assertHasWorkSegment(trimmed2);
    return trimmed2;
  }
  const latestBoundary = Math.max(
    ...segments.map((seg) => seg.endAt ? msOf(seg.endAt) : msOf(seg.startAt))
  );
  if (newMs >= latestBoundary) {
    const { seg: last, idx } = workSegments[workSegments.length - 1];
    const result = [...segments];
    result[idx] = { ...last, endAt: newTime, duration: newMs - msOf(last.startAt) };
    return result;
  }
  const trimmed = segments.flatMap((seg) => {
    const startMs = msOf(seg.startAt);
    if (startMs >= newMs) return [];
    const endMs = seg.endAt ? msOf(seg.endAt) : null;
    if (endMs !== null && endMs <= newMs) return [seg];
    return [{ ...seg, endAt: newTime, duration: newMs - startMs }];
  });
  assertHasWorkSegment(trimmed);
  return trimmed;
}
function resumeAttendance(attendance, segmentId, now) {
  assertStatus(
    "attendance",
    attendance.id,
    attendance.status,
    [AttendanceStatus.CLOCKED_OUT],
    "resume"
  );
  const nowMs = new Date(now).getTime();
  const truncatedSegments = attendance.segments.map((seg) => {
    const startMs = new Date(seg.startAt).getTime();
    if (!seg.endAt) {
      return { ...seg, endAt: now, duration: Math.max(0, nowMs - startMs) };
    }
    if (new Date(seg.endAt).getTime() > nowMs) {
      return { ...seg, endAt: now, duration: Math.max(0, nowMs - startMs) };
    }
    return seg;
  });
  const newSegment = createSegment(segmentId, attendance.id, SegmentType.WORK, now);
  return {
    ...attendance,
    clockOutAt: null,
    status: AttendanceStatus.CLOCKED_IN,
    segments: [...truncatedSegments, newSegment],
    updatedAt: now
  };
}
function clockIn(id, segmentId, userId, existingActiveAttendance, now) {
  if (existingActiveAttendance) {
    throw new Error(
      `User ${userId} already has an active attendance record ${existingActiveAttendance.id}`
    );
  }
  const initialSegment = createSegment(segmentId, id, SegmentType.WORK, now);
  return {
    id,
    userId,
    date: toKstDateString(new Date(now)),
    clockInAt: now,
    clockOutAt: null,
    status: AttendanceStatus.CLOCKED_IN,
    note: null,
    segments: [initialSegment],
    createdAt: now,
    updatedAt: now
  };
}
function clockOut(attendance, now) {
  assertStatus(
    "attendance",
    attendance.id,
    attendance.status,
    [AttendanceStatus.CLOCKED_IN, AttendanceStatus.ON_BREAK],
    "clock out"
  );
  const lastSegment = attendance.segments.at(-1);
  if (!lastSegment) {
    throw new Error(`Attendance ${attendance.id} has no segments to close`);
  }
  const nowMs = new Date(now).getTime();
  const normalizedSegments = attendance.segments.flatMap((seg) => {
    const startMs = new Date(seg.startAt).getTime();
    if (startMs > nowMs) return [];
    if (seg.endAt && new Date(seg.endAt).getTime() > nowMs) {
      return [closeSegment(seg, now)];
    }
    return [seg];
  });
  const lastIdx = normalizedSegments.length - 1;
  if (lastIdx < 0) {
    throw new Error(`Attendance ${attendance.id} has no segments to close`);
  }
  const finalSegment = normalizedSegments[lastIdx];
  const closedSegment = finalSegment.endAt ? finalSegment : closeSegment(finalSegment, now);
  const updatedSegments = [...normalizedSegments.slice(0, -1), closedSegment];
  return {
    ...attendance,
    clockOutAt: now,
    status: AttendanceStatus.CLOCKED_OUT,
    segments: updatedSegments,
    updatedAt: now
  };
}
var MIN_WORK_SEGMENT_BEFORE_BREAK_MS = 2e3;
function startBreak(attendance, now, segmentId) {
  assertStatus(
    "attendance",
    attendance.id,
    attendance.status,
    [AttendanceStatus.CLOCKED_IN],
    "start break on"
  );
  const lastSegment = attendance.segments.at(-1);
  if (!lastSegment) {
    throw new Error(`Attendance ${attendance.id} has no segments to start break`);
  }
  const elapsedSinceLastWorkStart = new Date(now).getTime() - new Date(lastSegment.startAt).getTime();
  if (elapsedSinceLastWorkStart < MIN_WORK_SEGMENT_BEFORE_BREAK_MS) {
    throw new Error("\uCD9C\uADFC \uC9C1\uD6C4 \uC7A0\uC2DC \uD6C4\uC5D0 \uD734\uC2DD\uC744 \uC2DC\uC791\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4 (\uC785\uB825 \uC81C\uD55C)");
  }
  const closedWorkSegment = closeSegment(lastSegment, now);
  const newBreakSegment = createSegment(segmentId, attendance.id, SegmentType.BREAK, now);
  const updatedSegments = [...attendance.segments.slice(0, -1), closedWorkSegment, newBreakSegment];
  return {
    ...attendance,
    status: AttendanceStatus.ON_BREAK,
    segments: updatedSegments,
    updatedAt: now
  };
}
function endBreak(attendance, now, segmentId) {
  assertStatus(
    "attendance",
    attendance.id,
    attendance.status,
    [AttendanceStatus.ON_BREAK],
    "end break on"
  );
  const lastSegment = attendance.segments.at(-1);
  if (!lastSegment) {
    throw new Error(`Attendance ${attendance.id} has no segments to end break`);
  }
  const closedBreakSegment = closeSegment(lastSegment, now);
  const newWorkSegment = createSegment(segmentId, attendance.id, SegmentType.WORK, now);
  const updatedSegments = [...attendance.segments.slice(0, -1), closedBreakSegment, newWorkSegment];
  return {
    ...attendance,
    status: AttendanceStatus.CLOCKED_IN,
    segments: updatedSegments,
    updatedAt: now
  };
}
function calculateTotalWorkDuration(attendance) {
  return attendance.segments.filter((segment) => segment.type === SegmentType.WORK && segment.duration !== null).reduce((total, segment) => total + (segment.duration ?? 0), 0);
}
function formatElapsed(ms) {
  const totalSeconds = Math.floor(ms / 1e3);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor(totalSeconds % 3600 / 60);
  const s = totalSeconds % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
function calculateCurrentWorkDuration(attendance, now) {
  const nowMs = new Date(now).getTime();
  return attendance.segments.filter((segment) => segment.type === SegmentType.WORK).reduce((total, segment) => {
    if (segment.duration !== null) {
      return total + segment.duration;
    }
    return total + (nowMs - new Date(segment.startAt).getTime());
  }, 0);
}
var MAX_CORRECTION_SPAN_MS = 24 * 60 * 60 * 1e3;
function applyAbsentDayCorrection(attendance, fieldName, newValue, now, newSegmentId) {
  const dayStartMs = getKstDayRange(new Date(attendance.date)).todayStart.getTime();
  const hasRealClockOut = attendance.clockOutAt !== null && new Date(attendance.clockOutAt).getTime() > dayStartMs;
  const updated = { ...attendance, segments: [], updatedAt: now };
  if (fieldName === "clockInAt") {
    if (hasRealClockOut && attendance.clockOutAt !== null) {
      validateTimeOrder(newValue, attendance.clockOutAt);
      if (new Date(attendance.clockOutAt).getTime() - new Date(newValue).getTime() > MAX_CORRECTION_SPAN_MS) {
        throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uCD9C\uADFC \uC2DC\uAC04\uC73C\uB85C\uBD80\uD130 24\uC2DC\uAC04 \uC774\uB0B4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
      }
    }
    updated.clockInAt = newValue;
    updated.clockInUnknown = false;
  } else {
    const clockOutMs = new Date(newValue).getTime();
    if (attendance.clockInUnknown === true) {
      if (clockOutMs <= dayStartMs) {
        throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uD574\uB2F9 \uB0A0\uC9DC\uC758 \uC790\uC815 \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
      }
      if (clockOutMs - dayStartMs > 2 * MAX_CORRECTION_SPAN_MS) {
        throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uD574\uB2F9 \uB0A0\uC9DC\uC758 \uC790\uC815\uC73C\uB85C\uBD80\uD130 48\uC2DC\uAC04 \uC774\uB0B4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
      }
    } else {
      const spanMs = clockOutMs - new Date(attendance.clockInAt).getTime();
      if (spanMs <= 0) {
        throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uCD9C\uADFC \uC2DC\uAC04\uBCF4\uB2E4 \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
      }
      if (spanMs > MAX_CORRECTION_SPAN_MS) {
        throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uCD9C\uADFC \uC2DC\uAC04\uC73C\uB85C\uBD80\uD130 24\uC2DC\uAC04 \uC774\uB0B4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
      }
    }
    updated.clockOutAt = newValue;
  }
  if (updated.clockInUnknown !== true && updated.clockOutAt !== null && new Date(updated.clockOutAt).getTime() > dayStartMs) {
    if (!newSegmentId) {
      throw new Error("\uADFC\uBB34 \uAD6C\uAC04\uC744 \uC0DD\uC131\uD558\uB824\uBA74 \uAD6C\uAC04 ID\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4");
    }
    updated.status = AttendanceStatus.CLOCKED_OUT;
    updated.segments = [
      closeSegment(
        createSegment(newSegmentId, attendance.id, SegmentType.WORK, updated.clockInAt),
        updated.clockOutAt
      )
    ];
  }
  return updated;
}
function applyCorrection(attendance, fieldName, newValue, now, newSegmentId) {
  const updated = { ...attendance, segments: [...attendance.segments] };
  if (fieldName === "clockInAt" || fieldName === "clockOutAt") {
    if (new Date(newValue).getTime() > new Date(now).getTime()) {
      throw new Error(
        fieldName === "clockInAt" ? "\uCD9C\uADFC \uC2DC\uAC01\uC740 \uD604\uC7AC \uC2DC\uAC01 \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uD1F4\uADFC \uC2DC\uAC01\uC740 \uD604\uC7AC \uC2DC\uAC01 \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4"
      );
    }
  }
  if (attendance.status === AttendanceStatus.ABSENT && (fieldName === "clockInAt" || fieldName === "clockOutAt")) {
    return applyAbsentDayCorrection(attendance, fieldName, newValue, now, newSegmentId);
  }
  if (fieldName === "clockInAt") {
    if (attendance.clockOutAt) {
      validateTimeOrder(newValue, attendance.clockOutAt);
    }
    updated.clockInAt = newValue;
    if (attendance.clockInUnknown === true) {
      updated.clockInUnknown = false;
    }
    updated.segments = syncSegmentBoundaries(updated.segments, "clockInAt", newValue);
  } else if (fieldName === "clockOutAt") {
    if (new Date(newValue).getTime() <= new Date(attendance.clockInAt).getTime()) {
      throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uCD9C\uADFC \uC2DC\uAC04\uBCF4\uB2E4 \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
    }
    if (new Date(newValue).getTime() - new Date(attendance.clockInAt).getTime() > MAX_CORRECTION_SPAN_MS) {
      throw new Error("\uD1F4\uADFC \uC2DC\uAC04\uC740 \uCD9C\uADFC \uC2DC\uAC04\uC73C\uB85C\uBD80\uD130 24\uC2DC\uAC04 \uC774\uB0B4\uC5EC\uC57C \uD569\uB2C8\uB2E4");
    }
    updated.clockOutAt = newValue;
    if (attendance.status === AttendanceStatus.CLOCKED_IN) {
      updated.status = AttendanceStatus.CLOCKED_OUT;
    }
    updated.segments = syncSegmentBoundaries(updated.segments, "clockOutAt", newValue);
  } else if (fieldName === "status") {
    updated.status = newValue;
    if (newValue === AttendanceStatus.CLOCKED_OUT) {
      if (!attendance.clockOutAt) {
        updated.clockOutAt = now;
      }
      updated.segments = closeAllOpenSegments(updated.segments, now);
    }
  } else {
    throw new Error(`\uC9C0\uC6D0\uB418\uC9C0 \uC54A\uB294 \uC815\uC815 \uD56D\uBAA9\uC785\uB2C8\uB2E4: ${fieldName}`);
  }
  updated.updatedAt = now;
  return updated;
}
function applyAdminEdit(attendance, changes, now) {
  const updated = { ...attendance, segments: [...attendance.segments] };
  const changedFields = [];
  let segmentsAlreadyClosed = false;
  if (changes.clockInAt !== void 0) {
    changedFields.push({
      field: "clockInAt",
      oldValue: attendance.clockInAt,
      newValue: changes.clockInAt
    });
    updated.clockInAt = changes.clockInAt;
    if (attendance.clockInUnknown === true) {
      changedFields.push({
        field: "clockInUnknown",
        oldValue: "true",
        newValue: "false"
      });
      updated.clockInUnknown = false;
    }
  }
  if (changes.clockOutAt !== void 0) {
    changedFields.push({
      field: "clockOutAt",
      oldValue: attendance.clockOutAt,
      newValue: changes.clockOutAt
    });
    updated.clockOutAt = changes.clockOutAt;
    if (changes.status === void 0 && (updated.status === AttendanceStatus.CLOCKED_IN || updated.status === AttendanceStatus.ON_BREAK)) {
      changedFields.push({
        field: "status",
        oldValue: attendance.status,
        newValue: AttendanceStatus.CLOCKED_OUT
      });
      updated.status = AttendanceStatus.CLOCKED_OUT;
      updated.segments = closeAllOpenSegments(updated.segments, updated.clockOutAt);
      segmentsAlreadyClosed = true;
    }
  }
  if (changes.status !== void 0) {
    changedFields.push({ field: "status", oldValue: attendance.status, newValue: changes.status });
    updated.status = changes.status;
    if (changes.status === AttendanceStatus.CLOCKED_OUT) {
      if (!updated.clockOutAt) {
        updated.clockOutAt = now;
        changedFields.push({ field: "clockOutAt", oldValue: attendance.clockOutAt, newValue: now });
      }
      updated.segments = closeAllOpenSegments(updated.segments, updated.clockOutAt);
      segmentsAlreadyClosed = true;
    }
  }
  if (changes.note !== void 0) {
    updated.note = changes.note;
  }
  if (updated.clockInAt && updated.clockOutAt) {
    validateTimeOrder(updated.clockInAt, updated.clockOutAt);
  }
  if (changes.clockInAt !== void 0) {
    updated.segments = syncSegmentBoundaries(updated.segments, "clockInAt", changes.clockInAt);
  }
  if (changes.clockOutAt !== void 0 && !segmentsAlreadyClosed) {
    updated.segments = syncSegmentBoundaries(updated.segments, "clockOutAt", changes.clockOutAt);
  }
  return { attendance: updated, changedFields };
}
function applySegmentTypeCorrection(attendance, segmentId, oldType, newType, now) {
  if (oldType === newType) {
    throw new Error("\uC815\uC815 \uC804\uD6C4 \uADFC\uBB34 \uAD6C\uAC04 \uD0C0\uC785\uC774 \uB3D9\uC77C\uD569\uB2C8\uB2E4");
  }
  const idx = attendance.segments.findIndex((s) => s.id === segmentId);
  if (idx < 0) {
    throw new Error(`\uADFC\uBB34 \uAD6C\uAC04\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4: ${segmentId}`);
  }
  const target = attendance.segments[idx];
  if (target.type !== oldType) {
    throw new Error(
      `\uC815\uC815 \uC694\uCCAD \uC774\uD6C4 \uADFC\uBB34 \uAD6C\uAC04\uC774 \uBCC0\uACBD\uB418\uC5B4 \uC2B9\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4 (current=${target.type}, expected=${oldType})`
    );
  }
  if (target.endAt === null) {
    throw new Error("\uC9C4\uD589 \uC911\uC778 \uADFC\uBB34 \uAD6C\uAC04\uC740 \uD0C0\uC785\uC744 \uC815\uC815\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4");
  }
  const updatedSegment = { ...target, type: newType };
  const updatedSegments = [...attendance.segments];
  updatedSegments[idx] = updatedSegment;
  return {
    ...attendance,
    segments: updatedSegments,
    updatedAt: now
  };
}
function deriveClockTimesFromSegments(segments) {
  if (segments.length === 0) return null;
  let earliest = Infinity;
  let latest = -Infinity;
  let hasOpen = false;
  for (const seg of segments) {
    const start = new Date(seg.startAt).getTime();
    if (start < earliest) earliest = start;
    if (seg.endAt) {
      const end = new Date(seg.endAt).getTime();
      if (end > latest) latest = end;
    } else {
      hasOpen = true;
    }
  }
  return {
    clockInAt: new Date(earliest).toISOString(),
    clockOutAt: hasOpen ? null : new Date(latest).toISOString()
  };
}
function validateSegmentTimes(segments) {
  if (segments.length === 0) return { valid: true };
  for (let i = 0; i < segments.length; i++) {
    const seg = segments[i];
    const start = new Date(seg.startAt).getTime();
    const end = seg.endAt ? new Date(seg.endAt).getTime() : null;
    if (end !== null && start > end) {
      return {
        valid: false,
        error: `\uADFC\uBB34 \uAD6C\uAC04 ${i + 1}: \uC2DC\uC791 \uC2DC\uAC04\uC774 \uC885\uB8CC \uC2DC\uAC04\uBCF4\uB2E4 \uB2A6\uC2B5\uB2C8\uB2E4`
      };
    }
  }
  const sorted = [...segments].map((s) => ({
    start: new Date(s.startAt).getTime(),
    end: s.endAt ? new Date(s.endAt).getTime() : null
  })).sort((a, b) => a.start - b.start);
  for (let i = 0; i < sorted.length - 1; i++) {
    const current = sorted[i];
    const next = sorted[i + 1];
    if (current.end !== null && current.end > next.start) {
      return { valid: false, error: "\uADFC\uBB34 \uAD6C\uAC04 \uC2DC\uAC04\uC774 \uACB9\uCE69\uB2C8\uB2E4" };
    }
  }
  return { valid: true };
}

// src/domain/leave/values.ts
var LeaveProofStatus = {
  NOT_REQUIRED: "NOT_REQUIRED",
  PENDING: "PENDING",
  SUBMITTED: "SUBMITTED",
  REVIEWED: "REVIEWED",
  OVERDUE: "OVERDUE"
};
var LeaveType = {
  ANNUAL: "ANNUAL",
  SICK: "SICK",
  SPECIAL: "SPECIAL"
};
function isLeaveType(value) {
  return Object.values(LeaveType).includes(value);
}
function parseLeaveType(value) {
  if (!isLeaveType(value)) {
    throw new Error(`\uC54C \uC218 \uC5C6\uB294 \uD734\uAC00 \uC885\uB958\uC785\uB2C8\uB2E4: ${String(value)}`);
  }
  return value;
}

// src/domain/leave/leave.ts
import { startOfDay as startOfDay2, isWeekend as isWeekend2, eachDayOfInterval as eachDayOfInterval2 } from "date-fns";
function canReviewProof(proofStatus) {
  return proofStatus === LeaveProofStatus.SUBMITTED;
}
function canRequestResubmit(proofStatus) {
  return proofStatus === LeaveProofStatus.SUBMITTED;
}
function resolveLeaveApprovalAuthority(input) {
  if (input.actorId === input.requesterId) return null;
  if (input.approverIds.includes(input.actorId)) return "DESIGNATED";
  if (input.actorHasHrManagement) return "HR_PROXY";
  return null;
}
function calculateServicePeriod(hireDate, referenceDate = /* @__PURE__ */ new Date()) {
  const hire = toKstParts(hireDate);
  const ref = toKstParts(referenceDate);
  const annMonth = hire.month;
  const lastDayOfAnnMonth = new Date(ref.year, annMonth, 0).getDate();
  const annDay = Math.min(hire.day, lastDayOfAnnMonth);
  let years = ref.year - hire.year;
  if (ref.month < annMonth || ref.month === annMonth && ref.day < annDay) {
    years--;
  }
  years = Math.max(years, 0);
  let months = (ref.year - hire.year) * 12 + (ref.month - hire.month);
  const lastDayOfRefMonth = new Date(ref.year, ref.month, 0).getDate();
  const adjustedHireDay = Math.min(hire.day, lastDayOfRefMonth);
  if (ref.day < adjustedHireDay) {
    months--;
  }
  months = Math.max(months, 0);
  return { completedYears: years, completedMonths: months };
}
function calculateAnnualLeaveEntitlement(completedYears, completedMonths) {
  if (completedYears < 1) {
    return Math.min(Math.max(completedMonths, 0), 11);
  }
  return Math.min(15 + Math.floor((completedYears - 1) / 2), 25);
}
function validateLeaveBalance(entitled, carryover, used, requestDays) {
  const remaining = entitled + carryover - used;
  return { valid: remaining >= requestDays, remaining };
}
function validateHalfDayRequest(startDate, endDate, days, weekdayCount) {
  if (startDate !== endDate) return { valid: false, errorCode: "HALF_DAY_SINGLE_ONLY" };
  if (days !== 0.5) return { valid: false, errorCode: "HALF_DAY_HALF_ONLY" };
  if (weekdayCount !== 1) return { valid: false, errorCode: "HALF_DAY_NO_WEEKEND" };
  return { valid: true };
}
function isBalanceDeductible(leaveType) {
  return leaveType === LeaveType.ANNUAL;
}
function isPastDate(dateStr, todayKst) {
  return dateStr < todayKst;
}
function splitLeaveDaysByServiceYear(hireDate, startDate, endDate, totalDays) {
  if (totalDays % 1 !== 0) {
    const year = calculateServicePeriod(hireDate, startDate).completedYears;
    return /* @__PURE__ */ new Map([[year, totalDays]]);
  }
  const result = /* @__PURE__ */ new Map();
  const kstStart = startOfDay2(kstDate(startDate));
  const kstEnd = startOfDay2(kstDate(endDate));
  const days = eachDayOfInterval2({ start: kstStart, end: kstEnd });
  for (const day of days) {
    if (isWeekend2(day)) continue;
    const year = calculateServicePeriod(hireDate, day).completedYears;
    result.set(year, (result.get(year) ?? 0) + 1);
  }
  return result;
}

// src/domain/leave/index.ts
var LEAVE_TYPE_LABELS = {
  ANNUAL: "\uC5F0\uCC28",
  SICK: "\uBCD1\uAC00",
  SPECIAL: "\uACF5\uAC00"
};
var LeaveStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED"
};
var LeaveApprovalType = {
  APPROVER: "APPROVER",
  REFERRER: "REFERRER"
};
var LeaveApprovalStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};

// src/domain/attendance/weekly-holiday-pay.ts
var WEEKLY_PAY_HOURS = 5;
var MIN_WEEKLY_WORK_MS = 10 * 36e5;
function computeWeeklyHolidayPay(totalWorkMs, hourlyWage) {
  const eligible = totalWorkMs >= MIN_WEEKLY_WORK_MS;
  const amount = eligible ? hourlyWage * WEEKLY_PAY_HOURS : 0;
  return { totalWorkMs, eligible, amount };
}

// src/domain/attendance/gross-pay.ts
var MS_PER_HOUR = 36e5;
function dayBeforeKst(dateStr) {
  return toKstDateString(new Date((/* @__PURE__ */ new Date(dateStr + "T00:00:00+09:00")).getTime() - 864e5));
}
function inclusiveDayCount(start, end) {
  const startMs = (/* @__PURE__ */ new Date(start + "T00:00:00+09:00")).getTime();
  const endMs = (/* @__PURE__ */ new Date(end + "T00:00:00+09:00")).getTime();
  if (endMs < startMs) return 0;
  return Math.floor((endMs - startMs) / 864e5) + 1;
}
function computeSegmentedGrossPay(input) {
  const {
    periodStart,
    periodEnd,
    internConvertedAt,
    level,
    internWorkMs,
    internWeekWorkMs,
    hourlyCompensation,
    monthlyCompensation
  } = input;
  let internSeg;
  let fulltimeSeg;
  if (internConvertedAt == null) {
    if (level === "INTERN") {
      internSeg = { start: periodStart, end: periodEnd, empty: false };
      fulltimeSeg = { start: periodStart, end: periodStart, empty: true };
    } else {
      internSeg = { start: periodStart, end: periodStart, empty: true };
      fulltimeSeg = { start: periodStart, end: periodEnd, empty: false };
    }
  } else {
    const rawInternEnd = dayBeforeKst(internConvertedAt);
    const internEnd = rawInternEnd > periodEnd ? periodEnd : rawInternEnd;
    internSeg = { start: periodStart, end: internEnd, empty: internEnd < periodStart };
    const fulltimeStart = internConvertedAt < periodStart ? periodStart : internConvertedAt;
    fulltimeSeg = {
      start: fulltimeStart,
      end: periodEnd,
      empty: fulltimeStart > periodEnd
    };
  }
  let weeklyHolidayPayAmount = 0;
  if (hourlyCompensation && !internSeg.empty) {
    for (const weekMs of internWeekWorkMs) {
      weeklyHolidayPayAmount += computeWeeklyHolidayPay(weekMs, hourlyCompensation.amount).amount;
    }
  }
  let internGross;
  if (internSeg.empty) {
    internGross = 0;
  } else if (!hourlyCompensation) {
    internGross = null;
  } else {
    const hours = internWorkMs / MS_PER_HOUR;
    internGross = Math.round(hourlyCompensation.amount * hours) + weeklyHolidayPayAmount;
  }
  let fulltimeGross;
  if (fulltimeSeg.empty) {
    fulltimeGross = 0;
  } else if (!monthlyCompensation) {
    fulltimeGross = null;
  } else {
    const periodDays = inclusiveDayCount(periodStart, periodEnd);
    const fulltimeDays = inclusiveDayCount(fulltimeSeg.start, fulltimeSeg.end);
    const denominator = periodDays > 0 ? periodDays : 1;
    fulltimeGross = Math.round(monthlyCompensation.amount * (fulltimeDays / denominator));
  }
  const totalGross = internGross == null || fulltimeGross == null ? null : internGross + fulltimeGross;
  return {
    internGross,
    fulltimeGross,
    weeklyHolidayPayAmount,
    totalGross
  };
}

// src/domain/attendance/aggregate.ts
import {
  startOfDay as startOfDay3,
  eachDayOfInterval as eachDayOfInterval3,
  isWeekend as isWeekend3,
  getMonth,
  getDate,
  getYear,
  startOfWeek as startOfWeek2,
  format as format2
} from "date-fns";
function isInternSegmentDay(dateStr, internCutoff, level) {
  if (internCutoff != null) return dateStr < internCutoff;
  return level === "INTERN";
}
function countBusinessDays(startDate, endDate, holidays) {
  const start = startOfDay3(kstDate(/* @__PURE__ */ new Date(startDate + "T00:00:00+09:00")));
  const end = startOfDay3(kstDate(/* @__PURE__ */ new Date(endDate + "T00:00:00+09:00")));
  const days = eachDayOfInterval3({ start, end });
  const businessDays = days.filter((d) => !isWeekend3(d)).length;
  const holidayWeekdays = /* @__PURE__ */ new Set();
  for (const h of holidays) {
    const hDate = h.date instanceof Date ? h.date : new Date(h.date);
    if (h.isRecurring) {
      const m = getMonth(hDate);
      const d = getDate(hDate);
      const startYear = getYear(start);
      const endYear = getYear(end);
      for (let y = startYear; y <= endYear; y++) {
        const mm = String(m + 1).padStart(2, "0");
        const dd = String(d).padStart(2, "0");
        const candidate = startOfDay3(kstDate(/* @__PURE__ */ new Date(`${y}-${mm}-${dd}`)));
        if (!isWeekend3(candidate) && candidate >= start && candidate <= end) {
          holidayWeekdays.add(`${y}-${m}-${d}`);
        }
      }
    } else {
      const y = getYear(hDate);
      const m = getMonth(hDate);
      const d = getDate(hDate);
      const mm = String(m + 1).padStart(2, "0");
      const dd = String(d).padStart(2, "0");
      const candidate = startOfDay3(kstDate(/* @__PURE__ */ new Date(`${y}-${mm}-${dd}`)));
      if (!isWeekend3(candidate) && candidate >= start && candidate <= end) {
        holidayWeekdays.add(`${y}-${m}-${d}`);
      }
    }
  }
  return Math.max(0, businessDays - holidayWeekdays.size);
}
function kstPreviousDate(dateStr) {
  return toKstDateString(new Date((/* @__PURE__ */ new Date(dateStr + "T00:00:00+09:00")).getTime() - 864e5));
}
function toKstDateOnly(value) {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  return toKstDateString(new Date(value));
}
function expandLeaveBusinessDates(leaveStart, leaveEnd, holidayDates, userScheduleMap, clipStart, endForUser) {
  const start = startOfDay3(kstDate(/* @__PURE__ */ new Date(leaveStart + "T00:00:00+09:00")));
  const end = startOfDay3(kstDate(/* @__PURE__ */ new Date(leaveEnd + "T00:00:00+09:00")));
  if (end < start) return { dates: [], weekdayCountInRange: 0 };
  const dates = [];
  let weekdayCountInRange = 0;
  for (const d of eachDayOfInterval3({ start, end })) {
    if (isWeekend3(d)) continue;
    weekdayCountInRange++;
    const dateStr = format2(d, "yyyy-MM-dd");
    if (holidayDates.has(dateStr)) continue;
    const scheduleType = userScheduleMap?.get(dateStr);
    if (scheduleType === "OFF_DAY" || scheduleType === "HOLIDAY") continue;
    if (dateStr < clipStart || dateStr > endForUser) continue;
    dates.push(dateStr);
  }
  return { dates, weekdayCountInRange };
}
function computeAttendanceAggregate(input) {
  const {
    users,
    attendances,
    classifications,
    holidays,
    leaves,
    leaveBalances,
    schedules,
    startDate,
    endDate,
    today,
    nowKstMinutes,
    coreTimeStartMinutes,
    coreTimeEndMinutes,
    standardWorkMs
  } = input;
  const remainingByUser = /* @__PURE__ */ new Map();
  for (const b of leaveBalances ?? []) {
    remainingByUser.set(b.userId, b.remaining);
  }
  const todaySettled = nowKstMinutes != null && coreTimeEndMinutes != null && nowKstMinutes >= coreTimeEndMinutes;
  const lastSettledDate = today ? todaySettled ? today : kstPreviousDate(today) : null;
  const effectiveEnd = lastSettledDate && lastSettledDate < endDate ? lastSettledDate : endDate;
  const totalBusinessDays = effectiveEnd < startDate ? 0 : countBusinessDays(startDate, effectiveEnd, holidays);
  const terminationByUser = /* @__PURE__ */ new Map();
  for (const u of users) {
    if (u.terminationDate) terminationByUser.set(u.id, u.terminationDate);
  }
  const endForUserOf = (userId) => {
    const term = terminationByUser.get(userId);
    return term && term < effectiveEnd ? term : effectiveEnd;
  };
  const extraOffDaysByUser = /* @__PURE__ */ new Map();
  if (schedules && schedules.length > 0) {
    const publicHolidayDates = /* @__PURE__ */ new Set();
    for (const h of holidays) {
      const hDate = h.date instanceof Date ? h.date : new Date(h.date);
      publicHolidayDates.add(toUtcDateString(hDate));
    }
    const hireDateByUser = /* @__PURE__ */ new Map();
    for (const u of users) {
      if (u.hireDate) hireDateByUser.set(u.id, u.hireDate);
    }
    for (const s of schedules) {
      if (s.scheduleType === "OFF_DAY" || s.scheduleType === "HOLIDAY") {
        if (s.date > endForUserOf(s.userId)) continue;
        const hire = hireDateByUser.get(s.userId);
        if (hire && s.date < hire) continue;
        const d = startOfDay3(kstDate(/* @__PURE__ */ new Date(s.date + "T00:00:00+09:00")));
        if (isWeekend3(d) || publicHolidayDates.has(s.date)) continue;
        extraOffDaysByUser.set(s.userId, (extraOffDaysByUser.get(s.userId) ?? 0) + 1);
      }
    }
  }
  const attendanceByUser = /* @__PURE__ */ new Map();
  for (const row of attendances) {
    if (!attendanceByUser.has(row.userId)) {
      attendanceByUser.set(row.userId, []);
    }
    attendanceByUser.get(row.userId).push(row);
  }
  const segmentToUser = /* @__PURE__ */ new Map();
  const segmentToDate = /* @__PURE__ */ new Map();
  for (const row of attendances) {
    const rowDate = toKstDateString(new Date(row.clockInAt));
    for (const seg of row.segments) {
      segmentToUser.set(seg.id, row.userId);
      segmentToDate.set(seg.id, rowDate);
    }
  }
  const internCutoffByUser = /* @__PURE__ */ new Map();
  const levelByUser = /* @__PURE__ */ new Map();
  for (const u of users) {
    internCutoffByUser.set(
      u.id,
      u.internConvertedAt ? toKstDateString(new Date(u.internConvertedAt)) : null
    );
    levelByUser.set(u.id, u.level);
  }
  const emptyClassMetrics = () => ({
    nightMs: 0,
    holidayMs: 0,
    overtimeMs: 0,
    nightOvertimeMs: 0
  });
  const classificationByUser = /* @__PURE__ */ new Map();
  for (const c of classifications) {
    const userId = segmentToUser.get(c.segmentId);
    if (!userId) continue;
    if (!classificationByUser.has(userId)) {
      classificationByUser.set(userId, {
        intern: emptyClassMetrics(),
        fulltime: emptyClassMetrics()
      });
    }
    const buckets = classificationByUser.get(userId);
    const dateStr = segmentToDate.get(c.segmentId);
    const isIntern = dateStr != null && isInternSegmentDay(dateStr, internCutoffByUser.get(userId) ?? null, levelByUser.get(userId));
    const agg = isIntern ? buckets.intern : buckets.fulltime;
    if (c.isNight) agg.nightMs += c.duration;
    if (c.isHoliday) agg.holidayMs += c.duration;
    if (c.isOvertime) agg.overtimeMs += c.duration;
    if (c.isNight && c.isOvertime) agg.nightOvertimeMs += c.duration;
  }
  const leavesByUser = /* @__PURE__ */ new Map();
  for (const leave of leaves) {
    if (!leavesByUser.has(leave.userId)) {
      leavesByUser.set(leave.userId, []);
    }
    leavesByUser.get(leave.userId).push(leave);
  }
  const lateHolidayDates = /* @__PURE__ */ new Set();
  {
    const rangeStartYear = getYear(startOfDay3(kstDate(/* @__PURE__ */ new Date(startDate + "T00:00:00+09:00"))));
    const rangeEndYear = getYear(startOfDay3(kstDate(/* @__PURE__ */ new Date(effectiveEnd + "T00:00:00+09:00"))));
    for (const h of holidays) {
      const hDate = h.date instanceof Date ? h.date : new Date(h.date);
      if (h.isRecurring) {
        const m = getMonth(hDate);
        const d = getDate(hDate);
        for (let y = rangeStartYear; y <= rangeEndYear; y++) {
          const mm = String(m + 1).padStart(2, "0");
          const dd = String(d).padStart(2, "0");
          lateHolidayDates.add(`${y}-${mm}-${dd}`);
        }
      } else {
        lateHolidayDates.add(toUtcDateString(hDate));
      }
    }
  }
  const scheduleByUser = /* @__PURE__ */ new Map();
  for (const s of schedules ?? []) {
    if (!scheduleByUser.has(s.userId)) scheduleByUser.set(s.userId, /* @__PURE__ */ new Map());
    scheduleByUser.get(s.userId).set(s.date, s.scheduleType);
  }
  const leaveClipHolidayDates = /* @__PURE__ */ new Set();
  {
    const rangeStartYear = getYear(startOfDay3(kstDate(/* @__PURE__ */ new Date(startDate + "T00:00:00+09:00"))));
    const rangeEndYear = getYear(startOfDay3(kstDate(/* @__PURE__ */ new Date(effectiveEnd + "T00:00:00+09:00"))));
    for (const h of holidays) {
      const hDate = h.date instanceof Date ? h.date : new Date(h.date);
      if (h.isRecurring) {
        const m = getMonth(hDate);
        const d = getDate(hDate);
        for (let y = rangeStartYear; y <= rangeEndYear; y++) {
          const mm = String(m + 1).padStart(2, "0");
          const dd = String(d).padStart(2, "0");
          leaveClipHolidayDates.add(`${y}-${mm}-${dd}`);
        }
      } else {
        leaveClipHolidayDates.add(toKstDateString(hDate));
      }
    }
  }
  return users.map((user) => {
    const userAttendance = attendanceByUser.get(user.id) || [];
    const workDays = userAttendance.filter((a) => a.status !== "ABSENT").length;
    const internCutoff = internCutoffByUser.get(user.id) ?? null;
    let internWorkDays = 0;
    let fulltimeWorkDays = 0;
    let internSegWorkMs = 0;
    let fulltimeSegWorkMs = 0;
    let internSegOvertimeMs = 0;
    let fulltimeSegOvertimeMs = 0;
    const endForUser = endForUserOf(user.id);
    const userScheduleMap = scheduleByUser.get(user.id);
    let lateDays = 0;
    let totalWorkMs = 0;
    let totalOvertimeMs = 0;
    let inProgressDays = 0;
    let businessWorkDays = 0;
    const businessWorkDates = /* @__PURE__ */ new Set();
    for (const attendance of userAttendance) {
      const clockInDate = new Date(attendance.clockInAt);
      const clockInDateStr = toKstDateString(clockInDate);
      const isInternDay = isInternSegmentDay(clockInDateStr, internCutoff, user.level);
      if (attendance.status !== "ABSENT") {
        if (isInternDay) internWorkDays++;
        else fulltimeWorkDays++;
      }
      const scheduleType = userScheduleMap?.get(clockInDateStr);
      const isWeekendDay = isWeekend3(kstDate(clockInDate));
      const isPublicHoliday = lateHolidayDates.has(clockInDateStr);
      const isWorkday = scheduleType === "WORKDAY" ? true : !isWeekendDay && !isPublicHoliday && scheduleType !== "OFF_DAY" && scheduleType !== "HOLIDAY";
      const isWeekendByDate = isWeekend3(
        startOfDay3(kstDate(/* @__PURE__ */ new Date(clockInDateStr + "T00:00:00+09:00")))
      );
      if (attendance.status !== "ABSENT" && // 분모(baseBusinessDays = [clipStart, endForUser])와 같은 정산 경계로 상한 클립.
      // 미정산 당일(effectiveEnd=어제)의 출근은 분모에 없으므로 분자에서도 빼 "출근 > 의무" 비대칭을 막는다.
      clockInDateStr <= endForUser && !isWeekendByDate && !isPublicHoliday && scheduleType !== "OFF_DAY" && scheduleType !== "HOLIDAY") {
        businessWorkDays++;
        businessWorkDates.add(clockInDateStr);
      }
      if (isWorkday) {
        const clockInKstMinutes = toKstTimeMinutes(clockInDate);
        if (clockInKstMinutes > coreTimeStartMinutes) {
          lateDays++;
        }
      }
      let dayWorkMs = 0;
      let hasOpenWork = false;
      for (const segment of attendance.segments) {
        if (segment.type === "WORK") {
          if (segment.duration != null) {
            dayWorkMs += segment.duration;
            totalWorkMs += segment.duration;
          } else {
            hasOpenWork = true;
          }
        }
      }
      if (attendance.status !== "ABSENT" && hasOpenWork && clockInDateStr <= endForUser && !isWeekendDay && !isPublicHoliday && scheduleType !== "OFF_DAY" && scheduleType !== "HOLIDAY") {
        inProgressDays++;
      }
      if (isInternDay) internSegWorkMs += dayWorkMs;
      else fulltimeSegWorkMs += dayWorkMs;
      if (dayWorkMs > standardWorkMs) {
        const otMs = dayWorkMs - standardWorkMs;
        totalOvertimeMs += otMs;
        if (isInternDay) internSegOvertimeMs += otMs;
        else fulltimeSegOvertimeMs += otMs;
      }
    }
    const userLeaves = leavesByUser.get(user.id) || [];
    const leaveDaysByType = Object.fromEntries(
      Object.values(LeaveType).map((type) => [type, 0])
    );
    for (const leave of userLeaves) {
      if (isLeaveType(leave.leaveType)) leaveDaysByType[leave.leaveType] += leave.days;
    }
    const annualDays = leaveDaysByType.ANNUAL;
    const sickDays = leaveDaysByType.SICK;
    const specialDays = leaveDaysByType.SPECIAL;
    const totalLeaveDays = Object.values(leaveDaysByType).reduce((sum, days) => sum + days, 0);
    const userClassification = classificationByUser.get(user.id);
    const internClass = userClassification?.intern;
    const fulltimeClass = userClassification?.fulltime;
    const classTotal = userClassification ? {
      nightMs: userClassification.intern.nightMs + userClassification.fulltime.nightMs,
      holidayMs: userClassification.intern.holidayMs + userClassification.fulltime.holidayMs,
      overtimeMs: userClassification.intern.overtimeMs + userClassification.fulltime.overtimeMs,
      nightOvertimeMs: userClassification.intern.nightOvertimeMs + userClassification.fulltime.nightOvertimeMs
    } : null;
    let weeklyHolidayPay;
    let internWorkMs = 0;
    let internWeekWorkMs = [];
    const hasInternPhase = user.level === "INTERN" && internCutoff == null || internCutoff != null && internCutoff > startDate;
    if (hasInternPhase) {
      const whpHolidayDates = /* @__PURE__ */ new Set();
      const rangeStart = startOfDay3(kstDate(/* @__PURE__ */ new Date(startDate + "T00:00:00+09:00")));
      const rangeEnd = startOfDay3(kstDate(/* @__PURE__ */ new Date(effectiveEnd + "T00:00:00+09:00")));
      for (const h of holidays) {
        const hDate = h.date instanceof Date ? h.date : new Date(h.date);
        if (h.isRecurring) {
          const m = getMonth(hDate);
          const d = getDate(hDate);
          for (let y = getYear(rangeStart); y <= getYear(rangeEnd); y++) {
            const mm = String(m + 1).padStart(2, "0");
            const dd = String(d).padStart(2, "0");
            whpHolidayDates.add(`${y}-${mm}-${dd}`);
          }
        } else {
          whpHolidayDates.add(toUtcDateString(hDate));
        }
      }
      const workMsByWeek = /* @__PURE__ */ new Map();
      for (const attendance of userAttendance) {
        if (attendance.status === "ABSENT") continue;
        const clockInDate = new Date(attendance.clockInAt);
        const dateStr = toKstDateString(clockInDate);
        if (internCutoff != null && dateStr >= internCutoff) continue;
        let dayMs = 0;
        for (const seg of attendance.segments) {
          if (seg.type === "WORK" && seg.duration != null) {
            dayMs += seg.duration;
          }
        }
        internWorkMs += dayMs;
        const kstClockIn = kstDate(clockInDate);
        if (isWeekend3(kstClockIn)) continue;
        if (whpHolidayDates.has(dateStr)) continue;
        const weekStart = startOfWeek2(kstClockIn, { weekStartsOn: 1 });
        const weekKey = format2(weekStart, "yyyy-MM-dd");
        workMsByWeek.set(weekKey, (workMsByWeek.get(weekKey) ?? 0) + dayMs);
      }
      let eligibleWeeks = 0;
      for (const totalWorkMs2 of workMsByWeek.values()) {
        if (computeWeeklyHolidayPay(totalWorkMs2, 0).eligible) eligibleWeeks++;
      }
      internWeekWorkMs = [...workMsByWeek.values()];
      weeklyHolidayPay = { eligibleWeeks };
    }
    let grossPay;
    if (user.hourlyCompensation !== void 0 || user.monthlyCompensation !== void 0) {
      grossPay = computeSegmentedGrossPay({
        periodStart: startDate,
        periodEnd: effectiveEnd,
        internConvertedAt: internCutoff,
        level: user.level ?? "",
        internWorkMs,
        internWeekWorkMs,
        hourlyCompensation: user.hourlyCompensation ?? null,
        monthlyCompensation: user.monthlyCompensation ?? null
      });
    }
    const clipStart = user.hireDate && user.hireDate > startDate ? user.hireDate : startDate;
    const baseBusinessDays = endForUser < clipStart || user.hireDate && user.hireDate > endForUser ? 0 : clipStart > startDate || endForUser < effectiveEnd ? countBusinessDays(clipStart, endForUser, holidays) : totalBusinessDays;
    let effectiveLeaveDays = 0;
    let legacyLeaveDays = 0;
    let leaveWorkOverlap = 0;
    const userScheduleMapForLeave = scheduleByUser.get(user.id);
    for (const leave of userLeaves) {
      if (leave.startDate == null || leave.endDate == null) {
        legacyLeaveDays += leave.days;
        continue;
      }
      const { dates, weekdayCountInRange } = expandLeaveBusinessDates(
        toKstDateOnly(leave.startDate),
        toKstDateOnly(leave.endDate),
        leaveClipHolidayDates,
        userScheduleMapForLeave,
        clipStart,
        endForUser
      );
      if (weekdayCountInRange === 0) continue;
      const perDateFraction = leave.days / weekdayCountInRange;
      for (const dateStr of dates) {
        effectiveLeaveDays += perDateFraction;
        if (businessWorkDates.has(dateStr)) {
          leaveWorkOverlap += perDateFraction;
        }
      }
    }
    const deductibleLeaveDays = effectiveLeaveDays + legacyLeaveDays;
    const obligationDays = Math.max(
      0,
      baseBusinessDays - (extraOffDaysByUser.get(user.id) ?? 0) - deductibleLeaveDays - inProgressDays + // 같은날 출근+휴가는 실근무가 있었으므로 의무에서 빼지 않도록 겹침분을 되돌린다.
      leaveWorkOverlap
    );
    return {
      userId: user.id,
      name: user.username,
      teamId: user.teamId,
      level: user.level,
      teamRole: user.teamRole,
      roles: user.roles,
      workType: user.workType,
      workDays,
      businessWorkDays,
      // 결근 = 의무 영업일 − 영업일 실출근 − 휴가. workDays(주말·공휴일 출근 포함) 대신
      // businessWorkDays를 빼야 주말 출근이 평일 결근을 상쇄하지 않는다.
      // 휴가는 의무창 내 영업일로 클립한 deductibleLeaveDays를 쓰고, 같은날 출근+휴가 겹침은
      // leaveWorkOverlap으로 되돌려 한 날이 두 번 빠지지 않게 한다(이중차감 제거).
      absentDays: Math.max(
        0,
        baseBusinessDays - (extraOffDaysByUser.get(user.id) ?? 0) - businessWorkDays - deductibleLeaveDays + leaveWorkOverlap
      ),
      obligationDays,
      lateDays,
      leaveDays: totalLeaveDays,
      leaveByType: {
        annual: annualDays,
        sick: sickDays,
        special: specialDays
      },
      totalWorkMs,
      totalOvertimeMs: classTotal?.overtimeMs ?? totalOvertimeMs,
      totalNightMs: classTotal?.nightMs ?? 0,
      totalNightOvertimeMs: classTotal?.nightOvertimeMs ?? 0,
      totalHolidayWorkMs: classTotal?.holidayMs ?? 0,
      weeklyHolidayPay,
      grossPay,
      // 근무 지표 인턴/정규직 구간 분리 (CSV 다운로드용). 합계는 위 total* 과 일치.
      // 야간/휴일/야간초과는 classification 기반(없으면 0), 초과는 classification 우선·루프 폴백.
      internWork: {
        workDays: internWorkDays,
        totalWorkMs: internSegWorkMs,
        totalOvertimeMs: internClass ? internClass.overtimeMs : internSegOvertimeMs,
        totalNightMs: internClass?.nightMs ?? 0,
        totalNightOvertimeMs: internClass?.nightOvertimeMs ?? 0,
        totalHolidayWorkMs: internClass?.holidayMs ?? 0
      },
      fulltimeWork: {
        workDays: fulltimeWorkDays,
        totalWorkMs: fulltimeSegWorkMs,
        totalOvertimeMs: fulltimeClass ? fulltimeClass.overtimeMs : fulltimeSegOvertimeMs,
        totalNightMs: fulltimeClass?.nightMs ?? 0,
        totalNightOvertimeMs: fulltimeClass?.nightOvertimeMs ?? 0,
        totalHolidayWorkMs: fulltimeClass?.holidayMs ?? 0
      },
      remainingAnnualLeave: remainingByUser.get(user.id)
    };
  });
}

// src/domain/attendance/team-aggregate.ts
var ATTENDANCE_EXEMPT_ROLES = /* @__PURE__ */ new Set(["OPERATOR", "ADMIN"]);
var ATTENDANCE_EXEMPT_LEVELS = /* @__PURE__ */ new Set(["MANAGER", "EXECUTIVE"]);
function isExcludedFromTeamAverage(item) {
  if (item.teamRole === "LEADER") return true;
  if (item.workType === "FREE") return true;
  if (item.level != null && ATTENDANCE_EXEMPT_LEVELS.has(item.level)) return true;
  return (item.roles ?? []).some((r) => ATTENDANCE_EXEMPT_ROLES.has(r));
}
function computeTeamAggregate(items, teams) {
  const teamNameMap = new Map(teams.map((t) => [t.id, t.name]));
  const grouped = /* @__PURE__ */ new Map();
  for (const item of items) {
    if (item.teamId == null) continue;
    if (isExcludedFromTeamAverage(item)) continue;
    let agg = grouped.get(item.teamId);
    if (!agg) {
      agg = {
        members: 0,
        workDays: 0,
        businessWorkDays: 0,
        absentDays: 0,
        obligationDays: 0,
        lateDays: 0,
        leaveDays: 0,
        annual: 0,
        sick: 0,
        special: 0,
        totalOvertimeMs: 0,
        totalNightMs: 0,
        totalNightOvertimeMs: 0,
        totalHolidayWorkMs: 0,
        totalWorkMs: 0
      };
      grouped.set(item.teamId, agg);
    }
    agg.members++;
    agg.workDays += item.workDays;
    agg.businessWorkDays += item.businessWorkDays ?? item.workDays;
    agg.absentDays += item.absentDays;
    agg.obligationDays += item.obligationDays;
    agg.lateDays += item.lateDays;
    agg.leaveDays += item.leaveDays;
    agg.annual += item.leaveByType.annual;
    agg.sick += item.leaveByType.sick;
    agg.special += item.leaveByType.special;
    agg.totalOvertimeMs += item.totalOvertimeMs;
    agg.totalNightMs += item.totalNightMs;
    agg.totalNightOvertimeMs += item.totalNightOvertimeMs;
    agg.totalHolidayWorkMs += item.totalHolidayWorkMs;
    agg.totalWorkMs += item.totalWorkMs;
  }
  const result = [];
  for (const [teamId, agg] of grouped) {
    const rateDenominator = agg.businessWorkDays + agg.absentDays;
    result.push({
      teamId,
      teamName: teamNameMap.get(teamId) ?? teamId,
      memberCount: agg.members,
      workDays: agg.workDays,
      absentDays: agg.absentDays,
      obligationDays: agg.obligationDays,
      lateDays: agg.lateDays,
      leaveDays: agg.leaveDays,
      leaveByType: {
        annual: agg.annual,
        sick: agg.sick,
        special: agg.special
      },
      totalOvertimeMs: agg.totalOvertimeMs,
      totalNightMs: agg.totalNightMs,
      totalNightOvertimeMs: agg.totalNightOvertimeMs,
      totalHolidayWorkMs: agg.totalHolidayWorkMs,
      totalWorkMs: agg.totalWorkMs,
      avgOvertimeMs: agg.members > 0 ? agg.totalOvertimeMs / agg.members : 0,
      avgNightMs: agg.members > 0 ? agg.totalNightMs / agg.members : 0,
      avgNightOvertimeMs: agg.members > 0 ? agg.totalNightOvertimeMs / agg.members : 0,
      avgHolidayWorkMs: agg.members > 0 ? agg.totalHolidayWorkMs / agg.members : 0,
      attendanceRate: rateDenominator > 0 ? agg.businessWorkDays / rateDenominator : 0,
      avgWorkMs: agg.obligationDays > 0 ? agg.totalWorkMs / agg.obligationDays : 0
    });
  }
  return result;
}

// src/domain/attendance/policy.ts
function classifyWorkSegments(segments, policy, isHolidayFn) {
  const workSegments = segments.filter((s) => s.type === SegmentType.WORK && s.endAt !== null && s.duration !== null).sort((a, b) => new Date(a.startAt).getTime() - new Date(b.startAt).getTime());
  const overtimeThresholdMs = (policy.overtimeThresholdHours ?? policy.standardWorkHours) * 36e5;
  let cumulativeWorkMs = 0;
  const results = [];
  for (const segment of workSegments) {
    const segStart = new Date(segment.startAt).getTime();
    const segEnd = new Date(segment.endAt).getTime();
    const boundaries = collectBoundaries(
      segStart,
      segEnd,
      policy,
      cumulativeWorkMs,
      overtimeThresholdMs
    );
    const points = deduplicateAndSort([segStart, ...boundaries, segEnd]);
    for (let i = 0; i < points.length - 1; i++) {
      const subStart = points[i];
      const subEnd = points[i + 1];
      const duration = subEnd - subStart;
      if (duration <= 0) continue;
      const date2 = formatDate(new Date(subStart));
      const isOvertime = cumulativeWorkMs >= overtimeThresholdMs;
      const isNight = checkNightTime(subStart, policy);
      const isHoliday = isHolidayFn(date2);
      results.push({
        segmentId: segment.id,
        date: date2,
        startAt: new Date(subStart).toISOString(),
        endAt: new Date(subEnd).toISOString(),
        duration,
        isOvertime,
        isNight,
        isHoliday
      });
      cumulativeWorkMs += duration;
    }
  }
  return results;
}
function kstToUtcMs(year, month, day, hour = 0) {
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  const hh = String(hour).padStart(2, "0");
  return (/* @__PURE__ */ new Date(`${year}-${mm}-${dd}T${hh}:00:00+09:00`)).getTime();
}
function collectBoundaries(segStart, segEnd, policy, cumulativeWorkMs, overtimeThresholdMs) {
  const boundaries = [];
  const startKst = toKstParts(new Date(segStart));
  const endKst = toKstParts(new Date(segEnd));
  const dayStartMs = kstToUtcMs(startKst.year, startKst.month, startKst.day);
  const dayEndMs = kstToUtcMs(endKst.year, endKst.month, endKst.day);
  for (let dMs = dayStartMs; dMs <= dayEndMs + 864e5; dMs += 864e5) {
    const dKst = toKstParts(new Date(dMs));
    addBoundaryIfInRange(
      boundaries,
      kstToUtcMs(dKst.year, dKst.month, dKst.day),
      // KST 자정
      segStart,
      segEnd
    );
    addBoundaryIfInRange(
      boundaries,
      kstToUtcMs(dKst.year, dKst.month, dKst.day, policy.nightStartHour),
      segStart,
      segEnd
    );
    addBoundaryIfInRange(
      boundaries,
      kstToUtcMs(dKst.year, dKst.month, dKst.day, policy.nightEndHour),
      segStart,
      segEnd
    );
  }
  if (cumulativeWorkMs < overtimeThresholdMs) {
    const remainingMs = overtimeThresholdMs - cumulativeWorkMs;
    const overtimePoint = segStart + remainingMs;
    addBoundaryIfInRange(boundaries, overtimePoint, segStart, segEnd);
  }
  return boundaries;
}
function addBoundaryIfInRange(boundaries, point, segStart, segEnd) {
  if (point > segStart && point < segEnd) {
    boundaries.push(point);
  }
}
function checkNightTime(startMs, policy) {
  const { hour } = toKstParts(new Date(startMs));
  if (policy.nightStartHour > policy.nightEndHour) {
    return hour >= policy.nightStartHour || hour < policy.nightEndHour;
  }
  return hour >= policy.nightStartHour && hour < policy.nightEndHour;
}
function deduplicateAndSort(points) {
  return [...new Set(points)].sort((a, b) => a - b);
}
function formatDate(date2) {
  return toKstDateString(date2);
}

// src/domain/attendance/schedule.ts
function isHolidayForDate(date2, publicHolidays, workSchedules) {
  const schedule = workSchedules.find((ws) => ws.date === date2);
  if (schedule) {
    return schedule.scheduleType === ScheduleType.HOLIDAY || schedule.scheduleType === ScheduleType.OFF_DAY;
  }
  return publicHolidays.some(
    (h) => h.isRecurring ? h.date.slice(5) === date2.slice(5) : h.date === date2
  );
}
function isOffDayForDate(date2, publicHolidays, workSchedules) {
  const schedule = workSchedules.find((ws) => ws.date === date2);
  if (schedule?.scheduleType === ScheduleType.WORKDAY) {
    return false;
  }
  if (isHolidayForDate(date2, publicHolidays, workSchedules)) {
    return true;
  }
  const dayOfWeek = (/* @__PURE__ */ new Date(`${date2}T00:00:00Z`)).getUTCDay();
  return dayOfWeek === 0 || dayOfWeek === 6;
}
function createIsHolidayFn(publicHolidays, workSchedules, approvedOffDayDates = /* @__PURE__ */ new Set()) {
  return (date2) => isHolidayForDate(date2, publicHolidays, workSchedules) || approvedOffDayDates.has(date2);
}
function toAttendancePolicy(settings, options) {
  return {
    standardWorkHours: settings.standardWorkHours,
    ...options?.overtimeThresholdHours != null ? { overtimeThresholdHours: options.overtimeThresholdHours } : {},
    maxDailyWorkHours: settings.maxDailyWorkHours,
    nightStartHour: settings.nightStartHour,
    nightEndHour: settings.nightEndHour,
    correctionWindowDays: settings.correctionWindowDays
  };
}

// src/domain/attendance/pay-period.ts
function getPayPeriod(payDay, date2) {
  const y = date2.getUTCFullYear();
  const m = date2.getUTCMonth();
  const startMonthOffset = date2.getUTCDate() >= payDayOf(payDay, y, m) ? 0 : -1;
  const start = utcDate(y, m + startMonthOffset, payDayOf(payDay, y, m + startMonthOffset));
  const nextStart = utcDate(
    y,
    m + startMonthOffset + 1,
    payDayOf(payDay, y, m + startMonthOffset + 1)
  );
  return { start, end: new Date(nextStart.getTime() - DAY_MS) };
}
function payDayOf(payDay, year, month) {
  const normalized = new Date(Date.UTC(year, month, 1));
  return Math.min(payDay, lastDayOfMonth(normalized.getUTCFullYear(), normalized.getUTCMonth()));
}
function getLedgerPeriod(payDay, date2 = /* @__PURE__ */ new Date()) {
  const kstCalendarDate = /* @__PURE__ */ new Date(`${toKstDateString(date2)}T00:00:00.000Z`);
  const { end } = getPayPeriod(payDay, kstCalendarDate);
  const year = end.getUTCFullYear();
  const month = end.getUTCMonth() + 1;
  return `${year}-${String(month).padStart(2, "0")}`;
}
function getPayPeriodByKey(payDay, key) {
  const year = Number(key.slice(0, 4));
  const monthIndex = Number(key.slice(5, 7)) - 1;
  return getPayPeriod(payDay, utcDate(year, monthIndex, 1));
}
var DEFAULT_PAY_DAY = 25;
var KST_OFFSET_MS = 9 * 60 * 60 * 1e3;
var DAY_MS = 24 * 60 * 60 * 1e3;
function getPayPeriodUtcWindow(payDay, key) {
  const { start, end } = getPayPeriodByKey(payDay, key);
  return {
    start: new Date(start.getTime() - KST_OFFSET_MS),
    end: new Date(end.getTime() + DAY_MS - KST_OFFSET_MS)
  };
}
function lastDayOfMonth(year, month) {
  return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}
function utcDate(year, month, day) {
  return new Date(Date.UTC(year, month, day));
}

// src/domain/attendance/offline-queue.ts
var HOUR_MS = 60 * 60 * 1e3;
var MINUTE_MS = 60 * 1e3;
var SECOND_MS = 1e3;
var PUNCH_QUEUE = {
  /** Max age (relative to `now`) a queued / replayed punch may have. */
  TTL_MS: 48 * HOUR_MS,
  /** Max number of entries retained in the local queue. */
  MAX_ENTRIES: 20,
  /** ±tolerance used for the server-wins idempotency compare. */
  OCCURRED_AT_TOLERANCE_MS: 60 * SECOND_MS
};
var DEFAULT_MAX_FUTURE_SKEW_MS = 2 * MINUTE_MS;
function parseMs(iso2) {
  const ms = Date.parse(iso2);
  return Number.isNaN(ms) ? NaN : ms;
}
function isOccurredAtAcceptable(occurredAtISO, nowISO, opts = {}) {
  const maxPastMs = opts.maxPastMs ?? PUNCH_QUEUE.TTL_MS;
  const maxFutureSkewMs = opts.maxFutureSkewMs ?? DEFAULT_MAX_FUTURE_SKEW_MS;
  const occurredMs = parseMs(occurredAtISO);
  const nowMs = parseMs(nowISO);
  if (Number.isNaN(occurredMs) || Number.isNaN(nowMs)) return false;
  const delta = occurredMs - nowMs;
  if (delta > maxFutureSkewMs) return false;
  if (-delta > maxPastMs) return false;
  return true;
}
function prunePunchQueue(entries, nowISO, opts = {}) {
  const ttlMs = opts.ttlMs ?? PUNCH_QUEUE.TTL_MS;
  const maxEntries = opts.maxEntries ?? PUNCH_QUEUE.MAX_ENTRIES;
  const nowMs = parseMs(nowISO);
  if (Number.isNaN(nowMs)) return [];
  const seen = /* @__PURE__ */ new Set();
  const live = [];
  entries.forEach((entry, index) => {
    const ms = parseMs(entry.occurredAt);
    if (Number.isNaN(ms)) return;
    if (nowMs - ms > ttlMs) return;
    if (seen.has(entry.id)) return;
    seen.add(entry.id);
    live.push({ entry, index, ms });
  });
  let kept = live;
  if (live.length > maxEntries) {
    const newest = [...live].sort((a, b) => b.ms - a.ms || b.index - a.index).slice(0, maxEntries);
    kept = newest.sort((a, b) => a.index - b.index);
  }
  return kept.map((x) => x.entry);
}
function isSameInstantWithinTolerance(aISO, bISO, toleranceMs = PUNCH_QUEUE.OCCURRED_AT_TOLERANCE_MS) {
  const a = parseMs(aISO);
  const b = parseMs(bISO);
  if (Number.isNaN(a) || Number.isNaN(b)) return false;
  return Math.abs(a - b) <= toleranceMs;
}

// src/domain/attendance/index.ts
var INACTIVE_ATTENDANCE_STATUSES = [
  AttendanceStatus.CLOCKED_OUT,
  AttendanceStatus.ABSENT
];
var SegmentSourceType = {
  CLUB_FEED: "CLUB_FEED"
};
var CorrectionStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  INVALIDATED: "INVALIDATED"
};
var HolidayPaidType = {
  UNPAID: "UNPAID",
  COMPANY_DESIGNATED: "COMPANY_DESIGNATED",
  LEGALLY_PAID: "LEGALLY_PAID"
};
var OffDayApprovalStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};

// src/domain/compensation/resolve.ts
var CompensationType = {
  /** 시간급 — 인턴구간 산정용. */
  HOURLY: "HOURLY",
  /** 월급 — 정규직구간 산정용. */
  MONTHLY: "MONTHLY"
};
function resolveCompensationAt(records, dateKst) {
  if (records.length === 0) return void 0;
  let best;
  let bestKey = "";
  for (const r of records) {
    const key = toKstDateString(new Date(r.effectiveFrom));
    if (key <= dateKst && key >= bestKey) {
      bestKey = key;
      best = r;
    }
  }
  return best;
}

// src/domain/auth/auth.ts
import { z as z2 } from "zod";
var CLIENT_PLATFORMS = ["WEB", "IOS", "ANDROID"];
var loginSchema = z2.object({
  email: CrevasseEmailSchema,
  password: z2.string().min(PASSWORD_MIN_LENGTH, "\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uC18C 8\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4")
}).strict();
var registerSchema = z2.object({
  email: CrevasseEmailSchema
}).strict();
var registerVerifySchema = z2.object({
  email: CrevasseEmailSchema,
  code: z2.string().length(6, "\uC778\uC99D\uCF54\uB4DC\uB294 6\uC790\uB9AC\uC785\uB2C8\uB2E4"),
  username: LegalNameSchema,
  password: PasswordSchema
}).strict();
var changePasswordSchema = z2.object({
  currentPassword: z2.string().min(1, "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"),
  newPassword: PasswordSchema,
  // token-mode(모바일 bearer) 클라이언트는 쿠키가 없어 백엔드가 현세션을 식별 못 한다.
  // /auth/refresh 와 동일하게 raw refresh token 을 실어 보내면 백엔드가 현세션을 보존한다.
  // 웹(cookie mode)은 생략 — 쿠키로 식별.
  currentRefreshToken: z2.string().optional()
}).strict();
var identifySchema = z2.object({
  email: CrevasseEmailSchema
}).strict();
var LoginTicketSchema = z2.string().min(1).max(2048);
var hasEmailOrTicket = (v) => v.email === void 0 !== (v.ticket === void 0);
var authenticateSchema = z2.object({
  email: CrevasseEmailSchema.optional(),
  ticket: LoginTicketSchema.optional(),
  password: z2.string().min(PASSWORD_MIN_LENGTH, "\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uC18C 8\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4")
}).strict().refine(hasEmailOrTicket, "\uC774\uBA54\uC77C\uACFC \uB85C\uADF8\uC778 \uD45C \uC911 \uD558\uB098\uB9CC \uBCF4\uB0B4 \uC8FC\uC138\uC694");
var verifyIdentitySchema = z2.object({
  email: EmailSchema,
  username: z2.string().min(1, "\uC2E4\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694")
}).strict();
var resetPasswordSchema = z2.object({
  resetToken: z2.string().min(1, "\uC7AC\uC124\uC815 \uD1A0\uD070\uC774 \uD544\uC694\uD569\uB2C8\uB2E4"),
  newPassword: PasswordSchema
}).strict();
var revokeAllSessionsSchema = z2.object({
  reason: z2.string().min(10, "\uC0AC\uC720\uB294 \uCD5C\uC18C 10\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694").max(500, "\uC0AC\uC720\uB294 500\uC790\uB97C \uB118\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4")
}).strict();
var identifyByNameSchema = z2.object({
  username: z2.string().min(LEGAL_NAME_MIN_LENGTH).max(LEGAL_NAME_MAX_LENGTH),
  /** Optional email for disambiguation when duplicates exist */
  email: EmailSchema.optional()
}).strict();
var sendOtpSchema = z2.object({
  ticket: LoginTicketSchema
}).strict();
var verifyOtpSchema = z2.object({
  ticket: LoginTicketSchema,
  code: z2.string().length(6)
}).strict();

// src/domain/quest-task/feedback.ts
var CheckpointRejectReasonKind = {
  SPEC: "SPEC",
  EXECUTION: "EXECUTION"
};
function isCheckpointRejectReasonKind(value) {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(CheckpointRejectReasonKind, value);
}
function canWriteQuestTaskFeedback(ctx) {
  return ctx.isTeamLeader || ctx.roles.includes("OPERATOR") || ctx.roles.includes("ADMIN");
}
function canCommentOnQuestTaskFeedback(ctx) {
  return ctx.actorId === ctx.feedbackAuthorId || ctx.actorId === ctx.taskAssigneeId;
}
function createQuestTaskFeedback(params) {
  assertThreadBody(params.body, "feedback body");
  return {
    id: params.id,
    taskId: params.taskId,
    authorId: params.authorId,
    body: params.body,
    createdAt: params.now
  };
}
function createQuestTaskFeedbackComment(params) {
  assertThreadBody(params.body, "feedback comment body");
  return {
    id: params.id,
    feedbackId: params.feedbackId,
    authorId: params.authorId,
    body: params.body,
    createdAt: params.now
  };
}

// src/domain/campaign/ad-code.ts
var CAMPAIGN_AD_CODE_PATTERN = /^#[A-Za-z0-9+/=_-]+$/;
function isCampaignAdCode(value) {
  return CAMPAIGN_AD_CODE_PATTERN.test(value);
}

// src/domain/campaign/boosting-stage.ts
var BoostingStage = {
  ISSUED: "ISSUED",
  BOOSTING: "BOOSTING",
  STOP_REQUESTED: "STOP_REQUESTED",
  STOPPED: "STOPPED"
};
var BOOSTING_STAGE_ORDER = [
  BoostingStage.ISSUED,
  BoostingStage.BOOSTING,
  BoostingStage.STOP_REQUESTED,
  BoostingStage.STOPPED
];
var BOOSTING_RESUME_EDGES = [
  [BoostingStage.STOP_REQUESTED, BoostingStage.BOOSTING],
  [BoostingStage.STOPPED, BoostingStage.BOOSTING]
];
function assertBoostingTransition(from, to) {
  const isResume = BOOSTING_RESUME_EDGES.some(
    ([edgeFrom, edgeTo]) => edgeFrom === from && edgeTo === to
  );
  if (isResume) {
    return;
  }
  const fromIndex = BOOSTING_STAGE_ORDER.indexOf(from);
  const toIndex = BOOSTING_STAGE_ORDER.indexOf(to);
  if (toIndex !== fromIndex + 1) {
    throw new Error(`Invalid boosting transition: ${from} -> ${to}`);
  }
}
function planBoostingBackfillPath(from, to) {
  if (from === to) {
    return [];
  }
  const isResume = BOOSTING_RESUME_EDGES.some(
    ([edgeFrom, edgeTo]) => edgeFrom === from && edgeTo === to
  );
  if (isResume) {
    return [to];
  }
  const fromIndex = BOOSTING_STAGE_ORDER.indexOf(from);
  const toIndex = BOOSTING_STAGE_ORDER.indexOf(to);
  if (toIndex > fromIndex) {
    return BOOSTING_STAGE_ORDER.slice(fromIndex + 1, toIndex + 1);
  }
  return [];
}
function planBoostingBackfill(from, target) {
  if (!target) {
    return { path: [], review: null };
  }
  const path = planBoostingBackfillPath(from, target);
  const review = target !== from && path.length === 0 ? { from, to: target } : null;
  return { path, review };
}
function allowedBoostingTransitions(from) {
  const next = BOOSTING_STAGE_ORDER[BOOSTING_STAGE_ORDER.indexOf(from) + 1];
  const forward = next === void 0 ? [] : [next];
  const resume = BOOSTING_RESUME_EDGES.filter(([edgeFrom]) => edgeFrom === from).map(
    ([, edgeTo]) => edgeTo
  );
  return [...forward, ...resume];
}

// src/domain/scenario/values.ts
var ScenarioCampaignType = {
  DOMESTIC: "DOMESTIC",
  GLOBAL: "GLOBAL"
};
var ScenarioStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  ARCHIVED: "ARCHIVED"
};
var SCENARIO_CREATOR_COUNT_MIN = 1;
var SCENARIO_CREATOR_COUNT_MAX = 9999;
var DOMESTIC_TARGET_COUNTRIES = ["KR"];
function deriveCampaignType(targetCountries) {
  const domestic = targetCountries.length > 0 && targetCountries.every((c) => c === "KR");
  return domestic ? ScenarioCampaignType.DOMESTIC : ScenarioCampaignType.GLOBAL;
}

// src/domain/campaign/stop-rule.ts
var StopRuleMetric = {
  VIEWS: "VIEWS",
  FOLLOWERS: "FOLLOWERS"
};
var StopRuleDirection = {
  BELOW: "BELOW",
  ABOVE: "ABOVE"
};
function isMember(values, value) {
  return typeof value === "string" && Object.values(values).includes(value);
}
function isThreshold(value) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0;
}
function parseStopRule(raw) {
  if (typeof raw !== "object" || raw === null || Array.isArray(raw)) {
    return null;
  }
  const { metric, threshold, direction } = raw;
  if (!isMember(StopRuleMetric, metric) || !isThreshold(threshold) || !isMember(StopRuleDirection, direction)) {
    return null;
  }
  return { metric, threshold, direction };
}
var StopRuleVerdict = {
  REACHED: "REACHED",
  NOT_REACHED: "NOT_REACHED",
  UNKNOWN: "UNKNOWN"
};
function judgeStopRule(rule, measures) {
  const value = rule.metric === StopRuleMetric.VIEWS ? measures.views : measures.followers;
  if (value === null || !Number.isFinite(value)) {
    return StopRuleVerdict.UNKNOWN;
  }
  const reached = rule.direction === StopRuleDirection.ABOVE ? value >= rule.threshold : value <= rule.threshold;
  return reached ? StopRuleVerdict.REACHED : StopRuleVerdict.NOT_REACHED;
}

// src/domain/campaign/roster-status.ts
var RosterStatus = {
  LISTED: "\uB9AC\uC2A4\uD2B8\uC5C5",
  PRICE_NEGOTIATION: "\uB2E8\uAC00\uD611\uC0C1",
  GUIDELINE_SENT: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC804\uB2EC",
  REVISION_REQUESTED: "\uC218\uC815 \uC694\uCCAD",
  UPLOAD_REQUESTED: "\uC5C5\uB85C\uB4DC \uC694\uCCAD"
};
var ROSTER_WRITABLE_STATUSES = [
  RosterStatus.LISTED,
  RosterStatus.PRICE_NEGOTIATION,
  RosterStatus.GUIDELINE_SENT,
  RosterStatus.REVISION_REQUESTED,
  RosterStatus.UPLOAD_REQUESTED
];
var ROSTER_STATUSES = ROSTER_WRITABLE_STATUSES;
var DEFAULT_ROSTER_STATUS = RosterStatus.LISTED;
function hasUploadLink(completion) {
  return typeof completion?.videoUrl === "string" && completion.videoUrl.trim() !== "";
}
function hasDraftAwaitingReview(completion) {
  const at = completion?.draftReviewReceivedAt;
  return at !== null && at !== void 0 && at !== "";
}
function isRosterUploadComplete(status, completion) {
  return status === RosterStatus.UPLOAD_REQUESTED && hasUploadLink(completion);
}
var RosterPhase = {
  OUTREACH: "\uC12D\uC678",
  PRODUCTION: "\uC81C\uC791"
};
var PHASE_BY_STATUS = {
  [RosterStatus.LISTED]: RosterPhase.OUTREACH,
  [RosterStatus.PRICE_NEGOTIATION]: RosterPhase.OUTREACH,
  // 가이드라인 전달과 수정 요청이 같은 구간이라야 반려 왕복이 구간 역행을 만들지 않는다 (§2-1)
  [RosterStatus.GUIDELINE_SENT]: RosterPhase.PRODUCTION,
  [RosterStatus.REVISION_REQUESTED]: RosterPhase.PRODUCTION,
  [RosterStatus.UPLOAD_REQUESTED]: RosterPhase.PRODUCTION
};
function deriveRosterPhase(status) {
  if (typeof status !== "string") return null;
  return PHASE_BY_STATUS[status] ?? null;
}
var RosterBallHolder = {
  US: "US",
  CREATOR: "CREATOR",
  BOTH: "BOTH",
  /** 광고주가 섭외 명단을 들고 검수 중이다 — 검수 회차에 든 행의 넷째 주체 (§2-6). */
  ADVERTISER: "ADVERTISER"
};
var BALL_HOLDER_BY_SHIPPING = {
  NO_ADDRESS: RosterBallHolder.CREATOR,
  ADDRESS_UNCONFIRMED: RosterBallHolder.US,
  ADDRESS_CONFIRMED: RosterBallHolder.US,
  AWAITING_TRACKING: RosterBallHolder.ADVERTISER,
  TRACKING_RECEIVED: null
};
var BALL_HOLDER_BY_STATUS = {
  [RosterStatus.LISTED]: RosterBallHolder.US,
  [RosterStatus.PRICE_NEGOTIATION]: RosterBallHolder.BOTH,
  [RosterStatus.GUIDELINE_SENT]: RosterBallHolder.CREATOR,
  [RosterStatus.REVISION_REQUESTED]: RosterBallHolder.CREATOR,
  [RosterStatus.UPLOAD_REQUESTED]: RosterBallHolder.CREATOR
};
function deriveRosterBallHolder(status, completion) {
  if (typeof status !== "string") return null;
  if (completion?.advertiserReviewPending === true) return RosterBallHolder.ADVERTISER;
  const holder = BALL_HOLDER_BY_STATUS[status];
  if (holder === void 0) return null;
  if (hasDraftAwaitingReview(completion)) return RosterBallHolder.US;
  if (isRosterUploadComplete(status, completion)) return null;
  const shippingHolder = completion?.shippingState ? BALL_HOLDER_BY_SHIPPING[completion.shippingState] ?? null : null;
  return shippingHolder ?? holder;
}
var RosterDropKind = {
  CREATOR_DROP: "CREATOR_DROP",
  OUR_CANCEL: "OUR_CANCEL",
  /**
   * 광고주 셀렉에서 빠졌다 (§2-6, 2026-09-03). 크리에이터 사유도 우리 사유도 아니라 앞의 둘
   * 어디에도 안 맞는다. 회차의 판정으로 서는 것이 기본이고, 손으로는 **회차 판정 표에 한 줄도
   * 없는 행**에만 찍을 수 있다(섭외 IA §5, 2026-09-11) — 보충 행은 회차에 안 들어가 되짚을
   * 회차가 애초에 없고, 회차를 거친 행은 여전히 회차만 쓰므로 "회차의 판정이 곧 기록" 이 산다.
   * 그 조건은 `isAdvertiserRoundFree` 가 들고 서비스가 게이트다.
   */
  ADVERTISER_REJECT: "ADVERTISER_REJECT"
};
var ROSTER_DROP_KINDS = [
  RosterDropKind.CREATOR_DROP,
  RosterDropKind.OUR_CANCEL,
  RosterDropKind.ADVERTISER_REJECT
];
var ROSTER_MANUAL_DROP_KINDS = [
  RosterDropKind.CREATOR_DROP,
  RosterDropKind.OUR_CANCEL,
  RosterDropKind.ADVERTISER_REJECT
];
function isAdvertiserRoundFree(row) {
  return row.advertiserReview === null || row.advertiserReview === void 0;
}
var ROSTER_DROP_KIND_LABEL = {
  [RosterDropKind.CREATOR_DROP]: "\uD558\uCC28",
  [RosterDropKind.OUR_CANCEL]: "\uC9C4\uD589 \uCDE8\uC18C",
  [RosterDropKind.ADVERTISER_REJECT]: "\uAD11\uACE0\uC8FC \uAE30\uAC01"
};
function isRosterDropKind(value) {
  return typeof value === "string" && ROSTER_DROP_KINDS.includes(value);
}
function isManualRosterDropKind(value) {
  return typeof value === "string" && ROSTER_MANUAL_DROP_KINDS.includes(value);
}
var AdvertiserReviewVerdict = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var ADVERTISER_REVIEW_VERDICTS = [
  AdvertiserReviewVerdict.APPROVED,
  AdvertiserReviewVerdict.REJECTED
];
var ADVERTISER_REVIEW_VERDICT_LABEL = {
  [AdvertiserReviewVerdict.APPROVED]: "\uC2B9\uC778",
  [AdvertiserReviewVerdict.REJECTED]: "\uAE30\uAC01"
};
function isAdvertiserReviewVerdict(value) {
  return typeof value === "string" && ADVERTISER_REVIEW_VERDICTS.includes(value);
}
var rosterWritableStatusValidator = createRosterStatusValidator(ROSTER_WRITABLE_STATUSES);
function isWritableRosterStatus(value) {
  return rosterWritableStatusValidator.isAllowed(value);
}
function createRosterStatusValidator(allowed) {
  if (allowed.length === 0) {
    throw new Error("createRosterStatusValidator: allowed status list is empty");
  }
  if (allowed.some((status) => status.trim() === "")) {
    throw new Error("createRosterStatusValidator: allowed status list contains a blank value");
  }
  if (new Set(allowed).size !== allowed.length) {
    throw new Error("createRosterStatusValidator: allowed status list contains duplicates");
  }
  const lookup = new Set(allowed);
  const snapshot = [...allowed];
  return {
    allowed: snapshot,
    isAllowed(value) {
      return typeof value === "string" && lookup.has(value);
    }
  };
}

// src/domain/campaign/advertiser-review-mode.ts
var AdvertiserReviewMode = {
  /** 기본값. 전달 사실을 표식으로 남기고 담당자가 계속 진행한다 — 보고만으로 승인이 되지 않는다. */
  REPORT_THEN_PROCEED: "REPORT_THEN_PROCEED",
  /** 광고주의 실제 판정(회차 승인) 전까지 확정을 막는다. 셀렉 캠페인에서만 고를 수 있다. */
  APPROVAL_REQUIRED: "APPROVAL_REQUIRED",
  /** 내부 사유를 남긴 담당자의 명시적 확정 — 사유가 필수다. */
  SKIP: "SKIP"
};
var ADVERTISER_REVIEW_MODES = [
  AdvertiserReviewMode.REPORT_THEN_PROCEED,
  AdvertiserReviewMode.APPROVAL_REQUIRED,
  AdvertiserReviewMode.SKIP
];
var DEFAULT_ADVERTISER_REVIEW_MODE = AdvertiserReviewMode.REPORT_THEN_PROCEED;
var ADVERTISER_REVIEW_MODE_LABEL = {
  [AdvertiserReviewMode.REPORT_THEN_PROCEED]: "\uBCF4\uACE0 \uD6C4 \uC9C4\uD589",
  [AdvertiserReviewMode.APPROVAL_REQUIRED]: "\uC2B9\uC778 \uD544\uC694",
  [AdvertiserReviewMode.SKIP]: "\uD655\uC778 \uC0DD\uB7B5"
};
function isAdvertiserReviewMode(value) {
  return typeof value === "string" && ADVERTISER_REVIEW_MODES.includes(value);
}
function validateAdvertiserReviewModeChange(input) {
  if (input.toMode === AdvertiserReviewMode.APPROVAL_REQUIRED && !input.advertiserSelectsRoster) {
    return "APPROVAL_NEEDS_SELECT";
  }
  if (input.toMode === AdvertiserReviewMode.SKIP && (input.reason ?? "").trim() === "") {
    return "SKIP_NEEDS_REASON";
  }
  return null;
}
function normalizeAdvertiserReviewModeInitialReason(input) {
  if (input.mode === DEFAULT_ADVERTISER_REVIEW_MODE) return null;
  const trimmed = (input.reason ?? "").trim();
  return trimmed === "" ? null : trimmed;
}
function requiresAdvertiserApproval(input) {
  if (input.mode !== AdvertiserReviewMode.APPROVAL_REQUIRED) return false;
  if (input.hasAdvertiserApproval) return false;
  if (deriveRosterPhase(input.toStatus) !== RosterPhase.PRODUCTION) return false;
  return deriveRosterPhase(input.fromStatus) !== RosterPhase.PRODUCTION;
}

// src/domain/scenario/campaign-pricing.ts
var CampaignDifficulty = {
  NORMAL: "NORMAL",
  HARD: "HARD",
  VERY_HARD: "VERY_HARD"
};
var CAMPAIGN_DIFFICULTY_CONDITIONS = [
  /** 처음 하는 브랜드 — 같은 광고주의 이전 라운드가 없다 */
  "FIRST_TIME_BRAND",
  /** 요구 팔로워가 임계 이상 */
  "FOLLOWER_THRESHOLD",
  /** 조건에 맞는 온 크리에이터가 슬롯보다 적다 */
  "POOL_SHORTAGE",
  /** 글로벌 캠페인 */
  "GLOBAL",
  /** 제품 발송이 있다 */
  "PRODUCT_SHIPPING",
  /** 광고주 검수가 엄격 — 지난 라운드에 재업로드 요청 이력이 있다. 신규면 판정하지 않는다 */
  "STRICT_REVIEW",
  /** 광고주가 섭외 명단을 검수·선택한다 */
  "ADVERTISER_SELECT"
];
var CAMPAIGN_SLOT_PRICE = {
  NORMAL: 1700,
  HARD: null,
  VERY_HARD: null
};
var HARD_FROM = 2;
var VERY_HARD_FROM = 4;
function deriveCampaignDifficulty(conditions) {
  const count = new Set(conditions).size;
  if (count >= VERY_HARD_FROM) return CampaignDifficulty.VERY_HARD;
  if (count >= HARD_FROM) return CampaignDifficulty.HARD;
  return CampaignDifficulty.NORMAL;
}
function calculateCampaignPrice({
  contractSlotCount,
  campaignDifficulty
}) {
  if (contractSlotCount === null) return null;
  const slotPrice = CAMPAIGN_SLOT_PRICE[campaignDifficulty];
  if (slotPrice === null) return null;
  return slotPrice * contractSlotCount;
}

// src/domain/scenario/scenario.ts
function resolveCampaignType(targetCountries, claimed) {
  if (targetCountries.length === 0) {
    throw new Error("targetCountries must have at least one country (KR for domestic)");
  }
  const invalidCode = targetCountries.find((c) => !isValidIsoCountry(c));
  if (invalidCode !== void 0) {
    throw new Error(`Invalid ISO 3166-1 alpha-2 code: ${invalidCode}`);
  }
  const derived = deriveCampaignType(targetCountries);
  if (claimed !== void 0 && claimed !== derived) {
    throw new Error(
      `campaignType ${claimed} does not match targetCountries [${targetCountries.join(",")}] (derived ${derived})`
    );
  }
  return derived;
}
function createScenario(params) {
  if (!params.title.trim()) {
    throw new Error("Scenario title cannot be empty");
  }
  if (params.deadline !== null && isNaN(new Date(params.deadline).getTime())) {
    throw new Error(`Invalid deadline format: ${params.deadline}`);
  }
  assertAdvertiserUsable(params.advertiser);
  const creatorCount = params.creatorCount ?? 1;
  if (!Number.isInteger(creatorCount) || creatorCount < SCENARIO_CREATOR_COUNT_MIN || creatorCount > SCENARIO_CREATOR_COUNT_MAX) {
    throw new Error(
      `creatorCount must be ${SCENARIO_CREATOR_COUNT_MIN}~${SCENARIO_CREATOR_COUNT_MAX}, got ${creatorCount}`
    );
  }
  const targetCountries = params.targetCountries ?? [...DOMESTIC_TARGET_COUNTRIES];
  const campaignType = resolveCampaignType(targetCountries, params.campaignType);
  const difficultyConditions = [...new Set(params.difficultyConditions ?? [])];
  return {
    id: params.id,
    title: params.title,
    description: params.description,
    creatorId: params.creatorId,
    advertiserId: params.advertiser.id,
    creatorCount,
    targetTotalViews: params.targetTotalViews ?? null,
    stopRule: parseStopRule(params.stopRule),
    startsAt: params.startsAt ?? params.now,
    campaignType,
    targetCountries,
    guidelineUrl: params.guidelineUrl ?? null,
    outreachFormUrl: params.outreachFormUrl ?? null,
    campaignSheetInternalUrl: params.campaignSheetInternalUrl ?? null,
    campaignSheetExternalUrl: params.campaignSheetExternalUrl ?? null,
    productUrl: params.productUrl ?? null,
    guidelineNote: params.guidelineNote ?? null,
    status: ScenarioStatus.DRAFT,
    isSequential: params.isSequential ?? false,
    // ERD v3.3: default false (캠페인 병렬 디폴트)
    deadline: params.deadline,
    round: params.round ?? null,
    contractSlotCount: params.contractSlotCount ?? null,
    requiredFollowerCount: params.requiredFollowerCount ?? null,
    advertiserSelectsRoster: params.advertiserSelectsRoster ?? false,
    advertiserReviewMode: params.advertiserReviewMode ?? DEFAULT_ADVERTISER_REVIEW_MODE,
    advertiserReviewModeInitialReason: normalizeAdvertiserReviewModeInitialReason({
      mode: params.advertiserReviewMode ?? DEFAULT_ADVERTISER_REVIEW_MODE,
      reason: params.advertiserReviewModeInitialReason
    }),
    productShipping: params.productShipping ?? false,
    requirementNote: params.requirementNote ?? null,
    // 난이도는 받아 적지 않고 조건 목록에서 낸다 — 저장값과 파생이 갈릴 자리를 만들지 않는다.
    // DTO 가 이미 둘의 일치를 막았고, 여기서 파생하면 그 게이트를 통과한 값만 남는다.
    campaignDifficulty: deriveCampaignDifficulty(difficultyConditions),
    difficultyConditions,
    createdAt: params.now,
    updatedAt: params.now
  };
}
var DRAFT_ONLY_UPDATE_KEYS = [
  "campaignType",
  "targetCountries",
  "isSequential",
  "advertiserId",
  "startsAt",
  "advertiserReviewMode",
  "advertiserReviewModeInitialReason"
];
function updateScenario(scenario, updates, now) {
  assertStatus(
    "scenario",
    scenario.id,
    scenario.status,
    [ScenarioStatus.DRAFT, ScenarioStatus.ACTIVE],
    "update"
  );
  if (updates.deadline !== void 0 && updates.deadline !== null && isNaN(new Date(updates.deadline).getTime())) {
    throw new Error(`Invalid deadline format: ${updates.deadline}`);
  }
  if (scenario.status !== ScenarioStatus.DRAFT) {
    const offending = DRAFT_ONLY_UPDATE_KEYS.filter((k) => updates[k] !== void 0);
    if (offending.length > 0) {
      throw new Error(
        `Cannot update ${offending.join(", ")} on a ${scenario.status} scenario (DRAFT only)`
      );
    }
  }
  const targetCountries = updates.targetCountries ?? scenario.targetCountries;
  const campaignType = resolveCampaignType(targetCountries, updates.campaignType);
  const nextDifficultyConditions = updates.difficultyConditions ? [...new Set(updates.difficultyConditions)] : null;
  const nextAdvertiserReviewMode = updates.advertiserReviewMode ?? scenario.advertiserReviewMode;
  const nextAdvertiserReviewModeInitialReason = normalizeAdvertiserReviewModeInitialReason({
    mode: nextAdvertiserReviewMode,
    reason: updates.advertiserReviewModeInitialReason !== void 0 ? updates.advertiserReviewModeInitialReason : scenario.advertiserReviewModeInitialReason
  });
  return {
    ...scenario,
    campaignType,
    targetCountries,
    isSequential: updates.isSequential ?? scenario.isSequential,
    advertiserId: updates.advertiserId ?? scenario.advertiserId,
    startsAt: updates.startsAt ?? scenario.startsAt,
    title: updates.title ?? scenario.title,
    description: updates.description !== void 0 ? updates.description : scenario.description,
    campaignSheetInternalUrl: updates.campaignSheetInternalUrl !== void 0 ? updates.campaignSheetInternalUrl : scenario.campaignSheetInternalUrl,
    campaignSheetExternalUrl: updates.campaignSheetExternalUrl !== void 0 ? updates.campaignSheetExternalUrl : scenario.campaignSheetExternalUrl,
    deadline: updates.deadline !== void 0 ? updates.deadline : scenario.deadline,
    round: updates.round !== void 0 ? updates.round : scenario.round,
    creatorCount: updates.creatorCount !== void 0 ? updates.creatorCount : scenario.creatorCount,
    // `??` 금지 — null(해제)이 기존 값으로 되돌아간다. 바로 위 progressOwnerId 와 같은 축이다.
    targetTotalViews: updates.targetTotalViews !== void 0 ? updates.targetTotalViews : scenario.targetTotalViews,
    // `??` 금지 — 같은 축이다. null(해제)이 기존 정책으로 되돌아가면 중단 규칙을 못 끈다.
    stopRule: updates.stopRule !== void 0 ? parseStopRule(updates.stopRule) : scenario.stopRule,
    // `??` 금지 — null(회수)이 기존 값으로 되돌아간다. undefined(미변경)와 반드시 구분.
    progressOwnerId: updates.progressOwnerId !== void 0 ? updates.progressOwnerId : scenario.progressOwnerId,
    // `??` 금지 — null(해제)이 기존 값으로 되돌아간다. 위 셋과 같은 축이다.
    contractSlotCount: updates.contractSlotCount !== void 0 ? updates.contractSlotCount : scenario.contractSlotCount,
    requiredFollowerCount: updates.requiredFollowerCount !== void 0 ? updates.requiredFollowerCount : scenario.requiredFollowerCount,
    advertiserSelectsRoster: updates.advertiserSelectsRoster ?? scenario.advertiserSelectsRoster,
    // 발행 뒤의 확인 방식은 일반 수정으로 안 바뀐다 — 이력이 남는 전용 경로만 (섭외 IA §5).
    // 초안의 값은 생성 초기값이라 여기서 받는다 — ACTIVE 는 위 DRAFT 전용 가드가 이미 막았다.
    advertiserReviewMode: nextAdvertiserReviewMode,
    advertiserReviewModeInitialReason: nextAdvertiserReviewModeInitialReason,
    productShipping: updates.productShipping ?? scenario.productShipping,
    requirementNote: updates.requirementNote !== void 0 ? updates.requirementNote : scenario.requirementNote,
    campaignDifficulty: nextDifficultyConditions ? deriveCampaignDifficulty(nextDifficultyConditions) : scenario.campaignDifficulty,
    difficultyConditions: nextDifficultyConditions ?? scenario.difficultyConditions,
    updatedAt: now
  };
}
function activateScenario(scenario, now) {
  assertStatus("scenario", scenario.id, scenario.status, [ScenarioStatus.DRAFT], "activate");
  return {
    ...scenario,
    status: ScenarioStatus.ACTIVE,
    updatedAt: now
  };
}
function completeScenario(scenario, now) {
  assertStatus("scenario", scenario.id, scenario.status, [ScenarioStatus.ACTIVE], "complete");
  return {
    ...scenario,
    status: ScenarioStatus.COMPLETED,
    updatedAt: now
  };
}
function failScenario(scenario, now) {
  assertStatus("scenario", scenario.id, scenario.status, [ScenarioStatus.ACTIVE], "fail");
  return {
    ...scenario,
    status: ScenarioStatus.FAILED,
    updatedAt: now
  };
}
function archiveScenario(scenario, now) {
  assertStatus(
    "scenario",
    scenario.id,
    scenario.status,
    [ScenarioStatus.DRAFT, ScenarioStatus.ACTIVE, ScenarioStatus.COMPLETED, ScenarioStatus.FAILED],
    "archive"
  );
  return {
    ...scenario,
    status: ScenarioStatus.ARCHIVED,
    updatedAt: now
  };
}
function canArchiveScenario(activeQuestRewards) {
  return !activeQuestRewards.some((r) => r > 0);
}

// src/domain/scenario/scenario-tagging.ts
var MAX_QUESTS_PER_SCENARIO = 20;
function tagQuestToScenario(params) {
  const { scenario, scenarioTeamIds, quest, currentQuestCount } = params;
  assertStatus(
    "scenario",
    scenario.id,
    scenario.status,
    [ScenarioStatus.DRAFT, ScenarioStatus.ACTIVE],
    "tag quest"
  );
  if (quest.scenarioId !== null) {
    throw new Error(`Quest ${quest.id} is already tagged to scenario ${quest.scenarioId}`);
  }
  if (currentQuestCount >= MAX_QUESTS_PER_SCENARIO) {
    throw new Error(`Scenario can have at most ${MAX_QUESTS_PER_SCENARIO} quests`);
  }
  if (quest.scope !== "GLOBAL" && quest.teamId !== null) {
    if (!scenarioTeamIds.includes(quest.teamId)) {
      throw new Error(`Quest team ${quest.teamId} is not a participating team of this scenario`);
    }
  }
  return { questId: quest.id, scenarioId: scenario.id };
}
function untagQuestFromScenario(params) {
  assertStatus(
    "scenario",
    params.scenario.id,
    params.scenario.status,
    [ScenarioStatus.DRAFT],
    "untag quest"
  );
  return { questId: params.questId, scenarioId: null };
}

// src/domain/scenario/scenario-ordering.ts
function reorderQuests(scenario, questIds) {
  assertStatus(
    "scenario",
    scenario.id,
    scenario.status,
    [ScenarioStatus.DRAFT, ScenarioStatus.ACTIVE],
    "reorder quests"
  );
  return questIds.map((questId, index) => ({
    questId,
    scenarioOrder: index
  }));
}

// src/domain/scenario/scenario-code.ts
function formatScenarioCode(code) {
  return `SC-${String(code).padStart(4, "0")}`;
}

// src/domain/scenario/scenario-dependency.ts
function addDependency(edges, questId, dependsOnId) {
  if (questId === dependsOnId) {
    throw new Error("Quest cannot depend on itself");
  }
  if (edges.some((e) => e.questId === questId && e.dependsOnId === dependsOnId)) {
    return edges;
  }
  if (dependsOnReaches(edges, dependsOnId, questId)) {
    throw new Error(`Adding dependency ${questId} -> ${dependsOnId} would create a cycle`);
  }
  return [...edges, { questId, dependsOnId }];
}
function dependsOnReaches(edges, from, target) {
  const adj = /* @__PURE__ */ new Map();
  for (const e of edges) {
    const list = adj.get(e.questId);
    if (list) list.push(e.dependsOnId);
    else adj.set(e.questId, [e.dependsOnId]);
  }
  const stack = [from];
  const seen = /* @__PURE__ */ new Set();
  while (stack.length > 0) {
    const cur = stack.pop();
    if (cur === target) return true;
    if (seen.has(cur)) continue;
    seen.add(cur);
    for (const next of adj.get(cur) ?? []) stack.push(next);
  }
  return false;
}
function backfillLinearDependencies(quests) {
  const ordered = quests.filter((q) => q.scenarioOrder !== null).sort((a, b) => a.scenarioOrder - b.scenarioOrder);
  const edges = [];
  for (let i = 1; i < ordered.length; i++) {
    edges.push({ questId: ordered[i].id, dependsOnId: ordered[i - 1].id });
  }
  return edges;
}

// src/domain/scenario/scenario-progress.ts
var ScenarioProgressMetricKey = {
  CONTACTED_COUNT: "CONTACTED_COUNT",
  REPLIED_COUNT: "REPLIED_COUNT",
  NEGOTIATING_COUNT: "NEGOTIATING_COUNT",
  RECRUITED_COUNT: "RECRUITED_COUNT",
  DELIVERED_COUNT: "DELIVERED_COUNT",
  UPLOADED_COUNT: "UPLOADED_COUNT"
};
var SCENARIO_PROGRESS_METRIC_KEYS = Object.values(
  ScenarioProgressMetricKey
);
var SCENARIO_PROGRESS_METRIC_LABEL = {
  CONTACTED_COUNT: "\uCEE8\uD0DD",
  REPLIED_COUNT: "\uC751\uB2F5",
  NEGOTIATING_COUNT: "\uC870\uAC74\uD611\uC758",
  RECRUITED_COUNT: "\uC131\uC0AC",
  DELIVERED_COUNT: "\uC601\uC0C1 \uC218\uAE09",
  UPLOADED_COUNT: "\uC601\uC0C1 \uC5C5\uB85C\uB4DC"
};
var OUTREACH_METRIC_KEYS = [
  ScenarioProgressMetricKey.CONTACTED_COUNT,
  ScenarioProgressMetricKey.REPLIED_COUNT,
  ScenarioProgressMetricKey.NEGOTIATING_COUNT,
  ScenarioProgressMetricKey.RECRUITED_COUNT
];
function shouldIngestFormResponses(outreachQuestStatuses) {
  if (outreachQuestStatuses.length === 0) return true;
  return outreachQuestStatuses.some((status) => status !== "COMPLETED");
}
var ScenarioReviewMode = {
  MANAGER_ONLY: "MANAGER_ONLY",
  ADVERTISER_PRE_UPLOAD: "ADVERTISER_PRE_UPLOAD"
};
var ScenarioProgressCompletionState = {
  INSUFFICIENT_INSTRUMENTATION: "INSUFFICIENT_INSTRUMENTATION",
  IN_PROGRESS: "IN_PROGRESS",
  UPLOAD_COMPLETE_REPORT_PENDING: "UPLOAD_COMPLETE_REPORT_PENDING",
  CAMPAIGN_COMPLETE: "CAMPAIGN_COMPLETE"
};
var ScenarioProgressBlockerCode = {
  MISSING_SEMANTIC_ANCHOR: "MISSING_SEMANTIC_ANCHOR",
  INVALID_TARGET: "INVALID_TARGET",
  REVIEW_PENDING: "REVIEW_PENDING",
  OPEN_REPLACEMENT: "OPEN_REPLACEMENT"
};
var ScenarioDropSignalStatus = {
  OPEN: "OPEN",
  RESOLVED: "RESOLVED",
  CANCELLED: "CANCELLED"
};
var ScenarioContractTargetRevisionStatus = {
  APPLIED: "APPLIED",
  CANCELLED: "CANCELLED"
};
var REQUIRED_METRIC_KEYS = [
  ScenarioProgressMetricKey.RECRUITED_COUNT,
  ScenarioProgressMetricKey.DELIVERED_COUNT,
  ScenarioProgressMetricKey.UPLOADED_COUNT
];
function deriveScenarioProcedureProgressFromSignals(input) {
  return deriveScenarioProcedureProgress({
    ...input,
    contractTargetRevisionSlots: calculateScenarioContractTargetRevisionSlots(
      input.contractTargetRevisions ?? []
    ),
    openReplacementSignals: calculateOpenReplacementSignals(input.dropSignals ?? []),
    droppedSignals: calculateDroppedSignals(input.dropSignals ?? [])
  });
}
function calculateScenarioContractTargetRevisionSlots(revisions) {
  return revisions.filter((revision) => revision.status === ScenarioContractTargetRevisionStatus.APPLIED).reduce((sum, revision) => sum + normalizeInteger(revision.deltaSlots), 0);
}
function calculateOpenReplacementSignals(signals) {
  return signals.filter(
    (signal) => signal.status === ScenarioDropSignalStatus.OPEN && signal.replacementRequired === true
  ).reduce((sum, signal) => sum + normalizeNonNegativeInteger(signal.count), 0);
}
function calculateDroppedSignals(signals) {
  return signals.filter((signal) => signal.status === ScenarioDropSignalStatus.OPEN).reduce((sum, signal) => sum + normalizeNonNegativeInteger(signal.count), 0);
}
function deriveScenarioProcedureProgress(input) {
  const baseTargetSlots = normalizeNonNegativeInteger(input.baseTargetSlots);
  const contractTargetRevisionSlots = normalizeInteger(input.contractTargetRevisionSlots ?? 0);
  const effectiveTargetSlots = Math.max(0, baseTargetSlots + contractTargetRevisionSlots);
  const reportDelivered = input.topLevel?.reportDelivered ?? false;
  const metricCounts = input.metricCounts ?? {};
  const missingMetricKeys = reportDelivered ? [] : REQUIRED_METRIC_KEYS.filter((key) => metricCounts[key] == null);
  const recruitedSlots = readCount(metricCounts, ScenarioProgressMetricKey.RECRUITED_COUNT);
  const deliveredSlots = readCount(metricCounts, ScenarioProgressMetricKey.DELIVERED_COUNT);
  const uploadedSlots = readCount(metricCounts, ScenarioProgressMetricKey.UPLOADED_COUNT);
  const openReplacementSignals = normalizeNonNegativeInteger(input.openReplacementSignals ?? 0);
  const droppedSignals = normalizeNonNegativeInteger(input.droppedSignals ?? 0);
  const review = {
    mode: input.review?.mode ?? ScenarioReviewMode.MANAGER_ONLY,
    pendingSlots: normalizeNonNegativeInteger(input.review?.pendingSlots ?? 0),
    rejectedSlots: normalizeNonNegativeInteger(input.review?.rejectedSlots ?? 0),
    policyChangedAt: input.review?.policyChangedAt ?? null,
    // Plan 2026-05-22T09-21-23Z-c771704b — backend가 채운 quest 매핑 passthrough.
    // Optional spread: undefined 박지 않고 키 자체 생략 (JSON 응답 깔끔, fixture 호환).
    ...input.review?.pendingQuests && { pendingQuests: input.review.pendingQuests },
    ...input.review?.rejectedQuests && { rejectedQuests: input.review.rejectedQuests }
  };
  const blockers = missingMetricKeys.map((metricKey) => ({
    code: ScenarioProgressBlockerCode.MISSING_SEMANTIC_ANCHOR,
    metricKey
  }));
  if (input.baseTargetSlots < 0 || effectiveTargetSlots === 0) {
    blockers.push({ code: ScenarioProgressBlockerCode.INVALID_TARGET });
  }
  if (!reportDelivered && review.pendingSlots > 0) {
    blockers.push({ code: ScenarioProgressBlockerCode.REVIEW_PENDING });
  }
  if (!reportDelivered && openReplacementSignals > 0) {
    blockers.push({ code: ScenarioProgressBlockerCode.OPEN_REPLACEMENT });
  }
  const hasUploadedAnchor = uploadedSlots !== null;
  const rate2 = reportDelivered ? 1 : hasUploadedAnchor && effectiveTargetSlots > 0 ? clampRatio(uploadedSlots / effectiveTargetSlots) : null;
  const uploadedComplete = rate2 === 1 && hasUploadedAnchor;
  const state = reportDelivered ? ScenarioProgressCompletionState.CAMPAIGN_COMPLETE : missingMetricKeys.length > 0 || effectiveTargetSlots === 0 ? ScenarioProgressCompletionState.INSUFFICIENT_INSTRUMENTATION : uploadedComplete ? ScenarioProgressCompletionState.UPLOAD_COMPLETE_REPORT_PENDING : ScenarioProgressCompletionState.IN_PROGRESS;
  const topLevel = {
    kickoffDone: input.topLevel?.kickoffDone ?? false,
    guidelineAgreed: input.topLevel?.guidelineAgreed ?? false,
    creatorsRecruited: input.topLevel?.creatorsRecruited ?? (recruitedSlots !== null && effectiveTargetSlots > 0 ? recruitedSlots >= effectiveTargetSlots : false),
    reportDelivered
  };
  const creatorAggregate = {
    baseTargetSlots,
    contractTargetRevisionSlots,
    effectiveTargetSlots,
    recruitedSlots,
    deliveredSlots,
    uploadedSlots,
    openReplacementSignals,
    droppedSignals,
    review,
    blockers,
    rate: rate2
  };
  return {
    state,
    isFinal: state === ScenarioProgressCompletionState.CAMPAIGN_COMPLETE,
    rate: rate2,
    topLevel,
    creatorAggregate,
    blockers
  };
}
function deriveRecruitRemaining(input) {
  const targetSlots = normalizeNonNegativeInteger(input.effectiveTargetSlots);
  if (targetSlots === 0 || input.recruitedSlots == null) return null;
  const recruitedSlots = normalizeNonNegativeInteger(input.recruitedSlots);
  const remainingSlots = targetSlots - recruitedSlots;
  return {
    targetSlots,
    recruitedSlots,
    remainingSlots,
    surplusSlots: Math.max(0, -remainingSlots)
  };
}
function readCount(counts, key) {
  const value = counts[key];
  return value == null ? null : normalizeNonNegativeInteger(value);
}
function normalizeNonNegativeInteger(value) {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.floor(value));
}
function normalizeInteger(value) {
  if (!Number.isFinite(value)) return 0;
  return Math.trunc(value);
}
function clampRatio(value) {
  if (!Number.isFinite(value)) return 0;
  return Math.min(Math.max(value, 0), 1);
}

// src/domain/scenario/scenario-outreach-funnel.ts
var FUNNEL_ORDER = [
  ScenarioProgressMetricKey.CONTACTED_COUNT,
  ScenarioProgressMetricKey.REPLIED_COUNT,
  ScenarioProgressMetricKey.NEGOTIATING_COUNT,
  ScenarioProgressMetricKey.RECRUITED_COUNT
];
function deriveOutreachFunnel(counts) {
  const violations = [];
  for (let i = 0; i < FUNNEL_ORDER.length - 1; i += 1) {
    const from = FUNNEL_ORDER[i];
    const to = FUNNEL_ORDER[i + 1];
    const fromCount = readCount2(counts, from);
    const toCount = readCount2(counts, to);
    if (fromCount === null || toCount === null) continue;
    if (toCount > fromCount) violations.push({ from, to, fromCount, toCount });
  }
  return {
    replyRate: rate(
      counts,
      ScenarioProgressMetricKey.CONTACTED_COUNT,
      ScenarioProgressMetricKey.REPLIED_COUNT,
      violations
    ),
    closeRate: rate(
      counts,
      ScenarioProgressMetricKey.NEGOTIATING_COUNT,
      ScenarioProgressMetricKey.RECRUITED_COUNT,
      violations
    ),
    violations
  };
}
function rate(counts, denominatorKey, numeratorKey, violations) {
  const denominator = readCount2(counts, denominatorKey);
  const numerator = readCount2(counts, numeratorKey);
  if (denominator === null || numerator === null) return null;
  if (denominator === 0) return null;
  const broken = violations.some((v) => v.from === denominatorKey && v.to === numeratorKey);
  if (broken) return null;
  return numerator / denominator;
}
function readCount2(counts, key) {
  const value = counts[key];
  if (value == null || !Number.isFinite(value)) return null;
  return Math.max(0, Math.floor(value));
}

// src/domain/scenario/scenario-view-progress.ts
function calculateScenarioViewProgress(adcodes, targetTotalViews) {
  const representatives = pickRepresentativeAdcodePerVideo(adcodes);
  const measured = representatives.filter(
    (a) => a.views !== null
  );
  const totalViews = measured.length === 0 ? null : measured.reduce((sum, a) => sum + a.views, 0);
  const ratio = totalViews === null || !targetTotalViews ? null : totalViews / targetTotalViews;
  let lastObservedMs = null;
  for (const a of measured) {
    if (a.metricsObservedAt === null) continue;
    const ms = new Date(a.metricsObservedAt).getTime();
    if (lastObservedMs === null || ms > lastObservedMs) lastObservedMs = ms;
  }
  return {
    totalViews,
    targetTotalViews,
    measuredCount: measured.length,
    trackedCount: representatives.length,
    complete: representatives.length > 0 && measured.length === representatives.length,
    ratio,
    gaugeRatio: ratio === null ? null : Math.min(ratio, 1),
    surplusViews: ratio === null || totalViews === null || !targetTotalViews ? null : Math.max(0, totalViews - targetTotalViews),
    lastObservedAt: lastObservedMs === null ? null : new Date(lastObservedMs).toISOString()
  };
}
function pickRepresentativeAdcodePerVideo(adcodes) {
  const byRow = /* @__PURE__ */ new Map();
  for (const a of adcodes) {
    const current = byRow.get(a.rosterEntryId);
    if (current === void 0 || outranks(a, current)) byRow.set(a.rosterEntryId, a);
  }
  return [...byRow.values()];
}
function outranks(a, b) {
  if (a.archivedAt === null) return true;
  if (b.archivedAt === null) return false;
  return new Date(a.archivedAt).getTime() > new Date(b.archivedAt).getTime();
}

// src/domain/scenario/scenario-operational-health.ts
var ScenarioOperationalIssueArea = {
  RECRUITING: "RECRUITING",
  CONTENT_DELIVERY: "CONTENT_DELIVERY"
};
var ScenarioRecruitingIssueReason = {
  NO_RESPONSE: "NO_RESPONSE",
  NEGOTIATION_STALLED: "NEGOTIATION_STALLED",
  OTHER: "OTHER"
};
var ScenarioContentDeliveryIssueReason = {
  DELIVERY_DELAY: "DELIVERY_DELAY",
  REVISION_LOOP: "REVISION_LOOP",
  OTHER: "OTHER"
};
var ScenarioOperationalIssueReportStatus = {
  OPEN: "OPEN",
  RESOLVED: "RESOLVED",
  CANCELLED: "CANCELLED"
};
var ScenarioOperationalHealthLabel = {
  RECRUITING_DIFFICULTY: "RECRUITING_DIFFICULTY",
  CONTENT_DELIVERY_DELAY: "CONTENT_DELIVERY_DELAY"
};
var OPERATIONAL_REASONS_BY_AREA = {
  [ScenarioOperationalIssueArea.RECRUITING]: [
    ScenarioRecruitingIssueReason.NO_RESPONSE,
    ScenarioRecruitingIssueReason.NEGOTIATION_STALLED,
    ScenarioRecruitingIssueReason.OTHER
  ],
  [ScenarioOperationalIssueArea.CONTENT_DELIVERY]: [
    ScenarioContentDeliveryIssueReason.DELIVERY_DELAY,
    ScenarioContentDeliveryIssueReason.REVISION_LOOP,
    ScenarioContentDeliveryIssueReason.OTHER
  ]
};
function isReasonValidForArea(area, reason) {
  const validReasons = OPERATIONAL_REASONS_BY_AREA[area];
  return validReasons.includes(reason);
}
function captureInitialCreatorsRecruitedAt(input) {
  if (input.currentValue !== null) return input.currentValue;
  if (input.recruitedSlots === null) return null;
  if (input.effectiveTargetSlots <= 0) return null;
  return input.recruitedSlots >= input.effectiveTargetSlots ? input.observedAt : null;
}
function summarizeScenarioOperationalHealth(reports) {
  const openReports = reports.filter(
    (report) => report.status === ScenarioOperationalIssueReportStatus.OPEN
  );
  const labels = [];
  if (openReports.some((report) => report.area === ScenarioOperationalIssueArea.RECRUITING)) {
    labels.push(ScenarioOperationalHealthLabel.RECRUITING_DIFFICULTY);
  }
  if (openReports.some((report) => report.area === ScenarioOperationalIssueArea.CONTENT_DELIVERY)) {
    labels.push(ScenarioOperationalHealthLabel.CONTENT_DELIVERY_DELAY);
  }
  return {
    labels,
    helpNeeded: openReports.some((report) => report.helpNeeded),
    openReportCount: openReports.length,
    primaryBottleneck: null
  };
}
var ScenarioOperationalSignalGapDirection = {
  /** 가이드라인 컨펌이 초기 섭외 도달보다 먼저 끝남 (섭외 지연 리스크) */
  GUIDELINE_FIRST: "GUIDELINE_FIRST",
  /** 초기 섭외 도달이 가이드라인 컨펌보다 먼저 끝남 (크리에이터 이탈 리스크) */
  RECRUIT_FIRST: "RECRUIT_FIRST",
  /** 거의 동시 (리스크 없음) */
  ALIGNED: "ALIGNED"
};
var SCENARIO_OPERATIONAL_SIGNAL_GAP_ALIGNED_HOURS = 24;
function deriveOperationalSignalGap(input) {
  const { guidelineAgreedAt, initialCreatorsRecruitedAt } = input;
  if (!guidelineAgreedAt || !initialCreatorsRecruitedAt) return null;
  const guideline = new Date(guidelineAgreedAt).getTime();
  const recruit = new Date(initialCreatorsRecruitedAt).getTime();
  const hoursDiff = (guideline - recruit) / 36e5;
  let direction;
  if (Math.abs(hoursDiff) <= SCENARIO_OPERATIONAL_SIGNAL_GAP_ALIGNED_HOURS) {
    direction = ScenarioOperationalSignalGapDirection.ALIGNED;
  } else if (hoursDiff < 0) {
    direction = ScenarioOperationalSignalGapDirection.GUIDELINE_FIRST;
  } else {
    direction = ScenarioOperationalSignalGapDirection.RECRUIT_FIRST;
  }
  return { direction, guidelineAgreedAt, initialCreatorsRecruitedAt, hoursDiff };
}
function visibleReportsForViewer(reports, viewer) {
  if (viewer.canManage) return reports;
  return reports.filter(
    (report) => report.reporterId === viewer.userId || report.helpNeeded && report.reporterTeamId != null && viewer.teamId != null && report.reporterTeamId === viewer.teamId
  );
}
var SCENARIO_OPERATIONAL_ISSUE_REPORT_COMMENT_MAX_LENGTH = 2e3;
function createScenarioOperationalIssueReportComment(params) {
  if (!params.body.trim()) {
    throw new Error("report comment body cannot be empty");
  }
  if (params.body.length > SCENARIO_OPERATIONAL_ISSUE_REPORT_COMMENT_MAX_LENGTH) {
    throw new Error(
      `report comment body cannot exceed ${SCENARIO_OPERATIONAL_ISSUE_REPORT_COMMENT_MAX_LENGTH} characters`
    );
  }
  return {
    id: params.id,
    reportId: params.reportId,
    authorId: params.authorId,
    body: params.body,
    createdAt: params.now
  };
}
function canCommentOnOperationalIssueReport(ctx) {
  const isSameTeamHelper = ctx.helpNeeded === true && ctx.reporterTeamId != null && ctx.teamId != null && ctx.reporterTeamId === ctx.teamId;
  return (ctx.actorId === ctx.reporterId || ctx.canManage || isSameTeamHelper) && ctx.reportStatus !== ScenarioOperationalIssueReportStatus.CANCELLED;
}
var SCENARIO_OPERATIONAL_SIGNAL_REPORTS_LIMIT = 20;

// src/domain/scenario/index.ts
var SCENARIO_TARGET_TOTAL_VIEWS_MAX = 2147483647;

// src/domain/campaign/boosting-flags.ts
var BoostingFlagWarning = {
  /** 진행 플래그가 둘 이상 켜져 있어 단일 상태로 접었다. */
  CONTRADICTORY_FLAGS: "CONTRADICTORY_FLAGS",
  /** 애드코드가 없는데 진행 플래그가 켜져 있다. */
  STAGE_WITHOUT_ADCODE: "STAGE_WITHOUT_ADCODE"
};
function deriveBoostingStage(flags, hasAdCode) {
  const warnings = [];
  const raised = [flags.boosting, flags.stopRequested, flags.ended].filter(Boolean).length;
  if (raised > 1) {
    warnings.push(BoostingFlagWarning.CONTRADICTORY_FLAGS);
  }
  if (!hasAdCode) {
    if (raised > 0) {
      warnings.push(BoostingFlagWarning.STAGE_WITHOUT_ADCODE);
    }
    return { stage: null, warnings };
  }
  const stage = flags.ended ? BoostingStage.STOPPED : flags.stopRequested ? BoostingStage.STOP_REQUESTED : flags.boosting ? BoostingStage.BOOSTING : BoostingStage.ISSUED;
  return { stage, warnings };
}

// src/domain/campaign/kakao-channel-name.ts
var EMPTY = { nickname: null, discarded: false, unverified: false };
var PAREN_GROUP = /[(（]([^()（）]*)(?:[)）]|$)/u;
function matchKey(value) {
  return value.normalize("NFKC").toLowerCase().replace(/[^\p{L}\p{N}]/gu, "");
}
function matchesAny(candidate, refs) {
  const key = matchKey(candidate);
  if (key.length === 0) {
    return false;
  }
  return refs.some((ref) => {
    if (ref === key) {
      return true;
    }
    const shorter = key.length < ref.length ? key : ref;
    if (Array.from(shorter).length < 2) {
      return false;
    }
    return key.includes(ref) || ref.includes(key);
  });
}
function stripSlashMemo(text2, refs) {
  const slash = text2.indexOf("/");
  if (slash < 0) {
    return { value: text2.trim(), discarded: false };
  }
  const head = text2.slice(0, slash).trim();
  const tail = text2.slice(slash + 1).trim();
  if (matchesAny(head, refs)) {
    return { value: head, discarded: tail.length > 0 };
  }
  return { value: tail.length > 0 ? tail : head, discarded: true };
}
function splitKakaoChannelName(raw, ctx) {
  const source = typeof raw === "string" ? raw.trim() : "";
  if (source === "") {
    return { ...EMPTY };
  }
  const refs = [ctx.nickname, ctx.handle].filter((value) => typeof value === "string").map(matchKey).filter((key) => key.length > 0);
  const group = PAREN_GROUP.exec(source);
  if (group === null) {
    const { value, discarded } = stripSlashMemo(source, refs);
    return { nickname: value, discarded, unverified: !matchesAny(value, refs) };
  }
  const before = stripSlashMemo(source.slice(0, group.index), refs).value;
  const insideTokens = (group[1] ?? "").split("/").map((token) => token.trim()).filter((token) => token.length > 0);
  let chosen;
  if (before.length > 0 && matchesAny(before, refs)) {
    chosen = before;
  } else {
    const insideMatch = insideTokens.find((token) => matchesAny(token, refs));
    chosen = insideMatch ?? (before.length > 0 ? before : insideTokens[0] ?? "");
  }
  if (chosen.length === 0) {
    return { nickname: null, discarded: true, unverified: false };
  }
  return { nickname: chosen, discarded: true, unverified: !matchesAny(chosen, refs) };
}

// src/domain/campaign/roster-label.ts
var RosterLabelKey = {
  SEQ: "seq",
  CREATOR_NICKNAME: "creatorNickname",
  CREATOR_HANDLE: "creatorHandle",
  TIKTOK_URL: "tiktokUrl",
  FOLLOWERS: "followers",
  UPLOAD_DATE: "uploadDate",
  VIDEO_URL: "videoUrl",
  AD_CODE: "adCode",
  CLEAN_FILE: "cleanFile",
  ISSUE_NOTE: "issueNote",
  PRICE: "price",
  KAKAO_CHANNEL_NO: "kakaoChannelNo",
  KAKAO_CHANNEL_NAME: "kakaoChannelName",
  SETTLEMENT: "settlement",
  PRODUCT_VARIANT: "productVariant",
  GUIDELINE: "guideline",
  ACCOUNT_NOTE: "accountNote",
  CROSS_PLATFORM: "crossPlatform",
  REAL_NAME: "realName",
  CONTACT_PINPLY: "contactPinply",
  PAYPAL: "paypal",
  EMAIL: "email"
};
var ROSTER_LABEL_ALIASES = {
  seq: ["\uBC88\uD638"],
  creatorNickname: ["\uB2C9\uB124\uC784"],
  creatorHandle: ["\uD2F1\uD1A1 \uC544\uC774\uB514", "\uD2F1\uD1A1 ID"],
  // '틱톡주소 (고유링크)' 는 니들리 실측 헤더다. 필수 키라 흘리면 전 행이 필수 누락으로 떨어진다.
  tiktokUrl: ["\uD2F1\uD1A1 \uC8FC\uC18C", "\uD2F1\uD1A1 \uB9C1\uD06C", "\uD2F1\uD1A1\uC8FC\uC18C (\uACE0\uC720\uB9C1\uD06C)"],
  followers: ["\uD314\uB85C\uC6CC", "\uD314\uB85C\uC6CC \uC218"],
  uploadDate: ["\uC5C5\uB85C\uB4DC \uC77C\uC790", "\uC601\uC0C1 \uC5C5\uB85C\uB4DC \uC77C\uC790"],
  // '영상 주소' 는 AGE20'S 애드코드 시트 헤더 실측 (QD-3 §4-1).
  videoUrl: ["\uC601\uC0C1 \uB9C1\uD06C", "\uC601\uC0C1 \uC5C5\uB85C\uB4DC \uB9C1\uD06C", "\uC5C5\uB85C\uB4DC \uB9C1\uD06C", "\uC601\uC0C1 \uC8FC\uC18C"],
  adCode: ["\uC560\uB4DC\uCF54\uB4DC"],
  // '클린본 저장' 은 니들리 실측 헤더 — 값이 boolean 이라 링크가 아니라 이 boolean 칸이 맞다.
  // 같은 시트의 '완성본 저장' 은 다른 파일이라 여기 넣지 않는다.
  cleanFile: ["\uD074\uB9B0\uBCF8", "\uD074\uB9B0\uBCF8 \uC800\uC7A5"],
  issueNote: [
    "\uC774\uC288/\uBE44\uACE0",
    "\uBE44\uACE0",
    "\uBE44\uACE0/\uC774\uC288 \uC0AC\uD56D(>\uC218\uC815 \uC0AC\uD56D)",
    "\uC601\uC0C1 \uC218\uC815 \uC0AC\uD56D",
    "\uBA54\uBAA8",
    "\uD2B9\uC774\uC0AC\uD56D"
  ],
  // '영상 단가 ($)' 는 실측 헤더다 — 정확 일치라 이 줄이 없으면 그 칸이 통째로 버려진다.
  price: [
    "\uB2E8\uAC00",
    "\uB2E8\uAC00 ($)",
    "\uCD5C\uC885 \uB2E8\uAC00",
    "\uCD5C\uC885\uB2E8\uAC00 ($)",
    "\uC601\uC0C1 \uB2E8\uAC00 ($)",
    // 니들리 실측 — 헤더가 단위 설명까지 한 칸에 적혀 있다. 통화는 아래 PRICE_LABEL_CURRENCY 가 따로 판정한다.
    "\uD655\uC815 \uB2E8\uAC00($) \uC601\uC0C1 1\uAC1C \uAE30\uC900",
    // 글로벌 드라이브 전수 스냅샷 실측(2026-09-30) — 10개·5개 단위.
    "\uCD1D \uD655\uC815 \uB2E8\uAC00($) \uC601\uC0C1 1\uAC1C \uAE30\uC900",
    "\uB2E8\uAC00 ($) (\uC601\uC0C1 1\uAC1C \uAE30\uC900)",
    // 니들리 폴란드 실측(2026-09-30) — 크리에이터 고료. 같은 시트의 '제품비 ($)'·'총 금액' 은 단가가 아니다.
    "\uACE0\uB8CC ($)"
  ],
  kakaoChannelNo: ["\uCE74\uCC44\uB110 \uBC88\uD638", "\uCE74\uCC44\uB110\uBC29 \uBC88\uD638"],
  kakaoChannelName: ["\uCE74\uCC44\uB110 \uB2C9\uB124\uC784"],
  settlement: ["\uC815\uC0B0"],
  // QD-3 M-1: §8 이 한 키로 묶었던 5별칭을 3키로 가른다 — 크리에이터가 쓴 제품과
  // 촬영 가이드라인, 계정 구분은 서로 다른 사실이라 한 칸에 접으면 되돌릴 수 없다.
  // '진행 제품'·'shade' 는 글로벌 드라이브 전수 스냅샷 실측(2026-09-30).
  productVariant: ["\uC81C\uD488", "\uC0AC\uC6A9 \uC81C\uD488", "\uC250\uC774\uB4DC", "\uD638\uC218", "\uC81C\uD488/\uC250\uC774\uB4DC/\uD638\uC218", "\uC9C4\uD589 \uC81C\uD488", "shade"],
  // '가이드라인 구분' 은 AGE20'S 실측 헤더다 (QE-12). 값이 5종 카테고리라 '구분' 이 붙는다.
  guideline: ["\uAC00\uC774\uB4DC\uB77C\uC778", "\uAC00\uC774\uB4DC\uB77C\uC778 \uAD6C\uBD84"],
  accountNote: ["\uAD6C\uBD84"],
  crossPlatform: [
    "\uD0C0 \uD50C\uB7AB\uD3FC",
    "\uD0C0 \uD50C\uB7AB\uD3FC \uC790\uC728 \uC5C5\uB85C\uB4DC",
    "\uBC14\uC774\uC624 \uB9C1\uD06C \uBC0F \uD0C0 \uD50C\uB7AB\uD3FC \uC5C5\uB85C\uB4DC",
    "\uD504\uB85C\uD544 \uBC14\uC774\uC624 \uB9C1\uD06C \uCD94\uAC00 \uBC0F \uD0C0\uD50C\uB7AB\uD3FC \uC5C5\uB85C\uB4DC",
    // 글로벌 드라이브 전수 스냅샷 실측(2026-09-30). '프로필 바이오 링크 추가' 단독 칸은
    // 타 플랫폼 업로드와 다른 사실이라 넣지 않는다.
    "\uD0C0 \uD50C\uB7AB\uD3FC \uC5C5\uB85C\uB4DC",
    "\uD0C0\uD50C\uB7AB\uD3FC \uC5C5\uB85C\uB4DC \uD639\uC740 \uBC14\uC774\uC624 \uB4F1\uB85D",
    "\uD504\uB85C\uD544 \uBC14\uC774\uC624 / \uD0C0\uD50C\uB7AB\uD3FC \uC5C5\uB85C\uB4DC"
  ],
  // PII — 라벨은 알아보되 값은 버린다 (§7-5). 알아보지 못하면 미지 라벨로 흘러
  // "이 시트에 실명이 있었다"는 사실조차 보고하지 못한다.
  realName: ["\uC2E4\uBA85"],
  // '연락 채널 - 구글' 은 니들리 실측 — 채널 이름이 접미로 붙는다.
  // 마지막 것은 AGE20'S 실측 헤더 (QE-12) — 주소가 헤더에 통째로 박혀 있다.
  // **이 칸이 시트가 주소를 적는 자리다** (AGE20'S 293행). 이름은 '연락 채널' 이지만 값은
  // 크리에이터 이메일이라 `EMAIL_LABEL_KEYS` 가 이 키를 든다.
  contactPinply: [
    "\uC5F0\uB77D \uCC44\uB110",
    "\uC5F0\uB77D \uCC44\uB110 (pinply)",
    "pinply",
    "\uD540\uD50C\uB9AC",
    "\uC5F0\uB77D \uCC44\uB110 - \uAD6C\uAE00",
    "\uC5F0\uB77D \uCC44\uB110 - \uAD6C\uAE00 contact@pinply.com",
    // 글로벌 드라이브 전수 스냅샷 실측(2026-09-30) — 보낸 메일함이 헤더에 박힌 같은 칸이다.
    "\uC5F0\uB77D \uCC44\uB110 - \uAD6C\uAE00 aegislab_beauty@crevasse.ai"
  ],
  paypal: ["\uD398\uC774\uD314", "paypal", "\uD398\uC774\uD314 \uC8FC\uC18C Paypal", "\uD398\uC774\uD314 \uC8FC\uC18C", "PayPal address"],
  email: ["\uC774\uBA54\uC77C", "\uC774\uBA54\uC77C \uC8FC\uC18C", "\uBA54\uC77C \uC8FC\uC18C"]
};
var PII_LABEL_KEYS = /* @__PURE__ */ new Set([RosterLabelKey.REAL_NAME]);
var PAYOUT_LABEL_KEYS = /* @__PURE__ */ new Set([RosterLabelKey.PAYPAL]);
var EMAIL_LABEL_KEYS = /* @__PURE__ */ new Set([
  RosterLabelKey.EMAIL,
  RosterLabelKey.CONTACT_PINPLY
]);
function compare(label) {
  return label.replace(/\s+/g, "").toLowerCase();
}
var LOOKUP = new Map(
  Object.entries(ROSTER_LABEL_ALIASES).flatMap(
    ([key, labels]) => labels.map((label) => [compare(label), key])
  )
);
function normalizeRosterLabel(label) {
  return LOOKUP.get(compare(label)) ?? null;
}
var PRICE_LABEL_CURRENCY = new Map(
  [
    ["\uB2E8\uAC00 ($)", "USD"],
    ["\uCD5C\uC885\uB2E8\uAC00 ($)", "USD"],
    ["\uC601\uC0C1 \uB2E8\uAC00 ($)", "USD"],
    // 니들리 실측 헤더. 이 표는 별칭표와 별개라 `ROSTER_LABEL_ALIASES` 에만 넣으면
    // 라벨은 price 로 흡수되는데 통화가 null 이 되어 금액만 짝 없이 선다.
    ["\uD655\uC815 \uB2E8\uAC00($) \uC601\uC0C1 1\uAC1C \uAE30\uC900", "USD"],
    ["\uCD1D \uD655\uC815 \uB2E8\uAC00($) \uC601\uC0C1 1\uAC1C \uAE30\uC900", "USD"],
    ["\uB2E8\uAC00 ($) (\uC601\uC0C1 1\uAC1C \uAE30\uC900)", "USD"],
    ["\uACE0\uB8CC ($)", "USD"]
  ].map(([label, currency]) => [compare(label), currency])
);
function rosterPriceCurrency(label) {
  return PRICE_LABEL_CURRENCY.get(compare(label)) ?? null;
}

// src/domain/campaign/video-url.ts
var ABSOLUTE_URL = /^([a-zA-Z][a-zA-Z0-9+.-]*):\/\/([^/?#]*)([^?#]*)/;
var HTTP_SCHEMES = /* @__PURE__ */ new Set(["http", "https"]);
function parse(value) {
  const matched = ABSOLUTE_URL.exec(value.trim());
  if (!matched) {
    return null;
  }
  const scheme = matched[1].toLowerCase();
  const rawAuthority = matched[2];
  if (!HTTP_SCHEMES.has(scheme) || rawAuthority === "") {
    return null;
  }
  const at = rawAuthority.lastIndexOf("@");
  const userinfo = at === -1 ? "" : rawAuthority.slice(0, at + 1);
  const host = rawAuthority.slice(at + 1).toLowerCase();
  if (host === "") {
    return null;
  }
  return { scheme, authority: `${userinfo}${host}`, path: matched[3] ?? "" };
}
function normalizeVideoUrl(raw) {
  const parsed = parse(raw);
  if (parsed === null) {
    return null;
  }
  const path = parsed.path.replace(/\/+$/, "");
  return `${parsed.scheme}://${parsed.authority}${path}`;
}
function isTikTokUrl(url) {
  const parsed = parse(url);
  if (parsed === null) {
    return false;
  }
  const at = parsed.authority.lastIndexOf("@");
  const hostname = parsed.authority.slice(at + 1).split(":")[0] ?? "";
  return hostname === "tiktok.com" || hostname.endsWith(".tiktok.com");
}

// src/domain/campaign/import.ts
import { z as z3 } from "zod";
var MappingWarningCode = {
  /** §8 표에 없는 헤더 — 추측하지 않고 그 칸을 버린다. */
  UNKNOWN_LABEL: "UNKNOWN_LABEL",
  /** 애드코드 형식 값이 애드코드 전용칸이 아닌 곳에 있다 (§1 실측: 비고·단가·클린본·상태칸). */
  AD_CODE_IN_WRONG_FIELD: "AD_CODE_IN_WRONG_FIELD",
  /** 애드코드 칸인데 `^#` 형식이 아니다. */
  MALFORMED_AD_CODE: "MALFORMED_AD_CODE",
  /** 상태 칸에 숫자가 들어 있다 (§1 실측: 90, 6). */
  NUMERIC_IN_STATE_COLUMN: "NUMERIC_IN_STATE_COLUMN",
  /** 상태 칸 값이 §5-1 canonical 매핑 어디에도 없다. */
  UNKNOWN_STAGE_VALUE: "UNKNOWN_STAGE_VALUE",
  /** 진행 플래그가 둘 이상 켜져 있다 (§5-2 모순 조합). */
  CONTRADICTORY_FLAGS: "CONTRADICTORY_FLAGS",
  /** 애드코드가 없는데 진행 플래그가 켜져 있다. */
  STAGE_WITHOUT_AD_CODE: "STAGE_WITHOUT_AD_CODE",
  /** 숫자·날짜·불리언 칸을 해석할 수 없다. 값은 버린다. */
  TYPE_COERCION_FAILED: "TYPE_COERCION_FAILED",
  /** 링크 칸이 URL 이 아니거나 틱톡 주소가 아니다. */
  MALFORMED_URL: "MALFORMED_URL",
  /**
   * 영상 링크가 없는데 클린본·애드코드가 차 있다 — 링크를 빠뜨린 행일 수 있다 (퀘스트 3000f53c).
   * 단계는 규칙표대로 두고 사람이 시트를 보게 알린다.
   */
  PROGRESS_WITHOUT_LINK: "PROGRESS_WITHOUT_LINK",
  /** 로스터 필수 스냅샷(닉네임·틱톡 아이디·틱톡 주소)이 비어 있다. */
  REQUIRED_FIELD_MISSING: "REQUIRED_FIELD_MISSING",
  /** PII 컬럼 — 값을 버렸다. 필드명만 보고한다 (§7-5). */
  PII_FIELD_DISCARDED: "PII_FIELD_DISCARDED",
  /**
   * 주소 칸인데 값이 주소가 아니거나 254자를 넘는다 — 값을 버린다 (퀘스트 05753db1).
   *
   * `PII_FIELD_DISCARDED` 와 가른 이유는 손이 갈 자리가 다르기 때문이다. 저쪽은 "담지 않기로
   * 한 칸"이라 시트를 고칠 것이 없고, 이쪽은 **담기로 한 칸인데 못 담은 값**이라 시트에서
   * 고칠 행이 있다. 한 코드로 묶으면 리허설 리포트에서 그 구분이 라벨로만 남는다.
   */
  MALFORMED_EMAIL: "MALFORMED_EMAIL",
  /**
   * 페이팔 칸인데 값이 주소도 `paypal.me` 링크도 아니다 — 값을 버린다 (2026-09-18).
   * `MALFORMED_EMAIL` 과 같은 이유로 가른다: 담기로 한 칸인데 못 담은 값이라 시트에 고칠 행이 있다.
   */
  MALFORMED_PAYPAL: "MALFORMED_PAYPAL",
  /**
   * 카채널 닉네임이 같은 행의 틱톡 닉네임·핸들과 맞지 않는다 — 카카오 표시명이 실명일 수 있어
   * 사람이 dry-run 에서 확인한다. 값은 저장된다(운영이 이 칸으로 사람을 찾는다).
   */
  KAKAO_CHANNEL_NAME_UNVERIFIED: "KAKAO_CHANNEL_NAME_UNVERIFIED",
  /** 애드코드 행에 영상 링크가 없어 로스터 행을 찾을 키가 없다 (D-5). */
  BINDING_KEY_MISSING: "BINDING_KEY_MISSING",
  /** 애드코드 시트에 크리에이터 식별 컬럼이 없어 교차검증을 건너뛴다 (D-5, 침묵 금지). */
  CREATOR_CROSS_CHECK_UNAVAILABLE: "CREATOR_CROSS_CHECK_UNAVAILABLE",
  /**
   * 단가 칸인데 통화를 정할 수 없다 — 값을 버린다.
   *
   * 글로벌 시트가 맨 `단가` 헤더를 쓰면 여기 걸린다. GLOBAL 을 USD 로 메우던 옛 동작은
   * 지웠다: 실측 시트의 정산 갈래 265행이 전부 CAD 였고, 시나리오 `targetCountries` 는 배열이라
   * `[JP, TH]` 를 동시에 들 수 있어 캠페인에서 통화가 한 값으로 안 나온다. 고치는 법은 시트
   * 헤더에 통화를 적는 것이다(`영상 단가 ($)`) — 그 기호를 `rosterPriceCurrency` 가 읽는다.
   */
  PRICE_CURRENCY_UNKNOWN: "PRICE_CURRENCY_UNKNOWN"
};
var CREATOR_EMAIL_MAX_LENGTH = 254;
var creatorEmailSchema = z3.email().max(CREATOR_EMAIL_MAX_LENGTH);
var paypalMeSchema = z3.string().max(500).regex(/^(https?:\/\/)?(www\.)?paypal\.me\/[\w.-]+\/?$/i);
var AdcodeLabelKey = {
  /** 니들리 "글로벌 부스팅 중"·"애드코드 태움" · AGE20'S "애드코드 등록" (§5-1). */
  STAGE_BOOSTING: "stageBoosting",
  /** 니들리 "꺼주세요" · AGE20'S "애드코드 중단 요청". */
  STAGE_STOP_REQUESTED: "stageStopRequested",
  /** 니들리 "종료 여부" · AGE20'S "애드코드 중단 완료". */
  STAGE_ENDED: "stageEnded",
  VIEWS: "views",
  LIKES: "likes",
  COMMENTS: "comments",
  SHARES: "shares",
  SAVES: "saves"
};
var ADCODE_LABEL_ALIASES = {
  stageBoosting: ["\uAE00\uB85C\uBC8C \uBD80\uC2A4\uD305 \uC911", "\uBD80\uC2A4\uD305 \uC911", "\uC560\uB4DC\uCF54\uB4DC \uB4F1\uB85D", "\uAD11\uACE0 \uB4F1\uB85D", "\uC560\uB4DC\uCF54\uB4DC \uD0DC\uC6C0"],
  stageStopRequested: ["\uAEBC\uC8FC\uC138\uC694", "\uC560\uB4DC\uCF54\uB4DC \uC911\uB2E8 \uC694\uCCAD", "\uC911\uB2E8 \uC694\uCCAD"],
  stageEnded: ["\uC885\uB8CC \uC5EC\uBD80", "\uC560\uB4DC\uCF54\uB4DC \uC911\uB2E8 \uC644\uB8CC", "\uC911\uB2E8 \uC644\uB8CC"],
  views: ["\uC870\uD68C\uC218"],
  likes: ["\uC88B\uC544\uC694"],
  comments: ["\uB313\uAE00"],
  shares: ["\uACF5\uC720"],
  saves: ["\uC800\uC7A5"]
};
function compareLabel(label) {
  return label.replace(/\s+/g, "").toLowerCase();
}
var ADCODE_LOOKUP = new Map(
  Object.entries(ADCODE_LABEL_ALIASES).flatMap(
    ([key, labels]) => labels.map((label) => [compareLabel(label), key])
  )
);
function normalizeAdcodeLabel(label) {
  return normalizeRosterLabel(label) ?? ADCODE_LOOKUP.get(compareLabel(label)) ?? null;
}
function isBlank(value) {
  return value === null || value === void 0 || typeof value === "string" && value.trim() === "";
}
function looksLikeAdCode(value) {
  return typeof value === "string" && isCampaignAdCode(value.trim());
}
function readText(value) {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed === "" ? null : trimmed;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }
  return null;
}
var NUMBER_NOISE = /[,\s₩$원]/g;
function hasAtMostTwoDecimals(value) {
  const [, decimals = ""] = value.toString().split(".");
  return !decimals.includes("e") && decimals.length <= 2;
}
function negotiatedCurrencyFor(label, campaignType) {
  const fromLabel = rosterPriceCurrency(label);
  if (fromLabel !== null) return fromLabel;
  return campaignType === ScenarioCampaignType.DOMESTIC ? "KRW" : null;
}
function readNumber(value) {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value !== "string") {
    return null;
  }
  const cleaned = value.replace(NUMBER_NOISE, "");
  if (cleaned === "" || !/^-?\d+(\.\d+)?$/.test(cleaned)) {
    return null;
  }
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
}
function readInteger(value) {
  const parsed = readNumber(value);
  if (parsed === null || !Number.isInteger(parsed)) {
    return null;
  }
  return parsed;
}
var DATE_PATTERN = /^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/;
var TWO_DIGIT_YEAR_DATE_PATTERN = /^(\d{2})[-./](\d{1,2})[-./](\d{1,2})$/;
function readIsoDate(value) {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return null;
    }
    const year2 = String(value.getFullYear()).padStart(4, "0");
    const month2 = String(value.getMonth() + 1).padStart(2, "0");
    const day2 = String(value.getDate()).padStart(2, "0");
    return `${year2}-${month2}-${day2}`;
  }
  const text2 = typeof value === "string" ? value.trim() : null;
  if (text2 === null) {
    return null;
  }
  const full = DATE_PATTERN.exec(text2);
  const short = full ? null : TWO_DIGIT_YEAR_DATE_PATTERN.exec(text2);
  const matched = full ?? short;
  if (!matched) {
    return null;
  }
  const [, rawYear, month, day] = matched;
  const year = short ? `20${rawYear}` : rawYear;
  const monthNumber = Number(month);
  const dayNumber = Number(day);
  if (monthNumber < 1 || monthNumber > 12 || dayNumber < 1 || dayNumber > 31) {
    return null;
  }
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}
var TRUE_TOKENS = /* @__PURE__ */ new Set(["true", "o", "y", "yes", "\uC608", "v"]);
var FALSE_TOKENS = /* @__PURE__ */ new Set(["false", "x", "n", "no", "\uC544\uB2C8\uC624", "-"]);
function readStateFlag(value) {
  if (typeof value === "boolean") {
    return { kind: "value", value };
  }
  if (isBlank(value)) {
    return { kind: "blank" };
  }
  if (typeof value === "number") {
    if (value === 0 || value === 1) {
      return { kind: "value", value: value === 1 };
    }
    return { kind: "numeric" };
  }
  if (typeof value === "string") {
    const token = value.trim().toLowerCase();
    if (TRUE_TOKENS.has(token)) {
      return { kind: "value", value: true };
    }
    if (FALSE_TOKENS.has(token)) {
      return { kind: "value", value: false };
    }
    const numeric = readNumber(value);
    if (numeric !== null) {
      return numeric === 0 || numeric === 1 ? { kind: "value", value: numeric === 1 } : { kind: "numeric" };
    }
  }
  return { kind: "unknown" };
}
function normalizeCreatorHandle(handle) {
  return handle.trim().replace(/^@+/, "").trim().toLowerCase();
}
function isTiktokNumericId(value) {
  return /^[1-9][0-9]{14,19}$/.test(normalizeCreatorHandle(value));
}
function stripCreatorHandlePrefix(handle) {
  return handle.replace(/^@+/, "").trim();
}
var REQUIRED_ROSTER_KEYS = [
  RosterLabelKey.CREATOR_NICKNAME,
  RosterLabelKey.CREATOR_HANDLE,
  RosterLabelKey.TIKTOK_URL
];
var REQUIRED_ROSTER_FIELDS = {
  [RosterLabelKey.CREATOR_NICKNAME]: "creatorNicknameSnapshot",
  [RosterLabelKey.CREATOR_HANDLE]: "creatorHandleSnapshot",
  [RosterLabelKey.TIKTOK_URL]: "tiktokUrlSnapshot"
};
function missingRequiredRosterKeys(entry) {
  return REQUIRED_ROSTER_KEYS.filter((key) => entry[REQUIRED_ROSTER_FIELDS[key]] === null);
}
function emptyRosterEntry() {
  return {
    creatorNicknameSnapshot: null,
    creatorHandleSnapshot: null,
    tiktokUrlSnapshot: null,
    followersSnapshot: null,
    uploadDate: null,
    videoUrl: null,
    adCode: null,
    cleanFile: null,
    cleanFileUrl: null,
    issueNote: null,
    negotiatedAmount: null,
    negotiatedCurrency: null,
    kakaoChannelNo: null,
    kakaoChannelName: null,
    creatorEmail: null,
    crossPlatform: null,
    productVariantSnapshot: null,
    guideline: null,
    accountNote: null,
    settlement: null
  };
}
function mapRawRosterRow(raw, campaignType) {
  const entry = emptyRosterEntry();
  const warnings = [];
  const creatorLookup = {
    externalCreatorId: null,
    handleCandidate: null,
    tiktokUrlCandidate: null
  };
  const warn = (code, label, key) => {
    warnings.push({ code, label, key });
  };
  let kakaoChannelNameLabel = null;
  const emailCells = [];
  const payoutCells = [];
  for (const [label, value] of Object.entries(raw)) {
    const key = normalizeRosterLabel(label);
    if (key === null) {
      if (!isBlank(value)) {
        warn(MappingWarningCode.UNKNOWN_LABEL, label, null);
      }
      continue;
    }
    if (PII_LABEL_KEYS.has(key)) {
      warn(MappingWarningCode.PII_FIELD_DISCARDED, label, key);
      continue;
    }
    if (isBlank(value)) {
      continue;
    }
    if (EMAIL_LABEL_KEYS.has(key)) {
      emailCells.push({ key, label, value });
      continue;
    }
    if (PAYOUT_LABEL_KEYS.has(key)) {
      payoutCells.push({ key, label, value });
      continue;
    }
    if (key !== RosterLabelKey.AD_CODE && looksLikeAdCode(value)) {
      warn(MappingWarningCode.AD_CODE_IN_WRONG_FIELD, label, key);
      continue;
    }
    switch (key) {
      case RosterLabelKey.SEQ:
        break;
      case RosterLabelKey.CREATOR_NICKNAME:
        entry.creatorNicknameSnapshot = readText(value);
        break;
      case RosterLabelKey.CREATOR_HANDLE: {
        const handle = readText(value);
        if (handle === null) {
          break;
        }
        entry.creatorHandleSnapshot = stripCreatorHandlePrefix(handle);
        creatorLookup.handleCandidate = normalizeCreatorHandle(handle);
        break;
      }
      case RosterLabelKey.TIKTOK_URL: {
        const text2 = readText(value);
        const normalized = text2 === null ? null : normalizeVideoUrl(text2);
        if (normalized === null || !isTikTokUrl(normalized)) {
          warn(MappingWarningCode.MALFORMED_URL, label, key);
          break;
        }
        entry.tiktokUrlSnapshot = normalized;
        creatorLookup.tiktokUrlCandidate = normalized;
        break;
      }
      case RosterLabelKey.FOLLOWERS: {
        const followers = readInteger(value);
        if (followers === null) {
          warn(MappingWarningCode.TYPE_COERCION_FAILED, label, key);
          break;
        }
        entry.followersSnapshot = followers;
        break;
      }
      case RosterLabelKey.UPLOAD_DATE: {
        const date2 = readIsoDate(value);
        if (date2 === null) {
          warn(MappingWarningCode.TYPE_COERCION_FAILED, label, key);
          break;
        }
        entry.uploadDate = date2;
        break;
      }
      case RosterLabelKey.VIDEO_URL: {
        const text2 = readText(value);
        const normalized = text2 === null ? null : normalizeVideoUrl(text2);
        if (normalized === null || !isTikTokUrl(normalized)) {
          warn(MappingWarningCode.MALFORMED_URL, label, key);
          break;
        }
        entry.videoUrl = normalized;
        break;
      }
      case RosterLabelKey.AD_CODE: {
        if (!looksLikeAdCode(value)) {
          warn(MappingWarningCode.MALFORMED_AD_CODE, label, key);
          break;
        }
        entry.adCode = value.trim();
        break;
      }
      case RosterLabelKey.CLEAN_FILE: {
        const flag = readStateFlag(value);
        if (flag.kind === "value") {
          entry.cleanFile = flag.value;
          break;
        }
        const text2 = readText(value);
        const url = text2 === null ? null : normalizeVideoUrl(text2);
        if (url !== null) {
          entry.cleanFileUrl = url;
          break;
        }
        warn(MappingWarningCode.TYPE_COERCION_FAILED, label, key);
        break;
      }
      case RosterLabelKey.PRICE: {
        const currency = negotiatedCurrencyFor(label, campaignType);
        if (currency === null) {
          warn(MappingWarningCode.PRICE_CURRENCY_UNKNOWN, label, key);
          break;
        }
        const price = readNumber(value);
        if (price === null || !hasAtMostTwoDecimals(price)) {
          warn(MappingWarningCode.TYPE_COERCION_FAILED, label, key);
          break;
        }
        entry.negotiatedAmount = price;
        entry.negotiatedCurrency = currency;
        break;
      }
      case RosterLabelKey.KAKAO_CHANNEL_NO:
        entry.kakaoChannelNo = readText(value);
        break;
      case RosterLabelKey.KAKAO_CHANNEL_NAME:
        entry.kakaoChannelName = readText(value);
        kakaoChannelNameLabel = label;
        break;
      case RosterLabelKey.CROSS_PLATFORM:
        entry.crossPlatform = readText(value);
        break;
      case RosterLabelKey.PRODUCT_VARIANT:
        entry.productVariantSnapshot = readText(value);
        break;
      case RosterLabelKey.GUIDELINE:
        entry.guideline = readText(value);
        break;
      case RosterLabelKey.ACCOUNT_NOTE:
        entry.accountNote = readText(value);
        break;
      case RosterLabelKey.SETTLEMENT:
        entry.settlement = readText(value);
        break;
      case RosterLabelKey.ISSUE_NOTE:
        entry.issueNote = readText(value);
        break;
      default:
        break;
    }
  }
  const orderedEmailCells = [
    ...emailCells.filter((candidate) => candidate.key === RosterLabelKey.EMAIL),
    ...emailCells.filter((candidate) => candidate.key !== RosterLabelKey.EMAIL)
  ];
  for (const cell of orderedEmailCells) {
    const text2 = readText(cell.value);
    const parsed = text2 === null ? null : creatorEmailSchema.safeParse(text2);
    if (parsed === null || !parsed.success) {
      warn(MappingWarningCode.MALFORMED_EMAIL, cell.label, cell.key);
      continue;
    }
    if (entry.creatorEmail !== null) {
      warn(MappingWarningCode.PII_FIELD_DISCARDED, cell.label, cell.key);
      continue;
    }
    entry.creatorEmail = parsed.data;
  }
  const payout = { paypalEmail: null, paypalMe: null };
  for (const cell of payoutCells) {
    const text2 = readText(cell.value);
    const asEmail = text2 === null ? null : creatorEmailSchema.safeParse(text2);
    const asLink = text2 === null ? null : paypalMeSchema.safeParse(text2);
    if (asEmail?.success && payout.paypalEmail === null) {
      payout.paypalEmail = asEmail.data;
    } else if (asLink?.success && payout.paypalMe === null) {
      payout.paypalMe = asLink.data;
    } else if (asEmail?.success || asLink?.success) {
      warn(MappingWarningCode.PII_FIELD_DISCARDED, cell.label, cell.key);
    } else {
      warn(MappingWarningCode.MALFORMED_PAYPAL, cell.label, cell.key);
    }
  }
  if (entry.kakaoChannelName !== null) {
    const split = splitKakaoChannelName(entry.kakaoChannelName, {
      nickname: entry.creatorNicknameSnapshot,
      handle: entry.creatorHandleSnapshot
    });
    entry.kakaoChannelName = split.nickname;
    const label = kakaoChannelNameLabel ?? "\uCE74\uCC44\uB110 \uB2C9\uB124\uC784";
    if (split.discarded) {
      warn(MappingWarningCode.PII_FIELD_DISCARDED, label, RosterLabelKey.KAKAO_CHANNEL_NAME);
    }
    if (split.unverified) {
      warn(
        MappingWarningCode.KAKAO_CHANNEL_NAME_UNVERIFIED,
        label,
        RosterLabelKey.KAKAO_CHANNEL_NAME
      );
    }
  }
  for (const key of missingRequiredRosterKeys(entry)) {
    warn(MappingWarningCode.REQUIRED_FIELD_MISSING, requiredRosterKeyLabel(key), key);
  }
  const hasProgressTrace = entry.cleanFile === true || entry.cleanFileUrl !== null || entry.adCode !== null;
  if (entry.videoUrl === null && hasProgressTrace) {
    warn(MappingWarningCode.PROGRESS_WITHOUT_LINK, "\uC601\uC0C1 \uB9C1\uD06C", RosterLabelKey.VIDEO_URL);
  }
  return { entry, payout, creatorLookup, warnings };
}
function requiredRosterKeyLabel(key) {
  switch (key) {
    case RosterLabelKey.CREATOR_NICKNAME:
      return "\uB2C9\uB124\uC784";
    case RosterLabelKey.CREATOR_HANDLE:
      return "\uD2F1\uD1A1 \uC544\uC774\uB514";
    case RosterLabelKey.TIKTOK_URL:
      return "\uD2F1\uD1A1 \uC8FC\uC18C";
  }
}
function mapRawAdcodeRow(raw) {
  const warnings = [];
  const adcode = {
    adCode: null,
    boostingStage: null,
    views: null,
    likes: null,
    comments: null,
    shares: null,
    saves: null
  };
  const flags = { boosting: false, stopRequested: false, ended: false };
  let videoUrl = null;
  let handleCandidate = null;
  let sawCreatorColumn = false;
  const warn = (code, label, key) => {
    warnings.push({ code, label, key });
  };
  const readFlagCell = (label, key, value, apply) => {
    const reading = readStateFlag(value);
    switch (reading.kind) {
      case "value":
        apply(reading.value);
        return;
      case "numeric":
        warn(MappingWarningCode.NUMERIC_IN_STATE_COLUMN, label, key);
        return;
      case "unknown":
        if (looksLikeAdCode(value)) {
          warn(MappingWarningCode.AD_CODE_IN_WRONG_FIELD, label, key);
          return;
        }
        warn(MappingWarningCode.UNKNOWN_STAGE_VALUE, label, key);
        return;
      case "blank":
        return;
    }
  };
  const readMetricCell = (label, key, value) => {
    const metric = readInteger(value);
    if (metric === null || metric < 0) {
      warn(MappingWarningCode.TYPE_COERCION_FAILED, label, key);
      return null;
    }
    return metric;
  };
  for (const [label, value] of Object.entries(raw)) {
    const key = normalizeAdcodeLabel(label);
    if (key === null) {
      if (!isBlank(value)) {
        warn(MappingWarningCode.UNKNOWN_LABEL, label, null);
      }
      continue;
    }
    if (key === RosterLabelKey.CREATOR_HANDLE || key === RosterLabelKey.CREATOR_NICKNAME) {
      sawCreatorColumn = true;
    }
    if (PII_LABEL_KEYS.has(key) || PAYOUT_LABEL_KEYS.has(key)) {
      warn(MappingWarningCode.PII_FIELD_DISCARDED, label, key);
      continue;
    }
    if (isBlank(value)) {
      continue;
    }
    const isStateColumn = key === AdcodeLabelKey.STAGE_BOOSTING || key === AdcodeLabelKey.STAGE_STOP_REQUESTED || key === AdcodeLabelKey.STAGE_ENDED;
    if (key !== RosterLabelKey.AD_CODE && !isStateColumn && looksLikeAdCode(value)) {
      warn(MappingWarningCode.AD_CODE_IN_WRONG_FIELD, label, key);
      continue;
    }
    switch (key) {
      case RosterLabelKey.AD_CODE: {
        if (!looksLikeAdCode(value)) {
          warn(MappingWarningCode.MALFORMED_AD_CODE, label, key);
          break;
        }
        adcode.adCode = value.trim();
        break;
      }
      case RosterLabelKey.VIDEO_URL: {
        const text2 = readText(value);
        const normalized = text2 === null ? null : normalizeVideoUrl(text2);
        if (normalized === null || !isTikTokUrl(normalized)) {
          warn(MappingWarningCode.MALFORMED_URL, label, key);
          break;
        }
        videoUrl = normalized;
        break;
      }
      case RosterLabelKey.CREATOR_HANDLE: {
        const handle = readText(value);
        if (handle !== null) {
          handleCandidate = normalizeCreatorHandle(handle);
        }
        break;
      }
      case AdcodeLabelKey.STAGE_BOOSTING:
        readFlagCell(label, key, value, (flag) => {
          flags.boosting = flag;
        });
        break;
      case AdcodeLabelKey.STAGE_STOP_REQUESTED:
        readFlagCell(label, key, value, (flag) => {
          flags.stopRequested = flag;
        });
        break;
      case AdcodeLabelKey.STAGE_ENDED:
        readFlagCell(label, key, value, (flag) => {
          flags.ended = flag;
        });
        break;
      case AdcodeLabelKey.VIEWS:
        adcode.views = readMetricCell(label, key, value);
        break;
      case AdcodeLabelKey.LIKES:
        adcode.likes = readMetricCell(label, key, value);
        break;
      case AdcodeLabelKey.COMMENTS:
        adcode.comments = readMetricCell(label, key, value);
        break;
      case AdcodeLabelKey.SHARES:
        adcode.shares = readMetricCell(label, key, value);
        break;
      case AdcodeLabelKey.SAVES:
        adcode.saves = readMetricCell(label, key, value);
        break;
      default:
        break;
    }
  }
  const derived = deriveBoostingStage(flags, adcode.adCode !== null);
  adcode.boostingStage = derived.stage;
  for (const flagWarning of derived.warnings) {
    warnings.push({
      code: flagWarning === BoostingFlagWarning.CONTRADICTORY_FLAGS ? MappingWarningCode.CONTRADICTORY_FLAGS : MappingWarningCode.STAGE_WITHOUT_AD_CODE,
      label: "\uBD80\uC2A4\uD305 \uC0C1\uD0DC",
      key: null
    });
  }
  if (videoUrl === null) {
    warn(MappingWarningCode.BINDING_KEY_MISSING, "\uC601\uC0C1 \uB9C1\uD06C", null);
  }
  if (!sawCreatorColumn) {
    warn(MappingWarningCode.CREATOR_CROSS_CHECK_UNAVAILABLE, "\uD2F1\uD1A1 \uC544\uC774\uB514", null);
  }
  return {
    adcode,
    rosterLookup: {
      videoUrl,
      creatorHandleCandidate: handleCandidate,
      canCrossCheckCreator: sawCreatorColumn
    },
    warnings
  };
}
function rosterImportMatchKey(mapping) {
  const handle = mapping.entry.creatorHandleSnapshot;
  if (handle === null) {
    return null;
  }
  return `${handle}::${mapping.entry.videoUrl ?? ""}`;
}
function findRosterImportDuplicateKeys(rows) {
  const seen = /* @__PURE__ */ new Set();
  const duplicated = /* @__PURE__ */ new Set();
  for (const row of rows) {
    const key = rosterImportMatchKey(row);
    if (key === null) {
      continue;
    }
    if (seen.has(key)) {
      duplicated.add(key);
    }
    seen.add(key);
  }
  return [...duplicated];
}

// src/domain/campaign/roster-content-review.ts
var RosterContentReview = {
  /** 콘텐츠를 보고 이번 캠페인 조건에 맞는지 판단했다. 협의 착수·참여 확정과는 별개다. */
  REVIEWED: "REVIEWED",
  /** 보고 이번 캠페인에서는 진행하지 않기로 했다. 관계 전체 차단으로 승격하지 않는다. */
  SKIPPED: "SKIPPED"
};
var ROSTER_CONTENT_REVIEWS = [
  RosterContentReview.REVIEWED,
  RosterContentReview.SKIPPED
];
var RosterContentReviewDisplay = {
  REVIEWED: "REVIEWED",
  SKIPPED: "SKIPPED",
  /** 값이 없고 섭외 구간이다. */
  UNREVIEWED: "UNREVIEWED",
  /** 값이 없고 제작 구간이다 — 가이드라인 전달부터는 검토를 지나온 행이다. */
  PASSED: "PASSED"
};
var ROSTER_CONTENT_REVIEW_DISPLAY_LABEL = {
  [RosterContentReviewDisplay.REVIEWED]: "\uAC80\uD1A0\uD568",
  [RosterContentReviewDisplay.SKIPPED]: "\uC774\uBC88 \uCEA0\uD398\uC778 \uBBF8\uC9C4\uD589",
  [RosterContentReviewDisplay.UNREVIEWED]: "\uBBF8\uAC80\uD1A0",
  [RosterContentReviewDisplay.PASSED]: "\uAC80\uD1A0 \uC9C0\uB0A8"
};
function isRosterContentReview(value) {
  return typeof value === "string" && ROSTER_CONTENT_REVIEWS.includes(value);
}
function deriveRosterContentReviewDisplay(contentReview, rosterStatus) {
  if (isRosterContentReview(contentReview)) return contentReview;
  const phase = deriveRosterPhase(rosterStatus);
  if (phase === RosterPhase.OUTREACH) return RosterContentReviewDisplay.UNREVIEWED;
  if (phase === RosterPhase.PRODUCTION) return RosterContentReviewDisplay.PASSED;
  return null;
}

// src/domain/campaign/settlement-currency.ts
var SETTLEMENT_CURRENCY_PATTERN = /^[A-Z]{3}$/;
function isIso4217AlphaCode(value) {
  return typeof value === "string" && SETTLEMENT_CURRENCY_PATTERN.test(value);
}
function createSettlementCurrencyValidator(allowed) {
  if (allowed.length === 0) {
    throw new Error("createSettlementCurrencyValidator: allowed currency list is empty");
  }
  if (allowed.some((code) => code.trim() === "")) {
    throw new Error(
      "createSettlementCurrencyValidator: allowed currency list contains a blank value"
    );
  }
  if (new Set(allowed).size !== allowed.length) {
    throw new Error("createSettlementCurrencyValidator: allowed currency list contains duplicates");
  }
  const malformed = allowed.filter((code) => !isIso4217AlphaCode(code));
  if (malformed.length > 0) {
    throw new Error(
      `createSettlementCurrencyValidator: not an ISO 4217 alpha-3 code: ${malformed.join(", ")}`
    );
  }
  const lookup = new Set(allowed);
  const snapshot = [...allowed];
  return {
    allowed: snapshot,
    isAllowed(value) {
      return typeof value === "string" && lookup.has(value);
    }
  };
}

// src/domain/campaign/settlement-kind.ts
var SettlementKind = {
  /** 고료 — 자사가 선입금하고 크리에이터에게 송금한다. */
  FEE: "FEE",
  /** 직접 구매비 환급 — 크리에이터가 산 제품 값을 돌려주고 광고주에게 청구한다. */
  PRODUCT_PURCHASE_REIMBURSEMENT: "PRODUCT_PURCHASE_REIMBURSEMENT",
  /** 제품 발송 — 송금이 발생하지 않는 현물 건이라 실행자 소관이 아니다 (agreement §3-6 · §5). */
  PRODUCT_SHIPMENT: "PRODUCT_SHIPMENT"
};
var SETTLEMENT_KINDS = Object.values(SettlementKind);
var SETTLEMENT_REQUESTABLE_KINDS = [
  SettlementKind.FEE,
  SettlementKind.PRODUCT_PURCHASE_REIMBURSEMENT
];
var SettlementCostBearer = {
  SELF: "SELF",
  ADVERTISER: "ADVERTISER"
};
var SettlementPayoutForm = {
  CASH: "CASH",
  IN_KIND: "IN_KIND"
};
var SettlementPayoutMethod = {
  PAYPAL: "PAYPAL",
  INTERNATIONAL_WIRE: "INTERNATIONAL_WIRE",
  DOMESTIC_TRANSFER: "DOMESTIC_TRANSFER"
};
var SETTLEMENT_DOMESTIC_CURRENCY = "KRW";
function isSettlementTermAllowedFor(campaignType, term) {
  const domestic = term.currency === SETTLEMENT_DOMESTIC_CURRENCY && term.payoutMethod === SettlementPayoutMethod.DOMESTIC_TRANSFER;
  if (campaignType === "DOMESTIC") return domestic;
  return term.currency !== SETTLEMENT_DOMESTIC_CURRENCY && term.payoutMethod !== SettlementPayoutMethod.DOMESTIC_TRANSFER;
}
var SETTLEMENT_KIND_ACCOUNTING_DEFAULTS = {
  // 고료는 자사가 먼저 지급하고 송금한다.
  [SettlementKind.FEE]: {
    costBearer: SettlementCostBearer.SELF,
    payoutForm: SettlementPayoutForm.CASH
  },
  // 직접 구매비는 대납분이라 광고주 청구 — 이 줄이 뒤집히면 광고주 대납분이 자사 원가로 계상된다.
  [SettlementKind.PRODUCT_PURCHASE_REIMBURSEMENT]: {
    costBearer: SettlementCostBearer.ADVERTISER,
    payoutForm: SettlementPayoutForm.CASH
  },
  // 제품 발송은 송금이 발생하지 않는 유일한 줄이다 (agreement §3-6).
  [SettlementKind.PRODUCT_SHIPMENT]: {
    costBearer: SettlementCostBearer.ADVERTISER,
    payoutForm: SettlementPayoutForm.IN_KIND
  }
};
var DECLARED_KINDS = new Set(SETTLEMENT_KINDS);
var REQUESTABLE_KINDS = new Set(SETTLEMENT_REQUESTABLE_KINDS);
var DECLARED_COST_BEARERS = new Set(Object.values(SettlementCostBearer));
var DECLARED_PAYOUT_FORMS = new Set(Object.values(SettlementPayoutForm));
var DECLARED_PAYOUT_METHODS = new Set(Object.values(SettlementPayoutMethod));
function isSettlementKind(value) {
  return typeof value === "string" && DECLARED_KINDS.has(value);
}
function isRequestableSettlementKind(value) {
  return typeof value === "string" && REQUESTABLE_KINDS.has(value);
}
function isSettlementCostBearer(value) {
  return typeof value === "string" && DECLARED_COST_BEARERS.has(value);
}
function isSettlementPayoutForm(value) {
  return typeof value === "string" && DECLARED_PAYOUT_FORMS.has(value);
}
function isSettlementPayoutMethod(value) {
  return typeof value === "string" && DECLARED_PAYOUT_METHODS.has(value);
}

// src/domain/campaign/settlement-policy.ts
var SETTLEMENT_APPROVAL_THRESHOLD_USD = 200;
var SETTLEMENT_APPROVAL_THRESHOLD_CURRENCY = "USD";
var SETTLEMENT_AMOUNT_PATTERN = /^(0|[1-9]\d{0,11})(?:\.(\d{1,2}))?$/;
var SettlementApprovalVerdict = {
  REQUIRED: "REQUIRED",
  NOT_REQUIRED: "NOT_REQUIRED",
  UNDETERMINED: "UNDETERMINED"
};
var SettlementApprovalUndeterminedReason = {
  /** 임계 통화(USD)가 아니라 환산 근거가 없다. */
  FOREIGN_CURRENCY: "FOREIGN_CURRENCY",
  /** 금액을 읽을 수 없다 — 오염을 "임계 미만"으로 승격시키지 않는다. */
  UNPARSEABLE_AMOUNT: "UNPARSEABLE_AMOUNT"
};
function isSettlementAmount(value) {
  return toMinorUnits(value) !== null;
}
function toMinorUnits(value) {
  const text2 = typeof value === "string" ? value : typeof value === "number" ? String(value) : null;
  if (text2 === null) {
    return null;
  }
  const matched = SETTLEMENT_AMOUNT_PATTERN.exec(text2);
  if (matched === null) {
    return null;
  }
  const whole = matched[1] ?? "0";
  const fraction = (matched[2] ?? "").padEnd(2, "0");
  return Number(whole) * 100 + Number(fraction);
}
function undetermined(reason, thresholdUsd) {
  return {
    verdict: SettlementApprovalVerdict.UNDETERMINED,
    undeterminedReason: reason,
    thresholdUsd
  };
}
function judgeSettlementApproval(input, thresholdUsd = SETTLEMENT_APPROVAL_THRESHOLD_USD) {
  if (!Number.isFinite(thresholdUsd) || thresholdUsd <= 0) {
    throw new RangeError(
      `judgeSettlementApproval: threshold must be a finite positive number, got ${String(thresholdUsd)}`
    );
  }
  const amountMinorUnits = toMinorUnits(input.amount);
  if (amountMinorUnits === null) {
    return undetermined(SettlementApprovalUndeterminedReason.UNPARSEABLE_AMOUNT, thresholdUsd);
  }
  if (input.currency !== SETTLEMENT_APPROVAL_THRESHOLD_CURRENCY) {
    return undetermined(SettlementApprovalUndeterminedReason.FOREIGN_CURRENCY, thresholdUsd);
  }
  const thresholdMinorUnits = Math.round(thresholdUsd * 100);
  return {
    // 경계 포함(`>=`) — 위 모듈 주석의 fail-closed 판정 지점이다. 뒤집으려면 이 1글자.
    verdict: amountMinorUnits >= thresholdMinorUnits ? SettlementApprovalVerdict.REQUIRED : SettlementApprovalVerdict.NOT_REQUIRED,
    undeterminedReason: null,
    thresholdUsd
  };
}
function requiresExecutiveApproval(input, thresholdUsd = SETTLEMENT_APPROVAL_THRESHOLD_USD) {
  if (input.currency === SETTLEMENT_DOMESTIC_CURRENCY) return false;
  const judgement = judgeSettlementApproval(input, thresholdUsd);
  return judgement.verdict !== SettlementApprovalVerdict.NOT_REQUIRED && judgement.undeterminedReason !== SettlementApprovalUndeterminedReason.FOREIGN_CURRENCY;
}

// src/domain/campaign/roster-price-proposer.ts
var RosterPriceProposer = {
  /** 우리가 제시한 값. */
  OUR_SIDE: "OUR_SIDE",
  /** 크리에이터가 부른 값. */
  CREATOR: "CREATOR"
};
var ROSTER_PRICE_PROPOSERS = [
  RosterPriceProposer.OUR_SIDE,
  RosterPriceProposer.CREATOR
];

// src/domain/campaign/roster-schedule.ts
import { z as z4 } from "zod";
var RosterScheduleKind = {
  /** 크리에이터가 초안을 내기로 한 날. */
  DRAFT_DUE: "DRAFT_DUE",
  /** 크리에이터가 영상을 올리기로 한 날. 조건 리비전의 `uploadDeadline` 이 이 값을 따라간다. */
  PLANNED_UPLOAD: "PLANNED_UPLOAD"
};
var ROSTER_SCHEDULE_KINDS = [
  RosterScheduleKind.DRAFT_DUE,
  RosterScheduleKind.PLANNED_UPLOAD
];
function isRosterScheduleKind(value) {
  return typeof value === "string" && ROSTER_SCHEDULE_KINDS.includes(value);
}
var scheduleDate = z4.iso.date();
var rosterScheduleConfirmInputSchema = z4.object({
  /** 둘 중 적어도 하나. 한 메시지로 둘을 확정하면 둘 다 온다. */
  draftDueDate: scheduleDate.nullable().optional(),
  plannedUploadDate: scheduleDate.nullable().optional(),
  /** 사유는 입력에서 필수다(경계 합의안 §3-2) — 날짜만 오면 상대의 약속인지 담당자 추정인지 갈리지 않는다. */
  note: z4.string().trim().min(1).max(500),
  /** 누가 부른 값인가 — 값 정본은 `RosterPriceProposer` 다. 기록한 사람(`actorId`)과 다른 축이다. */
  proposedBy: z4.enum(ROSTER_PRICE_PROPOSERS),
  /** 기록한 사람. 서버가 채운다 — 그래서 wire DTO 는 이 칸을 뺀다. */
  actorId: z4.string().nullable(),
  /** 근거 두 칸은 없을 수 있다 — 회신 없이 통화로 받은 약속도 사유만 있으면 선다. */
  conversationId: z4.string().nullable().default(null),
  messageId: z4.string().nullable().default(null)
}).strict();
function buildScheduleRevisions(input) {
  const parsed = rosterScheduleConfirmInputSchema.parse(input);
  const evidence = {
    note: parsed.note,
    proposedBy: parsed.proposedBy,
    actorId: parsed.actorId,
    conversationId: parsed.conversationId,
    messageId: parsed.messageId
  };
  const drafts = [];
  if (parsed.draftDueDate != null)
    drafts.push({ kind: RosterScheduleKind.DRAFT_DUE, date: parsed.draftDueDate, ...evidence });
  if (parsed.plannedUploadDate != null)
    drafts.push({
      kind: RosterScheduleKind.PLANNED_UPLOAD,
      date: parsed.plannedUploadDate,
      ...evidence
    });
  if (drafts.length === 0)
    throw new Error(
      "\uD655\uC815\uD560 \uC77C\uC815\uC774 \uC5C6\uC2B5\uB2C8\uB2E4 \u2014 \uCD08\uC548 \uC81C\uCD9C\uC77C\uACFC \uC608\uC815 \uC5C5\uB85C\uB4DC\uC77C \uC911 \uD558\uB098\uB294 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4."
    );
  return drafts;
}
function isAfter(candidate, current) {
  if (candidate.occurredAt !== current.occurredAt) return candidate.occurredAt > current.occurredAt;
  return candidate.id > current.id;
}
function latestScheduleByKind(revisions) {
  const latest = {
    [RosterScheduleKind.DRAFT_DUE]: null,
    [RosterScheduleKind.PLANNED_UPLOAD]: null
  };
  for (const revision of revisions) {
    const current = latest[revision.kind];
    if (current === null || isAfter(revision, current)) latest[revision.kind] = revision;
  }
  return latest;
}
function rosterScheduleView(row, revisions) {
  const latest = latestScheduleByKind(revisions);
  return {
    draftDue: latest[RosterScheduleKind.DRAFT_DUE]?.date ?? null,
    plannedUpload: latest[RosterScheduleKind.PLANNED_UPLOAD]?.date ?? null,
    actualUpload: row.uploadDate,
    confirmedAt: row.uploadCompletedAt
  };
}
function toParticipantConditions(existing, revisions) {
  return {
    ...existing,
    uploadDeadline: latestScheduleByKind(revisions)[RosterScheduleKind.PLANNED_UPLOAD]?.date ?? null
  };
}
function snapshotConditionsForWrite(input, revisions) {
  return toParticipantConditions(input, revisions);
}
function scheduleConfirmationState(revisions, kind, lastConditionChangeAt) {
  const own = revisions.filter((revision) => revision.kind === kind);
  const latest = latestScheduleByKind(own)[kind];
  if (latest === null) return "UNRECORDED";
  if (lastConditionChangeAt === null) return "FIRST_AGREEMENT";
  if (latest.occurredAt < lastConditionChangeAt) return "RECONFIRM_NEEDED";
  return own.some((revision) => revision.occurredAt < lastConditionChangeAt) ? "RECONFIRMED" : "FIRST_AGREEMENT";
}

// src/domain/campaign/roster-takedown-requester.ts
var RosterTakedownRequester = {
  /** 우리가 보고 내리라고 한 것. */
  OUR_SIDE: "OUR_SIDE",
  /** 광고주가 물어서 내린 것. */
  ADVERTISER: "ADVERTISER"
};
var ROSTER_TAKEDOWN_REQUESTERS = [
  RosterTakedownRequester.OUR_SIDE,
  RosterTakedownRequester.ADVERTISER
];
function isRosterTakedownRequester(value) {
  return typeof value === "string" && ROSTER_TAKEDOWN_REQUESTERS.includes(value);
}

// src/domain/campaign/video-rights.ts
var VideoRightAxis = {
  ADCODE_USE: "ADCODE_USE",
  EDIT_REUSE: "EDIT_REUSE"
};
var VideoRightValue = {
  UNCONFIRMED: "UNCONFIRMED",
  ALLOWED: "ALLOWED",
  NOT_ALLOWED: "NOT_ALLOWED"
};
var VIDEO_RIGHT_AXES = [VideoRightAxis.ADCODE_USE, VideoRightAxis.EDIT_REUSE];
var VIDEO_RIGHT_VALUES = [
  VideoRightValue.UNCONFIRMED,
  VideoRightValue.ALLOWED,
  VideoRightValue.NOT_ALLOWED
];
var VIDEO_RIGHT_AXIS_LABEL = {
  ADCODE_USE: "\uC560\uB4DC\uCF54\uB4DC \uD65C\uC6A9",
  EDIT_REUSE: "\uD3B8\uC9D1\xB7\uC7AC\uAC00\uACF5"
};
var VIDEO_RIGHT_VALUE_LABEL = {
  UNCONFIRMED: "\uBBF8\uD655\uC778",
  ALLOWED: "\uD5C8\uC6A9",
  NOT_ALLOWED: "\uBD88\uD5C8"
};
function isVideoRightAxis(value) {
  return typeof value === "string" && VIDEO_RIGHT_AXES.includes(value);
}
function isVideoRightValue(value) {
  return typeof value === "string" && VIDEO_RIGHT_VALUES.includes(value);
}
function currentVideoRights(revisions) {
  const rights = {
    ADCODE_USE: VideoRightValue.UNCONFIRMED,
    EDIT_REUSE: VideoRightValue.UNCONFIRMED
  };
  const latestAt = /* @__PURE__ */ new Map();
  for (const revision of revisions) {
    const at = revision.createdAt.getTime();
    const seen = latestAt.get(revision.axis);
    if (seen === void 0 || at >= seen) {
      latestAt.set(revision.axis, at);
      rights[revision.axis] = revision.value;
    }
  }
  return rights;
}
function adcodeIssueWarning(rights) {
  return rights.ADCODE_USE === VideoRightValue.NOT_ALLOWED ? "ADCODE_USE_NOT_ALLOWED" : null;
}

// src/domain/campaign/settlement-status.ts
var SettlementStatus = {
  REQUESTED: "REQUESTED",
  APPROVAL_PENDING: "APPROVAL_PENDING",
  ON_HOLD: "ON_HOLD",
  PAID: "PAID",
  FAILED: "FAILED",
  RETURNED: "RETURNED"
};
var SETTLEMENT_STATUS_TRANSITIONS = {
  // 요청 접수 직후 갈라지는 네 갈래 — §4-2 "전이 근거" 열이 그대로 준다.
  [SettlementStatus.REQUESTED]: [
    SettlementStatus.APPROVAL_PENDING,
    SettlementStatus.PAID,
    SettlementStatus.ON_HOLD,
    SettlementStatus.FAILED
  ],
  // 대표 승인 통과분은 곧장 송금 시도로 간다 — 중간 APPROVED 상태가 없어 결과 3종으로 갈라진다 (§4-2).
  [SettlementStatus.APPROVAL_PENDING]: [
    SettlementStatus.PAID,
    SettlementStatus.ON_HOLD,
    SettlementStatus.FAILED
  ],
  // 보류는 종단이 아니다 — "담당자 확인 후 재진행" (agreement §3-2). 재진행이 실패하면 FAILED.
  // APPROVAL_PENDING 복귀는 재심에서 열었다 — 미승인 USD 200 초과 건이 승인 없이 PAID 로
  // 직행하면 §8-4 확인이 이력에서 통째로 사라진다 (§4-3 보존 논증).
  [SettlementStatus.ON_HOLD]: [
    SettlementStatus.APPROVAL_PENDING,
    SettlementStatus.PAID,
    SettlementStatus.FAILED
  ],
  // 미등록 이메일을 페이팔이 보관하다 자동 취소 — 이미 나간 뒤 되돌아오는 유일한 출구다 (§4-2).
  [SettlementStatus.PAID]: [SettlementStatus.RETURNED],
  // 반송분은 담당자 확인 대기로 돌아간다 — §3-2 '재진행' 서술에서 유도된다.
  [SettlementStatus.RETURNED]: [SettlementStatus.ON_HOLD],
  // 송금 불가도 종단이 아니다 — 수취 계정이 생기면 되살아난다. 다만 되살리는 문은 ON_HOLD
  // 하나뿐이라 재개 사유가 reason 필수로 반드시 남는다 (재심 · §7 인수조건 #6).
  [SettlementStatus.FAILED]: [SettlementStatus.ON_HOLD]
};
var SETTLEMENT_REASON_REQUIRED_STATUSES = [
  SettlementStatus.ON_HOLD,
  SettlementStatus.FAILED,
  SettlementStatus.RETURNED
];
var SETTLEMENT_APPROVAL_CLEARANCE_TRANSITION = [SettlementStatus.APPROVAL_PENDING, SettlementStatus.PAID];
function requiresSettlementClearanceReason(from, to) {
  const [clearanceFrom, clearanceTo] = SETTLEMENT_APPROVAL_CLEARANCE_TRANSITION;
  return from === clearanceFrom && to === clearanceTo;
}
var DECLARED_STATUSES = new Set(Object.values(SettlementStatus));
function isSettlementStatus(value) {
  return typeof value === "string" && DECLARED_STATUSES.has(value);
}
function canTransitionSettlement(from, to) {
  const targets = SETTLEMENT_STATUS_TRANSITIONS[from];
  return targets !== void 0 && targets.includes(to);
}
function assertSettlementTransition(from, to) {
  if (!canTransitionSettlement(from, to)) {
    throw new Error(`Invalid settlement transition: ${from} -> ${to}`);
  }
}

// src/domain/notification/navigation-context.ts
import { z as z5 } from "zod";
var FinanceLedgerNavigationSchema = z5.object({
  financeTab: z5.literal("ledger"),
  ledgerPeriod: z5.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  ledgerPool: z5.enum(["all", "TEAM", "WORLD", "FLEX"]),
  ledgerTeam: z5.string().min(1).max(100),
  ledgerReview: z5.enum(["true", "false"])
});
var NavigationContextSchema = z5.object({
  ...FinanceLedgerNavigationSchema.partial().shape,
  questId: z5.string().optional(),
  /** 퀘스트 안에서 누른 체크포인트 — 오늘 창 체크인 폼이 이것을 미리 고른다(2026-09-25). */
  checkpointId: z5.string().optional(),
  leaveRequestId: z5.string().optional(),
  advertiserId: z5.string().optional(),
  scenarioId: z5.string().optional(),
  scenarioView: z5.literal("roster").optional(),
  /** 캠페인 성과급 창의 착지 탭. 어느 캠페인인지는 옆의 `scenarioId` 가 든다. */
  campaignBonusTab: z5.enum(["mine", "accruals", "team"]).optional(),
  /**
   * 제품 축(개발 퀘스트 창)의 착지 탭. `scenarioId` 와 같은 자리다 — 스파인 축이 다를 뿐이다.
   *
   * 없으면 소비처가 대상 퀘스트에서 역도출하지만, 그러려면 대상이 그 창의 목록에 있어야 한다.
   * 검색·필터에 가려 목록에 없을 때는 역도출이 불가능하므로, 퀘스트를 손에 쥔 진입점(오늘 창
   * '증빙 제출하러 가기')이 눌린 시점의 제품을 여기 실어 보낸다.
   */
  productId: z5.string().optional(),
  bugReportId: z5.string().optional(),
  channelId: z5.string().optional(),
  reservationId: z5.string().optional(),
  offDayRequestId: z5.string().optional(),
  targetWindowId: z5.string().optional(),
  /**
   * Gmail 동의에서 돌아온 결과 (2026-09-22).
   *
   * 좌표와 나란한 별도 파라미터가 아니라 **좌표 안**에 싣는다 — 홈 라우트가 딥링크를 처리한 뒤
   * 쿼리를 통째로 지워서(`routes/index.tsx`), 밖에 두면 창이 열리기 전에 사라진다.
   */
  mailConnection: z5.enum(["connected", "error"]).optional(),
  /** 실패 사유(`CREATOR_MAIL_CONNECT_FAILURES`). 성공에는 없다. */
  mailConnectionReason: z5.string().max(40).optional(),
  /**
   * 덮개를 메일 면으로 열고 스레드를 세울 관계 행 (퀘스트 7ae8c4bd). 대화 좌표가 캠페인 × 관계 행이라
   * `scenarioId` 옆에 싣는다 — 로스터 행 id 로 두면 폼 전 후보(행이 없다)로는 옮겨 갈 수 없다.
   */
  mailRelationId: z5.uuid().optional(),
  /**
   * 덮개를 열자마자 확정 창을 띄울 가이드라인 시안(GUIDELINE_DRAFT_UPLOADED 이벤트 id, 퀘스트 f7b726fd).
   * 「[가이드라인 전달]」 CP 승인에서 올라온 시안을 확정하고 필수 장면을 등록하러 가는 길이다 —
   * CP 행 안내와 서류 칩 「가이드라인 · 확정 대기」가 싣는다. 그 사이 판정됐으면 창을 띄우지 않는다.
   */
  guidelineConfirmDraftId: z5.uuid().optional(),
  /**
   * 크리에이터 관계 창이 조서를 열 관계 행. 로스터 「관계 카드 열기」가 싣는다 — 이 창의 주 진입이
   * 한 사람을 보러 오는 길이라(2026-09-23 결정) 창만 열면 목록에서 다시 찾아야 한다.
   */
  relationId: z5.uuid().optional()
});
var DEEP_LINK_VIEW_PARAM = "view";
function parseDeepLinkFromQuery(query) {
  const view = query[DEEP_LINK_VIEW_PARAM];
  if (!view) return null;
  const { [DEEP_LINK_VIEW_PARAM]: _, ...rest } = query;
  const result = NavigationContextSchema.safeParse(rest);
  if (!result.success) return null;
  return { view, context: result.data };
}
function buildDeepLinkQuery(view, context = {}) {
  const query = { [DEEP_LINK_VIEW_PARAM]: view };
  for (const [key, value] of Object.entries(context)) {
    if (value != null) query[key] = value;
  }
  return query;
}

// src/domain/creator-relation/time.ts
function toEpochMs(at) {
  return at instanceof Date ? at.getTime() : new Date(at).getTime();
}

// src/domain/creator-relation/relation-state.ts
var RELATION_STATES = [
  "UNCONTACTED",
  "ATTEMPTED",
  "COLLABORATED",
  "RECOLLABORATED",
  "REGULAR"
];
var RELATION_HISTORY_TYPES = [
  "CONTACT_SENT",
  "ROSTER_JOINED",
  "CONTENT_POSTED",
  // 캠페인 결과 셋 (퀘스트 5ac14fe5, IA §7) — 로스터의 사실 자리에서 파생하거나(미진행 표식 ·
  // 광고주 기각 종료) 사람이 적는(재섭외) 결과다. 어떤 판정의 입력도 아니다: 상태 파생도
  // 후보 조회도 이 셋을 보지 않는다 (recruitment-policy.ts). 사실 쪽이라 판단 앞에 놓인다.
  "CAMPAIGN_SKIPPED",
  "NOT_SELECTED",
  // 크리에이터 하차 (2026-09-23) — 로스터 하차 종료에서 파생하는 사실이다. 하차한 사람을 관계
  // 화면에서 모아 보려고 남긴다. 상태 파생의 입력은 아니다.
  "CREATOR_DROPPED",
  "RE_RECRUITED",
  "REPLY_RECEIVED",
  // 폼 재제출 (AEG-18) — 첫 제출은 로스터 행이 들고, 그다음부터는 행을 안 건드리고 이 사건만 남는다
  // (roster-form-intake §5). 재포함한 사람의 자동 제외가 새 폼을 알아보는 신호이고 상태 파생의
  // 입력은 아니다. 값은 payload 에도 없다 — 언제 다시 냈는지만 든다.
  "FORM_RESUBMITTED",
  // 단가 합의·재협의 — 사실 쪽이다. 로스터 재협의 쓰기가 같은 트랜잭션에서 파생하므로
  // 사람이 누르는 판단 사건보다 먼저 놓인다 (규칙 17). 금액은 payload 에 없고 값은
  // CreatorPlatformPriceRevision 이 든다 (creator-price-relation-ownership.md §3-7).
  "PRICE_AGREED",
  // 조건 변경 합의 (퀘스트 d4f35ad8 CP3) — 단가 합의의 형제라 바로 뒤에 선다. 사건 하나가
  // 조건 다섯 축을 다 덮고, 업로드일이 함께 정해지면 값은 CampaignRosterScheduleRevision 이
  // 든다 (퀘스트 8039bf58 결정 1). 사건 payload 에 날짜를 넣지 않는다 — 규칙 22 와 같은 이유로
  // 값의 정본이 둘이 되면 갈린다.
  "CONDITION_AGREED",
  "RESOLVED",
  // 병합 (퀘스트 2d6493d0) — 확정이 같은 사람의 핸들 관계를 번호 관계로 합쳤다. 확정과 같은
  // 시각에 서므로 RESOLVED 바로 뒤다. 옮긴 건수와 충돌(종류·참조)만 payload 에 들고 값은 없다.
  // 어떤 파생의 입력도 아니다.
  "RELATION_MERGED",
  "TOMBSTONED",
  "CREDIT_GRANTED",
  "STATE_CHANGED",
  "NOTE_ADDED",
  "OWNER_CHANGED",
  // 차단은 사람 판단이라 같은 시각의 사실·상태 변경 위에 놓인다 (relation-block.ts).
  "BLOCKED",
  "UNBLOCKED",
  // 연락 거부 — 보류(BLOCKED, 기한)와 다른 범위의 사람 판단이라 따로 서고 목록 끝이다
  // (recruitment-policy.ts, 퀘스트 5ac14fe5 CP1 §2-3).
  "OUTREACH_BLOCKED",
  "OUTREACH_UNBLOCKED",
  // 무효화 (2026-09-24) — 틀리게 쌓인 사건을 지우지 않고 되돌린다. 원 사건 id 는 `revokedHistoryId`
  // (payload)와 `externalRef`(멱등 열쇠)에 함께 든다. 파생은 `effectiveRelationHistory` 로 원 사건과
  // 이 사건을 둘 다 빼고 본다. 타임라인은 둘 다 보인다. 무효화의 무효화는 두지 않는다.
  "HISTORY_REVOKED"
];
var RELATION_HISTORY_ORIGINS = ["PERSON", "SYSTEM", "IMPORT"];
var OWNER_CHANGE_CAUSES = [
  "ASSIGNED",
  "REASSIGNED",
  "RELEASED",
  "TIER_REVERTED",
  "TOMBSTONED",
  "OFFBOARDED",
  "TEAM_MOVED",
  "ELIGIBILITY_LOST"
];
var CREATOR_RELATION_SOURCE_SYSTEM = "AEGISLAB_HASHTAG_CRAWLER";
var CREATOR_RELATION_INVALID_TRANSITION = "CREATOR_RELATION_INVALID_TRANSITION";
var OPENING_TYPES = /* @__PURE__ */ new Set(["CONTACT_SENT", "ROSTER_JOINED"]);
function isRelationState(value) {
  return RELATION_STATES.includes(value);
}
function relationStateRank(state) {
  return RELATION_STATES.indexOf(state);
}
function typeRank(type) {
  return RELATION_HISTORY_TYPES.indexOf(type);
}
function sortRelationHistory(entries) {
  return [...entries].sort(
    (a, b) => toEpochMs(a.occurredAt) - toEpochMs(b.occurredAt) || typeRank(a.type) - typeRank(b.type) || // createdAt 은 둘 다 있을 때만 가른다 — 한쪽만 없으면 동순위(epoch 0 으로 앞세우지 않는다).
    (a.createdAt != null && b.createdAt != null ? toEpochMs(a.createdAt) - toEpochMs(b.createdAt) : 0) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0)
  );
}
function effectiveRelationHistory(entries) {
  const revoked = new Set(
    entries.flatMap(
      (e) => e.type === "HISTORY_REVOKED" && e.revokedHistoryId ? [e.revokedHistoryId] : []
    )
  );
  return entries.filter((e) => e.type !== "HISTORY_REVOKED" && !revoked.has(e.id));
}
function deriveRelationState(entries) {
  let state = "UNCONTACTED";
  for (const entry of sortRelationHistory(effectiveRelationHistory(entries))) {
    if (OPENING_TYPES.has(entry.type)) {
      if (state === "UNCONTACTED") state = "ATTEMPTED";
    } else if (entry.type === "STATE_CHANGED" && entry.to && isRelationState(entry.to)) {
      state = entry.to;
    }
  }
  const floor = floorRelationState(entries);
  return relationStateRank(floor) > relationStateRank(state) ? floor : state;
}
function floorRelationState(all) {
  const entries = effectiveRelationHistory(all);
  const posted = new Set(
    entries.filter((e) => e.type === "CONTENT_POSTED" && e.scenarioId).map((e) => e.scenarioId)
  );
  if (posted.size >= 2) return "RECOLLABORATED";
  if (posted.size === 1) return "COLLABORATED";
  return entries.some((entry) => OPENING_TYPES.has(entry.type)) ? "ATTEMPTED" : "UNCONTACTED";
}
function evaluateRelationStateChange(entries, to, opts) {
  const current = deriveRelationState(entries);
  if (to === current) return { ok: false, code: "SAME_STATE" };
  if (relationStateRank(to) > relationStateRank(current)) {
    return opts.canRaise ? { ok: true } : { ok: false, code: "RAISE_NOT_ALLOWED" };
  }
  if (!opts.reason?.trim()) return { ok: false, code: "REASON_REQUIRED" };
  if (relationStateRank(to) < relationStateRank(floorRelationState(entries))) {
    return { ok: false, code: "BELOW_FLOOR" };
  }
  return { ok: true };
}
var RelationStateChangeError = class extends Error {
  constructor(code) {
    super(`${CREATOR_RELATION_INVALID_TRANSITION}: ${code}`);
    this.code = code;
    this.name = "RelationStateChangeError";
  }
  code;
};
function assertRelationStateChange(entries, to, opts) {
  const verdict = evaluateRelationStateChange(entries, to, opts);
  if (!verdict.ok) throw new RelationStateChangeError(verdict.code);
}

// src/domain/creator-relation/relation-block.ts
var BLOCK_REASON_KINDS = [
  "NO_CONTACT",
  "NO_DELIVERY",
  "HARD_TO_WORK_WITH",
  "OTHER"
];
function isBlockReasonKind(value) {
  return BLOCK_REASON_KINDS.includes(value);
}
function parseUntil(value) {
  if (value === void 0) return null;
  const ms = toEpochMs(value);
  return Number.isNaN(ms) ? null : new Date(ms);
}
function deriveBlockedUntil(entries) {
  let until = null;
  for (const entry of sortRelationHistory(entries)) {
    if (entry.type === "BLOCKED") {
      until = parseUntil(entry.until);
    } else if (entry.type === "UNBLOCKED") {
      until = null;
    }
  }
  return until;
}
function isBlockActive(blockedUntil, now) {
  if (blockedUntil === null) return false;
  return toEpochMs(blockedUntil) > now.getTime();
}
function evaluateBlock(input, now) {
  return isBlockActive(input.blockedUntil, now) ? { ok: true } : { ok: false, code: "UNTIL_NOT_FUTURE" };
}
function evaluateUnblock(entries) {
  return deriveBlockedUntil(entries) === null ? { ok: false, code: "NOT_BLOCKED" } : { ok: true };
}

// src/domain/creator-relation/recruitment-policy.ts
var RE_RECRUIT_REASON_KINDS = [
  "REPLACEMENT_SHORTAGE",
  "ADVERTISER_DESIGNATED",
  "OTHER"
];
function isReRecruitReasonKind(value) {
  return RE_RECRUIT_REASON_KINDS.includes(value);
}
function deriveOutreachBlockedAt(entries) {
  let at = null;
  for (const entry of sortRelationHistory(entries)) {
    if (entry.type === "OUTREACH_BLOCKED") {
      at = new Date(toEpochMs(entry.occurredAt));
    } else if (entry.type === "OUTREACH_UNBLOCKED") {
      at = null;
    }
  }
  return at;
}
function evaluateOutreachUnblock(entries) {
  return deriveOutreachBlockedAt(entries) === null ? { ok: false, code: "NOT_OUTREACH_BLOCKED" } : { ok: true };
}
function deriveRecruitmentPolicy(input, now) {
  const candidate = input.outreachBlockedAt !== null ? "BLOCKED" : isBlockActive(input.blockedUntil, now) ? "HELD" : "ELIGIBLE";
  return { candidate, email: input.emailChannel ?? "UNKNOWN" };
}

// src/domain/creator-relation/regular-hint.ts
var REGULAR_PARAMS = [
  { K: 3, N: 12, effectiveFrom: "2026-08-27" }
];
function effectiveFromMs(params) {
  return kstStartOfDay(new Date(params.effectiveFrom)).getTime();
}
function regularParamsAt(at, params = REGULAR_PARAMS) {
  const atMs = toEpochMs(at);
  const ordered = [...params].sort((a, b) => effectiveFromMs(a) - effectiveFromMs(b));
  const chosen = ordered.filter((p) => effectiveFromMs(p) <= atMs).at(-1) ?? ordered[0];
  if (!chosen) throw new Error("REGULAR_PARAMS is empty");
  return chosen;
}
function windowStartMs(today, months) {
  const { year, month, day } = toKstParts(new Date(toEpochMs(today)));
  const target = month - 1 - months;
  const lastDay = new Date(Date.UTC(year, target + 1, 0)).getUTCDate();
  return kstStartOfDay(new Date(Date.UTC(year, target, Math.min(day, lastDay)))).getTime();
}
function recommendRegular(entries, today, params = REGULAR_PARAMS) {
  if (deriveRelationState(entries) === "REGULAR") return false;
  const { K, N } = regularParamsAt(today, params);
  const sorted = sortRelationHistory(entries);
  const lastLowerIndex = sorted.findLastIndex(
    (e) => e.type === "STATE_CHANGED" && e.from !== void 0 && e.to !== void 0 && relationStateRank(e.to) < relationStateRank(e.from)
  );
  const sinceMs = windowStartMs(today, N);
  const todayMs = toEpochMs(today);
  const scenarios = /* @__PURE__ */ new Set();
  sorted.forEach((entry, index) => {
    if (index <= lastLowerIndex) return;
    if (entry.type !== "CONTENT_POSTED" || !entry.scenarioId) return;
    const at = toEpochMs(entry.occurredAt);
    if (at < sinceMs || at > todayMs) return;
    scenarios.add(entry.scenarioId);
  });
  return scenarios.size >= K;
}

// src/domain/creator-relation/touch.ts
var TOUCH_HISTORY_TYPES = ["CONTACT_SENT", "REPLY_RECEIVED"];
var IDLE_WARN_DAYS = 30;
var TOUCH_SET = new Set(TOUCH_HISTORY_TYPES);
function toIso(at) {
  return new Date(toEpochMs(at)).toISOString();
}
function kstDayStartMs(at) {
  return kstStartOfDay(new Date(toEpochMs(at))).getTime();
}
function lastTouchAt(entries) {
  const last = sortRelationHistory(entries).filter((e) => TOUCH_SET.has(e.type)).at(-1);
  return last ? toIso(last.occurredAt) : null;
}
function idleDays(entries, today) {
  const last = lastTouchAt(entries);
  if (last === null) return null;
  return Math.max(0, Math.floor((kstDayStartMs(today) - kstDayStartMs(last)) / 864e5));
}
function ownerScopeMeasures(entries, ownerUserId) {
  const mine = sortRelationHistory(entries).filter(
    (e) => TOUCH_SET.has(e.type) && e.actorId === ownerUserId
  );
  const last = mine.at(-1);
  return { lastDirectAt: last ? toIso(last.occurredAt) : null, count: mine.length };
}

// src/domain/creator-relation/owner.ts
function currentOwnerUserId(entries) {
  const last = sortRelationHistory(entries).filter((e) => e.type === "OWNER_CHANGED").at(-1);
  return last?.toUserId ?? null;
}
function discovererUserId(entries) {
  return sortRelationHistory(effectiveRelationHistory(entries)).find((e) => e.type === "CREDIT_GRANTED")?.discoveredById ?? null;
}
function hasTombstoneHistory(entries) {
  return entries.some((e) => e.type === "TOMBSTONED");
}

// src/domain/creator-visibility/index.ts
var CreatorVisibilityTier = {
  STANDARD: "STANDARD",
  PREMIUM: "PREMIUM"
};
function isManagerOrAbove(viewer) {
  return viewer.level === "MANAGER" || viewer.level === "EXECUTIVE" || viewer.scenarioTeamRole === "LEADER";
}
function canSearchCreatorsCompanyWide(viewer) {
  return viewer.level === "MANAGER" || viewer.level === "EXECUTIVE" || viewer.leadsAnyTeam;
}
var CREATOR_PIPELINE_MAX_LAG_MS = 7 * 24 * 60 * 60 * 1e3;
function isPipelineStale(lastRefreshedAt, now) {
  if (lastRefreshedAt == null) return true;
  const refreshed = new Date(lastRefreshedAt).getTime();
  if (Number.isNaN(refreshed)) return true;
  const at = new Date(now).getTime();
  if (Number.isNaN(at)) return true;
  return at - refreshed >= CREATOR_PIPELINE_MAX_LAG_MS;
}
var CREATOR_UNKNOWN_TO_SOURCE = Object.freeze({ kind: "UNKNOWN_TO_SOURCE" });
function isUnknownToSource(subject) {
  return subject === CREATOR_UNKNOWN_TO_SOURCE;
}
function isRestrictedCreator(projection, context) {
  if (isUnknownToSource(projection)) return false;
  if (context.pipelineStale) return true;
  if (projection === null) return true;
  if (projection.visibilityTier !== CreatorVisibilityTier.STANDARD) return true;
  return projection.tombstonedAt !== null;
}
function isOwnerEligible(projection, context) {
  if (isUnknownToSource(projection)) return false;
  return !context.pipelineStale && projection != null && projection.tombstonedAt == null && projection.visibilityTier === CreatorVisibilityTier.PREMIUM;
}
function ownerRevocationCause(projection, context) {
  if (isUnknownToSource(projection)) return null;
  if (context.pipelineStale) return null;
  if (projection == null) return null;
  if (projection.tombstonedAt != null) return "TOMBSTONED";
  if (projection.visibilityTier === CreatorVisibilityTier.STANDARD) return "TIER_REVERTED";
  return null;
}
function canViewCreator(viewer, projection, context, opts = {}) {
  if (!isRestrictedCreator(projection, context)) {
    return viewer.canReadScenario || viewer.settlementExecutor;
  }
  if (viewer.role === "ADMIN") {
    return true;
  }
  if (opts.viewerIsOwner && isOwnerEligible(projection, context)) {
    return true;
  }
  if (viewer.settlementExecutor) {
    return true;
  }
  return viewer.canReadScenario && isManagerOrAbove(viewer);
}
function canReviewCreatorMatching(viewer) {
  if (viewer.role === "ADMIN") {
    return true;
  }
  return viewer.canReadScenario && isManagerOrAbove(viewer);
}
function canRestoreRosterDrop(viewer, target) {
  if (viewer.role === "ADMIN") {
    return true;
  }
  if (!viewer.canReadScenario) {
    return false;
  }
  return isManagerOrAbove(viewer) || target.progressOwnerId === target.userId;
}
function canExportCreators(viewer, projections, context) {
  return projections.every((p) => canViewCreator(viewer, p, context));
}

// src/domain/creator-relation/card-sections.ts
function cardSections(projection, relation, viewer, context) {
  const sections = {
    discoverer: { userId: discovererUserId(relation.history) }
  };
  if (relation.campaignPrices !== void 0 && relation.campaignPrices.length > 0) {
    sections.campaignPrices = relation.campaignPrices;
  }
  if (!isOwnerEligible(projection, context)) return sections;
  const ownerUserId = relation.assigneeUserId;
  if (ownerUserId === null) {
    sections.owner = { state: "PENDING_ASSIGNMENT" };
    sections.intimacy = { state: "PENDING_ASSIGNMENT" };
    sections.idleWarning = { state: "PENDING_ASSIGNMENT" };
    return sections;
  }
  const measured = ownerScopeMeasures(relation.history, ownerUserId);
  const days = idleDays(relation.history, context.today);
  sections.owner = { state: "ASSIGNED", userId: ownerUserId };
  sections.intimacy = {
    state: "ASSIGNED",
    viewerIsOwner: viewer.userId === ownerUserId,
    measures: [
      { key: "lastDirectAt", value: measured.lastDirectAt },
      { key: "directCount", value: measured.count }
    ]
  };
  sections.idleWarning = {
    state: "ASSIGNED",
    idleDays: days,
    warn: days !== null && days >= IDLE_WARN_DAYS
  };
  return sections;
}

// src/domain/creator-relation/price-platform.ts
var CreatorPricePlatform = {
  TIKTOK: "TIKTOK"
};
var CREATOR_PRICE_PLATFORMS = [CreatorPricePlatform.TIKTOK];
function isCreatorPricePlatform(value) {
  return CREATOR_PRICE_PLATFORMS.includes(value);
}

// src/domain/creator-relation/warm-pool.ts
var WARM_POOL_STATES = ["ACTIVE", "RESERVE"];
var WARM_POOL_BASES = ["REPLY", "COLLABORATION"];
function iso(value) {
  return typeof value === "string" ? value : value.toISOString();
}
function deriveWarmPoolSummary(entries) {
  const latest = sortRelationHistory(entries).filter((entry) => entry.type === "REPLY_RECEIVED" || entry.type === "CONTENT_POSTED").at(-1);
  if (!latest) return null;
  return {
    state: latest.warmPoolState === "RESERVE" ? "RESERVE" : "ACTIVE",
    basis: latest.type === "REPLY_RECEIVED" ? "REPLY" : "COLLABORATION",
    sourceScenarioId: latest.scenarioId ?? null,
    qualifiedAt: iso(latest.occurredAt)
  };
}

// src/domain/chat/chat.ts
var DOKKAEBI_SYSTEM_USER_ID = "00000000-0000-7000-a000-000000000001";
var CHANNEL_NOTIFY_LEVELS = ["ALL", "MENTIONS", "OFF"];

// src/domain/team/values.ts
var TeamType = {
  DEPARTMENT: "DEPARTMENT",
  TASK_FORCE: "TASK_FORCE",
  CLUB: "CLUB"
};
var TeamStatus = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED"
};
var TeamRole = {
  MEMBER: "MEMBER",
  LEADER: "LEADER"
};
var TeamCapability = {
  HR_MANAGEMENT: "HR_MANAGEMENT",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  FINANCE: "FINANCE",
  BETA_TESTER: "BETA_TESTER",
  ADCODE: "ADCODE",
  VA: "VA",
  /** 사내 제품별 퀘스트 묶음(개발 퀘스트 창)을 쓰는 팀. 확장 시점을 데이터로 쥐기 위한 게이트다 —
   * 제품이 등록됐다는 사실만으로 창이 열리면 발행자가 정한 확장 순서를 지킬 수 없다. */
  DEV: "DEV",
  /** 캠페인 정산 **실행자**(지급을 집행하고 상태를 찍는 팀 — 피플팀). 요청자 권한이 아니다.
   * 시나리오 참여팀이 아닌 팀이 정산 표면에만 닿게 하는 두 번째 축이고, 시나리오 본문·로스터·
   * 애드코드·검색은 열지 않는다 — docs/design/campaign-sheet-qe10b-executor-capability.md §3. */
  CAMPAIGN_SETTLEMENT: "CAMPAIGN_SETTLEMENT",
  /** 국내 캠페인 정산 **실행자**(3팀장, fact #2902). 모든 팀의 국내 캠페인 정산을 조회·처리한다.
   * 해외는 보지 않고, 크리에이터 개인정보 열람(creator:pii:view)도 주지 않는다 — 계좌·주민번호는
   * AXIOM 밖(정산 드라이브)에 있다. */
  DOMESTIC_CAMPAIGN_SETTLEMENT: "DOMESTIC_CAMPAIGN_SETTLEMENT",
  /** 인사 부서(피플팀) 표지. 이 팀 팀장이 병가 신청의 자동 수신자다(퀘스트 b218e164). 권한은 더하지 않는다 —
   * HR_MANAGEMENT 는 개발팀도 가져서 HR 팀장 한 사람을 가르지 못한다
   * (docs/plan/sick-leave-hr-recipient/cp1-decision-2026-10-12.md). */
  HR_DEPARTMENT: "HR_DEPARTMENT"
};

// src/domain/team/team.ts
function createDepartment(teamId, leaderMemberId, name, leaderId, existingNames, now) {
  if (existingNames.includes(name)) {
    throw new Error(`Team name "${name}" already exists`);
  }
  const team = {
    id: teamId,
    name,
    type: TeamType.DEPARTMENT,
    status: TeamStatus.ACTIVE,
    metadata: null,
    capabilities: [],
    // 새 팀은 당김 없음으로 시작 — 팀장이 '설정'에서 표준 리드타임을 잡는다.
    defaultDeadlineOffsetDays: 0,
    createdAt: now,
    updatedAt: now
  };
  if (!leaderId || !leaderMemberId) {
    return { team, members: [] };
  }
  const leaderMember = {
    id: leaderMemberId,
    userId: leaderId,
    teamId,
    role: TeamRole.LEADER,
    createdAt: now,
    updatedAt: now
  };
  return { team, members: [leaderMember] };
}
function createTaskForce(teamId, leaderMemberId, name, leaderId, metadata, existingNames, now) {
  if (existingNames.includes(name)) {
    throw new Error(`Team name "${name}" already exists`);
  }
  if (metadata.purpose === "") {
    throw new Error("Task force purpose cannot be empty");
  }
  const team = {
    id: teamId,
    name,
    type: TeamType.TASK_FORCE,
    status: TeamStatus.ACTIVE,
    metadata,
    capabilities: [],
    // 새 팀은 당김 없음으로 시작 — 팀장이 '설정'에서 표준 리드타임을 잡는다.
    defaultDeadlineOffsetDays: 0,
    createdAt: now,
    updatedAt: now
  };
  if (!leaderId || !leaderMemberId) {
    return { team, members: [] };
  }
  const leaderMember = {
    id: leaderMemberId,
    userId: leaderId,
    teamId,
    role: TeamRole.LEADER,
    createdAt: now,
    updatedAt: now
  };
  return { team, members: [leaderMember] };
}
function createClub(teamId, leaderMemberId, name, leaderId, metadata, existingNames, now) {
  if (existingNames.includes(name)) {
    throw new Error(`Team name "${name}" already exists`);
  }
  const team = {
    id: teamId,
    name,
    type: TeamType.CLUB,
    status: TeamStatus.ACTIVE,
    metadata,
    capabilities: [],
    // 새 팀은 당김 없음으로 시작 — 팀장이 '설정'에서 표준 리드타임을 잡는다.
    defaultDeadlineOffsetDays: 0,
    createdAt: now,
    updatedAt: now
  };
  if (!leaderId || !leaderMemberId) {
    return { team, members: [] };
  }
  const leaderMember = {
    id: leaderMemberId,
    userId: leaderId,
    teamId,
    role: TeamRole.LEADER,
    createdAt: now,
    updatedAt: now
  };
  return { team, members: [leaderMember] };
}
function archiveTeam(team, now) {
  assertStatus("team", team.id, team.status, [TeamStatus.ACTIVE], "archive");
  return {
    ...team,
    status: TeamStatus.ARCHIVED,
    updatedAt: now
  };
}
function restoreTeam(team, now) {
  assertStatus("team", team.id, team.status, [TeamStatus.ARCHIVED], "restore");
  return {
    ...team,
    status: TeamStatus.ACTIVE,
    updatedAt: now
  };
}
function addMember(team, members, userId, now, memberId) {
  assertStatus("team", team.id, team.status, [TeamStatus.ACTIVE], "add member to");
  if (members.some((m) => m.userId === userId)) {
    throw new Error(`Cannot add user ${userId} to team ${team.id}: user is already a member`);
  }
  const newMember = {
    id: memberId,
    userId,
    teamId: team.id,
    role: TeamRole.MEMBER,
    createdAt: now,
    updatedAt: now
  };
  return [...members, newMember];
}
function removeMember(members, userId) {
  const member = members.find((m) => m.userId === userId);
  if (!member) {
    throw new Error(`User ${userId} is not a member of this team`);
  }
  if (member.role === TeamRole.LEADER) {
    throw new Error(`Cannot remove user ${userId} from team: role is ${member.role}`);
  }
  return members.filter((m) => m.userId !== userId);
}
function transferLeadership(members, newLeaderUserId) {
  const newLeader = members.find((m) => m.userId === newLeaderUserId);
  if (!newLeader) {
    throw new Error(`User ${newLeaderUserId} is not a member of this team`);
  }
  if (newLeader.role === TeamRole.LEADER) {
    throw new Error(`User ${newLeaderUserId} is already the leader`);
  }
  return members.map((m) => {
    if (m.role === TeamRole.LEADER) {
      return { ...m, role: TeamRole.MEMBER };
    }
    if (m.userId === newLeaderUserId) {
      return { ...m, role: TeamRole.LEADER };
    }
    return m;
  });
}
function getLeader(members) {
  return members.find((m) => m.role === TeamRole.LEADER);
}
function getMembers(members) {
  return members.filter((m) => m.role === TeamRole.MEMBER);
}
function updateTeamCapabilities(team, capabilities, now) {
  if (team.status !== TeamStatus.ACTIVE) {
    throw new Error("Cannot update archived team");
  }
  const valid = Object.values(TeamCapability);
  for (const cap of capabilities) {
    if (!valid.includes(cap)) {
      throw new Error(`Invalid capability: ${cap}`);
    }
  }
  return { ...team, capabilities: [...new Set(capabilities)], updatedAt: now };
}

// src/domain/ceo/ceo-policy.ts
var CEO_POLICY_KEYS = [
  "team_base_budget",
  "quest.difficulty.points",
  "r1_self_assign_monthly_threshold",
  "ceo_semester_schedule",
  // 월드·FLEX 풀 배정액 — 결정 주체가 대표(budget-policy §1)인데 일반 설정 경로로 열려 있었다(감사 U3).
  "world_quest_budget",
  "flex_budget"
];
function isCeoPolicyKey(key) {
  return CEO_POLICY_KEYS.includes(key);
}
var CEO_POLICY_LABELS = {
  team_base_budget: "\uD300 \uAE30\uBCF8 \uC608\uC0B0 (base)",
  "quest.difficulty.points": "\uD018\uC2A4\uD2B8 \uB09C\uC774\uB3C4\uBCC4 \uD3EC\uC778\uD2B8 \uBC94\uC704",
  r1_self_assign_monthly_threshold: "R1 \uC790\uAE30\uC218\uD589 \uC6D4 \uB204\uC801 \uC784\uACC4\uCE58",
  ceo_semester_schedule: "\uBC18\uAE30 \uC885\uB8CC\uC77C \uC77C\uC815",
  world_quest_budget: "\uC6D4\uB4DC \uD018\uC2A4\uD2B8 \uC608\uC0B0 (\uC6D4)",
  flex_budget: "\uB3D9\uC544\uB9AC \uD50C\uB809\uC2A4 \uC608\uC0B0 (\uC6D4)"
};
var CEO_POLICY_EFFECT_NOTES = {
  team_base_budget: "\uB2E4\uC74C \uB2EC 1\uC77C \uC6D0\uC7A5 \uC0DD\uC131(cron)\uBD84\uBD80\uD130 \uBC18\uC601",
  "quest.difficulty.points": "\uC800\uC7A5 \uC989\uC2DC \uD018\uC2A4\uD2B8 \uC0DD\uC131 \uD3FC\uC5D0 \uBC18\uC601",
  r1_self_assign_monthly_threshold: "\uC800\uC7A5 \uC989\uC2DC R1 \uC790\uB3D9 \uCC28\uB2E8\uC5D0 \uBC18\uC601",
  ceo_semester_schedule: "\uC800\uC7A5 \uC989\uC2DC C5 \uBC18\uAE30 \uC870\uC815 \uC54C\uB9BC\uC5D0 \uBC18\uC601",
  world_quest_budget: "\uB2E4\uC74C \uAE09\uC5EC\uAE30\uAC04 \uC6D0\uC7A5 \uC0DD\uC131(cron)\uBD84\uBD80\uD130 \uBC18\uC601",
  flex_budget: "\uB2E4\uC74C \uAE09\uC5EC\uAE30\uAC04 \uC6D0\uC7A5 \uC0DD\uC131(cron)\uBD84\uBD80\uD130 \uBC18\uC601 \u2014 0 \uC774\uBA74 \uD50C\uB809\uC2A4 \uC815\uC0B0\uC744 \uAC74\uB108\uB6F4\uB2E4"
};
var QUEST_DIFFICULTY_LEVELS = [
  QuestDifficulty.COMMON,
  QuestDifficulty.UNCOMMON,
  QuestDifficulty.RARE,
  QuestDifficulty.EPIC,
  QuestDifficulty.LEGENDARY
];
var CEO_POLICY_DEFAULTS = {
  team_base_budget: 5e5,
  // 전 팀 공용 기본값 — 운영 중 대표콘솔에서 조정한다(reward-policy.md §2.2: 조정 기준은
  // "예산 핏"이 아니라 "기대감 핏"). 팀별 단가 정책의 밴드와는 별개다.
  "quest.difficulty.points": {
    COMMON: { min: 1e3, max: 3e3 },
    UNCOMMON: { min: 3e3, max: 8e3 },
    RARE: { min: 8e3, max: 2e4 },
    EPIC: { min: 2e4, max: 5e4 },
    LEGENDARY: { min: 5e4, max: 1e5 }
  },
  r1_self_assign_monthly_threshold: 1e5,
  ceo_semester_schedule: { ends: ["06-30", "12-31"] },
  // 아래 둘은 budget-ledger-cron 의 DEFAULT_WORLD_QUEST_BUDGET · DEFAULT_FLEX_BUDGET 과 같아야 한다.
  world_quest_budget: 1e6,
  flex_budget: { monthly: 0 }
};
var isPositiveInt = (v) => typeof v === "number" && Number.isInteger(v) && v > 0;
var isNonNegativeInt = (v) => typeof v === "number" && Number.isInteger(v) && v >= 0;
var MM_DD_RE = /^(\d{2})-(\d{2})$/;
function validateTeamBaseBudget(value) {
  if (!isPositiveInt(value)) {
    return { ok: false, error: "\uC591\uC758 \uC815\uC218(\uC6D0/P \uB2E8\uC704)\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  return { ok: true, value };
}
function validateDifficultyRanges(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return { ok: false, error: "\uB09C\uC774\uB3C4\uBCC4 {min, max} \uAC1D\uCCB4\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  const ranges = value;
  const out = {};
  for (const level of QUEST_DIFFICULTY_LEVELS) {
    const range = ranges[level];
    if (range === null || typeof range !== "object") {
      return { ok: false, error: `${level} \uBC94\uC704\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4` };
    }
    const { min, max } = range;
    if (!isPositiveInt(min) || !isPositiveInt(max)) {
      return { ok: false, error: `${level}: min\xB7max\uB294 \uC591\uC758 \uC815\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4` };
    }
    if (min > max) {
      return { ok: false, error: `${level}: min\uC774 max\uBCF4\uB2E4 \uD074 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4` };
    }
    out[level] = { min, max };
  }
  return { ok: true, value: out };
}
function validateR1Threshold(value) {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return { ok: false, error: "\uC591\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  return { ok: true, value };
}
function validateSemesterSchedule(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return { ok: false, error: "{ ends: [MM-DD, ...] } \uD615\uD0DC\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  const ends = value.ends;
  if (!Array.isArray(ends) || ends.length === 0) {
    return { ok: false, error: "\uC885\uB8CC\uC77C\uC774 \uCD5C\uC18C 1\uAC1C \uD544\uC694\uD569\uB2C8\uB2E4" };
  }
  const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  for (const end of ends) {
    if (typeof end !== "string") {
      return { ok: false, error: "\uC885\uB8CC\uC77C\uC740 MM-DD \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" };
    }
    const m = MM_DD_RE.exec(end);
    if (!m) {
      return { ok: false, error: `'${end}'\uB294 MM-DD \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4` };
    }
    const month = Number(m[1]);
    const day = Number(m[2]);
    const maxDay = DAYS_IN_MONTH[month - 1] ?? 0;
    if (month < 1 || month > 12 || day < 1 || day > maxDay) {
      return { ok: false, error: `'${end}'\uB294 \uB2EC\uB825 \uBC94\uC704\uB97C \uBC97\uC5B4\uB0A9\uB2C8\uB2E4` };
    }
  }
  return { ok: true, value: { ends: [...ends] } };
}
function validateWorldQuestBudget(value) {
  if (!isNonNegativeInt(value)) {
    return { ok: false, error: "0 \uC774\uC0C1\uC758 \uC815\uC218(\uC6D0/P \uB2E8\uC704)\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  return { ok: true, value };
}
function validateFlexBudget(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return { ok: false, error: "{ monthly: 0 \uC774\uC0C1\uC758 \uC815\uC218 } \uD615\uD0DC\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  const monthly = value.monthly;
  if (!isNonNegativeInt(monthly)) {
    return { ok: false, error: "monthly \uB294 0 \uC774\uC0C1\uC758 \uC815\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4" };
  }
  return { ok: true, value: { monthly } };
}
function validateCeoPolicyValue(key, value) {
  switch (key) {
    case "team_base_budget":
      return validateTeamBaseBudget(value);
    case "quest.difficulty.points":
      return validateDifficultyRanges(value);
    case "r1_self_assign_monthly_threshold":
      return validateR1Threshold(value);
    case "ceo_semester_schedule":
      return validateSemesterSchedule(value);
    case "world_quest_budget":
      return validateWorldQuestBudget(value);
    case "flex_budget":
      return validateFlexBudget(value);
  }
}

// src/domain/team/difficulty-pricing.ts
import { z as z6 } from "zod";
var difficultyPriceSchema = z6.object({
  min: z6.number().int().min(0),
  max: z6.number().int().min(0),
  /** 기준값 — 이 팀 퀘스트에서 난이도를 고르면 폼이 이 값을 채운다 */
  anchor: z6.number().int().min(0).optional()
}).strict().refine((v) => v.max >= v.min, { message: "\uCD5C\uB300\uAC12\uC740 \uCD5C\uC18C\uAC12\uBCF4\uB2E4 \uC791\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." }).refine((v) => v.anchor === void 0 || v.anchor >= v.min && v.anchor <= v.max, {
  message: "\uAE30\uC900\uAC12\uC740 \uCD5C\uC18C\uAC12\uACFC \uCD5C\uB300\uAC12 \uC0AC\uC774\uC5D0 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4."
});
var teamDifficultyPricingSchema = z6.object({
  COMMON: difficultyPriceSchema.optional(),
  UNCOMMON: difficultyPriceSchema.optional(),
  RARE: difficultyPriceSchema.optional(),
  EPIC: difficultyPriceSchema.optional(),
  LEGENDARY: difficultyPriceSchema.optional()
}).strict();
function resolveDifficultyPricing(team, company) {
  const ranges = { ...company };
  const anchors = {};
  let source = "company";
  for (const [level, price] of Object.entries(team ?? {})) {
    if (!price) continue;
    source = "team";
    ranges[level] = { min: price.min, max: price.max };
    if (price.anchor !== void 0) anchors[level] = price.anchor;
  }
  return { source, ranges, anchors };
}
function readCompanyDifficultyRanges(value) {
  const checked = validateCeoPolicyValue("quest.difficulty.points", value);
  return checked.ok ? checked.value : CEO_POLICY_DEFAULTS["quest.difficulty.points"];
}
function judgeRewardByPricing(pricing, input) {
  if (!(input.rewardPoints > 0)) return { ok: true };
  if (!input.difficulty) return { ok: false, reason: "DIFFICULTY_REQUIRED" };
  const { min, max } = pricing.ranges[input.difficulty];
  if (input.rewardPoints < min || input.rewardPoints > max) {
    return { ok: false, reason: "OUT_OF_RANGE", difficulty: input.difficulty, min, max };
  }
  return { ok: true };
}
function pricingNeedsReasonCode(pricing, input) {
  if (!(input.rewardPoints > 0) || !input.difficulty) return false;
  const { min, max } = pricing.ranges[input.difficulty];
  const anchor = pricing.anchors[input.difficulty];
  if (anchor !== void 0) return input.rewardPoints !== anchor;
  return input.rewardPoints === min || input.rewardPoints === max;
}

// src/domain/team/index.ts
import { z as z7 } from "zod";
var TaskForceMetadataSchema = z7.object({
  purpose: z7.string(),
  startDate: z7.string(),
  expectedEndDate: z7.string()
});
var ClubMetadataSchema = z7.object({
  description: z7.string().optional(),
  rules: z7.string().optional(),
  code: z7.string().optional(),
  tagline: z7.string().optional(),
  meetingCycle: z7.enum(["weekly", "biweekly", "monthly"]).optional()
});
var TeamMetadataSchema = z7.discriminatedUnion("type", [
  z7.object({ type: z7.literal(TeamType.TASK_FORCE), metadata: TaskForceMetadataSchema }),
  z7.object({ type: z7.literal(TeamType.CLUB), metadata: ClubMetadataSchema }),
  z7.object({ type: z7.literal(TeamType.DEPARTMENT), metadata: z7.null() })
]);

// src/domain/user/index.ts
var UserLevel = {
  INTERN: "INTERN",
  ASSOCIATE: "ASSOCIATE",
  MANAGER: "MANAGER",
  EXECUTIVE: "EXECUTIVE"
};
var UserRole = {
  PLAYER: "PLAYER",
  OPERATOR: "OPERATOR",
  ADMIN: "ADMIN"
};
var WorkType = {
  FIXED: "FIXED",
  FREE: "FREE"
};
var UserStatus = {
  PENDING_SIGNUP: "PENDING_SIGNUP",
  PENDING_ONBOARD: "PENDING_ONBOARD",
  ACTIVE: "ACTIVE",
  PENDING_OFFBOARD: "PENDING_OFFBOARD",
  OFFBOARDED: "OFFBOARDED",
  PURGED: "PURGED"
};
var USER_STATUS_LABELS = {
  PENDING_SIGNUP: "\uAC00\uC785 \uD655\uC778 \uC911",
  PENDING_ONBOARD: "\uC785\uC0AC\uC608\uC815",
  ACTIVE: "\uD65C\uC131",
  PENDING_OFFBOARD: "\uD1F4\uC0AC\uC608\uC815",
  OFFBOARDED: "\uD1F4\uC0AC\uC790",
  PURGED: "\uC775\uBA85\uD654\uB428"
};
var DEPARTED_USER_STATUSES = [
  UserStatus.OFFBOARDED,
  UserStatus.PURGED
];
function isDepartedUserStatus(status) {
  return DEPARTED_USER_STATUSES.includes(status);
}
var LEVEL_LABELS = {
  INTERN: "\uC778\uD134",
  ASSOCIATE: "\uC0AC\uC6D0",
  MANAGER: "\uB9E4\uB2C8\uC800",
  EXECUTIVE: "\uC784\uC6D0"
};
var INTERN_CONVERSION_REVIEW_MONTHS = 3;
function calculateInternConversionDate(hireDateIso) {
  const hire = toKstParts(new Date(hireDateIso));
  const monthIndex = hire.month - 1 + INTERN_CONVERSION_REVIEW_MONTHS;
  const year = hire.year + Math.floor(monthIndex / 12);
  const month = monthIndex % 12 + 1;
  const lastDayOfMonth2 = new Date(year, month, 0).getDate();
  const day = Math.min(hire.day, lastDayOfMonth2);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
function calculateInternConversionDday(hireDateIso, todayIso) {
  if (!hireDateIso) return null;
  const conversionDate = calculateInternConversionDate(hireDateIso);
  const MS_PER_DAY = 864e5;
  const daysLeft = Math.round(
    (Date.parse(`${conversionDate}T00:00:00Z`) - Date.parse(`${todayIso}T00:00:00Z`)) / MS_PER_DAY
  );
  return { conversionDate, daysLeft };
}

// src/domain/agent/agent.ts
var AgentConnectionType = {
  OPENCLAW: "OPENCLAW",
  API: "API"
};
var AgentStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ERROR: "ERROR"
};
var AgentMessageType = {
  TEXT: "TEXT",
  FORM_UPDATE: "FORM_UPDATE",
  ACTION: "ACTION"
};

// src/domain/piecework/values.ts
var PieceworkActivityStatus = {
  /** HR/매니저 생성 직후, ADMIN 승인 대기. */
  PENDING_APPROVAL: "PENDING_APPROVAL",
  /** ADMIN reject — 사유는 rejectionReason. */
  REJECTED: "REJECTED",
  ACTIVE: "ACTIVE",
  LOCKED: "LOCKED",
  ARCHIVED: "ARCHIVED"
};
var PieceworkAudienceScope = {
  TEAM: "TEAM",
  GLOBAL: "GLOBAL"
};
var PieceworkCycle = {
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY"
};
var PieceworkSubmissionStatus = {
  DONE: "DONE",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};

// src/domain/piecework/activity.ts
function createActivity(params) {
  if (!params.title.trim()) {
    throw new Error("PieceworkActivity title cannot be empty");
  }
  if (params.rewardPerSubmission <= 0) {
    throw new Error(`rewardPerSubmission must be positive, got ${params.rewardPerSubmission}`);
  }
  if (params.cycle === null) {
    if (params.cycleStartAt !== null || params.cycleEndAt !== null) {
      throw new Error("cycleStartAt/cycleEndAt must be null when cycle is null");
    }
  } else {
    if (params.cycleStartAt === null || params.cycleEndAt === null) {
      throw new Error(`cycleStartAt/cycleEndAt are required when cycle=${params.cycle}`);
    }
    if (new Date(params.cycleEndAt).getTime() <= new Date(params.cycleStartAt).getTime()) {
      throw new Error("cycleEndAt must be after cycleStartAt");
    }
  }
  if (params.maxSubmissionsPerCycle !== null && params.maxSubmissionsPerCycle <= 0) {
    throw new Error(
      `maxSubmissionsPerCycle must be positive or null, got ${params.maxSubmissionsPerCycle}`
    );
  }
  return {
    id: params.id,
    creatorId: params.creatorId,
    title: params.title,
    description: params.description,
    rewardPerSubmission: params.rewardPerSubmission,
    audienceScope: params.audienceScope,
    cycle: params.cycle,
    cycleStartAt: params.cycleStartAt,
    cycleEndAt: params.cycleEndAt,
    requiresApproval: params.requiresApproval,
    maxSubmissionsPerCycle: params.maxSubmissionsPerCycle,
    status: params.autoApprove ? PieceworkActivityStatus.ACTIVE : PieceworkActivityStatus.PENDING_APPROVAL,
    approvedAt: params.autoApprove ? params.now : null,
    approvedBy: params.autoApprove ? params.creatorId : null,
    rejectionReason: null,
    createdAt: params.now,
    updatedAt: params.now
  };
}
function approveActivity(params) {
  if (!params.isAuthorizedApprover) {
    throw new Error(
      `Approver ${params.approverId} not authorized to approve piecework activity ${params.activity.id} (ADMIN only)`
    );
  }
  if (params.activity.status === PieceworkActivityStatus.ACTIVE) {
    return params.activity;
  }
  if (params.activity.status !== PieceworkActivityStatus.PENDING_APPROVAL) {
    throw new Error(
      `Cannot approve piecework activity ${params.activity.id}: status is ${params.activity.status}, expected PENDING_APPROVAL`
    );
  }
  return {
    ...params.activity,
    status: PieceworkActivityStatus.ACTIVE,
    approvedAt: params.now,
    approvedBy: params.approverId,
    rejectionReason: null,
    updatedAt: params.now
  };
}
function rejectActivityCreation(params) {
  if (!params.isAuthorizedApprover) {
    throw new Error(
      `Approver ${params.approverId} not authorized to reject piecework activity ${params.activity.id} (ADMIN only)`
    );
  }
  if (!params.reason.trim()) {
    throw new Error("Rejection reason is required");
  }
  assertStatus(
    "piecework activity",
    params.activity.id,
    params.activity.status,
    [PieceworkActivityStatus.PENDING_APPROVAL],
    "reject"
  );
  return {
    ...params.activity,
    status: PieceworkActivityStatus.REJECTED,
    approvedAt: params.now,
    approvedBy: params.approverId,
    rejectionReason: params.reason.trim(),
    updatedAt: params.now
  };
}
function archiveActivity(activity, now) {
  if (activity.status === PieceworkActivityStatus.ARCHIVED) {
    return activity;
  }
  return { ...activity, status: PieceworkActivityStatus.ARCHIVED, updatedAt: now };
}
function lockActivity(activity, now) {
  assertStatus(
    "piecework activity",
    activity.id,
    activity.status,
    [PieceworkActivityStatus.ACTIVE],
    "lock"
  );
  return { ...activity, status: PieceworkActivityStatus.LOCKED, updatedAt: now };
}
function unlockActivity(activity, now) {
  assertStatus(
    "piecework activity",
    activity.id,
    activity.status,
    [PieceworkActivityStatus.LOCKED],
    "unlock"
  );
  return { ...activity, status: PieceworkActivityStatus.ACTIVE, updatedAt: now };
}

// src/domain/piecework/cycle.ts
var CYCLE_KEY_NONE = "NONE";
function computeCycleKey(cycle, when) {
  if (cycle === null) return CYCLE_KEY_NONE;
  const d = new Date(when);
  if (Number.isNaN(d.getTime())) {
    throw new Error(`computeCycleKey: invalid date ${when}`);
  }
  if (cycle === PieceworkCycle.WEEKLY) {
    const { year: year2, week } = isoWeek(d);
    return `${year2}-W${String(week).padStart(2, "0")}`;
  }
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth() + 1;
  return `${year}-M${String(month).padStart(2, "0")}`;
}
function computeNextCycle(cycle, fromCycleEndAt) {
  const from = new Date(fromCycleEndAt);
  if (Number.isNaN(from.getTime())) {
    throw new Error(`computeNextCycle: invalid date ${fromCycleEndAt}`);
  }
  if (cycle === PieceworkCycle.WEEKLY) {
    const start2 = from;
    const end2 = new Date(from.getTime() + 7 * 24 * 60 * 60 * 1e3);
    return { start: start2.toISOString(), end: end2.toISOString() };
  }
  const start = from;
  const targetYear = start.getUTCFullYear();
  const targetMonth = start.getUTCMonth() + 1;
  const lastDay = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
  const day = Math.min(start.getUTCDate(), lastDay);
  const end = new Date(
    Date.UTC(
      targetYear,
      targetMonth,
      day,
      start.getUTCHours(),
      start.getUTCMinutes(),
      start.getUTCSeconds()
    )
  );
  return { start: start.toISOString(), end: end.toISOString() };
}
function isoWeek(date2) {
  const d = new Date(Date.UTC(date2.getUTCFullYear(), date2.getUTCMonth(), date2.getUTCDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((d.getTime() - yearStart.getTime()) / 864e5 + 1) / 7);
  return { year: d.getUTCFullYear(), week };
}

// src/domain/piecework/submission.ts
function assertCanSubmit(activity, isAudience, existingSubmissionCount, now) {
  assertStatus(
    "piecework activity",
    activity.id,
    activity.status,
    [PieceworkActivityStatus.ACTIVE],
    "submit to"
  );
  if (!isAudience) {
    throw new Error(
      `Participant is not in audience for activity ${activity.id} (scope=${activity.audienceScope})`
    );
  }
  if (activity.cycle !== null && activity.cycleStartAt !== null && activity.cycleEndAt !== null) {
    const t = new Date(now).getTime();
    if (t < new Date(activity.cycleStartAt).getTime() || t >= new Date(activity.cycleEndAt).getTime()) {
      throw new Error(`activity ${activity.id} is outside its current cycle window`);
    }
  }
  if (activity.maxSubmissionsPerCycle !== null && existingSubmissionCount >= activity.maxSubmissionsPerCycle) {
    throw new Error(
      `maxSubmissionsPerCycle (${activity.maxSubmissionsPerCycle}) reached for activity ${activity.id}`
    );
  }
}
function submitPiecework(params) {
  assertCanSubmit(params.activity, params.isAudience, params.existingSubmissionCount, params.now);
  const cycleKey = computeCycleKey(params.activity.cycle, params.now);
  const initialStatus = params.activity.requiresApproval ? PieceworkSubmissionStatus.PENDING_APPROVAL : PieceworkSubmissionStatus.DONE;
  return {
    id: params.id,
    activityId: params.activity.id,
    participantId: params.participantId,
    uploadIds: params.uploadIds,
    memo: params.memo,
    status: initialStatus,
    cycleKey,
    submittedAt: params.now,
    approvedAt: null,
    approvedBy: null,
    pointHistoryId: null
  };
}
function approveSubmission(params) {
  if (!params.isAuthorizedApprover) {
    throw new Error(
      `Approver ${params.approverId} not authorized for submission ${params.submission.id} (creator + ADMIN only)`
    );
  }
  if (params.submission.status === PieceworkSubmissionStatus.APPROVED) {
    return params.submission;
  }
  if (params.submission.status !== PieceworkSubmissionStatus.PENDING_APPROVAL) {
    throw new Error(
      `Cannot approve submission ${params.submission.id}: status is ${params.submission.status}, expected PENDING_APPROVAL`
    );
  }
  return {
    ...params.submission,
    status: PieceworkSubmissionStatus.APPROVED,
    approvedAt: params.now,
    approvedBy: params.approverId
  };
}
function rejectSubmission(params) {
  if (!params.isAuthorizedApprover) {
    throw new Error(
      `Approver ${params.approverId} not authorized for submission ${params.submission.id} (creator + ADMIN only)`
    );
  }
  assertStatus(
    "piecework submission",
    params.submission.id,
    params.submission.status,
    [PieceworkSubmissionStatus.PENDING_APPROVAL],
    "reject"
  );
  return {
    ...params.submission,
    status: PieceworkSubmissionStatus.REJECTED,
    approvedAt: params.now,
    approvedBy: params.approverId
  };
}
function isParticipantInAudience(activity, participantTeamIds, creatorTeamIds) {
  if (activity.audienceScope === PieceworkAudienceScope.GLOBAL) return true;
  return participantTeamIds.some((t) => creatorTeamIds.includes(t));
}

// src/domain/point/point-krw.ts
var DEFAULT_POINT_TO_KRW_RATE = 1;
function pointsToKrw(points, rate2 = DEFAULT_POINT_TO_KRW_RATE) {
  if (!Number.isFinite(points)) {
    throw new RangeError(`pointsToKrw: points \uB294 \uC720\uD55C\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4 (\uBC1B\uC740 \uAC12: ${points})`);
  }
  if (!Number.isFinite(rate2) || rate2 <= 0) {
    throw new RangeError(`pointsToKrw: rate \uB294 0 \uBCF4\uB2E4 \uD070 \uC720\uD55C\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4 (\uBC1B\uC740 \uAC12: ${rate2})`);
  }
  const raw = points * rate2;
  return Math.sign(raw) * Math.round(Math.abs(raw));
}

// src/domain/point/index.ts
var PointHistoryType = {
  EARN: "EARN",
  GRANT: "GRANT",
  ADJUST: "ADJUST",
  FLEX_SETTLE: "FLEX_SETTLE",
  /** 일상(piecework) 복지활동 적립 — 퀘스트 EARN과 구분하기 위한 전용 출처 */
  PIECEWORK: "PIECEWORK",
  /**
   * 캠페인 종료 시 매니저 성과급 — 시나리오 층에서 로스터를 읽어 한 번에 나가는 적립
   * (`domain/campaign/manager-bonus.ts`, 퀘스트 b425f8fe). 퀘스트를 거치지 않아
   * `questId` 가 null 이고, 시나리오 연결은 `campaign_manager_bonus_shares` 가 든다.
   */
  CAMPAIGN_BONUS: "CAMPAIGN_BONUS",
  /**
   * 긴급 회수 — 항상 음수. 원본 EARN row 를 지우지 않고 음수 row 를 덧붙이는 방식이라
   * (D10 계약) 순 적립을 내려면 EARN 과 함께 합산해야 한다 (`dto/team-workload.ts`
   * earnedPoints 주석). 만들던 코드(대표 콘솔 즉시 차단)는 2026-09-18 걷혀 새 행은 생기지
   * 않지만, 과거 행을 읽는 라벨·필터를 위해 값은 남긴다.
   */
  REVOKE: "REVOKE"
};
var ADJUST_REASON_CATEGORIES = [
  /** 마감 몰수 재심 보전 — 몰수 경로는 PointHistory 행을 만들지 않아 되돌릴 대상이 없다. */
  "FORFEIT_REVIEW",
  /** 자동 적립 유실 보전 — fire-and-forget 리스너가 삼킨 적립에는 참조할 행이 없다. */
  "LOST_ACCRUAL",
  /** 과소 적립 증액 — 부족분이 원거래보다 클 수 있어 환원 의미론으로 표현되지 않는다. */
  "UNDER_ACCRUAL",
  /** 위 셋에 들지 않는 보전 — note 에 사유를 상술한다. */
  "OTHER"
];
var ADJUST_REASON_CATEGORY_LABELS = {
  FORFEIT_REVIEW: "\uBAB0\uC218 \uC7AC\uC2EC \uBCF4\uC804",
  LOST_ACCRUAL: "\uC801\uB9BD \uC720\uC2E4 \uBCF4\uC804",
  UNDER_ACCRUAL: "\uACFC\uC18C \uC801\uB9BD \uC99D\uC561",
  OTHER: "\uAE30\uD0C0 (\uC0AC\uC720 \uC0C1\uC220)"
};
var REVERSIBLE_POINT_HISTORY_TYPES = [
  PointHistoryType.ADJUST,
  PointHistoryType.REVOKE
];

// src/domain/quest-proposal/proposal.ts
import { z as z8 } from "zod";
var QuestProposalStatus = {
  OPEN: "OPEN",
  ADOPTED: "ADOPTED",
  DECLINED: "DECLINED"
};
var isResolvedQuestProposalStatus = (status) => status === QuestProposalStatus.ADOPTED || status === QuestProposalStatus.DECLINED;
var QUEST_PROPOSAL_TITLE_MAX_LENGTH = 100;
var QUEST_PROPOSAL_DESCRIPTION_MAX_LENGTH = 2e3;
var QuestProposalTitleSchema = z8.string().trim().min(1, "\uC81C\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694").max(
  QUEST_PROPOSAL_TITLE_MAX_LENGTH,
  `\uC81C\uBAA9\uC740 \uCD5C\uB300 ${QUEST_PROPOSAL_TITLE_MAX_LENGTH}\uC790\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4`
);
var QuestProposalDescriptionSchema = z8.string().trim().min(1, "\uC124\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694").max(
  QUEST_PROPOSAL_DESCRIPTION_MAX_LENGTH,
  `\uC124\uBA85\uC740 \uCD5C\uB300 ${QUEST_PROPOSAL_DESCRIPTION_MAX_LENGTH}\uC790\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4`
);

// src/domain/scenario-template/values.ts
var SCENARIO_TEMPLATE_CREATOR_COUNT_MIN = 1;
var SCENARIO_TEMPLATE_CREATOR_COUNT_MAX = 9999;
var SCENARIO_TEMPLATE_DURATION_DAYS_MIN = 1;
var SCENARIO_TEMPLATE_TARGET_REGION_MAX = 64;

// src/domain/scenario-template/scenario-template.ts
function validateTargetRegion(region) {
  if (region.length > SCENARIO_TEMPLATE_TARGET_REGION_MAX) {
    throw new Error(
      `defaultTargetRegion length (${region.length}) exceeds max ${SCENARIO_TEMPLATE_TARGET_REGION_MAX}`
    );
  }
  const seen = /* @__PURE__ */ new Set();
  for (const code of region) {
    if (!/^[A-Z]{2}$/.test(code) || !isValidIsoCountry(code)) {
      throw new Error(`Invalid ISO 3166-1 alpha-2 code in defaultTargetRegion: ${code}`);
    }
    if (seen.has(code)) {
      throw new Error(`Duplicate target region code: ${code}`);
    }
    seen.add(code);
  }
}
function createScenarioTemplate(params) {
  if (!params.name.trim()) {
    throw new Error("Scenario template name cannot be empty");
  }
  if (!Number.isInteger(params.defaultCreatorCount) || params.defaultCreatorCount < SCENARIO_TEMPLATE_CREATOR_COUNT_MIN || params.defaultCreatorCount > SCENARIO_TEMPLATE_CREATOR_COUNT_MAX) {
    throw new Error(
      `defaultCreatorCount must be ${SCENARIO_TEMPLATE_CREATOR_COUNT_MIN}~${SCENARIO_TEMPLATE_CREATOR_COUNT_MAX}, got ${params.defaultCreatorCount}`
    );
  }
  if (!Number.isInteger(params.defaultDurationDays) || params.defaultDurationDays < SCENARIO_TEMPLATE_DURATION_DAYS_MIN) {
    throw new Error(
      `defaultDurationDays must be \u2265 ${SCENARIO_TEMPLATE_DURATION_DAYS_MIN}, got ${params.defaultDurationDays}`
    );
  }
  const defaultCampaignType = params.defaultCampaignType ?? ScenarioCampaignType.DOMESTIC;
  const defaultTargetRegion = defaultCampaignType === ScenarioCampaignType.DOMESTIC ? [] : params.defaultTargetRegion ?? [];
  validateTargetRegion(defaultTargetRegion);
  return {
    id: params.id,
    name: params.name,
    description: params.description ?? null,
    ownerId: params.ownerId ?? null,
    ownerTeamId: params.ownerTeamId,
    defaultAdvertiserId: params.defaultAdvertiserId ?? null,
    defaultCreatorCount: params.defaultCreatorCount,
    defaultDurationDays: params.defaultDurationDays,
    defaultGuidelineUrl: params.defaultGuidelineUrl ?? null,
    defaultCampaignType,
    defaultTargetRegion,
    defaultIsSequential: params.defaultIsSequential ?? false,
    defaultDescription: params.defaultDescription ?? null,
    usageCount: 0,
    teamIds: params.teamIds ?? [],
    questItems: params.questItems ?? [],
    createdAt: params.now,
    updatedAt: params.now
  };
}
function instantiateTemplate(params) {
  if (!params.advertiserId.trim()) {
    throw new Error("instantiateTemplate requires a non-empty advertiserId");
  }
  const templateTeamIds = new Set(params.template.teamIds);
  const callerMemberTeamIds = new Set(params.callerMemberTeamIds);
  const additionalTeamIds = params.additionalTeamIds ?? [];
  for (const teamId of additionalTeamIds) {
    const allowed = templateTeamIds.has(teamId) || callerMemberTeamIds.has(teamId);
    if (!allowed) {
      throw new Error(`Cannot add external team to scenario: ${teamId}`);
    }
  }
  const scenarioTeamIds = [.../* @__PURE__ */ new Set([...params.template.teamIds, ...additionalTeamIds])];
  const ownerTeamMemberIds = new Set(params.ownerTeamMemberIds);
  const scenarioQuestTemplates = params.template.questItems.map((item) => ({
    title: item.title,
    description: item.description,
    difficulty: item.difficulty,
    rewardPoints: item.rewardPoints,
    estimatedHours: item.estimatedHours,
    defaultAssigneeId: item.defaultAssigneeId !== null && ownerTeamMemberIds.has(item.defaultAssigneeId) ? item.defaultAssigneeId : null,
    orderIndex: item.orderIndex
  }));
  return {
    advertiserId: params.advertiserId,
    scenarioTeamIds,
    scenarioQuestTemplates
  };
}

// src/domain/scenario-timeline/values.ts
var TimelineEventType = {
  ADVERTISER_REQUEST: "ADVERTISER_REQUEST",
  ADVERTISER_FEEDBACK: "ADVERTISER_FEEDBACK",
  INTERPRETATION: "INTERPRETATION",
  NOTE: "NOTE",
  GUIDELINE_UPLOADED: "GUIDELINE_UPLOADED",
  // 가이드라인 시안 흐름 (fact #2429) — 시안을 올리면 확인 대기, 팀장·담당자가 확정 또는 반려(사유 필수).
  // 확정은 GUIDELINE_UPLOADED 가 metadata.draftEventId 로 시안을 가리키는 것이라 확정 판정 규칙은 그대로다.
  GUIDELINE_DRAFT_UPLOADED: "GUIDELINE_DRAFT_UPLOADED",
  GUIDELINE_DRAFT_REJECTED: "GUIDELINE_DRAFT_REJECTED",
  // 팀 → 크리에이터 가이드 전달 시점. UPLOADED(팀장 시스템 업로드)와 의도 분리.
  // Plan 2026-05-22T09-30-08Z-da1c1958.
  GUIDELINE_DELIVERED: "GUIDELINE_DELIVERED",
  REPORT_DELIVERED: "REPORT_DELIVERED",
  // Creator funnel stage events — scenario-scoped, spawn quest with funnel-templated CPs.
  // 섭외 → 수급 → 업로드 순서. metricKey 자동 매핑은 quest spawn 시점에 derive (L5).
  CREATOR_RECRUITED: "CREATOR_RECRUITED",
  CREATOR_DELIVERED: "CREATOR_DELIVERED",
  CREATOR_UPLOADED: "CREATOR_UPLOADED",
  // 크리에이터 이탈 보고 — 순수 시스템 로그 (시딩매니저 CTA 보고 → DropSignal + 본 이벤트).
  // 이탈 사실(count·replacementRequired·reason·note)만 기록. 액션 없음 (PR1 재작업 A안).
  // 섭외(CREATOR_RECRUITED)는 타임라인에 남는데 이탈만 안 남던 비대칭 해소.
  // Plan 2026-06-01T06-51-07Z-1b130400 §13.5 F-10. type 컬럼은 String 이라 migration 불필요.
  CREATOR_DROPPED: "CREATOR_DROPPED",
  // 재섭외 필요 — 재섭외=예 이탈에서 CREATOR_DROPPED 와 함께 추가 생성되는 액션 카드.
  // [재섭외 퀘스트 생성] + (팀장)[보고 취소] 액션 담당. metadata.dropSignalId 가 취소 대상.
  // PR1 재작업 A안: 시스템 로그(CREATOR_DROPPED)와 액션(CREATOR_REPLACEMENT) 분리.
  CREATOR_REPLACEMENT: "CREATOR_REPLACEMENT",
  QUEST_CREATED: "QUEST_CREATED",
  QUEST_COMPLETED: "QUEST_COMPLETED",
  QUEST_FAILED: "QUEST_FAILED",
  QUEST_REASSIGNED: "QUEST_REASSIGNED",
  SCENARIO_ACTIVATED: "SCENARIO_ACTIVATED",
  SCENARIO_COMPLETED: "SCENARIO_COMPLETED",
  SCENARIO_FAILED: "SCENARIO_FAILED",
  // 진행 책임자 지정·이전·회수 (D1). 사람 이전 이벤트라 타임라인에 남긴다 —
  // 스칼라 필드 변경은 타임라인 대상이 아니라는 ERD 거버넌스 선(scenario-template-erd.md §312)의
  // QUEST_REASSIGNED 쪽. 지정/이전/회수 3동작을 metadata {fromUserId,toUserId} 의 null 조합으로 표현.
  // type 컬럼은 CHECK 없는 TEXT 라 migration 불필요.
  SCENARIO_PROGRESS_OWNER_CHANGED: "SCENARIO_PROGRESS_OWNER_CHANGED"
};
var FUNNEL_CP_TEMPLATE = {
  [TimelineEventType.CREATOR_RECRUITED]: {
    title: "\uC12D\uC678 \uC778\uC6D0",
    description: "\uB9AC\uC2A4\uD2B8\uC5C5\uC774 \uC544\uB2C8\uB77C \uC12D\uC678\uAC00 \uD655\uC815\uB41C \uC778\uC6D0\uC744 \uC13C\uB2E4. \uB0B4\uBD80\uC6A9 \uC2DC\uD2B8\uC758 \uD655\uC815 \uB9AC\uC2A4\uD2B8 \uB9C1\uD06C\uC640 \uD655\uC815 \uC778\uC6D0 \uC218\uB85C \uD655\uC778\uD55C\uB2E4.",
    metricKey: "RECRUITED_COUNT"
  },
  [TimelineEventType.CREATOR_DELIVERED]: {
    title: "\uC218\uAE09 \uC18C\uC7AC \uC218",
    description: "\uC601\uC0C1 \uAC74\uC218\uB85C \uC13C\uB2E4. \uC218\uAE09 \uD604\uD669\uC744 \uAC31\uC2E0\uD55C \uB0B4\uBD80\uC6A9 \uC2DC\uD2B8 \uD0ED\uACFC \uC218\uAE09 \uAC74\uC218\uB85C \uD655\uC778\uD55C\uB2E4.",
    metricKey: "DELIVERED_COUNT"
  },
  [TimelineEventType.CREATOR_UPLOADED]: {
    title: "\uC5C5\uB85C\uB4DC \uC218",
    description: "\uBAA9\uD45C\uB294 \uACC4\uC57D \uC778\uC6D0 \uC218\uB2E4. \uC678\uBD80\uC6A9 \uC2DC\uD2B8 \uD655\uC815 \uB9AC\uC2A4\uD2B8 \uD0ED\uACFC \uC5C5\uB85C\uB4DC \uC644\uB8CC \uC218(\uC601\uC0C1 \uB9C1\uD06C\uAC00 \uCC2C \uD589)\uB85C \uD655\uC778\uD55C\uB2E4.",
    metricKey: "UPLOADED_COUNT"
  }
};
var NON_FUNNEL_CP_TITLE = {
  [TimelineEventType.NOTE]: "\uC644\uB8CC \uD655\uC778",
  [TimelineEventType.GUIDELINE_DELIVERED]: "\uC804\uB2EC \uC644\uB8CC \uD655\uC778"
};
function seedCheckpointDiscriminator(type) {
  const funnel = FUNNEL_CP_TEMPLATE[type];
  if (funnel) return { metricKey: funnel.metricKey };
  const title = NON_FUNNEL_CP_TITLE[type];
  return title ? { title } : null;
}

// src/domain/scenario-timeline/guideline-delivery.ts
var URL_IN_TEXT = /https?:\/\/[^\s]+/gi;
function normalizeGuidelineUrl(url) {
  return url.trim().replace(/[?#].*$/, "").replace(/\/+$/, "").replace(/\/(edit|view|preview)$/i, "");
}
function guidelineDeliveryCandidates(input) {
  const found = [
    ...input.taskTitles.flatMap((title) => title.match(URL_IN_TEXT) ?? []),
    ...input.attachments.filter((a) => a.type === "URL").map((a) => a.path.trim())
  ];
  const seen = /* @__PURE__ */ new Set();
  const urls = [];
  for (const url of found) {
    const key = normalizeGuidelineUrl(url);
    if (seen.has(key)) continue;
    seen.add(key);
    urls.push(url);
  }
  return { urls, hasFiles: input.attachments.some((a) => a.type !== "URL") };
}
function isGuidelineDeliveryCheckpoint(cp) {
  const discriminator = seedCheckpointDiscriminator(TimelineEventType.GUIDELINE_DELIVERED);
  return cp.scenarioId !== null && discriminator !== null && "title" in discriminator && cp.title === discriminator.title;
}

// src/domain/scenario-timeline/index.ts
var TIMELINE_EVENT_TYPE_DISPLAY_LABEL = {
  ADVERTISER_REQUEST: "\uAD11\uACE0\uC8FC \uC694\uCCAD",
  ADVERTISER_FEEDBACK: "\uAD11\uACE0\uC8FC \uD53C\uB4DC\uBC31",
  INTERPRETATION: "\uB0B4\uBD80 \uD574\uC11D",
  NOTE: "\uBA54\uBAA8",
  GUIDELINE_UPLOADED: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC62C\uB9BC",
  GUIDELINE_DRAFT_UPLOADED: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC2DC\uC548 \uC62C\uB9BC",
  GUIDELINE_DRAFT_REJECTED: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC2DC\uC548 \uBC18\uB824",
  GUIDELINE_DELIVERED: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC804\uB2EC",
  REPORT_DELIVERED: "\uACB0\uACFC \uBCF4\uACE0 \uC804\uB2EC",
  CREATOR_RECRUITED: "\uD06C\uB9AC\uC5D0\uC774\uD130 \uC12D\uC678",
  CREATOR_DELIVERED: "\uC81C\uD488 \uBC1C\uC1A1",
  CREATOR_UPLOADED: "\uC601\uC0C1 \uC5C5\uB85C\uB4DC",
  CREATOR_DROPPED: "\uD06C\uB9AC\uC5D0\uC774\uD130 \uC774\uD0C8",
  CREATOR_REPLACEMENT: "\uC7AC\uC12D\uC678 \uD544\uC694",
  QUEST_CREATED: "\uD018\uC2A4\uD2B8 \uC0DD\uC131",
  QUEST_COMPLETED: "\uD018\uC2A4\uD2B8 \uC644\uB8CC",
  QUEST_FAILED: "\uD018\uC2A4\uD2B8 \uC2E4\uD328",
  QUEST_REASSIGNED: "\uB2F4\uB2F9\uC790 \uBCC0\uACBD",
  SCENARIO_ACTIVATED: "\uC2DC\uB098\uB9AC\uC624 \uC2DC\uC791",
  SCENARIO_COMPLETED: "\uC2DC\uB098\uB9AC\uC624 \uC644\uB8CC",
  SCENARIO_FAILED: "\uC2DC\uB098\uB9AC\uC624 \uC2E4\uD328",
  SCENARIO_PROGRESS_OWNER_CHANGED: "\uC9C4\uD589 \uCC45\uC784\uC790 \uBCC0\uACBD"
};
var TimelineAttachmentType = {
  URL: "URL",
  FILE: "FILE"
};
var RESUME_POINT_MAX_LENGTH = 120;
var TYPES_BODY_REQUIRED = /* @__PURE__ */ new Set([
  TimelineEventType.ADVERTISER_REQUEST,
  TimelineEventType.ADVERTISER_FEEDBACK,
  TimelineEventType.INTERPRETATION,
  TimelineEventType.NOTE,
  TimelineEventType.GUIDELINE_DRAFT_REJECTED
]);
var TYPES_QUEST_ID_REQUIRED = /* @__PURE__ */ new Set([
  TimelineEventType.QUEST_CREATED,
  TimelineEventType.QUEST_COMPLETED,
  TimelineEventType.QUEST_FAILED,
  TimelineEventType.QUEST_REASSIGNED
]);
var TYPES_QUEST_ID_FORBIDDEN = /* @__PURE__ */ new Set([
  TimelineEventType.GUIDELINE_UPLOADED,
  TimelineEventType.GUIDELINE_DRAFT_UPLOADED,
  TimelineEventType.GUIDELINE_DRAFT_REJECTED,
  TimelineEventType.GUIDELINE_DELIVERED,
  TimelineEventType.REPORT_DELIVERED,
  TimelineEventType.CREATOR_RECRUITED,
  TimelineEventType.CREATOR_DELIVERED,
  TimelineEventType.CREATOR_UPLOADED,
  // 이탈 이벤트는 scenario-scoped 시스템 자동 생성 — quest 와 무관.
  // Plan 2026-06-01T06-51-07Z-1b130400 §13.5 F-10.
  TimelineEventType.CREATOR_DROPPED,
  // 재섭외 필요 카드도 scenario-scoped — quest 와 무관 (PR1 재작업 A안).
  TimelineEventType.CREATOR_REPLACEMENT,
  TimelineEventType.SCENARIO_ACTIVATED,
  TimelineEventType.SCENARIO_COMPLETED,
  TimelineEventType.SCENARIO_FAILED,
  // 진행 책임자 변경은 scenario-scoped — quest 와 무관 (D1).
  TimelineEventType.SCENARIO_PROGRESS_OWNER_CHANGED
]);
var SYSTEM_TIMELINE_EVENT_TYPES = /* @__PURE__ */ new Set([
  TimelineEventType.QUEST_CREATED,
  TimelineEventType.QUEST_COMPLETED,
  TimelineEventType.QUEST_FAILED,
  TimelineEventType.QUEST_REASSIGNED,
  TimelineEventType.SCENARIO_ACTIVATED,
  TimelineEventType.SCENARIO_COMPLETED,
  TimelineEventType.SCENARIO_FAILED,
  TimelineEventType.SCENARIO_PROGRESS_OWNER_CHANGED
]);
var TYPES_SYSTEM = SYSTEM_TIMELINE_EVENT_TYPES;
function validateTimelineEvent(event) {
  const type = event.type;
  if (!type) throw new Error("ScenarioTimelineEvent.type is required");
  if (!Object.values(TimelineEventType).includes(type)) {
    throw new Error(`Invalid TimelineEventType: ${type}`);
  }
  if (TYPES_BODY_REQUIRED.has(type) && !event.body?.trim()) {
    throw new Error(`TimelineEventType ${type} requires non-empty body`);
  }
  if (TYPES_QUEST_ID_REQUIRED.has(type) && !event.questId) {
    throw new Error(`TimelineEventType ${type} requires questId`);
  }
  if (TYPES_QUEST_ID_FORBIDDEN.has(type) && event.questId) {
    throw new Error(`TimelineEventType ${type} must not have questId`);
  }
  if (TYPES_SYSTEM.has(type) && event.authorId !== null && event.authorId !== void 0) {
    throw new Error(`System TimelineEventType ${type} must have null authorId`);
  }
  if (event.metadata && typeof event.metadata === "object" && "deadline" in event.metadata) {
    const dl = event.metadata.deadline;
    if (dl !== void 0 && (typeof dl !== "string" || Number.isNaN(Date.parse(dl)))) {
      throw new Error(`TimelineEventMetadata.deadline must be ISO 8601 date string when present`);
    }
  }
  if (type === TimelineEventType.GUIDELINE_DRAFT_UPLOADED && !readMetaString(event.metadata, "draftUrl")) {
    throw new Error(`TimelineEventType ${type} requires metadata.draftUrl`);
  }
  if (type === TimelineEventType.GUIDELINE_DRAFT_REJECTED && !readMetaString(event.metadata, "draftEventId")) {
    throw new Error(`TimelineEventType ${type} requires metadata.draftEventId`);
  }
  if (event.metadata && typeof event.metadata === "object" && "resumePoint" in event.metadata) {
    const rp = event.metadata.resumePoint;
    if (rp !== void 0) {
      if (type !== TimelineEventType.NOTE) {
        throw new Error(
          `TimelineEventMetadata.resumePoint is only allowed on ${TimelineEventType.NOTE}`
        );
      }
      if (typeof rp !== "string") {
        throw new Error(`TimelineEventMetadata.resumePoint must be a string`);
      }
      if (rp.length > RESUME_POINT_MAX_LENGTH) {
        throw new Error(
          `TimelineEventMetadata.resumePoint must be ${RESUME_POINT_MAX_LENGTH} characters or fewer`
        );
      }
    }
  }
}
function readMetaString(metadata, key) {
  if (!metadata || typeof metadata !== "object") return void 0;
  const value = metadata[key];
  return typeof value === "string" && value.trim() !== "" ? value : void 0;
}
function deriveGuidelineDrafts(events) {
  const byTime = [...events].sort((a, b) => a.occurredAt.localeCompare(b.occurredAt));
  const drafts = [];
  const index = /* @__PURE__ */ new Map();
  for (const e of byTime) {
    if (e.type !== TimelineEventType.GUIDELINE_DRAFT_UPLOADED) continue;
    const url = readMetaString(e.metadata, "draftUrl");
    if (!url) continue;
    const fileName = readMetaString(e.metadata, "fileName");
    const draft = {
      eventId: e.id,
      version: drafts.length + 1,
      url,
      ...fileName ? { fileName } : {},
      uploadedById: e.authorId,
      uploadedAt: e.occurredAt
    };
    drafts.push(draft);
    index.set(e.id, draft);
  }
  for (const e of byTime) {
    const target = index.get(readMetaString(e.metadata, "draftEventId") ?? "");
    if (!target || target.verdict) continue;
    if (e.type === TimelineEventType.GUIDELINE_DRAFT_REJECTED) {
      target.verdict = {
        kind: "rejected",
        byId: e.authorId,
        at: e.occurredAt,
        reason: e.body ?? ""
      };
    } else if (e.type === TimelineEventType.GUIDELINE_UPLOADED) {
      target.verdict = { kind: "confirmed", byId: e.authorId, at: e.occurredAt };
    }
  }
  return drafts;
}
function readResumePoint(metadata) {
  if (!metadata || typeof metadata !== "object") return void 0;
  const rp = metadata.resumePoint;
  return typeof rp === "string" && rp.length > 0 ? rp : void 0;
}
function validateTimelineAttachment(att) {
  const type = att.type;
  if (!type) throw new Error("ScenarioTimelineEventAttachment.type is required");
  if (!Object.values(TimelineAttachmentType).includes(type)) {
    throw new Error(`Invalid TimelineAttachmentType: ${type}`);
  }
  if (!att.path?.trim()) throw new Error("Attachment path is required");
  if (att.path.length > 2048) {
    throw new Error("Attachment path exceeds max length 2048");
  }
  if (type === TimelineAttachmentType.FILE) {
    if (!att.fileName?.trim()) throw new Error("FILE attachment requires fileName");
    if (att.fileSize === void 0 || att.fileSize === null) {
      throw new Error("FILE attachment requires fileSize");
    }
    if (!att.mimeType?.trim()) throw new Error("FILE attachment requires mimeType");
  }
}
var SPAWNABLE_TYPES = /* @__PURE__ */ new Set([
  TimelineEventType.ADVERTISER_REQUEST,
  TimelineEventType.ADVERTISER_FEEDBACK,
  TimelineEventType.INTERPRETATION,
  TimelineEventType.NOTE,
  TimelineEventType.GUIDELINE_UPLOADED,
  TimelineEventType.GUIDELINE_DELIVERED,
  TimelineEventType.REPORT_DELIVERED,
  TimelineEventType.CREATOR_RECRUITED,
  TimelineEventType.CREATOR_DELIVERED,
  TimelineEventType.CREATOR_UPLOADED,
  // 재섭외 → 재섭외 퀘스트 spawn (재섭외 필요=예 일 때만 생성되는 카드).
  // PR1 재작업 A안.
  TimelineEventType.CREATOR_REPLACEMENT
]);
var TIMELINE_EVENT_TYPE_LABEL = {
  [TimelineEventType.ADVERTISER_REQUEST]: "\uAD11\uACE0\uC8FC \uC694\uCCAD",
  [TimelineEventType.ADVERTISER_FEEDBACK]: "\uAD11\uACE0\uC8FC \uD53C\uB4DC\uBC31",
  [TimelineEventType.INTERPRETATION]: "\uD574\uC11D \uBC18\uC601",
  [TimelineEventType.NOTE]: "\uBA54\uBAA8",
  [TimelineEventType.GUIDELINE_UPLOADED]: "\uAC00\uC774\uB4DC\uB77C\uC778",
  [TimelineEventType.GUIDELINE_DRAFT_UPLOADED]: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC2DC\uC548",
  [TimelineEventType.GUIDELINE_DRAFT_REJECTED]: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC2DC\uC548 \uBC18\uB824",
  [TimelineEventType.GUIDELINE_DELIVERED]: "\uAC00\uC774\uB4DC\uB77C\uC778 \uC804\uB2EC",
  [TimelineEventType.REPORT_DELIVERED]: "\uACB0\uACFC \uBCF4\uACE0",
  [TimelineEventType.CREATOR_RECRUITED]: "\uC12D\uC678",
  [TimelineEventType.CREATOR_DELIVERED]: "\uC218\uAE09",
  [TimelineEventType.CREATOR_UPLOADED]: "\uC5C5\uB85C\uB4DC",
  // CREATOR_DROPPED 라벨은 표시용으로 유지 (spawn 불가지만 카드 라벨에 사용).
  [TimelineEventType.CREATOR_DROPPED]: "\uC774\uD0C8",
  [TimelineEventType.CREATOR_REPLACEMENT]: "\uC7AC\uC12D\uC678",
  [TimelineEventType.QUEST_CREATED]: "\uD018\uC2A4\uD2B8 \uC0DD\uC131",
  [TimelineEventType.QUEST_COMPLETED]: "\uD018\uC2A4\uD2B8 \uC644\uB8CC",
  [TimelineEventType.QUEST_FAILED]: "\uD018\uC2A4\uD2B8 \uC2E4\uD328",
  [TimelineEventType.QUEST_REASSIGNED]: "\uD018\uC2A4\uD2B8 \uC7AC\uBC30\uC815",
  [TimelineEventType.SCENARIO_ACTIVATED]: "\uC2DC\uB098\uB9AC\uC624 \uC2DC\uC791",
  [TimelineEventType.SCENARIO_COMPLETED]: "\uC2DC\uB098\uB9AC\uC624 \uC644\uB8CC",
  [TimelineEventType.SCENARIO_FAILED]: "\uC2DC\uB098\uB9AC\uC624 \uC2E4\uD328",
  [TimelineEventType.SCENARIO_PROGRESS_OWNER_CHANGED]: "\uC9C4\uD589 \uCC45\uC784\uC790 \uBCC0\uACBD"
};
var QUEST_DRAFT_TITLE_MAX = 60;
var FUNNEL_CP_DEFAULT_TARGET = 1;
var NOTE_CP_DESCRIPTION = /* @__PURE__ */ new Map([
  [
    "\uAC00\uC774\uB4DC\uB77C\uC778 \uD611\uC758",
    "\uAD11\uACE0\uC8FC\uC640 \uAC00\uC774\uB4DC\uB77C\uC778 \uB0B4\uC6A9\uC744 \uD569\uC758\uD588\uB294\uC9C0 \uCE74\uD1A1 \uB610\uB294 \uAD11\uACE0\uC8FC\uC640 \uD611\uC758\uD55C \uB9E4\uCCB4\uC758 \uAE30\uB85D\uC73C\uB85C \uD655\uC778\uD55C\uB2E4."
  ],
  ["\uACB0\uACFC \uBCF4\uACE0", "\uACB0\uACFC \uBCF4\uACE0\uC11C \uD30C\uC77C \uB610\uB294 \uB9C1\uD06C\uB85C \uD655\uC778\uD55C\uB2E4."]
]);
function questDraftFirstLine(text2) {
  return text2.split("\n", 1)[0]?.trim() ?? "";
}
function questDraftTruncate(text2, max) {
  return text2.length > max ? text2.slice(0, max - 1).trimEnd() + "\u2026" : text2;
}
function deriveQuestDraftFromEvent(event, options) {
  const { type, body, metadata } = event;
  if (!SPAWNABLE_TYPES.has(type)) {
    throw new Error(`TimelineEventType ${type} is not spawnable into a quest draft`);
  }
  const label = TIMELINE_EVENT_TYPE_LABEL[type] ?? type;
  const bodyText = body?.trim() ?? "";
  const bodyHead = questDraftFirstLine(bodyText);
  const dropReplacementNeeded = type === TimelineEventType.CREATOR_REPLACEMENT ? resolveDropReplacementNeeded(options?.replacementNeeded, metadata) : null;
  const title = dropReplacementNeeded !== null ? `[\uC7AC\uC12D\uC678] \uD06C\uB9AC\uC5D0\uC774\uD130 ${dropReplacementNeeded}\uBA85 \uC7AC\uC12D\uC678` : bodyHead ? questDraftTruncate(`[${label}] ${bodyHead}`, QUEST_DRAFT_TITLE_MAX) : `${label} \uD6C4\uC18D \uC791\uC5C5`;
  const descriptionParts = [];
  if (bodyText) descriptionParts.push(bodyText);
  if (type === TimelineEventType.GUIDELINE_UPLOADED && metadata && typeof metadata === "object") {
    const guidelineUrl = "guidelineUrl" in metadata ? String(metadata.guidelineUrl) : "";
    if (guidelineUrl) descriptionParts.push(`\uCC38\uC870 \uAC00\uC774\uB4DC\uB77C\uC778: ${guidelineUrl}`);
  }
  const checkpoints = deriveFunnelCheckpoints(event, dropReplacementNeeded);
  const deadline = metadata && typeof metadata === "object" && "deadline" in metadata ? (() => {
    const dl = metadata.deadline;
    return typeof dl === "string" && dl.length > 0 ? dl : void 0;
  })() : void 0;
  return {
    title,
    description: descriptionParts.join("\n\n"),
    ...checkpoints ? { checkpoints } : {},
    ...deadline ? { deadline } : {}
  };
}
function resolveDropReplacementNeeded(replacementNeeded, metadata) {
  if (replacementNeeded !== void 0) {
    return Number.isFinite(replacementNeeded) && replacementNeeded > 0 ? Math.floor(replacementNeeded) : null;
  }
  return readMetadataCumulativeReplacementNeeded(metadata);
}
function readMetadataCumulativeReplacementNeeded(metadata) {
  if (!metadata || typeof metadata !== "object" || !("cumulativeReplacementNeeded" in metadata)) {
    return null;
  }
  const raw = Number(
    metadata.cumulativeReplacementNeeded
  );
  if (!Number.isFinite(raw) || raw <= 0) return null;
  return Math.floor(raw);
}
function deriveFunnelCheckpoints(event, dropReplacementNeeded) {
  const { type, body, metadata } = event;
  if (type === TimelineEventType.CREATOR_REPLACEMENT) {
    if (dropReplacementNeeded === null) return void 0;
    return [
      {
        title: "\uC7AC\uC12D\uC678 \uC778\uC6D0",
        checkpointType: "numeric",
        targetValue: dropReplacementNeeded,
        metricKey: "RECRUITED_COUNT"
      }
    ];
  }
  const template = FUNNEL_CP_TEMPLATE[type];
  if (!template) {
    const completionTitle = NON_FUNNEL_CP_TITLE[type];
    const description = type === TimelineEventType.NOTE ? NOTE_CP_DESCRIPTION.get(questDraftFirstLine(body ?? "")) : type === TimelineEventType.GUIDELINE_DELIVERED ? "\uD655\uC815\uB41C \uD06C\uB9AC\uC5D0\uC774\uD130 \uC804\uC6D0\uC5D0\uAC8C \uAC00\uC774\uB4DC\uB77C\uC778\uC744 \uC804\uB2EC\uD588\uB294\uC9C0 \uCE74\uD1A1 \uB610\uB294 \uD611\uC758 \uB9E4\uCCB4\uC758 \uAE30\uB85D\uC73C\uB85C \uD655\uC778\uD55C\uB2E4." : void 0;
    return completionTitle ? [
      {
        title: completionTitle,
        checkpointType: "completion",
        ...description ? { description } : {}
      }
    ] : void 0;
  }
  const creatorCount = metadata && typeof metadata === "object" && "creatorCount" in metadata ? Number(metadata.creatorCount) : NaN;
  const creatorTarget = Number.isFinite(creatorCount) && creatorCount > 0 ? creatorCount : FUNNEL_CP_DEFAULT_TARGET;
  const contractSlotCount = metadata && typeof metadata === "object" && "contractSlotCount" in metadata ? metadata.contractSlotCount : void 0;
  const targetValue = type === TimelineEventType.CREATOR_UPLOADED && typeof contractSlotCount === "number" && Number.isFinite(contractSlotCount) && contractSlotCount > 0 ? contractSlotCount : creatorTarget;
  return [
    {
      title: template.title,
      description: template.description,
      checkpointType: "numeric",
      targetValue,
      metricKey: template.metricKey
    }
  ];
}

// src/domain/campaign/target-slot-conditions.ts
import { z as z9 } from "zod";
var country = z9.string().regex(/^[A-Z]{2}$/);
var date = z9.iso.date();
var text = z9.string().trim().min(1).max(120);
var requirementFields = {
  countryCodes: z9.array(country).min(1).max(250).nullable(),
  productIds: z9.array(z9.uuid()).min(1).max(100).nullable(),
  contentFormats: z9.array(text).min(1).max(20).nullable(),
  uploadDeadline: date.nullable(),
  minFollowers: z9.number().int().min(0).max(2147483647).nullable()
};
var targetSlotRequirementsSchema = z9.object(requirementFields).strict();
var targetSlotOverridesSchema = targetSlotRequirementsSchema.partial();
var targetSlotParticipantConditionsSchema = z9.object({
  countryCode: country.nullable(),
  productId: z9.uuid().nullable(),
  contentFormat: text.nullable(),
  uploadDeadline: date.nullable(),
  followers: z9.number().int().min(0).max(2147483647).nullable()
}).strict();
function resolveTargetSlotRequirements(common, overrides) {
  return {
    ...common,
    ...Object.fromEntries(
      Object.entries(overrides ?? {}).filter(([, value]) => value !== void 0)
    )
  };
}
function evaluateTargetSlotConditions(required, actual) {
  const issues = [];
  const check = (field, label, value, matches) => {
    if (required[field] === null) return;
    if (value === null)
      issues.push({
        code: "EVIDENCE_MISSING",
        field,
        message: `${label}\uC744 \uD655\uC778\uD560 \uC790\uB8CC\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.`
      });
    else if (!matches)
      issues.push({
        code: "CONDITION_MISMATCH",
        field,
        message: `${label}\uC774 \uC57D\uC18D\uD55C \uC870\uAC74\uACFC \uB9DE\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.`
      });
  };
  check(
    "countryCodes",
    "\uAD6D\uAC00 \uC870\uAC74",
    actual.countryCode,
    required.countryCodes?.includes(actual.countryCode ?? "") ?? true
  );
  check(
    "productIds",
    "\uC81C\uD488 \uC870\uAC74",
    actual.productId,
    required.productIds?.includes(actual.productId ?? "") ?? true
  );
  check(
    "contentFormats",
    "\uC601\uC0C1 \uD615\uC2DD",
    actual.contentFormat,
    required.contentFormats?.some(
      (value) => value.toLocaleLowerCase() === actual.contentFormat?.toLocaleLowerCase()
    ) ?? true
  );
  check(
    "uploadDeadline",
    "\uC57D\uC18D\uD55C \uC5C5\uB85C\uB4DC \uAE30\uD55C",
    actual.uploadDeadline,
    required.uploadDeadline === null || actual.uploadDeadline !== null && actual.uploadDeadline <= required.uploadDeadline
  );
  check(
    "minFollowers",
    "\uD314\uB85C\uC6CC \uC218",
    actual.followers,
    required.minFollowers === null || actual.followers !== null && actual.followers >= required.minFollowers
  );
  return issues;
}

// src/domain/campaign/campaign-timeline.ts
var CampaignTimelineMilestone = {
  CAMPAIGN_PERIOD: "CAMPAIGN_PERIOD",
  REPORT: "REPORT"
};
var CAMPAIGN_TIMELINE_MILESTONE_LABEL = {
  CAMPAIGN_PERIOD: "\uCEA0\uD398\uC778 \uAE30\uAC04",
  REPORT: "\uACB0\uACFC \uBCF4\uACE0\uC11C"
};
var CAMPAIGN_TIMELINE_MAX_ENTRIES = 30;
var CAMPAIGN_TIMELINE_LABEL_MAX = 200;
function defaultCampaignTimeline(input) {
  const row = (label, milestone = null) => ({ label, startsOn: null, endsOn: null, milestone });
  return [
    row("\uD06C\uB9AC\uC5D0\uC774\uD130 \uC12D\uC678 \uBC0F \uC8FC\uC18C\uC9C0 \uC804\uB2EC"),
    row("\uAC00\uC774\uB4DC\uB77C\uC778 \uD611\uC758 \uBC0F \uD655\uC815"),
    row("\uCD9C\uACE0 \uBC0F \uC6B4\uC1A1\uC7A5 \uBC88\uD638 \uC804\uB2EC"),
    row("\uD06C\uB9AC\uC5D0\uC774\uD130 \uC601\uC0C1 \uC81C\uC791"),
    {
      ...row("\uCEA0\uD398\uC778 \uAE30\uAC04 (\uC601\uC0C1 \uC5C5\uB85C\uB4DC)", CampaignTimelineMilestone.CAMPAIGN_PERIOD),
      startsOn: input.startsOn,
      endsOn: input.startsOn ? campaignPeriodEnd(input.startsOn, input.endsOn) : null
    },
    row("\uACB0\uACFC \uBCF4\uACE0\uC11C \uC804\uB2EC", CampaignTimelineMilestone.REPORT)
  ];
}
function campaignPeriodEnd(startsOn, endsOn) {
  return endsOn && endsOn >= startsOn ? endsOn : null;
}
function campaignPeriod(entries) {
  const row = entries.find(
    (entry) => entry.milestone === CampaignTimelineMilestone.CAMPAIGN_PERIOD
  );
  return row ? { startsOn: row.startsOn, endsOn: row.endsOn } : null;
}
function alignCampaignPeriod(entries, scenario) {
  const endsOn = campaignPeriodEnd(scenario.startsOn, scenario.endsOn);
  return entries.map(
    (row) => row.milestone !== CampaignTimelineMilestone.CAMPAIGN_PERIOD || row.startsOn === scenario.startsOn && row.endsOn === endsOn ? row : { ...row, startsOn: scenario.startsOn, endsOn }
  );
}
function kstDateToInstant(date2) {
  return /* @__PURE__ */ new Date(`${date2}T00:00:00+09:00`);
}
function validateCampaignTimeline(entries) {
  for (const [index, entry] of entries.entries()) {
    const at = `${index + 1}\uBC88\uC9F8 \uD589`;
    if (!entry.label.trim()) return `${at}: \uB0B4\uC6A9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.`;
    if (entry.endsOn && !entry.startsOn) return `${at}: \uAE30\uAC04\uC758 \uC2DC\uC791 \uB0A0\uC9DC\uB97C \uBA3C\uC800 \uC785\uB825\uD574 \uC8FC\uC138\uC694.`;
    if (entry.startsOn && entry.endsOn && entry.endsOn < entry.startsOn)
      return `${at}: \uAE30\uAC04\uC758 \uB05D \uB0A0\uC9DC\uAC00 \uC2DC\uC791 \uB0A0\uC9DC\uBCF4\uB2E4 \uC55E\uC12D\uB2C8\uB2E4.`;
  }
  for (const milestone of Object.values(CampaignTimelineMilestone)) {
    if (entries.filter((entry) => entry.milestone === milestone).length > 1)
      return `\u300C${CAMPAIGN_TIMELINE_MILESTONE_LABEL[milestone]}\u300D \uD45C\uC2DC\uB294 \uD55C \uD589\uC5D0\uB9CC \uBD99\uC77C \uC218 \uC788\uC2B5\uB2C8\uB2E4.`;
  }
  if (!campaignPeriod(entries)?.startsOn) return "\u300C\uCEA0\uD398\uC778 \uAE30\uAC04\u300D \uD589\uC758 \uC2DC\uC791 \uB0A0\uC9DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
  return null;
}

// src/domain/reply-template/model.ts
var REPLY_TEMPLATE_LAYERS = ["TEAM", "CAMPAIGN", "PERSONAL"];
var REPLY_TEMPLATE_STAGES = ["RECRUIT", "PRODUCTION"];
var REPLY_TEMPLATE_KINDS = ["FIRST_CONTACT", "REPLY"];

// src/domain/reply-template/variables.ts
var REPLY_TEMPLATE_VARIABLE_KEYS = ["\uC81C\uD488\uBA85", "\uCD08\uC548\uC77C", "\uC5C5\uB85C\uB4DC\uC77C", "\uAE08\uC561"];
var VARIABLE_PATTERN = /\{([^{}]*)\}/g;
var isAllowed = (name) => REPLY_TEMPLATE_VARIABLE_KEYS.includes(name);
var isFilled = (value) => value !== void 0 && value.trim() !== "";
function findUnknownTemplateVariables(body) {
  const unknown = [];
  for (const match of body.matchAll(VARIABLE_PATTERN)) {
    const name = match[1] ?? "";
    if (!isAllowed(name) && !unknown.includes(name)) unknown.push(name);
  }
  return unknown;
}
function renderReplyTemplate(body, values, required) {
  const missing = required.filter((key) => !isFilled(values[key]));
  if (missing.length > 0) return { status: "MISSING_REQUIRED", missing };
  const text2 = body.replace(VARIABLE_PATTERN, (match, name) => {
    if (!isAllowed(name)) return match;
    const value = values[name];
    return isFilled(value) ? value : "";
  });
  return { status: "OK", text: text2 };
}

// src/domain/outreach-draft/image-crop.ts
var CROP_ASPECT_PRESETS = ["16:9", "4:3", "1:1", "4:5"];
var FREE_CROP_MIN_RATIO = 4 / 5;
var FREE_CROP_MAX_RATIO = 2;
var ASPECT_RATIO_PATTERN = /^\d{1,3}:\d{1,3}$/;
function parseAspectRatio(value) {
  if (!ASPECT_RATIO_PATTERN.test(value)) return null;
  const [rawWidth, rawHeight] = value.split(":");
  const height = Number(rawHeight);
  if (height === 0) return null;
  return Number(rawWidth) / height;
}
function isAllowedCropAspectRatio(value) {
  const ratio = parseAspectRatio(value);
  if (ratio === null) return false;
  return ratio >= FREE_CROP_MIN_RATIO && ratio <= FREE_CROP_MAX_RATIO;
}
function applyCropEdit(image, edit) {
  if (!isAllowedCropAspectRatio(edit.aspectRatio)) {
    throw new Error(`\uCD9C\uB825 \uBE44\uC728\uC740 2:1 \uC5D0\uC11C 4:5 \uC0AC\uC774\uB9CC \uB429\uB2C8\uB2E4: ${edit.aspectRatio}`);
  }
  if (!(edit.zoom > 0)) {
    throw new Error(`\uBC30\uC728\uC740 0 \uBCF4\uB2E4 \uCEE4\uC57C \uD569\uB2C8\uB2E4: ${edit.zoom}`);
  }
  return {
    assetPath: image.assetPath,
    altText: image.altText,
    crop: { x: edit.x, y: edit.y, zoom: edit.zoom, aspectRatio: edit.aspectRatio }
  };
}

// src/domain/outreach-draft/schedule-format.ts
var OUTREACH_DATE_FORMATS = ["ISO", "MONTH_DAY_YEAR", "DAY_MONTH_YEAR"];
var DEFAULT_OUTREACH_DATE_FORMAT = "ISO";
var MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
function formatOutreachDate(value, format3) {
  if (format3 === "ISO") return value;
  const match = ISO_DATE_PATTERN.exec(value);
  if (match === null) return value;
  const month = Number(match[2]);
  const monthName = MONTH_NAMES[month - 1];
  if (monthName === void 0) return value;
  const day = Number(match[3]);
  if (!(day >= 1 && day <= 31)) return value;
  const year = match[1];
  return format3 === "MONTH_DAY_YEAR" ? `${monthName} ${day}, ${year}` : `${day} ${monthName} ${year}`;
}

// src/domain/campaign/approved-original.ts
var ApprovedOriginalSource = {
  /** AXIOM 검수 회차에서 승인된 파일. */
  REVIEW_APPROVED: "REVIEW_APPROVED",
  /** 국내 카카오톡 등 AXIOM 밖에서 승인된 최종본을 담당자가 올린 것. */
  OFFLINE_APPROVED: "OFFLINE_APPROVED",
  /** 원본이 없을 때 크리에이터에게 다시 받은 파일. */
  CREATOR_RESEND: "CREATOR_RESEND"
};
var ApprovedOriginalState = {
  ACTIVE: "ACTIVE",
  INTEGRITY_SUSPECT: "INTEGRITY_SUSPECT",
  MISSING: "MISSING"
};
var ApprovedOriginalReceivedVia = {
  EMAIL: "EMAIL",
  KAKAO: "KAKAO",
  OTHER: "OTHER"
};
var ApprovedOriginalFileOrigin = {
  ORIGINAL_FILE: "ORIGINAL_FILE",
  PLATFORM_OWNER_DOWNLOAD: "PLATFORM_OWNER_DOWNLOAD"
};
function selectApprovedOriginalFile(files, originalFileId) {
  if (originalFileId) {
    const picked = files.find((file) => file.id === originalFileId);
    if (!picked) return { kind: "ERROR", code: "ORIGINAL_FILE_NOT_IN_REVISION" };
    if (picked.state !== "READY") return { kind: "ERROR", code: "ORIGINAL_FILE_NOT_READY" };
    return { kind: "SELECTED", fileId: picked.id };
  }
  const [only, ...others] = files.filter((file) => file.state === "READY");
  if (!only) return { kind: "NONE" };
  if (others.length > 0) return { kind: "ERROR", code: "ORIGINAL_FILE_REQUIRED" };
  return { kind: "SELECTED", fileId: only.id };
}
function planApprovedOriginalWrite(existing, incoming) {
  const sameFile = existing.find((row) => row.driveFileId === incoming.driveFileId);
  if (sameFile) {
    return sameFile.rosterEntryId === incoming.rosterEntryId ? { kind: "EXISTING", originalId: sameFile.id } : { kind: "CONFLICT", code: "DRIVE_FILE_ATTACHED_TO_OTHER_SLOT" };
  }
  const slot = existing.filter((row) => row.rosterEntryId === incoming.rosterEntryId);
  const version = slot.reduce((max, row) => Math.max(max, row.version), 0) + 1;
  const active = slot.find((row) => row.supersededAt === null);
  return { kind: "CREATE", version, supersedeId: active?.id ?? null };
}
function assessOriginalIntegrity(stored, drive) {
  if (!drive.found || drive.trashed) return ApprovedOriginalState.MISSING;
  const matches = drive.md5Checksum === stored.md5Checksum && drive.sizeBytes === stored.sizeBytes && drive.mimeType === stored.mimeType && (stored.sha256Checksum === null || drive.sha256Checksum === stored.sha256Checksum) && (stored.headRevisionId === null || drive.headRevisionId === stored.headRevisionId);
  return matches ? ApprovedOriginalState.ACTIVE : ApprovedOriginalState.INTEGRITY_SUSPECT;
}
function reviewFileIntegrityAction(input) {
  return input.isApprovedOriginal ? "MARK_ORIGINAL_SUSPECT" : "TRASH";
}
var RECEIVED_VIA_LABEL = {
  EMAIL: "\uC774\uBA54\uC77C",
  KAKAO: "\uCE74\uCE74\uC624\uD1A1",
  OTHER: "\uAE30\uD0C0 \uACBD\uB85C"
};
function validateOriginalProvenance(input) {
  if (input.source === ApprovedOriginalSource.REVIEW_APPROVED) {
    if (!input.reviewFileId) return "REVIEW_FILE_REQUIRED";
    if (input.provenance) return "PROVENANCE_NOT_ALLOWED";
    return null;
  }
  if (input.reviewFileId) return "REVIEW_FILE_NOT_ALLOWED";
  if (!input.provenance) return "PROVENANCE_REQUIRED";
  return null;
}
function approvedOriginalSourceLabel(input) {
  if (input.source === ApprovedOriginalSource.REVIEW_APPROVED) return "\uAC80\uC218 \uC2B9\uC778\uBCF8";
  const via = input.provenance ? RECEIVED_VIA_LABEL[input.provenance.receivedVia] : null;
  if (input.source === ApprovedOriginalSource.OFFLINE_APPROVED) {
    return via ? `\uC678\uBD80 \uC2B9\uC778\uBCF8 (${via})` : "\uC678\uBD80 \uC2B9\uC778\uBCF8";
  }
  const origin = input.provenance?.fileOrigin === ApprovedOriginalFileOrigin.PLATFORM_OWNER_DOWNLOAD ? "\uD50C\uB7AB\uD3FC\uC5D0\uC11C \uBC1B\uC740 \uD30C\uC77C" : "\uC6D0\uBCF8 \uD30C\uC77C";
  return `\uD06C\uB9AC\uC5D0\uC774\uD130 \uC7AC\uC804\uC1A1 \u2014 ${origin}`;
}
function classifyOriginalRecovery(input) {
  if (input.activeOriginalState === ApprovedOriginalState.ACTIVE) return "COVERED";
  if (!input.videoUrl && input.activeOriginalState === null) return "NOT_POSTED";
  return input.postAccess === "GONE" ? "UNRECOVERABLE_RESEND_ONLY" : "REQUEST_RESEND";
}
var CREATOR_RESEND_CLOSED_MESSAGE = "\uAC8C\uC2DC\uBB3C\uC774 \uBE44\uACF5\uAC1C\uB85C \uD655\uC778\uB418\uC5B4 \uD06C\uB9AC\uC5D0\uC774\uD130 \uC7AC\uC804\uC1A1\uC744 \uC62C\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uAC8C\uC2DC\uBB3C\uC774 \uB2E4\uC2DC \uACF5\uAC1C\uB41C \uB4A4 \uC62C\uB824 \uC8FC\uC138\uC694.";
function isCreatorResendOpen(postAccess) {
  return postAccess !== "RESTRICTED";
}

// src/domain/wiki/model.ts
var WIKI_DOCUMENT_KINDS = ["FEATURE", "TERM", "EVENT"];
var WIKI_HOME_TITLE = "\uB300\uBB38";
var WIKI_AREAS = [
  "ONTOLOGY",
  "PAGE",
  "QUEST",
  "ATTENDANCE",
  "CAMPAIGN",
  "SETTLEMENT",
  "TEAM",
  "PHILOSOPHY",
  "AI_DATA",
  "BUSINESS",
  "PRODUCT",
  "CONTENT",
  "LOGISTICS",
  "REGION",
  "GENERAL"
];
var WIKI_AREA_LABELS = {
  ONTOLOGY: "\uC628\uD1A8\uB85C\uC9C0",
  PAGE: "\uD398\uC774\uC9C0",
  QUEST: "\uD018\uC2A4\uD2B8",
  ATTENDANCE: "\uADFC\uD0DC",
  CAMPAIGN: "\uCEA0\uD398\uC778 \xB7 \uC12D\uC678",
  SETTLEMENT: "\uC815\uC0B0 \xB7 \uD3EC\uC778\uD2B8",
  TEAM: "\uD300 \uC6B4\uC601",
  PHILOSOPHY: "\uC0AC\uACE0 \xB7 \uCCA0\uD559",
  AI_DATA: "AI \xB7 \uB370\uC774\uD130",
  BUSINESS: "\uACBD\uC81C \xB7 \uACBD\uC601",
  PRODUCT: "\uC81C\uD488 \xB7 \uC0C1\uD488",
  CONTENT: "\uCF58\uD150\uCE20 \uC81C\uC791",
  LOGISTICS: "\uBB3C\uB958 \xB7 \uBB34\uC5ED",
  REGION: "\uAD6D\uAC00 \xB7 \uC9C0\uC5ED",
  GENERAL: "\uC77C\uBC18"
};
var WIKI_SYSTEM_AREA_KEYS = ["PAGE", "ONTOLOGY", "GENERAL"];
var WIKI_AREA_SEEDS = WIKI_AREAS.map((key, sortOrder) => ({
  key,
  label: WIKI_AREA_LABELS[key],
  sortOrder,
  isSystem: WIKI_SYSTEM_AREA_KEYS.includes(key)
}));
var WIKI_PAGE_TITLE_PREFIX = "\uD398\uC774\uC9C0/";
var isWikiPageTitle = (title) => title.startsWith(WIKI_PAGE_TITLE_PREFIX);
function resolveWikiArea(title, area) {
  if (isWikiPageTitle(title)) return "PAGE";
  return area ?? null;
}
function deriveWikiKind(area, occurredOn) {
  if (area === "PAGE") return "FEATURE";
  if (occurredOn) return "EVENT";
  return "TERM";
}
var WIKI_REVISION_KINDS = ["EDIT", "REVERT", "DELETE", "RESTORE", "RENAME"];
var WIKI_ERROR_CODES = {
  /** 편집을 시작한 판 뒤로 누가 먼저 저장했다. 추가 칸: currentRevision · updatedByName */
  STALE_REVISION: "WIKI_STALE_REVISION",
  /** 같은 제목의 문서가 있다(지운 문서 포함). 추가 칸: documentId · deleted */
  TITLE_TAKEN: "WIKI_TITLE_TAKEN",
  /** 제목이 재직 중인 사람 이름과 같다. */
  TITLE_IS_PERSON: "WIKI_TITLE_IS_PERSON",
  /** 지운 문서에는 토론을 새로 열거나 댓글을 달 수 없다. 읽기는 된다. */
  DOCUMENT_DELETED: "WIKI_DOCUMENT_DELETED"
};
var WIKI_DISCUSSION_STATUSES = ["OPEN", "RESOLVED"];

// src/domain/wiki/links.ts
function normalizeWikiTitle(raw) {
  return raw.normalize("NFC").replace(/\s+/g, " ").trim();
}
var LINK = /\[\[([^[\]|#\n]*)(?:#([^[\]|\n]*))?(?:\|([^[\]\n]*))?\]\]/g;
var FENCE = /^ {0,3}(`{3,}|~{3,})/;
function blankCode(body) {
  const lines = body.split("\n");
  let fence = null;
  const out = lines.map((line) => {
    const match = FENCE.exec(line);
    if (fence !== null) {
      if (match && match[1][0] === fence[0] && match[1].length >= fence.length) fence = null;
      return " ".repeat(line.length);
    }
    if (match) {
      fence = match[1];
      return " ".repeat(line.length);
    }
    return line.replace(/(`+)[^`]*?\1/g, (code) => " ".repeat(code.length));
  });
  return out.join("\n");
}
function parseWikiLinks(body) {
  const text2 = blankCode(body.normalize("NFC"));
  const links = [];
  for (const match of text2.matchAll(LINK)) {
    const start = match.index;
    if (start > 0 && text2[start - 1] === "\\") continue;
    const title = normalizeWikiTitle(match[1] ?? "");
    if (title === "") continue;
    const anchor = match[2] === void 0 ? null : normalizeWikiTitle(match[2]) || null;
    const label = match[3] === void 0 ? null : match[3].trim() || null;
    links.push({ title, anchor, label, start, end: start + match[0].length });
  }
  return links;
}
var REDIRECT = /^#넘겨주기\s*\[\[([^[\]|#\n]*)(?:#[^[\]|\n]*)?\]\]$/;
function parseWikiRedirect(body) {
  const first = body.normalize("NFC").trim().split("\n")[0]?.trim() ?? "";
  const match = REDIRECT.exec(first);
  if (!match) return null;
  return normalizeWikiTitle(match[1] ?? "") || null;
}
function wikiParentTitle(title) {
  const cut = title.lastIndexOf("/");
  if (cut <= 0 || cut === title.length - 1) return null;
  return title.slice(0, cut);
}
function uniqueWikiLinkTargets(links) {
  const seen = /* @__PURE__ */ new Set();
  const targets = [];
  for (const { title, anchor } of links) {
    const key = `${title}\0${anchor ?? ""}`;
    if (seen.has(key)) continue;
    seen.add(key);
    targets.push({ title, anchor });
  }
  return targets;
}

export {
  ISO_COUNTRIES,
  ISO_COUNTRY_BY_CODE,
  isValidIsoCountry,
  getIsoCountryNameKo,
  formatIsoCountryDisplay,
  USERNAME_MIN_LENGTH,
  USERNAME_MAX_LENGTH,
  USERNAME_PATTERN,
  PASSWORD_MIN_LENGTH,
  PASSWORD_PATTERN,
  LEGAL_NAME_MIN_LENGTH,
  LEGAL_NAME_MAX_LENGTH,
  CREVASSE_EMAIL_DOMAIN,
  MESSAGE_CONTENT_MAX_LENGTH,
  PROOF_DESCRIPTION_MAX_LENGTH,
  POINTS_MIN,
  REWARD_POINTS_MIN,
  CHECKPOINT_ORDER_MIN,
  UsernameSchema,
  PasswordSchema,
  LegalNameSchema,
  EmailSchema,
  CrevasseEmailSchema,
  MessageContentSchema,
  PointsSchema,
  RewardPointsSchema,
  CheckpointOrderSchema,
  IsoCountryCodeSchema,
  IsoCountryCodeArraySchema,
  isValidDateOnly,
  ISO8601_PATTERN,
  Iso8601Schema,
  assertStatus,
  kstDate,
  toKstParts,
  toKstDateString,
  getKstDateString,
  getKstMonthDay,
  getKstDateAfterDays,
  toKstTimeMinutes,
  getKstDayRange,
  WORK_DAY_CUTOFF_HOUR,
  toKstWorkDateString,
  getKstWorkDayRange,
  getKstWorkDayLastInstant,
  kstStartOfDay,
  getKstWeekStart,
  getKstMonthStart,
  getKstMonthRange,
  getKstPeriod,
  previousKstPeriod,
  nextKstPeriod,
  formatKstDateTime,
  formatKstTime,
  countWeekdays,
  formatDuration,
  toUtcDateString,
  COMMON_ERROR_CODES,
  AUTH_ERROR_CODES,
  QUEST_ERROR_CODES,
  BUDGET_LEDGER_ERROR_CODES,
  CHECKPOINT_ERROR_CODES,
  QUEST_TASK_ERROR_CODES,
  PROOF_ERROR_CODES,
  TEAM_ERROR_CODES,
  CLUB_ERROR_CODES,
  SCENARIO_ERROR_CODES,
  ATTENDANCE_ERROR_CODES,
  LEAVE_ERROR_CODES,
  WORKLOG_ERROR_CODES,
  POINT_ERROR_CODES,
  USER_ERROR_CODES,
  RANK_ERROR_CODES,
  CHAT_ERROR_CODES,
  ASSISTANT_ERROR_CODES,
  SETTINGS_ERROR_CODES,
  UPLOAD_ERROR_CODES,
  AGENT_ERROR_CODES,
  QUEST_TEMPLATE_ERROR_CODES,
  PROPOSAL_ERROR_CODES,
  Brand,
  DEFAULT_PAGE_LIMIT,
  buildCursorResponse,
  UNPAGINATED_LIST_CAP,
  fetchAllCursorPages,
  DEFAULT_FEATURE_FLAGS,
  DEV_VISIBLE_HIDDEN_FLAGS,
  featureFlags,
  resetFeatureFlags,
  applyFeatureFlagOverrides,
  getViewState,
  NOTIFICATION_FEATURE_MAP,
  isFeatureActive,
  isNotificationAllowed,
  matchHangul,
  QuestStatus,
  QuestApprovalStatus,
  QuestScope,
  QuestTargetType,
  QuestAcceptanceStatus,
  createQuest,
  submitForApproval,
  approveQuest,
  rejectQuest,
  completeQuest,
  failQuest,
  withdrawQuest,
  archiveQuest,
  deleteQuest,
  isSealedWorldQuestKind,
  revokeWorldQuest,
  validateCheckpointRewardTotal,
  validateCheckpointRewardBalanced,
  triggerOutbreak,
  computeWorldQuestLane,
  isQuestExpired,
  classifyExpiredAttribution,
  isQuestAcceptanceBlockedByCheckpoints,
  getQuestAcceptanceBlockedReason,
  acceptQuest,
  dropAcceptance,
  completeAcceptances,
  failAcceptances,
  withdrawAcceptances,
  getActiveParticipantCount,
  computeQuestProgress,
  ONBOARDING_QUEST_ORIGIN,
  isOnboardingQuestHiddenFor,
  onboardingQuestVisibilityWhere,
  unpricedQuestWhere,
  SCENARIO_SEED_QUEST_ORIGIN,
  isScenarioSeedQuest,
  assertThreadBody,
  ADCODE_REQUEST_COMMENT_MAX_LENGTH,
  hasAdcodeCommentThread,
  canCommentOnAdcodeRequest,
  canReviewAdcodeProof,
  PROOF_REMINDER_SUBMITTED_STATUSES,
  selectProofReminderTargets,
  isQuestChainCleared,
  groupPrerequisites,
  countPendingGroups,
  isUnblockedBy,
  describeQuestChain,
  QUEST_DIFFICULTY_GUIDE,
  QUEST_DIFFICULTY_CRITERIA_TEXT,
  QUEST_WEIGHT_FORMULA_VERSION,
  QUEST_WEIGHT_ALPHA_DEFAULT,
  BAND_MEDIAN,
  questDifficultyWeight,
  gateWeightSnapshot,
  gateWeightShares,
  gateWeight,
  resolveProofGateOwners,
  resolveQualitativeGateOwners,
  QuestProductAttachmentViolation,
  checkQuestProductAttachment,
  QUEST_STATES,
  QUEST_TRANSITIONS,
  questStateOf,
  splitQuestState,
  isReachableQuestState,
  canTransitionQuest,
  questTransitionSourcesTo,
  DISTRIBUTION_KINDS,
  computeDistribution,
  QuestDifficulty,
  normalizeAdvertiserName,
  createAdvertiser,
  updateAdvertiser,
  setAdvertiserActive,
  assertAdvertiserUsable,
  CONTRACT_PARTY_KINDS,
  AttendanceStatus,
  SegmentType,
  ScheduleType,
  detectMissedClockOut,
  forceCloseAttendance,
  closeMissedAttendance,
  exceedsDailyMax,
  validateMissedClockOutTime,
  validateMissedClockInTime,
  closeSegment,
  createSegment,
  closeAllOpenSegments,
  validateTimeOrder,
  syncSegmentBoundaries,
  resumeAttendance,
  clockIn,
  clockOut,
  MIN_WORK_SEGMENT_BEFORE_BREAK_MS,
  startBreak,
  endBreak,
  calculateTotalWorkDuration,
  formatElapsed,
  calculateCurrentWorkDuration,
  MAX_CORRECTION_SPAN_MS,
  applyCorrection,
  applyAdminEdit,
  applySegmentTypeCorrection,
  deriveClockTimesFromSegments,
  validateSegmentTimes,
  LeaveProofStatus,
  LeaveType,
  isLeaveType,
  parseLeaveType,
  canReviewProof,
  canRequestResubmit,
  resolveLeaveApprovalAuthority,
  calculateServicePeriod,
  calculateAnnualLeaveEntitlement,
  validateLeaveBalance,
  validateHalfDayRequest,
  isBalanceDeductible,
  isPastDate,
  splitLeaveDaysByServiceYear,
  LEAVE_TYPE_LABELS,
  LeaveStatus,
  LeaveApprovalType,
  LeaveApprovalStatus,
  computeSegmentedGrossPay,
  computeAttendanceAggregate,
  isExcludedFromTeamAverage,
  computeTeamAggregate,
  classifyWorkSegments,
  isHolidayForDate,
  isOffDayForDate,
  createIsHolidayFn,
  toAttendancePolicy,
  getPayPeriod,
  getLedgerPeriod,
  getPayPeriodByKey,
  DEFAULT_PAY_DAY,
  getPayPeriodUtcWindow,
  PUNCH_QUEUE,
  isOccurredAtAcceptable,
  prunePunchQueue,
  isSameInstantWithinTolerance,
  INACTIVE_ATTENDANCE_STATUSES,
  SegmentSourceType,
  CorrectionStatus,
  HolidayPaidType,
  OffDayApprovalStatus,
  CompensationType,
  resolveCompensationAt,
  CLIENT_PLATFORMS,
  loginSchema,
  registerSchema,
  registerVerifySchema,
  changePasswordSchema,
  identifySchema,
  LoginTicketSchema,
  hasEmailOrTicket,
  authenticateSchema,
  verifyIdentitySchema,
  resetPasswordSchema,
  revokeAllSessionsSchema,
  identifyByNameSchema,
  sendOtpSchema,
  verifyOtpSchema,
  CheckpointRejectReasonKind,
  isCheckpointRejectReasonKind,
  canWriteQuestTaskFeedback,
  canCommentOnQuestTaskFeedback,
  createQuestTaskFeedback,
  createQuestTaskFeedbackComment,
  CAMPAIGN_AD_CODE_PATTERN,
  isCampaignAdCode,
  BoostingStage,
  BOOSTING_STAGE_ORDER,
  BOOSTING_RESUME_EDGES,
  assertBoostingTransition,
  planBoostingBackfillPath,
  planBoostingBackfill,
  allowedBoostingTransitions,
  ScenarioCampaignType,
  ScenarioStatus,
  SCENARIO_CREATOR_COUNT_MIN,
  SCENARIO_CREATOR_COUNT_MAX,
  DOMESTIC_TARGET_COUNTRIES,
  deriveCampaignType,
  StopRuleMetric,
  StopRuleDirection,
  parseStopRule,
  StopRuleVerdict,
  judgeStopRule,
  RosterStatus,
  ROSTER_WRITABLE_STATUSES,
  ROSTER_STATUSES,
  DEFAULT_ROSTER_STATUS,
  hasDraftAwaitingReview,
  isRosterUploadComplete,
  RosterPhase,
  deriveRosterPhase,
  RosterBallHolder,
  deriveRosterBallHolder,
  RosterDropKind,
  ROSTER_DROP_KINDS,
  ROSTER_MANUAL_DROP_KINDS,
  isAdvertiserRoundFree,
  ROSTER_DROP_KIND_LABEL,
  isRosterDropKind,
  isManualRosterDropKind,
  AdvertiserReviewVerdict,
  ADVERTISER_REVIEW_VERDICTS,
  ADVERTISER_REVIEW_VERDICT_LABEL,
  isAdvertiserReviewVerdict,
  rosterWritableStatusValidator,
  isWritableRosterStatus,
  createRosterStatusValidator,
  AdvertiserReviewMode,
  ADVERTISER_REVIEW_MODES,
  DEFAULT_ADVERTISER_REVIEW_MODE,
  ADVERTISER_REVIEW_MODE_LABEL,
  isAdvertiserReviewMode,
  validateAdvertiserReviewModeChange,
  normalizeAdvertiserReviewModeInitialReason,
  requiresAdvertiserApproval,
  CampaignDifficulty,
  CAMPAIGN_DIFFICULTY_CONDITIONS,
  CAMPAIGN_SLOT_PRICE,
  deriveCampaignDifficulty,
  calculateCampaignPrice,
  createScenario,
  updateScenario,
  activateScenario,
  completeScenario,
  failScenario,
  archiveScenario,
  canArchiveScenario,
  MAX_QUESTS_PER_SCENARIO,
  tagQuestToScenario,
  untagQuestFromScenario,
  reorderQuests,
  formatScenarioCode,
  addDependency,
  backfillLinearDependencies,
  ScenarioProgressMetricKey,
  SCENARIO_PROGRESS_METRIC_KEYS,
  SCENARIO_PROGRESS_METRIC_LABEL,
  OUTREACH_METRIC_KEYS,
  shouldIngestFormResponses,
  ScenarioReviewMode,
  ScenarioProgressCompletionState,
  ScenarioProgressBlockerCode,
  ScenarioDropSignalStatus,
  ScenarioContractTargetRevisionStatus,
  deriveScenarioProcedureProgressFromSignals,
  calculateScenarioContractTargetRevisionSlots,
  calculateOpenReplacementSignals,
  calculateDroppedSignals,
  deriveScenarioProcedureProgress,
  deriveRecruitRemaining,
  deriveOutreachFunnel,
  calculateScenarioViewProgress,
  pickRepresentativeAdcodePerVideo,
  ScenarioOperationalIssueArea,
  ScenarioRecruitingIssueReason,
  ScenarioContentDeliveryIssueReason,
  ScenarioOperationalIssueReportStatus,
  ScenarioOperationalHealthLabel,
  OPERATIONAL_REASONS_BY_AREA,
  isReasonValidForArea,
  captureInitialCreatorsRecruitedAt,
  summarizeScenarioOperationalHealth,
  ScenarioOperationalSignalGapDirection,
  SCENARIO_OPERATIONAL_SIGNAL_GAP_ALIGNED_HOURS,
  deriveOperationalSignalGap,
  visibleReportsForViewer,
  SCENARIO_OPERATIONAL_ISSUE_REPORT_COMMENT_MAX_LENGTH,
  createScenarioOperationalIssueReportComment,
  canCommentOnOperationalIssueReport,
  SCENARIO_OPERATIONAL_SIGNAL_REPORTS_LIMIT,
  SCENARIO_TARGET_TOTAL_VIEWS_MAX,
  BoostingFlagWarning,
  deriveBoostingStage,
  splitKakaoChannelName,
  RosterLabelKey,
  ROSTER_LABEL_ALIASES,
  PII_LABEL_KEYS,
  PAYOUT_LABEL_KEYS,
  EMAIL_LABEL_KEYS,
  normalizeRosterLabel,
  rosterPriceCurrency,
  normalizeVideoUrl,
  isTikTokUrl,
  MappingWarningCode,
  CREATOR_EMAIL_MAX_LENGTH,
  creatorEmailSchema,
  paypalMeSchema,
  AdcodeLabelKey,
  normalizeAdcodeLabel,
  normalizeCreatorHandle,
  isTiktokNumericId,
  stripCreatorHandlePrefix,
  missingRequiredRosterKeys,
  mapRawRosterRow,
  requiredRosterKeyLabel,
  mapRawAdcodeRow,
  rosterImportMatchKey,
  findRosterImportDuplicateKeys,
  RosterContentReview,
  ROSTER_CONTENT_REVIEWS,
  RosterContentReviewDisplay,
  ROSTER_CONTENT_REVIEW_DISPLAY_LABEL,
  isRosterContentReview,
  deriveRosterContentReviewDisplay,
  SETTLEMENT_CURRENCY_PATTERN,
  isIso4217AlphaCode,
  createSettlementCurrencyValidator,
  SettlementKind,
  SETTLEMENT_KINDS,
  SETTLEMENT_REQUESTABLE_KINDS,
  SettlementCostBearer,
  SettlementPayoutForm,
  SettlementPayoutMethod,
  SETTLEMENT_DOMESTIC_CURRENCY,
  isSettlementTermAllowedFor,
  SETTLEMENT_KIND_ACCOUNTING_DEFAULTS,
  isSettlementKind,
  isRequestableSettlementKind,
  isSettlementCostBearer,
  isSettlementPayoutForm,
  isSettlementPayoutMethod,
  SETTLEMENT_APPROVAL_THRESHOLD_USD,
  SETTLEMENT_APPROVAL_THRESHOLD_CURRENCY,
  SETTLEMENT_AMOUNT_PATTERN,
  SettlementApprovalVerdict,
  SettlementApprovalUndeterminedReason,
  isSettlementAmount,
  judgeSettlementApproval,
  requiresExecutiveApproval,
  RosterPriceProposer,
  ROSTER_PRICE_PROPOSERS,
  RosterScheduleKind,
  ROSTER_SCHEDULE_KINDS,
  isRosterScheduleKind,
  rosterScheduleConfirmInputSchema,
  buildScheduleRevisions,
  latestScheduleByKind,
  rosterScheduleView,
  toParticipantConditions,
  snapshotConditionsForWrite,
  scheduleConfirmationState,
  RosterTakedownRequester,
  ROSTER_TAKEDOWN_REQUESTERS,
  isRosterTakedownRequester,
  VideoRightAxis,
  VideoRightValue,
  VIDEO_RIGHT_AXES,
  VIDEO_RIGHT_VALUES,
  VIDEO_RIGHT_AXIS_LABEL,
  VIDEO_RIGHT_VALUE_LABEL,
  isVideoRightAxis,
  isVideoRightValue,
  currentVideoRights,
  adcodeIssueWarning,
  SettlementStatus,
  SETTLEMENT_STATUS_TRANSITIONS,
  SETTLEMENT_REASON_REQUIRED_STATUSES,
  SETTLEMENT_APPROVAL_CLEARANCE_TRANSITION,
  requiresSettlementClearanceReason,
  isSettlementStatus,
  canTransitionSettlement,
  assertSettlementTransition,
  FinanceLedgerNavigationSchema,
  NavigationContextSchema,
  DEEP_LINK_VIEW_PARAM,
  parseDeepLinkFromQuery,
  buildDeepLinkQuery,
  toEpochMs,
  RELATION_STATES,
  RELATION_HISTORY_TYPES,
  RELATION_HISTORY_ORIGINS,
  OWNER_CHANGE_CAUSES,
  CREATOR_RELATION_SOURCE_SYSTEM,
  CREATOR_RELATION_INVALID_TRANSITION,
  isRelationState,
  relationStateRank,
  sortRelationHistory,
  effectiveRelationHistory,
  deriveRelationState,
  floorRelationState,
  evaluateRelationStateChange,
  RelationStateChangeError,
  assertRelationStateChange,
  BLOCK_REASON_KINDS,
  isBlockReasonKind,
  deriveBlockedUntil,
  isBlockActive,
  evaluateBlock,
  evaluateUnblock,
  RE_RECRUIT_REASON_KINDS,
  isReRecruitReasonKind,
  deriveOutreachBlockedAt,
  evaluateOutreachUnblock,
  deriveRecruitmentPolicy,
  REGULAR_PARAMS,
  regularParamsAt,
  recommendRegular,
  TOUCH_HISTORY_TYPES,
  IDLE_WARN_DAYS,
  lastTouchAt,
  idleDays,
  ownerScopeMeasures,
  currentOwnerUserId,
  discovererUserId,
  hasTombstoneHistory,
  CreatorVisibilityTier,
  canSearchCreatorsCompanyWide,
  CREATOR_PIPELINE_MAX_LAG_MS,
  isPipelineStale,
  CREATOR_UNKNOWN_TO_SOURCE,
  isRestrictedCreator,
  isOwnerEligible,
  ownerRevocationCause,
  canViewCreator,
  canReviewCreatorMatching,
  canRestoreRosterDrop,
  canExportCreators,
  cardSections,
  CreatorPricePlatform,
  CREATOR_PRICE_PLATFORMS,
  isCreatorPricePlatform,
  WARM_POOL_STATES,
  WARM_POOL_BASES,
  deriveWarmPoolSummary,
  DOKKAEBI_SYSTEM_USER_ID,
  CHANNEL_NOTIFY_LEVELS,
  TeamType,
  TeamStatus,
  TeamRole,
  TeamCapability,
  createDepartment,
  createTaskForce,
  createClub,
  archiveTeam,
  restoreTeam,
  addMember,
  removeMember,
  transferLeadership,
  getLeader,
  getMembers,
  updateTeamCapabilities,
  CEO_POLICY_KEYS,
  isCeoPolicyKey,
  CEO_POLICY_LABELS,
  CEO_POLICY_EFFECT_NOTES,
  QUEST_DIFFICULTY_LEVELS,
  CEO_POLICY_DEFAULTS,
  validateCeoPolicyValue,
  teamDifficultyPricingSchema,
  resolveDifficultyPricing,
  readCompanyDifficultyRanges,
  judgeRewardByPricing,
  pricingNeedsReasonCode,
  TaskForceMetadataSchema,
  ClubMetadataSchema,
  TeamMetadataSchema,
  UserLevel,
  UserRole,
  WorkType,
  UserStatus,
  USER_STATUS_LABELS,
  DEPARTED_USER_STATUSES,
  isDepartedUserStatus,
  LEVEL_LABELS,
  INTERN_CONVERSION_REVIEW_MONTHS,
  calculateInternConversionDate,
  calculateInternConversionDday,
  AgentConnectionType,
  AgentStatus,
  AgentMessageType,
  PieceworkActivityStatus,
  PieceworkAudienceScope,
  PieceworkCycle,
  PieceworkSubmissionStatus,
  createActivity,
  approveActivity,
  rejectActivityCreation,
  archiveActivity,
  lockActivity,
  unlockActivity,
  CYCLE_KEY_NONE,
  computeCycleKey,
  computeNextCycle,
  assertCanSubmit,
  submitPiecework,
  approveSubmission,
  rejectSubmission,
  isParticipantInAudience,
  DEFAULT_POINT_TO_KRW_RATE,
  pointsToKrw,
  PointHistoryType,
  ADJUST_REASON_CATEGORIES,
  ADJUST_REASON_CATEGORY_LABELS,
  REVERSIBLE_POINT_HISTORY_TYPES,
  QuestProposalStatus,
  isResolvedQuestProposalStatus,
  QUEST_PROPOSAL_TITLE_MAX_LENGTH,
  QUEST_PROPOSAL_DESCRIPTION_MAX_LENGTH,
  QuestProposalTitleSchema,
  QuestProposalDescriptionSchema,
  SCENARIO_TEMPLATE_CREATOR_COUNT_MIN,
  SCENARIO_TEMPLATE_CREATOR_COUNT_MAX,
  SCENARIO_TEMPLATE_DURATION_DAYS_MIN,
  SCENARIO_TEMPLATE_TARGET_REGION_MAX,
  createScenarioTemplate,
  instantiateTemplate,
  TimelineEventType,
  seedCheckpointDiscriminator,
  normalizeGuidelineUrl,
  guidelineDeliveryCandidates,
  isGuidelineDeliveryCheckpoint,
  TIMELINE_EVENT_TYPE_DISPLAY_LABEL,
  TimelineAttachmentType,
  RESUME_POINT_MAX_LENGTH,
  SYSTEM_TIMELINE_EVENT_TYPES,
  validateTimelineEvent,
  deriveGuidelineDrafts,
  readResumePoint,
  validateTimelineAttachment,
  TIMELINE_EVENT_TYPE_LABEL,
  deriveQuestDraftFromEvent,
  targetSlotRequirementsSchema,
  targetSlotOverridesSchema,
  targetSlotParticipantConditionsSchema,
  resolveTargetSlotRequirements,
  evaluateTargetSlotConditions,
  CampaignTimelineMilestone,
  CAMPAIGN_TIMELINE_MILESTONE_LABEL,
  CAMPAIGN_TIMELINE_MAX_ENTRIES,
  CAMPAIGN_TIMELINE_LABEL_MAX,
  defaultCampaignTimeline,
  campaignPeriodEnd,
  campaignPeriod,
  alignCampaignPeriod,
  kstDateToInstant,
  validateCampaignTimeline,
  REPLY_TEMPLATE_LAYERS,
  REPLY_TEMPLATE_STAGES,
  REPLY_TEMPLATE_KINDS,
  REPLY_TEMPLATE_VARIABLE_KEYS,
  findUnknownTemplateVariables,
  renderReplyTemplate,
  CROP_ASPECT_PRESETS,
  FREE_CROP_MIN_RATIO,
  FREE_CROP_MAX_RATIO,
  parseAspectRatio,
  isAllowedCropAspectRatio,
  applyCropEdit,
  OUTREACH_DATE_FORMATS,
  DEFAULT_OUTREACH_DATE_FORMAT,
  formatOutreachDate,
  ApprovedOriginalSource,
  ApprovedOriginalState,
  ApprovedOriginalReceivedVia,
  ApprovedOriginalFileOrigin,
  selectApprovedOriginalFile,
  planApprovedOriginalWrite,
  assessOriginalIntegrity,
  reviewFileIntegrityAction,
  validateOriginalProvenance,
  approvedOriginalSourceLabel,
  classifyOriginalRecovery,
  CREATOR_RESEND_CLOSED_MESSAGE,
  isCreatorResendOpen,
  WIKI_DOCUMENT_KINDS,
  WIKI_HOME_TITLE,
  WIKI_AREAS,
  WIKI_AREA_LABELS,
  WIKI_SYSTEM_AREA_KEYS,
  WIKI_AREA_SEEDS,
  WIKI_PAGE_TITLE_PREFIX,
  isWikiPageTitle,
  resolveWikiArea,
  deriveWikiKind,
  WIKI_REVISION_KINDS,
  WIKI_ERROR_CODES,
  WIKI_DISCUSSION_STATUSES,
  normalizeWikiTitle,
  parseWikiLinks,
  parseWikiRedirect,
  wikiParentTitle,
  uniqueWikiLinkTargets
};
//# sourceMappingURL=chunk-P7KRU2Z3.mjs.map